export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
};

export type AccountAvatarUploadInput = {
  /** Account avatar image file metadata */
  file: FileInput;
  /** Type of avatar file being uploaded */
  fileType?: InputMaybe<Scalars['String']['input']>;
};

/** AccountKpiModel */
export type AccountKpiModel = {
  __typename?: 'AccountKpiModel';
  /** Count of active patients in the account */
  active_patients: Scalars['Int']['output'];
  /** Count of alerts raised within the last 24 hours */
  alerts_within_24_hours: Scalars['Int']['output'];
  /** Count of currently open alerts */
  open_alerts: Scalars['Int']['output'];
  /** Count of patients with active alerts */
  patients_with_alerts: Scalars['Int']['output'];
  /** Count of patients with connected devices */
  patients_with_devices: Scalars['Int']['output'];
};

/** AccountModel */
export type AccountModel = {
  __typename?: 'AccountModel';
  /** Primary line of the account's alternative address */
  account_address?: Maybe<Scalars['String']['output']>;
  /** Secondary line of the account's alternative address */
  account_address2?: Maybe<Scalars['String']['output']>;
  /** City of the account's alternative address */
  account_city?: Maybe<Scalars['String']['output']>;
  /** Country ID of the account's alternative address */
  account_country_id?: Maybe<Scalars['String']['output']>;
  /** Unique identifier of the account */
  account_id: Scalars['String']['output'];
  /** Display name of the account */
  account_name?: Maybe<Scalars['String']['output']>;
  /** Region ID of the account's alternative address */
  account_region_id?: Maybe<Scalars['String']['output']>;
  /** Type of the account (individual or organization) */
  account_type?: Maybe<AccountType>;
  /** Zip or postal code of the account's alternative address */
  account_zip_postal?: Maybe<Scalars['String']['output']>;
  /** Primary line of the billing address */
  billing_address?: Maybe<Scalars['String']['output']>;
  /** Secondary line of the billing address */
  billing_address2?: Maybe<Scalars['String']['output']>;
  /** Child accounts nested under this account */
  children: Array<AccountModel>;
  /** City of the billing address */
  city?: Maybe<Scalars['String']['output']>;
  /** Country ID of the billing address */
  country_id?: Maybe<Scalars['String']['output']>;
  /** Timestamp when the account was created */
  created_at?: Maybe<Scalars['DateTime']['output']>;
  /** User ID that created the account */
  created_user_id?: Maybe<Scalars['String']['output']>;
  /** Currency used for account billing */
  currency?: Maybe<Scalars['String']['output']>;
  /** Contact email address for the account */
  email?: Maybe<Scalars['String']['output']>;
  /** Whether the account is soft-deleted */
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  /** Key performance indicators for this account */
  kpi: AccountKpiModel;
  /** The user who owns this account, if any */
  ownerUser?: Maybe<UserModel>;
  /** User ID of the account owner */
  owner_id?: Maybe<Scalars['String']['output']>;
  /** Parent account ID for child accounts */
  parent_id?: Maybe<Scalars['String']['output']>;
  /** Payment type configured for the account */
  payment_type?: Maybe<Scalars['String']['output']>;
  /** Contact phone number for the account */
  phone_number?: Maybe<Scalars['String']['output']>;
  /** URL of the account's profile picture */
  profile_picture?: Maybe<Scalars['String']['output']>;
  /** Region ID of the billing address */
  region_id?: Maybe<Scalars['String']['output']>;
  /** Status ID of the account */
  status_id?: Maybe<Scalars['String']['output']>;
  /** Stripe customer ID for the account */
  stripe_customer_id?: Maybe<Scalars['String']['output']>;
  /** Timestamp when the account was last updated */
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  /** Total number of users in this account */
  user_count: Scalars['Float']['output'];
  /** Users belonging to this account */
  users: Array<UserModel>;
  /** Zip or postal code of the billing address */
  zip_postal?: Maybe<Scalars['String']['output']>;
};

export type AccountOrSettingWrapper = {
  __typename?: 'AccountOrSettingWrapper';
  /** Unique identifier of the account */
  account_id: Scalars['String']['output'];
  /** URL of the account's branding logo */
  branding_logo_url?: Maybe<Scalars['String']['output']>;
  /** URL of the account's profile picture */
  profile_picture?: Maybe<Scalars['String']['output']>;
  /** Timestamp of the last update to the account settings */
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type AccountOwnerInput = {
  /** Whether the user completed CASL consent */
  casl_completed?: InputMaybe<Scalars['Boolean']['input']>;
  /** DEPRECATED */
  date_of_birth?: InputMaybe<Scalars['String']['input']>;
  /** Email address of the account owner */
  email: Scalars['String']['input'];
  /** User's first name */
  first_name: Scalars['String']['input'];
  /** DEPRECATED */
  gender?: InputMaybe<Scalars['String']['input']>;
  /** Group the user is assigned to */
  group_id?: InputMaybe<Scalars['String']['input']>;
  /** User's last name */
  last_name: Scalars['String']['input'];
  /** User's middle name */
  middle_name?: InputMaybe<Scalars['String']['input']>;
  /** User's initial password */
  password?: InputMaybe<Scalars['String']['input']>;
  /** Patient-specific fields when creating a patient user */
  patientInputs?: InputMaybe<CreatePatientUserModelInput>;
  /** Phone number of the account owner */
  phone_number?: InputMaybe<Scalars['String']['input']>;
  /** Plan to apply to the user. Only applicable for Orgs */
  plan_id?: InputMaybe<Scalars['String']['input']>;
  /** Whether the user completed the privacy notice */
  pn_completed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Practitioner-specific fields when creating a practitioner user */
  practitionerInputs?: InputMaybe<CreatePractitionerUserModelInput>;
  /** URL of the user's profile picture */
  profile_picture?: InputMaybe<Scalars['String']['input']>;
  /** DEPRECATED */
  questionnaire?: InputMaybe<PatientQuestionnaireModelInput>;
  /** Roles to assign to the user */
  roles?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Whether to send an invitation to the user */
  send_invite?: InputMaybe<Scalars['Boolean']['input']>;
  /** DEPRECATED */
  sex?: InputMaybe<Gender>;
  /** User's title or honorific */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Whether the user accepted the terms of care */
  toc_completed?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AccountSettingInput = {
  /** Whether MFA is required for patient users */
  is_patient_mfa_required?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether MFA is required for practitioner users */
  is_practitioner_mfa_required?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Shared tier to put the account on. Omitted, an organization gets a
   * license of its own instead.
   */
  license_id?: InputMaybe<Scalars['String']['input']>;
  /** Total patient seats the organization purchased */
  limit_patients?: InputMaybe<Scalars['Int']['input']>;
  /** Whether Medly integration is enabled for the account */
  medly_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether titration is enabled for the account */
  titration_enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

/** AccountSettingModel */
export type AccountSettingModel = {
  __typename?: 'AccountSettingModel';
  /** Unique identifier of the account */
  account_id: Scalars['String']['output'];
  /** Whether email notifications are sent when an account user is added */
  account_user_added_email_notifications_enabled: Scalars['Boolean']['output'];
  /** Primary branding color for the account */
  branding_color_primary?: Maybe<Scalars['String']['output']>;
  /** Secondary branding color for the account */
  branding_color_secondary?: Maybe<Scalars['String']['output']>;
  /** URL of the account's branding logo */
  branding_logo_url?: Maybe<Scalars['String']['output']>;
  /** Whether MFA is required for patients on this account */
  is_patient_mfa_required: Scalars['Boolean']['output'];
  /** Whether MFA is required for practitioners on this account */
  is_practitioner_mfa_required: Scalars['Boolean']['output'];
  /** Resolve the license associated with this account setting */
  license?: Maybe<LicenseModel>;
  /** License identifier applied to this account */
  license_id: Scalars['String']['output'];
  /** Whether Medly integration is enabled for the account */
  medly_enabled: Scalars['Boolean']['output'];
  /** Whether medication titration is enabled for the account */
  titration_enabled: Scalars['Boolean']['output'];
};

export enum AccountType {
  individual = 'individual',
  organization = 'organization',
  vitall = 'vitall'
}

export type ActivityModel = {
  __typename?: 'ActivityModel';
  /** Numeric code of the activity type */
  activity_type: Scalars['Float']['output'];
  /** Integration name of the Terra-connected device */
  device_name?: Maybe<Scalars['String']['output']>;
  /** When the activity ended */
  end_time?: Maybe<Scalars['DateTime']['output']>;
  /** FHIR observations for this activity with converted units */
  observations?: Maybe<Array<ObservationModel>>;
  /** When the activity started */
  start_time: Scalars['DateTime']['output'];
  /** Activity payload summary id */
  summary_id: Scalars['String']['output'];
  /** Terra connection that produced this activity */
  terra_connection_id: Scalars['String']['output'];
};

export type Address = {
  __typename?: 'Address';
  /** Name of city town etc. */
  city?: Maybe<Scalars['String']['output']>;
  /** Country (e.g. can be ISO 3166 2 or 3 letter code) */
  country?: Maybe<Scalars['String']['output']>;
  /** District name (aka county) */
  district?: Maybe<Scalars['String']['output']>;
  /** Street name number direction & P.O. Box etc. */
  line?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Time period when address was/is in use */
  period?: Maybe<Period>;
  /** Postal code for area */
  postalCode?: Maybe<Scalars['String']['output']>;
  /** Sub-unit of country (abbreviations ok) */
  state?: Maybe<Scalars['String']['output']>;
  /** Text representation of the address */
  text?: Maybe<Scalars['String']['output']>;
  /** postal | physical | both */
  type?: Maybe<Scalars['String']['output']>;
  /** home | work | temp | old | billing - purpose of this address */
  use?: Maybe<Scalars['String']['output']>;
};

export type AddressInput = {
  /** Name of city town etc. */
  city?: InputMaybe<Scalars['String']['input']>;
  /** Country (e.g. can be ISO 3166 2 or 3 letter code) */
  country?: InputMaybe<Scalars['String']['input']>;
  /** District name (aka county) */
  district?: InputMaybe<Scalars['String']['input']>;
  /** Street name number direction & P.O. Box etc. */
  line?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Time period when address was/is in use */
  period?: InputMaybe<PeriodInput>;
  /** Postal code for area */
  postalCode?: InputMaybe<Scalars['String']['input']>;
  /** Sub-unit of country (abbreviations ok) */
  state?: InputMaybe<Scalars['String']['input']>;
  /** Text representation of the address */
  text?: InputMaybe<Scalars['String']['input']>;
  /** postal | physical | both */
  type?: InputMaybe<Scalars['String']['input']>;
  /** home | work | temp | old | billing - purpose of this address */
  use?: InputMaybe<Scalars['String']['input']>;
};

export type AdminChangeEmailInput = {
  /** User's current email address */
  currentEmail: Scalars['String']['input'];
  /** New email address to assign to the user */
  newEmail: Scalars['String']['input'];
};

export type AdminChangePhoneInput = {
  /** New phone number to assign to the user */
  newPhone: Scalars['String']['input'];
  /** Identifier of the user whose phone is changing */
  user_id: Scalars['String']['input'];
};

export type Age = {
  __typename?: 'Age';
  /** Code */
  code: Scalars['String']['output'];
  /** System */
  system: Scalars['String']['output'];
  /** Unit */
  unit: Scalars['String']['output'];
  /** Value */
  value: Scalars['Float']['output'];
};

export type AgeInput = {
  /** Code */
  code: Scalars['String']['input'];
  /** System */
  system: Scalars['String']['input'];
  /** Unit */
  unit: Scalars['String']['input'];
  /** Value */
  value: Scalars['Float']['input'];
};

/** AlertModel */
export type AlertModel = {
  __typename?: 'AlertModel';
  /** Account ID the alert is associated with */
  account_id?: Maybe<Scalars['String']['output']>;
  /** Unique identifier of the alert */
  alert_id: Scalars['String']['output'];
  /** User who cleared the alert */
  cleared_alert_user?: Maybe<UserModel>;
  /** ID of the user who cleared the alert */
  cleared_by_user_id?: Maybe<Scalars['String']['output']>;
  /** Timestamp when the alert was created */
  created_at: Scalars['DateTime']['output'];
  /** FHIR Observation that triggered the alert */
  measurement?: Maybe<ObservationModel>;
  /** Counts of successful, failed and undelivered notifications */
  notification_count?: Maybe<AlertNotificationCountModel>;
  /** ID of the FHIR Observation that raised the alert */
  observation_id?: Maybe<Scalars['String']['output']>;
  /** Reference range that triggered the alert */
  reference_range?: Maybe<AlertReferenceRangeModel>;
  /** Current status of the alert */
  status: AlertStatus;
  /** Timestamp when the alert was last updated */
  updated_at: Scalars['DateTime']['output'];
  /** Patient the alert was raised for */
  vitall_patient?: Maybe<VitallPatientModel>;
  /** Vitall patient ID the alert belongs to */
  vitall_patient_id?: Maybe<Scalars['String']['output']>;
};

/** AlertNotificationCountModel */
export type AlertNotificationCountModel = {
  __typename?: 'AlertNotificationCountModel';
  /** Count of notifications that failed to deliver */
  fails: Scalars['Float']['output'];
  /** Count of notifications not yet delivered */
  not_delivered: Scalars['Float']['output'];
  /** Count of notifications delivered successfully */
  successes: Scalars['Float']['output'];
};

/** AlertNotificationDestinationModel */
export type AlertNotificationDestinationModel = {
  __typename?: 'AlertNotificationDestinationModel';
  /** Address the notification was sent to */
  destination: Scalars['String']['output'];
  /** Error message if the notification failed to send */
  error_message?: Maybe<Scalars['String']['output']>;
  /** Timestamp when the notification was sent */
  sent_at?: Maybe<Scalars['DateTime']['output']>;
  /** Delivery status of the notification */
  status: AlertNotificationStatus;
};

/** AlertNotificationModel */
export type AlertNotificationModel = {
  __typename?: 'AlertNotificationModel';
  /** Email delivery details for the notification */
  email_notification?: Maybe<AlertNotificationDestinationModel>;
  /** Display name of the notification recipient */
  name: Scalars['String']['output'];
  /** User or account ID */
  recipient_id: Scalars['String']['output'];
  /** SMS delivery details for the notification */
  sms_notification?: Maybe<AlertNotificationDestinationModel>;
  /** Type of recipient the notification targets */
  type: AlertRecipientType;
};

export enum AlertNotificationStatus {
  failed = 'failed',
  not_delivered = 'not_delivered',
  success = 'success'
}

export type AlertParameterInput = {
  /** Whether notifications are enabled for this parameter */
  notification_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Reference range condition this alert parameter targets */
  reference_range_condition_id: Scalars['String']['input'];
};

export type AlertParameterModel = {
  __typename?: 'AlertParameterModel';
  /** Unique identifier of the alert parameter */
  alert_parameter_id: Scalars['String']['output'];
  /** Observation code the parameter applies to */
  code?: Maybe<Scalars['String']['output']>;
  /** Whether this parameter uses a custom reference range */
  is_custom: Scalars['Boolean']['output'];
  /** Lower boundary of the parameter's reference range */
  lower_bound?: Maybe<ParameterBoundary>;
  /** Whether notifications are enabled for this parameter */
  notification_enabled: Scalars['Boolean']['output'];
  /** Risk level associated with this parameter */
  risk: Scalars['String']['output'];
  /** Upper boundary of the parameter's reference range */
  upper_bound?: Maybe<ParameterBoundary>;
};

export type AlertRecipientInput = {
  /** Account identifier of the alert recipient */
  account_id?: InputMaybe<Scalars['String']['input']>;
  /** User identifier of the alert recipient */
  user_id?: InputMaybe<Scalars['String']['input']>;
};

export type AlertRecipientModel = {
  __typename?: 'AlertRecipientModel';
  /** Account identifier of the alert recipient */
  account_id?: Maybe<Scalars['String']['output']>;
  /** Display name of the alert recipient */
  name: Scalars['String']['output'];
  /** User identifier of the alert recipient */
  user_id?: Maybe<Scalars['String']['output']>;
};

/** AlertRecipientSettingModel */
export type AlertRecipientSettingModel = {
  __typename?: 'AlertRecipientSettingModel';
  /** The account this alert recipient setting belongs to */
  account?: Maybe<AccountModel>;
  /** Account identifier the alert recipient setting belongs to */
  account_id?: Maybe<Scalars['String']['output']>;
  /** Email address alerts are delivered to */
  email_destination?: Maybe<Scalars['String']['output']>;
  /** Whether email alert delivery is enabled */
  email_enabled: Scalars['Boolean']['output'];
  /** Verification status of the email destination */
  email_status?: Maybe<Scalars['String']['output']>;
  /** Phone number alerts are delivered to */
  sms_destination?: Maybe<Scalars['String']['output']>;
  /** Whether SMS alert delivery is enabled */
  sms_enabled: Scalars['Boolean']['output'];
  /** Verification status of the SMS destination */
  sms_status?: Maybe<Scalars['String']['output']>;
  /** The user this alert recipient setting applies to */
  user?: Maybe<UserModel>;
  /** User identifier the alert recipient setting belongs to */
  user_id?: Maybe<Scalars['String']['output']>;
};

export enum AlertRecipientType {
  account = 'account',
  user = 'user'
}

/** AlertReferenceRangeModel */
export type AlertReferenceRangeModel = {
  __typename?: 'AlertReferenceRangeModel';
  /** Observation category the reference range applies to */
  category?: Maybe<Scalars['String']['output']>;
  /** Observation code the reference range applies to */
  code: Scalars['String']['output'];
  /** Risk-scored parameters within the reference range */
  parameters: Array<AlertRiskParameterModel>;
  /** ID of the reference range that triggered the alert */
  reference_range_id: Scalars['String']['output'];
};

/** AlertRiskParameterModel */
export type AlertRiskParameterModel = {
  __typename?: 'AlertRiskParameterModel';
  /** Observation code the parameter applies to */
  code: Scalars['String']['output'];
  /** Lower boundary of the parameter range */
  lower_bound?: Maybe<ParameterBoundary>;
  /** Unique identifier of the parameter */
  parameter_id: Scalars['String']['output'];
  /** Risk level of this reference range parameter */
  risk: ReferenceRangeRiskLevel;
  /** Upper boundary of the parameter range */
  upper_bound?: Maybe<ParameterBoundary>;
  /** Vitall patient this custom parameter belongs to, if any */
  vitall_patient_id?: Maybe<Scalars['String']['output']>;
};

export type AlertSettingChangesInput = {
  /** Updated list of alert parameters */
  parameters?: InputMaybe<Array<AlertParameterInput>>;
  /** Updated list of alert recipients */
  recipients?: InputMaybe<Array<AlertRecipientInput>>;
};

export type AlertSettingModel = {
  __typename?: 'AlertSettingModel';
  /** Parameters configured for this alert setting */
  alert_parameters: Array<AlertParameterModel>;
  /** Unique identifier of the alert setting */
  alert_setting_id: Scalars['String']['output'];
  /** Category grouping for the alert setting */
  category?: Maybe<Scalars['String']['output']>;
  /** Display name of the alert setting */
  name: Scalars['String']['output'];
  /** Whether notifications are enabled for this alert setting */
  notification_enabled: Scalars['Boolean']['output'];
  /** Recipients notified by this alert setting */
  recipients: Array<AlertRecipientModel>;
  /** Reference range identifier the alert setting derives from */
  reference_range_id: Scalars['String']['output'];
  /** Vitall patient identifier the alert setting belongs to */
  vitall_patient_id: Scalars['String']['output'];
};

/** AlertStatsModel */
export type AlertStatsModel = {
  __typename?: 'AlertStatsModel';
  /** Number of alerts matching the query */
  count: Scalars['Int']['output'];
  /** Timestamp of the most recent alert update */
  last_update?: Maybe<Scalars['DateTime']['output']>;
};

export enum AlertStatus {
  archived = 'archived',
  cleared = 'cleared',
  open = 'open'
}

/** AllPatientRecordsModel */
export type AllPatientRecordsModel = {
  __typename?: 'AllPatientRecordsModel';
  /** Patient allergy and intolerance records */
  allergy: Array<AllergyModel>;
  /** Patient appointment records */
  appointment: Array<AppointmentModel>;
  /** Patient blood type observation */
  blood_type?: Maybe<ObservationModel>;
  /** Patient body measurement observations */
  body_observation: Array<ObservationModel>;
  /** The patient's care team */
  care_team?: Maybe<PatientCareTeamModel>;
  /** Patient condition and diagnosis records */
  condition: Array<ConditionModel>;
  /** Patient consent records */
  consent: Array<ConsentModel>;
  /** Patient insurance coverage records */
  coverage: Array<CoverageModel>;
  /** Patient diagnostic report records */
  diagnostic_report: Array<DiagnosticReportModel>;
  /** Patient emergency visit encounters */
  emergency_visits_encounter: Array<EncounterModel>;
  /** Patient family member medical history */
  family_member_history: Array<FamilyMemberHistoryModel>;
  /** Patient genetic information observations */
  genetic_information_observation: Array<ObservationModel>;
  /** Patient body height observation */
  height_body_observation?: Maybe<ObservationModel>;
  /** Patient hospitalization encounters */
  hospitalizations_encounter: Array<EncounterModel>;
  /** Patient imaging diagnostic reports */
  imaging_report: Array<DiagnosticReportModel>;
  /** Patient imaging study records */
  imaging_study: Array<ImagingStudyModel>;
  /** Patient immunization records */
  immunization: Array<ImmunizationModel>;
  /** Patient laboratory diagnostic reports */
  lab_report: Array<DiagnosticReportModel>;
  /** Patient laboratory observations */
  laboratory_observation: Array<ObservationModel>;
  /** Patient legal directive consents */
  legal_directives: Array<ConsentModel>;
  /** Patient medication statement records */
  medication_statement: Array<MedicationStatementModel>;
  /** The patient demographic record */
  patient?: Maybe<PatientModel>;
  /** Patient procedure records */
  procedure: Array<ProcedureModel>;
  /** People related to the patient */
  related_person: Array<RelatedPersonModel>;
  /** Patient task records */
  task: Array<TaskModel>;
  /** Patient vital signs observations */
  vital_signs_observation: Array<ObservationModel>;
  /** Patient body weight observation */
  weight_body_observation?: Maybe<ObservationModel>;
};

/** AllergyModel */
export type AllergyModel = {
  __typename?: 'AllergyModel';
  /** Source of the information about the allergy */
  asserter?: Maybe<Reference>;
  associatedResources?: Maybe<Array<ResourceAssociationUnion>>;
  attachments?: Maybe<Array<Attachment>>;
  /** Category: food, medication, environment, or biologic */
  category?: Maybe<Array<CategoryCode>>;
  /** Clinical status: active, inactive, or resolved */
  clinicalStatus?: Maybe<CodeableConceptClinicalStatus>;
  /** Code identifying the allergy or intolerance substance */
  code?: Maybe<CodeableConcept>;
  /** Contained */
  contained?: Maybe<Array<Resource>>;
  /** Criticality: low, high, or unable-to-assess */
  criticality?: Maybe<CriticalityCode>;
  /** Curation metadata for this allergy resource */
  curationMeta?: Maybe<CurationMeta>;
  displayName?: Maybe<Scalars['String']['output']>;
  /** Encounter when the allergy or intolerance was asserted */
  encounter?: Maybe<Reference>;
  /** Extension */
  extension?: Maybe<Array<Extension>>;
  /** Logical id of the allergy resource */
  id?: Maybe<Scalars['String']['output']>;
  /** External ids for this allergy or intolerance */
  identifier?: Maybe<Array<Identifier>>;
  /** A set of rules under which this content was created */
  implicitRules?: Maybe<Scalars['String']['output']>;
  /** Language of the resource content */
  language?: Maybe<Scalars['String']['output']>;
  /** Date/time of last known occurrence of a reaction */
  lastOccurrence?: Maybe<Scalars['String']['output']>;
  /** Metadata about the resource */
  meta?: Maybe<Meta>;
  /** Additional notes not captured in other fields */
  note?: Maybe<Array<Annotation>>;
  /** Patient age at onset of the allergy or intolerance */
  onsetAge?: Maybe<Quantity>;
  /** Date/time the allergy or intolerance was identified */
  onsetDateTime?: Maybe<Scalars['String']['output']>;
  /** Period during which onset of the allergy or intolerance occurred */
  onsetPeriod?: Maybe<Period>;
  /** Age range at onset of the allergy or intolerance */
  onsetRange?: Maybe<Range>;
  /** Free-text description of onset */
  onsetString?: Maybe<Scalars['String']['output']>;
  /** Patient the sensitivity is for */
  patient: Reference;
  /** Adverse reaction events linked to substance exposure */
  reaction?: Maybe<Array<AllergyReaction>>;
  /** Date the first version of the resource was recorded */
  recordedDate?: Maybe<Scalars['String']['output']>;
  /** Who recorded the sensitivity */
  recorder?: Maybe<Reference>;
  /** FHIR resource type, always AllergyIntolerance */
  resourceType?: Maybe<Scalars['String']['output']>;
  /** Text */
  text?: Maybe<Narrative>;
  /** Underlying mechanism: allergy or intolerance */
  type?: Maybe<TypeCode>;
  /** Verification status: unconfirmed, confirmed, refuted, or entered-in-error */
  verificationStatus?: Maybe<CodeableConceptVerificationStatus>;
};

export type AllergyModelInput = {
  /** Source of the information about the allergy */
  asserter?: InputMaybe<ReferenceInput>;
  /** Category: food, medication, environment, or biologic */
  category?: InputMaybe<Array<CategoryCode>>;
  /** Clinical status: active, inactive, or resolved */
  clinicalStatus?: InputMaybe<CodeableConceptClinicalStatusInput>;
  /** Code identifying the allergy or intolerance substance */
  code?: InputMaybe<CodeableConceptInput>;
  /** Contained */
  contained?: InputMaybe<Array<ResourceInput>>;
  /** Criticality: low, high, or unable-to-assess */
  criticality?: InputMaybe<CriticalityCode>;
  /** Encounter when the allergy or intolerance was asserted */
  encounter?: InputMaybe<ReferenceInput>;
  /** Extension */
  extension?: InputMaybe<Array<ExtensionInput>>;
  /** Logical id of the allergy resource to write */
  id?: InputMaybe<Scalars['String']['input']>;
  /** External ids for this allergy or intolerance */
  identifier?: InputMaybe<Array<IdentifierInput>>;
  /** A set of rules under which this content was created */
  implicitRules?: InputMaybe<Scalars['String']['input']>;
  /** Language of the resource content */
  language?: InputMaybe<Scalars['String']['input']>;
  /** Date/time of last known occurrence of a reaction */
  lastOccurrence?: InputMaybe<Scalars['String']['input']>;
  /** Metadata about the resource */
  meta?: InputMaybe<MetaInput>;
  /** Additional notes not captured in other fields */
  note?: InputMaybe<Array<AnnotationInput>>;
  /** Patient age at onset of the allergy or intolerance */
  onsetAge?: InputMaybe<QuantityInput>;
  /** Date/time the allergy or intolerance was identified */
  onsetDateTime?: InputMaybe<Scalars['String']['input']>;
  /** Period during which onset of the allergy or intolerance occurred */
  onsetPeriod?: InputMaybe<PeriodInput>;
  /** Age range at onset of the allergy or intolerance */
  onsetRange?: InputMaybe<RangeInput>;
  /** Free-text description of onset */
  onsetString?: InputMaybe<Scalars['String']['input']>;
  /** Patient the sensitivity is for */
  patient: ReferenceInput;
  /** Adverse reaction events linked to substance exposure */
  reaction?: InputMaybe<Array<AllergyReactionInput>>;
  /** Date the first version of the resource was recorded */
  recordedDate?: InputMaybe<Scalars['String']['input']>;
  /** Who recorded the sensitivity */
  recorder?: InputMaybe<ReferenceInput>;
  /** FHIR resource type, always AllergyIntolerance */
  resourceType?: InputMaybe<Scalars['String']['input']>;
  /** Text */
  text?: InputMaybe<NarrativeInput>;
  /** Underlying mechanism: allergy or intolerance */
  type?: InputMaybe<TypeCode>;
  /** Verification status: unconfirmed, confirmed, refuted, or entered-in-error */
  verificationStatus?: InputMaybe<CodeableConceptVerificationStatusInput>;
};

export type AllergyReaction = {
  __typename?: 'AllergyReaction';
  /** Description of the event as a whole */
  description?: Maybe<Scalars['String']['output']>;
  /** How the subject was exposed to the substance */
  exposureRoute?: Maybe<CodeableConcept>;
  /** Clinical symptoms/signs associated with the Event */
  manifestation: Array<CodeableConcept>;
  /** Text about event not captured in other fields */
  note?: Maybe<Array<Annotation>>;
  /** Date(/time) when manifestations showed */
  onset?: Maybe<Scalars['String']['output']>;
  /** mild | moderate | severe (of event as a whole) */
  severity?: Maybe<Scalars['String']['output']>;
  /** Specific substance or pharmaceutical product considered to be responsible for event */
  substance?: Maybe<CodeableConcept>;
};

export type AllergyReactionInput = {
  /** Description of the event as a whole */
  description?: InputMaybe<Scalars['String']['input']>;
  /** How the subject was exposed to the substance */
  exposureRoute?: InputMaybe<CodeableConceptInput>;
  /** Clinical symptoms/signs associated with the Event */
  manifestation: Array<CodeableConceptInput>;
  /** Text about event not captured in other fields */
  note?: InputMaybe<Array<AnnotationInput>>;
  /** Date(/time) when manifestations showed */
  onset?: InputMaybe<Scalars['String']['input']>;
  /** mild | moderate | severe (of event as a whole) */
  severity?: InputMaybe<Scalars['String']['input']>;
  /** Specific substance or pharmaceutical product considered to be responsible for event */
  substance?: InputMaybe<CodeableConceptInput>;
};

export type Annotation = {
  __typename?: 'Annotation';
  /** Author reference */
  authorReference?: Maybe<Reference>;
  /** Author string */
  authorString?: Maybe<Scalars['String']['output']>;
  /** Id */
  id?: Maybe<Scalars['String']['output']>;
  /** Text */
  text: Scalars['String']['output'];
  /** Time */
  time?: Maybe<Scalars['String']['output']>;
};

export type AnnotationInput = {
  /** Author reference */
  authorReference?: InputMaybe<ReferenceInput>;
  /** Author string */
  authorString?: InputMaybe<Scalars['String']['input']>;
  /** Id */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Text */
  text: Scalars['String']['input'];
  /** Time */
  time?: InputMaybe<Scalars['String']['input']>;
};

export enum AppUpdateStatus {
  FORCE_UPDATE = 'FORCE_UPDATE',
  NONE = 'NONE',
  SOFT_UPDATE = 'SOFT_UPDATE'
}

export enum AppVersionApp {
  dha = 'dha',
  medly = 'medly',
  scan_app = 'scan_app'
}

export type AppVersionModel = {
  __typename?: 'AppVersionModel';
  /** Application this version belongs to */
  app: AppVersionApp;
  /** Unique identifier of the app version record */
  app_version_id: Scalars['String']['output'];
  /** Timestamp when the record was created */
  created_at: Scalars['DateTime']['output'];
  /** Whether this is the minimum supported version */
  is_minimum_version: Scalars['Boolean']['output'];
  /** Platform this version targets */
  platform: AppVersionPlatform;
  /** Scheduled release date of the version */
  release_date?: Maybe<Scalars['DateTime']['output']>;
  /** Release notes for this version */
  release_notes?: Maybe<Scalars['String']['output']>;
  /** Timestamp when the version was published */
  released_at?: Maybe<Scalars['DateTime']['output']>;
  /** Publication status of the version */
  status: AppVersionStatus;
  /** Timestamp when the record was last updated */
  updated_at: Scalars['DateTime']['output'];
  /** Semantic version string of the app */
  version_number: Scalars['String']['output'];
  /** Monotonic ordering sequence for the version */
  version_sequence: Scalars['Int']['output'];
};

export enum AppVersionPlatform {
  android = 'android',
  ios = 'ios'
}

export enum AppVersionStatus {
  deprecated = 'deprecated',
  draft = 'draft',
  published = 'published'
}

export type AppVersionSummaryModel = {
  __typename?: 'AppVersionSummaryModel';
  /** Application being summarized */
  app: AppVersionApp;
  /** Identifier of the current draft version */
  draft_id?: Maybe<Scalars['String']['output']>;
  /** Whether the current draft is the minimum supported version */
  draft_is_minimum_version?: Maybe<Scalars['Boolean']['output']>;
  /** Release date of the current draft */
  draft_release_date?: Maybe<Scalars['DateTime']['output']>;
  /** Release notes of the current draft */
  draft_release_notes?: Maybe<Scalars['String']['output']>;
  /** Version number of the current draft */
  draft_version?: Maybe<Scalars['String']['output']>;
  /** Whether an unpublished draft exists */
  has_draft: Scalars['Boolean']['output'];
  /** Whether the latest published version is the minimum supported */
  latest_is_minimum_version?: Maybe<Scalars['Boolean']['output']>;
  /** Timestamp of the latest published version */
  latest_published_at?: Maybe<Scalars['DateTime']['output']>;
  /** Latest published version number */
  latest_published_version?: Maybe<Scalars['String']['output']>;
  /** Release date of the latest published version */
  latest_release_date?: Maybe<Scalars['DateTime']['output']>;
  /** Release notes of the latest published version */
  latest_release_notes?: Maybe<Scalars['String']['output']>;
  /** Current minimum supported version number */
  minimum_version?: Maybe<Scalars['String']['output']>;
  /** Platform being summarized */
  platform: AppVersionPlatform;
};

export type AppointmentFilterInput = {
  /** Filter appointments by service type */
  serviceType?: InputMaybe<Scalars['String']['input']>;
};

/** AppointmentModel */
export type AppointmentModel = {
  __typename?: 'AppointmentModel';
  /** Style of appointment booked in the slot */
  appointmentType?: Maybe<CodeableConceptAppointmentType>;
  associatedResources?: Maybe<Array<ResourceAssociationUnion>>;
  attachments?: Maybe<Array<Attachment>>;
  /** Requests this appointment is allocated to assess */
  basedOn?: Maybe<Array<Reference>>;
  /** Coded reason the appointment was cancelled */
  cancelationReason?: Maybe<CodeableConcept>;
  /** Additional comments about the appointment */
  comment?: Maybe<Scalars['String']['output']>;
  /** Contained */
  contained?: Maybe<Array<Resource>>;
  /** Date the appointment was initially created */
  created?: Maybe<Scalars['String']['output']>;
  /** Curation metadata for this appointment resource */
  curationMeta?: Maybe<CurationMeta>;
  /** Subject line shown in meeting request or appointment list */
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  /** When the appointment is to conclude */
  end?: Maybe<Scalars['String']['output']>;
  /** Extension */
  extension?: Maybe<Array<Extension>>;
  /** Logical id of this artifact */
  id?: Maybe<Scalars['String']['output']>;
  /** External identifiers for this appointment */
  identifier?: Maybe<Array<Identifier>>;
  /** A set of rules under which this content was created */
  implicitRules?: Maybe<Scalars['String']['output']>;
  /** Language of the resource content */
  language?: Maybe<Scalars['String']['output']>;
  /** Resolves the Location resources referenced by the appointment */
  locationResource?: Maybe<Array<LocationModel>>;
  /** Metadata about the resource */
  meta?: Maybe<Meta>;
  /** Estimated duration in minutes, may differ from start/end */
  minutesDuration?: Maybe<Scalars['Float']['output']>;
  /** Participants involved in the appointment */
  participant: Array<Participant>;
  /** Detailed instructions for the patient */
  patientInstruction?: Maybe<Scalars['String']['output']>;
  /** Resolves the Practitioner resources participating in the appointment */
  practitionerResource?: Maybe<Array<PractitionerModel>>;
  /** Priority used to re-prioritize the appointment */
  priority?: Maybe<Scalars['Float']['output']>;
  /** Coded reasons this appointment is scheduled */
  reasonCode?: Maybe<Array<CodeableConcept>>;
  /** References to reasons this appointment is scheduled */
  reasonReference?: Maybe<Array<Reference>>;
  /** Requested date/time intervals to allocate the appointment */
  requestedPeriod?: Maybe<Array<Period>>;
  /** FHIR resource type, always Appointment */
  resourceType?: Maybe<Scalars['String']['output']>;
  /** Broad categorization of the service performed */
  serviceCategory?: Maybe<Array<CodeableConcept>>;
  /** Specific service to be performed during the appointment */
  serviceType?: Maybe<Array<CodeableConcept>>;
  /** Slots that this appointment is filling */
  slot?: Maybe<Array<Reference>>;
  /** Practitioner specialty required for the service */
  specialty?: Maybe<Array<CodeableConcept>>;
  /** When the appointment is to take place */
  start?: Maybe<Scalars['String']['output']>;
  /** Appointment status, e.g. proposed, booked, cancelled, noshow */
  status: Scalars['String']['output'];
  /** Patient or group associated with the appointment */
  subject?: Maybe<Reference>;
  /** Additional information supporting the appointment */
  supportingInformation?: Maybe<Array<Reference>>;
  /** Text */
  text?: Maybe<Narrative>;
};

export type AppointmentModelInput = {
  /** Style of appointment booked in the slot */
  appointmentType?: InputMaybe<CodeableConceptAppointmentTypeInput>;
  /** Requests this appointment is allocated to assess */
  basedOn?: InputMaybe<Array<ReferenceInput>>;
  /** Coded reason the appointment was cancelled */
  cancelationReason?: InputMaybe<CodeableConceptInput>;
  /** Additional comments about the appointment */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Contained */
  contained?: InputMaybe<Array<ResourceInput>>;
  /** Date the appointment was initially created */
  created?: InputMaybe<Scalars['String']['input']>;
  /** Subject line shown in meeting request or appointment list */
  description?: InputMaybe<Scalars['String']['input']>;
  /** When the appointment is to conclude */
  end?: InputMaybe<Scalars['String']['input']>;
  /** Extension */
  extension?: InputMaybe<Array<ExtensionInput>>;
  /** Logical id of this artifact */
  id?: InputMaybe<Scalars['String']['input']>;
  /** External identifiers for this appointment */
  identifier?: InputMaybe<Array<IdentifierInput>>;
  /** A set of rules under which this content was created */
  implicitRules?: InputMaybe<Scalars['String']['input']>;
  /** Language of the resource content */
  language?: InputMaybe<Scalars['String']['input']>;
  /** Metadata about the resource */
  meta?: InputMaybe<MetaInput>;
  /** Estimated duration in minutes, may differ from start/end */
  minutesDuration?: InputMaybe<Scalars['Float']['input']>;
  /** Participants involved in the appointment */
  participant: Array<ParticipantInput>;
  /** Detailed instructions for the patient */
  patientInstruction?: InputMaybe<Scalars['String']['input']>;
  /** Priority used to re-prioritize the appointment */
  priority?: InputMaybe<Scalars['Float']['input']>;
  /** Coded reasons this appointment is scheduled */
  reasonCode?: InputMaybe<Array<CodeableConceptInput>>;
  /** References to reasons this appointment is scheduled */
  reasonReference?: InputMaybe<Array<ReferenceInput>>;
  /** Requested date/time intervals to allocate the appointment */
  requestedPeriod?: InputMaybe<Array<PeriodInput>>;
  /** FHIR resource type, always Appointment */
  resourceType?: InputMaybe<Scalars['String']['input']>;
  /** Broad categorization of the service performed */
  serviceCategory?: InputMaybe<Array<CodeableConceptInput>>;
  /** Specific service to be performed during the appointment */
  serviceType?: InputMaybe<Array<CodeableConceptInput>>;
  /** Slots that this appointment is filling */
  slot?: InputMaybe<Array<ReferenceInput>>;
  /** Practitioner specialty required for the service */
  specialty?: InputMaybe<Array<CodeableConceptInput>>;
  /** When the appointment is to take place */
  start?: InputMaybe<Scalars['String']['input']>;
  /** Appointment status, e.g. proposed, booked, cancelled, noshow */
  status: StatusCode;
  /** Patient or group associated with the appointment */
  subject?: InputMaybe<ReferenceInput>;
  /** Additional information supporting the appointment */
  supportingInformation?: InputMaybe<Array<ReferenceInput>>;
  /** Text */
  text?: InputMaybe<NarrativeInput>;
};

export type AssessmentCredentials = {
  __typename?: 'AssessmentCredentials';
  /** QR code data used to initiate the assessment. */
  qr_code: Scalars['String']['output'];
  /** Token used to authenticate the assessment. */
  token: Scalars['String']['output'];
};

export type AssessmentModel = {
  __typename?: 'AssessmentModel';
  /** Unique identifier for the assessment. */
  assessment_id: Scalars['String']['output'];
  /** Timestamp when the assessment was completed. */
  completed_at?: Maybe<Scalars['DateTime']['output']>;
  /** Timestamp when the assessment was created. */
  created_at?: Maybe<Scalars['DateTime']['output']>;
  /** Resolves the linked FHIR RiskAssessment for the assessment */
  risk_assessment?: Maybe<RiskAssessmentModel>;
  /** Identifier of the associated FHIR RiskAssessment resource. */
  risk_assessment_id?: Maybe<Scalars['String']['output']>;
  /** Type of the assessment. */
  type?: Maybe<AssessmentType>;
  /** Timestamp when the assessment was last updated. */
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  /** Unique identifier for the patient. */
  vitall_patient_id: Scalars['String']['output'];
};

export enum AssessmentType {
  AHA = 'AHA',
  BHA = 'BHA'
}

export type AssignPatientPlansInput = {
  account_id: Scalars['String']['input'];
  assignments: Array<PlanAssignmentInput>;
};

export type Attachment = {
  __typename?: 'Attachment';
  /** Mime type of the content with charset etc. */
  contentType?: Maybe<Scalars['String']['output']>;
  /** Date attachment was first created */
  creation?: Maybe<Scalars['String']['output']>;
  /** Data inline base64ed */
  data?: Maybe<Scalars['String']['output']>;
  /** Extension */
  extension?: Maybe<Array<Extension>>;
  /** Hash of the data (sha-1 base64ed) */
  hash?: Maybe<Scalars['String']['output']>;
  /** ID of the resource */
  id?: Maybe<Scalars['String']['output']>;
  /** Human language of the content (BCP-47) */
  language?: Maybe<Scalars['String']['output']>;
  /** Number of bytes of content (if url provided) */
  size?: Maybe<Scalars['Float']['output']>;
  /** Label to display in place of the data */
  title?: Maybe<Scalars['String']['output']>;
  /** Uri where the data can be found */
  url?: Maybe<Scalars['String']['output']>;
};

export type AttachmentInput = {
  /** Mime type of the content with charset etc. */
  contentType?: InputMaybe<Scalars['String']['input']>;
  /** Date attachment was first created */
  creation?: InputMaybe<Scalars['String']['input']>;
  /** Data inline base64ed */
  data?: InputMaybe<Scalars['String']['input']>;
  /** Extension */
  extension?: InputMaybe<Array<ExtensionInput>>;
  /** Hash of the data (sha-1 base64ed) */
  hash?: InputMaybe<Scalars['String']['input']>;
  /** ID of the resource */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Human language of the content (BCP-47) */
  language?: InputMaybe<Scalars['String']['input']>;
  /** Number of bytes of content (if url provided) */
  size?: InputMaybe<Scalars['Float']['input']>;
  /** Label to display in place of the data */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Uri where the data can be found */
  url?: InputMaybe<Scalars['String']['input']>;
};

export type AuditLogFilterInput = {
  /** End of the date range to filter audit logs */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter audit logs by event types */
  eventTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Restrict results to user-triggered events only */
  onlyUsers?: InputMaybe<Scalars['Boolean']['input']>;
  /** Start of the date range to filter audit logs */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter audit logs by user identifiers */
  userIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter audit logs by Vitall patient identifier */
  vitall_patient_id?: InputMaybe<Scalars['String']['input']>;
};

export type AuditLogInput = {
  /** Number of records to return per page */
  count?: InputMaybe<Scalars['Int']['input']>;
  /** Filter criteria for querying audit logs */
  filters: AuditLogFilterInput;
  /** Page number to retrieve */
  page?: InputMaybe<Scalars['Int']['input']>;
};

/** AuditLogModel */
export type AuditLogModel = {
  __typename?: 'AuditLogModel';
  /** Timestamp when the audit event was created */
  created_at: Scalars['DateTime']['output'];
  /** Additional details describing the audit event */
  event_details?: Maybe<Scalars['String']['output']>;
  /** Unique identifier of the audit log event */
  event_id: Scalars['String']['output'];
  /** FHIR resource affected by the audit event */
  event_resource?: Maybe<Scalars['String']['output']>;
  /** Type of action recorded by the audit event */
  event_type: Scalars['String']['output'];
  /** User associated with the audit event, if any */
  user?: Maybe<AuditLogUserModel>;
  /** Vitall patient identifier the event relates to */
  vitall_patient_id?: Maybe<Scalars['String']['output']>;
};

export type AuditLogUserModel = {
  __typename?: 'AuditLogUserModel';
  /** First name of the user who triggered the audit event */
  first_name: Scalars['String']['output'];
  /** Last name of the user who triggered the audit event */
  last_name: Scalars['String']['output'];
  /** Unique identifier of the user who triggered the audit event */
  user_id: Scalars['String']['output'];
};

export type AuditLogsResponse = {
  __typename?: 'AuditLogsResponse';
  /** Page of audit log entries */
  data: Array<AuditLogModel>;
  /** Total number of matching audit log entries */
  total: Scalars['Float']['output'];
};

export type AuthChallenge = {
  __typename?: 'AuthChallenge';
  /** Challenge name */
  name: Scalars['String']['output'];
  /** Challenge parameters */
  parameters?: Maybe<Scalars['JSON']['output']>;
};

export type AuthModel = {
  __typename?: 'AuthModel';
  /** JWT access token */
  access?: Maybe<Scalars['String']['output']>;
  /** Pending authentication challenge, if any */
  challenge?: Maybe<AuthChallenge>;
  /** Authenticated user identifier */
  id?: Maybe<Scalars['String']['output']>;
  /** Authenticated user profile */
  user?: Maybe<UserModel>;
  /** Whether the login succeeded */
  valid?: Maybe<Scalars['Boolean']['output']>;
};

/** AvailableTime */
export type AvailableTime = {
  __typename?: 'AvailableTime';
  /** Always available? e.g. 24 hour service */
  allDay?: Maybe<Scalars['Boolean']['output']>;
  /** Closing time of day (ignored if allDay = true) */
  availableEndTime?: Maybe<Scalars['String']['output']>;
  /** Opening time of day (ignored if allDay = true) */
  availableStartTime?: Maybe<Scalars['String']['output']>;
  /** mon | tue | wed | thu | fri | sat | sun */
  daysOfWeek?: Maybe<Array<Scalars['String']['output']>>;
};

export type AvatarUploadInput = {
  /** Avatar image file metadata */
  file: FileInput;
  /** ID of the user whose avatar is being uploaded */
  user_id: Scalars['String']['input'];
};

export type BaseTitrationMedicationInput = {
  /** Current medication details (strength, quantity, frequency) */
  current: TitrationStepInput;
  /** Date that the medication is to be started on */
  date_started?: InputMaybe<Scalars['DateTime']['input']>;
  /** Clinical decision applied to this medication */
  decision?: InputMaybe<TitrationDecision>;
  /** Reasons supporting the titration decision */
  decision_reasons?: InputMaybe<Array<TitrationDecisionReason>>;
  /** Drug class targeted by this titration medication */
  drug_class: TitrationDrugClass;
  /** Coded medication being titrated */
  medication_codeable_concept: CodeableConceptInput;
  /** Free-text rationale for the titration */
  reason_for_titration?: InputMaybe<Scalars['String']['input']>;
  /** Source MedicationStatement id this titration derives from */
  source_medication_statement_id?: InputMaybe<Scalars['String']['input']>;
  /** Target medication details (strength, quantity, frequency) */
  target: TitrationStepInput;
};

export type BeginShareAuthInput = {
  /** Recipient email beginning share authentication */
  email: Scalars['String']['input'];
  /** Identifier of the share to authenticate against */
  share_id: Scalars['String']['input'];
};

export type BeginShareAuthResponse = {
  __typename?: 'BeginShareAuthResponse';
  /** Whether the auth challenge was sent successfully */
  success: Scalars['Boolean']['output'];
};

export type BroadcastChatAnnouncementInput = {
  /** Org account ID whose chat rooms receive the announcement. */
  account_id?: InputMaybe<Scalars['String']['input']>;
  /** Specific chat room IDs to broadcast the announcement to. */
  chat_room_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Announcement text to broadcast to the targeted chat rooms. */
  message: Scalars['String']['input'];
  /** Display name shown as the sender of the announcement. */
  sender_name?: InputMaybe<Scalars['String']['input']>;
};

/** BroadcastChatAnnouncementResult */
export type BroadcastChatAnnouncementResult = {
  __typename?: 'BroadcastChatAnnouncementResult';
  /** Number of chat rooms the announcement could not be sent to (they were not notified). */
  failed: Scalars['Int']['output'];
  /** Number of chat rooms the announcement was successfully queued for broadcasting to. */
  queued: Scalars['Int']['output'];
  /** Total number of chat rooms the announcement targeted. */
  total: Scalars['Int']['output'];
};

/** CarePlanActivityModel */
export type CarePlanActivityModel = {
  __typename?: 'CarePlanActivityModel';
  /** Coded results of the activity */
  outcomeCodeableConcept?: Maybe<Array<CodeableConcept>>;
  /** References to resources produced by the activity */
  outcomeReference?: Maybe<Array<Reference>>;
  /** Comments about the activity status or progress */
  progress?: Maybe<Array<Annotation>>;
  /** Resource defining the activity details */
  reference?: Maybe<Reference>;
};

/** CarePlanModel */
export type CarePlanModel = {
  __typename?: 'CarePlanModel';
  /** Planned activities that make up the care plan */
  activity?: Maybe<Array<CarePlanActivityModel>>;
  /** Conditions this plan addresses */
  addresses?: Maybe<Array<Reference>>;
  associatedResources?: Maybe<Array<ResourceAssociationUnion>>;
  attachments?: Maybe<Array<Attachment>>;
  /** Designated responsible party for the care plan */
  author?: Maybe<Reference>;
  /** Care plans this plan fulfills */
  basedOn?: Maybe<Array<Reference>>;
  /** Care teams involved in the plan */
  careTeam?: Maybe<Array<Reference>>;
  /** Categories classifying the type of care plan */
  category?: Maybe<Array<CodeableConcept>>;
  /** Contained */
  contained?: Maybe<Array<Resource>>;
  /** Parties who contributed to the care plan content */
  contributor?: Maybe<Array<Reference>>;
  /** Date the care plan was first recorded */
  created?: Maybe<Scalars['String']['output']>;
  /** Summary describing the nature of the plan */
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  /** Encounter during which the plan was created */
  encounter?: Maybe<Reference>;
  /** Extension */
  extension?: Maybe<Array<Extension>>;
  /** Goals this care plan aims to achieve */
  goal?: Maybe<Array<Reference>>;
  /** Logical id of this artifact */
  id?: Maybe<Scalars['String']['output']>;
  /** External identifiers for this care plan */
  identifier?: Maybe<Array<Identifier>>;
  /** A set of rules under which this content was created */
  implicitRules?: Maybe<Scalars['String']['output']>;
  /** Intent: proposal, plan, order, or option */
  intent?: Maybe<Scalars['String']['output']>;
  /** Language of the resource content */
  language?: Maybe<Scalars['String']['output']>;
  /** Metadata about the resource */
  meta?: Maybe<Meta>;
  /** Comments about the care plan */
  note?: Maybe<Array<Annotation>>;
  /** Larger care plans this plan is part of */
  partOf?: Maybe<Array<Reference>>;
  /** Time period the care plan covers */
  period?: Maybe<Period>;
  /** Care plans replaced by this care plan */
  replaces?: Maybe<Array<Reference>>;
  /** FHIR resource type, always CarePlan */
  resourceType?: Maybe<Scalars['String']['output']>;
  /** Lifecycle status of the care plan */
  status: CarePlanStatus;
  /** Patient or group the care plan is for */
  subject: Reference;
  /** Supporting information considered part of the plan */
  supportingInfo?: Maybe<Array<Reference>>;
  /** Text */
  text?: Maybe<Narrative>;
  /** Human-friendly name for the care plan */
  title?: Maybe<Scalars['String']['output']>;
};

export enum CarePlanStatus {
  active = 'active',
  completed = 'completed',
  draft = 'draft',
  enteredInError = 'enteredInError',
  onHold = 'onHold',
  revoked = 'revoked',
  unknown = 'unknown'
}

export enum CareTeamCategory {
  ClinicalResearch = 'ClinicalResearch',
  Condition = 'Condition',
  Encounter = 'Encounter',
  EpisodeOfCare = 'EpisodeOfCare',
  Event = 'Event',
  HomeCommunity = 'HomeCommunity',
  Longitudinal = 'Longitudinal',
  PublicHealth = 'PublicHealth'
}

/** CareTeamModel */
export type CareTeamModel = {
  __typename?: 'CareTeamModel';
  associatedResources?: Maybe<Array<ResourceAssociationUnion>>;
  attachments?: Maybe<Array<Attachment>>;
  /** Type or category of the care team */
  category?: Maybe<Array<CodeableConcept>>;
  /** Contained */
  contained?: Maybe<Array<Resource>>;
  displayName?: Maybe<Scalars['String']['output']>;
  /** Encounter the care team was created as part of */
  encounter?: Maybe<Reference>;
  /** Extension */
  extension?: Maybe<Array<Extension>>;
  /** Logical id of this artifact */
  id?: Maybe<Scalars['String']['output']>;
  /** External identifiers for this care team */
  identifier?: Maybe<Array<Identifier>>;
  /** A set of rules under which this content was created */
  implicitRules?: Maybe<Scalars['String']['output']>;
  /** Language of the resource content */
  language?: Maybe<Scalars['String']['output']>;
  /** Organizations responsible for the care team */
  managingOrganization?: Maybe<Array<Reference>>;
  /** Metadata about the resource */
  meta?: Maybe<Meta>;
  /** Human-readable name of the care team */
  name?: Maybe<Scalars['String']['output']>;
  /** Comments made about the care team */
  note?: Maybe<Array<Annotation>>;
  /** Members participating in the care team */
  participant?: Maybe<Array<CareTeamParticipant>>;
  /** Time period the care team covers */
  period?: Maybe<Period>;
  /** Coded reasons the care team exists */
  reasonCode?: Maybe<Array<CodeableConcept>>;
  /** Referenced resources explaining why the care team exists */
  reasonReference?: Maybe<Array<Reference>>;
  /** FHIR resource type, always CareTeam */
  resourceType?: Maybe<Scalars['String']['output']>;
  /** Care team status: proposed, active, suspended, or inactive */
  status?: Maybe<Scalars['String']['output']>;
  /** Patient the care team is for */
  subject?: Maybe<Reference>;
  /** Contact details applying to the whole care team */
  telecom?: Maybe<Array<ContactPoint>>;
  /** Text */
  text?: Maybe<Narrative>;
};

export type CareTeamParticipant = {
  __typename?: 'CareTeamParticipant';
  /** Reference to who is involved in the care team */
  member?: Maybe<Reference>;
  /** Organization on whose behalf the practitioner participates */
  onBehalfOf?: Maybe<Reference>;
  /** Time period the participant is part of the care team */
  period?: Maybe<Period>;
  /** Type of involvement of the participant in the care team */
  role?: Maybe<Array<CodeableConcept>>;
};

export enum CategoryCode {
  biologic = 'biologic',
  environment = 'environment',
  food = 'food',
  medication = 'medication'
}

export type ChangeEmailInput = {
  /** New email address to set */
  newEmail: Scalars['String']['input'];
};

export type ChangePasswordInput = {
  /**
   * DEPRECATED
   * @deprecated Not used. Password is changed for the logged in user.
   */
  email?: InputMaybe<Scalars['String']['input']>;
  /** New password to set */
  newPassword: Scalars['String']['input'];
  /** Current password */
  oldPassword: Scalars['String']['input'];
};

export type ChangePasswordModel = {
  __typename?: 'ChangePasswordModel';
  /** Password change confirmation message */
  message: Scalars['String']['output'];
};

export type ChangePhoneInput = {
  /** New phone number to set */
  newPhone: Scalars['String']['input'];
};

export type ChangeUserConsentInput = {
  /** Updated CASL consent */
  casl_completed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Updated privacy notice consent */
  pn_completed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Updated terms of care consent */
  toc_completed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Identifier of the user whose consent is changing */
  user_id: Scalars['String']['input'];
};

export type ChangeUserNameInput = {
  /** New first name */
  first_name: Scalars['String']['input'];
  /** New last name */
  last_name: Scalars['String']['input'];
  /** New middle name */
  middle_name?: InputMaybe<Scalars['String']['input']>;
  /** Identifier of the user whose name is changing */
  user_id: Scalars['String']['input'];
};

/** ChatConfigurationModel */
export type ChatConfigurationModel = {
  __typename?: 'ChatConfigurationModel';
  /** Base URL of the chat service. */
  base_url: Scalars['String']['output'];
  /** XMPP conference (multi-user chat) domain. */
  conference: Scalars['String']['output'];
  /** Development chat server endpoint. */
  dev_server: Scalars['String']['output'];
  /** XMPP host for the chat connection. */
  host: Scalars['String']['output'];
};

/** ChatRoomModel */
export type ChatRoomModel = {
  __typename?: 'ChatRoomModel';
  /** Description of the chat room. */
  description: Scalars['String']['output'];
  /** Unique identifier of the chat room. */
  name: Scalars['String']['output'];
  /** Human-readable title of the chat room. */
  title: Scalars['String']['output'];
};

export type CheckAppVersionInput = {
  /** Application to check the version for */
  app: AppVersionApp;
  /** Version currently running on the client */
  current_version: Scalars['String']['input'];
  /** Platform to check the version for */
  platform: AppVersionPlatform;
};

export type CheckAppVersionResult = {
  __typename?: 'CheckAppVersionResult';
  /** Application being checked */
  app: AppVersionApp;
  /** Version currently running on the client */
  current_version: Scalars['String']['output'];
  /** Timestamp of the latest published version */
  latest_published_at?: Maybe<Scalars['DateTime']['output']>;
  /** Latest available version for the client */
  latest_version?: Maybe<Scalars['String']['output']>;
  /** Minimum supported version for the client */
  minimum_version?: Maybe<Scalars['String']['output']>;
  /** Platform being checked */
  platform: AppVersionPlatform;
  /** Update requirement resulting from the version check */
  update_status: AppUpdateStatus;
};

export type CheckEhrZoneInput = {
  qie_zone_name: Scalars['String']['input'];
};

export type ClassHistory = {
  __typename?: 'ClassHistory';
  /** Encounter class during this historical period */
  class: Coding;
  /** Time the episode was in the specified class */
  period: Period;
};

export type ClassHistoryInput = {
  /** Encounter class during this historical period */
  class: CodingInput;
  /** Time the episode was in the specified class */
  period: PeriodInput;
};

export enum ClinicalStatusCode {
  active = 'active',
  inactive = 'inactive',
  resolved = 'resolved'
}

export type CodeDeliveryDetailsType = {
  __typename?: 'CodeDeliveryDetailsType';
  /** Attribute name verified with the code */
  AttributeName?: Maybe<Scalars['String']['output']>;
  /** Channel used to send the code (EMAIL or SMS) */
  DeliveryMedium?: Maybe<Scalars['String']['output']>;
  /** Email or phone destination where the code was sent */
  Destination?: Maybe<Scalars['String']['output']>;
};

export type CodeFilter = {
  __typename?: 'CodeFilter';
  /** Code */
  code?: Maybe<Array<Coding>>;
  /** Path */
  path?: Maybe<Scalars['String']['output']>;
  /** Search param */
  searchParam?: Maybe<Scalars['String']['output']>;
  /** Value set */
  valueSet?: Maybe<Scalars['String']['output']>;
};

export type CodeFilterInput = {
  /** Code */
  code?: InputMaybe<Array<CodingInput>>;
  /** Path */
  path?: InputMaybe<Scalars['String']['input']>;
  /** Search param */
  searchParam?: InputMaybe<Scalars['String']['input']>;
  /** Value set */
  valueSet?: InputMaybe<Scalars['String']['input']>;
};

export type CodeableConcept = {
  __typename?: 'CodeableConcept';
  /** Code defined by a terminology system */
  coding?: Maybe<Array<Coding>>;
  /** Plain text representation of the concept */
  text?: Maybe<Scalars['String']['output']>;
};

export type CodeableConceptAppointmentType = {
  __typename?: 'CodeableConceptAppointmentType';
  /** Codes defined by a terminology system */
  coding?: Maybe<Array<CodingAppointmentType>>;
  /** Plain text representation of the concept */
  text?: Maybe<Scalars['String']['output']>;
};

export type CodeableConceptAppointmentTypeInput = {
  /** Codes defined by a terminology system */
  coding?: InputMaybe<Array<CodingAppointmentTypeInput>>;
  /** Plain text representation of the concept */
  text?: InputMaybe<Scalars['String']['input']>;
};

export type CodeableConceptClinicalStatus = {
  __typename?: 'CodeableConceptClinicalStatus';
  /** Clinical status codings defined by a terminology system */
  coding?: Maybe<Array<CodingClinicalStatus>>;
  /** Plain text representation of the clinical status concept */
  text?: Maybe<Scalars['String']['output']>;
};

export type CodeableConceptClinicalStatusInput = {
  /** Clinical status codings defined by a terminology system */
  coding?: InputMaybe<Array<CodingClinicalStatusInput>>;
  /** Plain text representation of the clinical status concept */
  text?: InputMaybe<Scalars['String']['input']>;
};

export type CodeableConceptConditionClinicalStatus = {
  __typename?: 'CodeableConceptConditionClinicalStatus';
  /** Condition clinical status codings from a terminology system */
  coding?: Maybe<Array<CodingConditionClinicalStatus>>;
  /** Plain text representation of the clinical status concept */
  text?: Maybe<Scalars['String']['output']>;
};

export type CodeableConceptConditionClinicalStatusInput = {
  /** Condition clinical status codings from a terminology system */
  coding?: InputMaybe<Array<CodingConditionClinicalStatusInput>>;
  /** Plain text representation of the clinical status concept */
  text?: InputMaybe<Scalars['String']['input']>;
};

export type CodeableConceptConditionVerificationStatus = {
  __typename?: 'CodeableConceptConditionVerificationStatus';
  /** Condition verification status codings from a terminology system */
  coding?: Maybe<Array<CodingConditionVerificationStatus>>;
  /** Plain text representation of the verification status concept */
  text?: Maybe<Scalars['String']['output']>;
};

export type CodeableConceptConditionVerificationStatusInput = {
  /** Condition verification status codings from a terminology system */
  coding?: InputMaybe<Array<CodingConditionVerificationStatusInput>>;
  /** Plain text representation of the verification status concept */
  text?: InputMaybe<Scalars['String']['input']>;
};

export type CodeableConceptInput = {
  /** Code defined by a terminology system */
  coding?: InputMaybe<Array<CodingInput>>;
  /** Plain text representation of the concept */
  text?: InputMaybe<Scalars['String']['input']>;
};

export type CodeableConceptParticipantType = {
  __typename?: 'CodeableConceptParticipantType';
  /** Code defined by a terminology system */
  coding?: Maybe<Array<CodingParticipantType>>;
  /** Plain text representation of the concept */
  text?: Maybe<Scalars['String']['output']>;
};

export type CodeableConceptParticipantTypeInput = {
  /** Code defined by a terminology system */
  coding?: InputMaybe<Array<CodingParticipantTypeInput>>;
  /** Plain text representation of the concept */
  text?: InputMaybe<Scalars['String']['input']>;
};

export type CodeableConceptVerificationStatus = {
  __typename?: 'CodeableConceptVerificationStatus';
  /** Verification status codings defined by a terminology system */
  coding?: Maybe<Array<CodingVerificationStatus>>;
  /** Plain text representation of the verification status concept */
  text?: Maybe<Scalars['String']['output']>;
};

export type CodeableConceptVerificationStatusInput = {
  /** Verification status codings defined by a terminology system */
  coding?: InputMaybe<Array<CodingVerificationStatusInput>>;
  /** Plain text representation of the verification status concept */
  text?: InputMaybe<Scalars['String']['input']>;
};

export type CodeableReference = {
  __typename?: 'CodeableReference';
  /** Concept */
  concept?: Maybe<CodeableConcept>;
  /** Reference */
  reference?: Maybe<Reference>;
};

export type CodeableReferenceInput = {
  /** Concept */
  concept?: InputMaybe<CodeableConceptInput>;
  /** Reference */
  reference?: InputMaybe<ReferenceInput>;
};

export type Coding = {
  __typename?: 'Coding';
  /** Symbol in syntax defined by the system */
  code?: Maybe<Scalars['String']['output']>;
  /** Representation defined by the system */
  display?: Maybe<Scalars['String']['output']>;
  /** Identity of the terminology system */
  system?: Maybe<Scalars['String']['output']>;
  /** If this coding was chosen directly by the user */
  userSelected?: Maybe<Scalars['Boolean']['output']>;
  /** Version of the system - if relevant */
  version?: Maybe<Scalars['String']['output']>;
};

export type CodingAppointmentType = {
  __typename?: 'CodingAppointmentType';
  /** Symbol in syntax defined by the terminology system */
  code: Scalars['String']['output'];
  /** Human-readable representation defined by the system */
  display?: Maybe<Scalars['String']['output']>;
  /** Identity of the terminology system */
  system: Scalars['String']['output'];
  /** Whether this coding was chosen directly by the user */
  userSelected?: Maybe<Scalars['Boolean']['output']>;
  /** Version of the terminology system, if relevant */
  version?: Maybe<Scalars['String']['output']>;
};

export type CodingAppointmentTypeInput = {
  /** Symbol in syntax defined by the terminology system */
  code: Scalars['String']['input'];
  /** Human-readable representation defined by the system */
  display?: InputMaybe<Scalars['String']['input']>;
  /** Identity of the terminology system */
  system: Scalars['String']['input'];
  /** Whether this coding was chosen directly by the user */
  userSelected?: InputMaybe<Scalars['Boolean']['input']>;
  /** Version of the terminology system, if relevant */
  version?: InputMaybe<Scalars['String']['input']>;
};

export type CodingClinicalStatus = {
  __typename?: 'CodingClinicalStatus';
  /** Clinical status code symbol defined by the system */
  code: ClinicalStatusCode;
  /** Human-readable representation of the clinical status code */
  display?: Maybe<Scalars['String']['output']>;
  /** Identity of the clinical status terminology system */
  system: Scalars['String']['output'];
  /** Whether this coding was chosen directly by the user */
  userSelected?: Maybe<Scalars['Boolean']['output']>;
  /** Version of the terminology system, if relevant */
  version?: Maybe<Scalars['String']['output']>;
};

export type CodingClinicalStatusInput = {
  /** Clinical status code symbol defined by the system */
  code: ClinicalStatusCode;
  /** Human-readable representation of the clinical status code */
  display?: InputMaybe<Scalars['String']['input']>;
  /** Identity of the clinical status terminology system */
  system: Scalars['String']['input'];
  /** Whether this coding was chosen directly by the user */
  userSelected?: InputMaybe<Scalars['Boolean']['input']>;
  /** Version of the terminology system, if relevant */
  version?: InputMaybe<Scalars['String']['input']>;
};

export type CodingConditionClinicalStatus = {
  __typename?: 'CodingConditionClinicalStatus';
  /** Clinical status code from the terminology system */
  code: ConditionClinicalStatusCode;
  /** Human-readable display for the clinical status code */
  display?: Maybe<Scalars['String']['output']>;
  /** Identity of the terminology system */
  system: Scalars['String']['output'];
  /** Whether the user directly chose this coding */
  userSelected?: Maybe<Scalars['Boolean']['output']>;
  /** Version of the terminology system, if relevant */
  version?: Maybe<Scalars['String']['output']>;
};

export type CodingConditionClinicalStatusInput = {
  /** Clinical status code from the terminology system */
  code: ConditionClinicalStatusCode;
  /** Human-readable display for the clinical status code */
  display?: InputMaybe<Scalars['String']['input']>;
  /** Identity of the terminology system */
  system: Scalars['String']['input'];
  /** Whether the user directly chose this coding */
  userSelected?: InputMaybe<Scalars['Boolean']['input']>;
  /** Version of the terminology system, if relevant */
  version?: InputMaybe<Scalars['String']['input']>;
};

export type CodingConditionVerificationStatus = {
  __typename?: 'CodingConditionVerificationStatus';
  /** Verification status code from the terminology system */
  code: ConditionVerificationStatusCode;
  /** Human-readable display for the verification status code */
  display?: Maybe<Scalars['String']['output']>;
  /** Identity of the terminology system */
  system: Scalars['String']['output'];
  /** Whether the user directly chose this coding */
  userSelected?: Maybe<Scalars['Boolean']['output']>;
  /** Version of the terminology system, if relevant */
  version?: Maybe<Scalars['String']['output']>;
};

export type CodingConditionVerificationStatusInput = {
  /** Verification status code from the terminology system */
  code: ConditionVerificationStatusCode;
  /** Human-readable display for the verification status code */
  display?: InputMaybe<Scalars['String']['input']>;
  /** Identity of the terminology system */
  system: Scalars['String']['input'];
  /** Whether the user directly chose this coding */
  userSelected?: InputMaybe<Scalars['Boolean']['input']>;
  /** Version of the terminology system, if relevant */
  version?: InputMaybe<Scalars['String']['input']>;
};

export type CodingInput = {
  /** Symbol in syntax defined by the system */
  code?: InputMaybe<Scalars['String']['input']>;
  /** Representation defined by the system */
  display?: InputMaybe<Scalars['String']['input']>;
  /** Identity of the terminology system */
  system?: InputMaybe<Scalars['String']['input']>;
  /** If this coding was chosen directly by the user */
  userSelected?: InputMaybe<Scalars['Boolean']['input']>;
  /** Version of the system - if relevant */
  version?: InputMaybe<Scalars['String']['input']>;
};

export type CodingParticipantType = {
  __typename?: 'CodingParticipantType';
  /** Symbol in syntax defined by the system */
  code: ParticipantTypeCode;
  /** Representation defined by the system */
  display?: Maybe<Scalars['String']['output']>;
  /** Identity of the terminology system */
  system: Scalars['String']['output'];
  /** If this coding was chosen directly by the user */
  userSelected?: Maybe<Scalars['Boolean']['output']>;
  /** Version of the system - if relevant */
  version?: Maybe<Scalars['String']['output']>;
};

export type CodingParticipantTypeInput = {
  /** Symbol in syntax defined by the system */
  code: ParticipantTypeCode;
  /** Representation defined by the system */
  display?: InputMaybe<Scalars['String']['input']>;
  /** Identity of the terminology system */
  system: Scalars['String']['input'];
  /** If this coding was chosen directly by the user */
  userSelected?: InputMaybe<Scalars['Boolean']['input']>;
  /** Version of the system - if relevant */
  version?: InputMaybe<Scalars['String']['input']>;
};

export type CodingVerificationStatus = {
  __typename?: 'CodingVerificationStatus';
  /** Verification status code symbol defined by the system */
  code: VerificationStatusCode;
  /** Human-readable representation of the verification status code */
  display?: Maybe<Scalars['String']['output']>;
  /** Identity of the verification status terminology system */
  system: Scalars['String']['output'];
  /** Whether this coding was chosen directly by the user */
  userSelected?: Maybe<Scalars['Boolean']['output']>;
  /** Version of the terminology system, if relevant */
  version?: Maybe<Scalars['String']['output']>;
};

export type CodingVerificationStatusInput = {
  /** Verification status code symbol defined by the system */
  code: VerificationStatusCode;
  /** Human-readable representation of the verification status code */
  display?: InputMaybe<Scalars['String']['input']>;
  /** Identity of the verification status terminology system */
  system: Scalars['String']['input'];
  /** Whether this coding was chosen directly by the user */
  userSelected?: InputMaybe<Scalars['Boolean']['input']>;
  /** Version of the terminology system, if relevant */
  version?: InputMaybe<Scalars['String']['input']>;
};

export type CommunicationType = {
  __typename?: 'CommunicationType';
  /** Language */
  language: CodeableConcept;
  /** Preferred */
  preferred?: Maybe<Scalars['Boolean']['output']>;
};

export type CommunicationTypeInput = {
  /** Language */
  language: CodeableConceptInput;
  /** Preferred */
  preferred?: InputMaybe<Scalars['Boolean']['input']>;
};

/** CompleteMfaResponseModel */
export type CompleteMfaResponseModel = {
  __typename?: 'CompleteMfaResponseModel';
  /** MFA operation status message */
  message: Scalars['String']['output'];
  /** User profile after completing MFA */
  user: UserModel;
};

export type CompleteShareAuthInput = {
  /** Verification code sent to the recipient */
  code: Scalars['String']['input'];
  /** Recipient email completing share authentication */
  email: Scalars['String']['input'];
  /** Identifier of the share being authenticated */
  share_id: Scalars['String']['input'];
};

export type CompleteShareAuthResponse = {
  __typename?: 'CompleteShareAuthResponse';
  /** Access token granting the recipient share access */
  token: Scalars['String']['output'];
};

export enum ConditionClinicalStatusCode {
  active = 'active',
  inactive = 'inactive',
  recurrence = 'recurrence',
  relapse = 'relapse',
  remission = 'remission',
  resolved = 'resolved'
}

/** ConditionModel */
export type ConditionModel = {
  __typename?: 'ConditionModel';
  /** Age at which the condition resolved or went into remission */
  abatementAge?: Maybe<Age>;
  /** Date-time the condition resolved or went into remission */
  abatementDateTime?: Maybe<Scalars['String']['output']>;
  /** Period during which the condition resolved or went into remission */
  abatementPeriod?: Maybe<Period>;
  /** Age range at which the condition resolved or went into remission */
  abatementRange?: Maybe<Range>;
  /** Free-text description of when the condition abated */
  abatementString?: Maybe<Scalars['String']['output']>;
  /** Practitioner, role, patient or related person who asserts this condition */
  asserter?: Maybe<Reference>;
  associatedResources?: Maybe<Array<ResourceAssociationUnion>>;
  attachments?: Maybe<Array<Attachment>>;
  /** Anatomical location of the condition, if relevant */
  bodySite?: Maybe<Array<CodeableConcept>>;
  /** Category: problem-list-item or encounter-diagnosis */
  category?: Maybe<Array<CodeableConcept>>;
  /** Clinical status: active, recurrence, relapse, inactive, remission or resolved */
  clinicalStatus?: Maybe<CodeableConceptConditionClinicalStatus>;
  /** Identification of the condition, problem or diagnosis */
  code: CodeableConcept;
  /** Contained */
  contained?: Maybe<Array<Resource>>;
  /** Curation metadata for this condition resource */
  curationMeta?: Maybe<CurationMeta>;
  displayName?: Maybe<Scalars['String']['output']>;
  /** Encounter during which the condition was created */
  encounter?: Maybe<Reference>;
  /** Supporting evidence for the condition */
  evidence?: Maybe<Array<Evidence>>;
  /** Extension */
  extension?: Maybe<Array<Extension>>;
  /** Logical id of the condition resource */
  id?: Maybe<Scalars['String']['output']>;
  /** Business identifiers for this condition */
  identifier?: Maybe<Array<Identifier>>;
  /** A set of rules under which this content was created */
  implicitRules?: Maybe<Scalars['String']['output']>;
  /** Language of the resource content */
  language?: Maybe<Scalars['String']['output']>;
  /** Metadata about the resource */
  meta?: Maybe<Meta>;
  /** Additional notes about the condition */
  note?: Maybe<Array<Annotation>>;
  /** Estimated or actual age at which the condition began */
  onsetAge?: Maybe<Age>;
  /** Estimated or actual date-time the condition began */
  onsetDateTime?: Maybe<Scalars['String']['output']>;
  /** Estimated or actual period during which the condition began */
  onsetPeriod?: Maybe<Period>;
  /** Estimated or actual age range at which the condition began */
  onsetRange?: Maybe<Range>;
  /** Free-text description of when the condition began */
  onsetString?: Maybe<Scalars['String']['output']>;
  /** Date the condition record was first recorded */
  recordedDate?: Maybe<Scalars['String']['output']>;
  /** Practitioner, role, patient or related person who recorded the condition */
  recorder?: Maybe<Reference>;
  /** FHIR resource type, always Condition */
  resourceType?: Maybe<Scalars['String']['output']>;
  /** Subjective severity of the condition */
  severity?: Maybe<CodeableConcept>;
  /** Stage or grade of the condition, usually formally assessed */
  stage?: Maybe<Array<Stage>>;
  /** Patient or group who has the condition */
  subject: Reference;
  /** Text */
  text?: Maybe<Narrative>;
  /** Verification status: unconfirmed, provisional, differential, confirmed, refuted or entered-in-error */
  verificationStatus?: Maybe<CodeableConceptConditionVerificationStatus>;
};

export type ConditionModelInput = {
  /** Age at which the condition resolved or went into remission */
  abatementAge?: InputMaybe<AgeInput>;
  /** Date-time the condition resolved or went into remission */
  abatementDateTime?: InputMaybe<Scalars['String']['input']>;
  /** Period during which the condition resolved or went into remission */
  abatementPeriod?: InputMaybe<PeriodInput>;
  /** Age range at which the condition resolved or went into remission */
  abatementRange?: InputMaybe<RangeInput>;
  /** Free-text description of when the condition abated */
  abatementString?: InputMaybe<Scalars['String']['input']>;
  /** Practitioner, role, patient or related person who asserts this condition */
  asserter?: InputMaybe<ReferenceInput>;
  /** Anatomical location of the condition, if relevant */
  bodySite?: InputMaybe<Array<CodeableConceptInput>>;
  /** Category: problem-list-item or encounter-diagnosis */
  category?: InputMaybe<Array<CodeableConceptInput>>;
  /** Clinical status: active, recurrence, relapse, inactive, remission or resolved */
  clinicalStatus?: InputMaybe<CodeableConceptConditionClinicalStatusInput>;
  /** Identification of the condition, problem or diagnosis */
  code: CodeableConceptInput;
  /** Contained */
  contained?: InputMaybe<Array<ResourceInput>>;
  /** Encounter during which the condition was created */
  encounter?: InputMaybe<ReferenceInput>;
  /** Supporting evidence for the condition */
  evidence?: InputMaybe<Array<EvidenceInput>>;
  /** Extension */
  extension?: InputMaybe<Array<ExtensionInput>>;
  /** Logical id of the condition resource */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Business identifiers for this condition */
  identifier?: InputMaybe<Array<IdentifierInput>>;
  /** A set of rules under which this content was created */
  implicitRules?: InputMaybe<Scalars['String']['input']>;
  /** Language of the resource content */
  language?: InputMaybe<Scalars['String']['input']>;
  /** Metadata about the resource */
  meta?: InputMaybe<MetaInput>;
  /** Additional notes about the condition */
  note?: InputMaybe<Array<AnnotationInput>>;
  /** Estimated or actual age at which the condition began */
  onsetAge?: InputMaybe<AgeInput>;
  /** Estimated or actual date-time the condition began */
  onsetDateTime?: InputMaybe<Scalars['String']['input']>;
  /** Estimated or actual period during which the condition began */
  onsetPeriod?: InputMaybe<PeriodInput>;
  /** Estimated or actual age range at which the condition began */
  onsetRange?: InputMaybe<RangeInput>;
  /** Free-text description of when the condition began */
  onsetString?: InputMaybe<Scalars['String']['input']>;
  /** Date the condition record was first recorded */
  recordedDate?: InputMaybe<Scalars['String']['input']>;
  /** Practitioner, role, patient or related person who recorded the condition */
  recorder?: InputMaybe<ReferenceInput>;
  /** FHIR resource type, always Condition */
  resourceType?: InputMaybe<Scalars['String']['input']>;
  /** Subjective severity of the condition */
  severity?: InputMaybe<CodeableConceptInput>;
  /** Stage or grade of the condition, usually formally assessed */
  stage?: InputMaybe<Array<StageInput>>;
  /** Patient or group who has the condition */
  subject: ReferenceInput;
  /** Text */
  text?: InputMaybe<NarrativeInput>;
  /** Verification status: unconfirmed, provisional, differential, confirmed, refuted or entered-in-error */
  verificationStatus?: InputMaybe<CodeableConceptConditionVerificationStatusInput>;
};

export enum ConditionVerificationStatusCode {
  confirmed = 'confirmed',
  differential = 'differential',
  enteredInError = 'enteredInError',
  provisional = 'provisional',
  refuted = 'refuted',
  unconfirmed = 'unconfirmed'
}

export type ConfirmPasswordInput = {
  /** Email address of the account resetting its password */
  email: Scalars['String']['input'];
  /** New password to set */
  newPassword: Scalars['String']['input'];
  /** Password reset verification code */
  verificationCode: Scalars['String']['input'];
};

export type ConsentActor = {
  __typename?: 'ConsentActor';
  /** Reference to the resource acting as the actor */
  performer: Reference;
  /** How the actor is involved in the consent */
  role: CodeableConcept;
};

export type ConsentActorInput = {
  /** Reference to the resource acting as the actor */
  performer: ReferenceInput;
  /** How the actor is involved in the consent */
  role: CodeableConceptInput;
};

export type ConsentData = {
  __typename?: 'ConsentData';
  /** How the referenced data relates: instance, related, dependents, or authoredby */
  meaning: ConsentDataCode;
  /** Reference to the actual data covered by this consent */
  reference: Reference;
};

export enum ConsentDataCode {
  authoredby = 'authoredby',
  dependents = 'dependents',
  instance = 'instance',
  related = 'related'
}

export type ConsentDataInput = {
  /** How the referenced data relates: instance, related, dependents, or authoredby */
  meaning: ConsentDataCode;
  /** Reference to the actual data covered by this consent */
  reference: ReferenceInput;
};

/** ConsentModel */
export type ConsentModel = {
  __typename?: 'ConsentModel';
  associatedResources?: Maybe<Array<ResourceAssociationUnion>>;
  attachments?: Maybe<Array<Attachment>>;
  /** Classification of the consent statement for indexing and retrieval */
  category: Array<CodeableConcept>;
  /** Contained */
  contained?: Maybe<Array<Resource>>;
  /** Curation metadata for this consent resource */
  curationMeta?: Maybe<CurationMeta>;
  /** When this consent was created or indexed */
  dateTime?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  /** Extension */
  extension?: Maybe<Array<Extension>>;
  /** Logical id of this consent resource */
  id?: Maybe<Scalars['String']['output']>;
  /** External identifiers for this consent record */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /** A set of rules under which this content was created */
  implicitRules?: Maybe<Scalars['String']['output']>;
  /** Language of the resource content */
  language?: Maybe<Scalars['String']['output']>;
  /** Metadata about the resource */
  meta?: Maybe<Meta>;
  /** Organizations acting as custodian of the consent */
  organization?: Maybe<Array<Reference>>;
  /** Patient the consent applies to */
  patient?: Maybe<Reference>;
  /** Who is agreeing to the policy and rules */
  performer?: Maybe<Reference>;
  /** Policies covered by this consent */
  policy?: Maybe<Array<ConsentPolicy>>;
  /** Regulation that this consent adheres to */
  policyRule?: Maybe<CodeableConcept>;
  /** Constraints to the base consent decision */
  provision?: Maybe<ConsentProvision>;
  /** FHIR resource type, always "Consent" */
  resourceType?: Maybe<Scalars['String']['output']>;
  /** Which of the four areas this consent covers */
  scope: CodeableConcept;
  /** Attachment source from which this consent is taken */
  sourceAttachment?: Maybe<Attachment>;
  /** Reference source from which this consent is taken */
  sourceReference?: Maybe<Reference>;
  /** Consent lifecycle status: draft, proposed, active, rejected, inactive, or entered-in-error */
  status: ConsentStatus;
  /** Text */
  text?: Maybe<Narrative>;
  /** Consent verification by patient or family */
  verification?: Maybe<Array<Verification>>;
};

export type ConsentModelInput = {
  /** Classification of the consent statement for indexing and retrieval */
  category: Array<CodeableConceptInput>;
  /** Contained */
  contained?: InputMaybe<Array<ResourceInput>>;
  /** When this consent was created or indexed */
  dateTime?: InputMaybe<Scalars['String']['input']>;
  /** Extension */
  extension?: InputMaybe<Array<ExtensionInput>>;
  /** Logical id of this consent resource */
  id?: InputMaybe<Scalars['String']['input']>;
  /** External identifiers for this consent record */
  identifier?: InputMaybe<Array<InputMaybe<IdentifierInput>>>;
  /** A set of rules under which this content was created */
  implicitRules?: InputMaybe<Scalars['String']['input']>;
  /** Language of the resource content */
  language?: InputMaybe<Scalars['String']['input']>;
  /** Metadata about the resource */
  meta?: InputMaybe<MetaInput>;
  /** Organizations acting as custodian of the consent */
  organization?: InputMaybe<Array<ReferenceInput>>;
  /** Patient the consent applies to */
  patient?: InputMaybe<ReferenceInput>;
  /** Who is agreeing to the policy and rules */
  performer?: InputMaybe<ReferenceInput>;
  /** Policies covered by this consent */
  policy?: InputMaybe<Array<ConsentPolicyInput>>;
  /** Regulation that this consent adheres to */
  policyRule?: InputMaybe<CodeableConceptInput>;
  /** Constraints to the base consent decision */
  provision?: InputMaybe<ConsentProvisionInput>;
  /** FHIR resource type, always Consent */
  resourceType?: InputMaybe<Scalars['String']['input']>;
  /** Which of the four areas this consent covers */
  scope: CodeableConceptInput;
  /** Attachment source from which this consent is taken */
  sourceAttachment?: InputMaybe<AttachmentInput>;
  /** Reference source from which this consent is taken */
  sourceReference?: InputMaybe<ReferenceInput>;
  /** Consent lifecycle status: draft, proposed, active, rejected, inactive, or entered-in-error */
  status: ConsentStatus;
  /** Text */
  text?: InputMaybe<NarrativeInput>;
  /** Consent verification by patient or family */
  verification?: InputMaybe<Array<VerificationInput>>;
};

export type ConsentPolicy = {
  __typename?: 'ConsentPolicy';
  /** Enforcement source URI for the policy */
  authority?: Maybe<Scalars['String']['output']>;
  /** URI of the specific policy covered by this consent */
  uri?: Maybe<Scalars['String']['output']>;
};

export type ConsentPolicyInput = {
  /** Enforcement source URI for the policy */
  authority?: InputMaybe<Scalars['String']['input']>;
  /** URI of the specific policy covered by this consent */
  uri?: InputMaybe<Scalars['String']['input']>;
};

export type ConsentProvision = {
  __typename?: 'ConsentProvision';
  /** Actions controlled by this rule */
  action?: Maybe<Array<CodeableConcept>>;
  /** Who or what is controlled by this rule */
  actor?: Maybe<Array<ConsentActor>>;
  /** Enforcement source URI for the provision */
  authority?: Maybe<Scalars['String']['output']>;
  /** Resource classes covered, e.g. Resource Type, Profile, or CDA */
  class?: Maybe<Array<Coding>>;
  /** Content codes covered, e.g. LOINC or SNOMED CT */
  code?: Maybe<Array<CodeableConcept>>;
  /** Data resources controlled by this rule */
  data?: Maybe<Array<ConsentData>>;
  /** Timeframe for data controlled by this rule */
  dataPeriod?: Maybe<Period>;
  /** Timeframe for which this rule is valid */
  period?: Maybe<Period>;
  /** Context of activities covered by this rule */
  purpose?: Maybe<Array<Coding>>;
  /** Security labels defining resources affected by this rule */
  securityLabel?: Maybe<Array<Coding>>;
  /** Whether the rule denies or permits access */
  type?: Maybe<ConsentProvisionCode>;
  /** URI of the specific policy covered by this provision */
  uri?: Maybe<Scalars['String']['output']>;
};

export enum ConsentProvisionCode {
  deny = 'deny',
  permit = 'permit'
}

export type ConsentProvisionInput = {
  /** Actions controlled by this rule */
  action?: InputMaybe<Array<CodeableConceptInput>>;
  /** Who or what is controlled by this rule */
  actor?: InputMaybe<Array<ConsentActorInput>>;
  /** Enforcement source URI for the provision */
  authority?: InputMaybe<Scalars['String']['input']>;
  /** Resource classes covered, e.g. Resource Type, Profile, or CDA */
  class?: InputMaybe<Array<CodingInput>>;
  /** Content codes covered, e.g. LOINC or SNOMED CT */
  code?: InputMaybe<Array<CodeableConceptInput>>;
  /** Data resources controlled by this rule */
  data?: InputMaybe<Array<ConsentDataInput>>;
  /** Timeframe for data controlled by this rule */
  dataPeriod?: InputMaybe<PeriodInput>;
  /** Timeframe for which this rule is valid */
  period?: InputMaybe<PeriodInput>;
  /** Context of activities covered by this rule */
  purpose?: InputMaybe<Array<CodingInput>>;
  /** Security labels defining resources affected by this rule */
  securityLabel?: InputMaybe<Array<CodingInput>>;
  /** Whether the rule denies or permits access */
  type?: InputMaybe<ConsentProvisionCode>;
  /** URI of the specific policy covered by this provision */
  uri?: InputMaybe<Scalars['String']['input']>;
};

export enum ConsentStatus {
  active = 'active',
  draft = 'draft',
  enteredInError = 'enteredInError',
  inactive = 'inactive',
  proposed = 'proposed',
  rejected = 'rejected'
}

export type Contact = {
  __typename?: 'Contact';
  /** Address where the related person can be contacted or visited */
  address?: Maybe<Address>;
  /** male | female | other | unknown */
  gender?: Maybe<Gender>;
  /** A name associated with the person */
  name?: Maybe<HumanName>;
  /** Period */
  period?: Maybe<Period>;
  /** Image of the person */
  photo?: Maybe<Array<Maybe<Attachment>>>;
  /** The nature of the relationship */
  relationship?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** A contact detail for the person */
  telecom?: Maybe<Array<Maybe<ContactPoint>>>;
};

export type ContactDetail = {
  __typename?: 'ContactDetail';
  /** Name */
  name?: Maybe<Scalars['String']['output']>;
  /** Telecom */
  telecom?: Maybe<Array<ContactPoint>>;
};

export type ContactDetailInput = {
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Telecom */
  telecom?: InputMaybe<Array<ContactPointInput>>;
};

export type ContactInput = {
  /** Address where the related person can be contacted or visited */
  address?: InputMaybe<AddressInput>;
  /** male | female | other | unknown */
  gender?: InputMaybe<Gender>;
  /** A name associated with the person */
  name?: InputMaybe<HumanNameInput>;
  /** Period */
  period?: InputMaybe<PeriodInput>;
  /** Image of the person */
  photo?: InputMaybe<Array<InputMaybe<AttachmentInput>>>;
  /** The nature of the relationship */
  relationship?: InputMaybe<Array<InputMaybe<CodeableConceptInput>>>;
  /** A contact detail for the person */
  telecom?: InputMaybe<Array<InputMaybe<ContactPointInput>>>;
};

/** ContactModel */
export type ContactModel = {
  __typename?: 'ContactModel';
  /** Street address of the practitioner */
  address?: Maybe<Scalars['String']['output']>;
  /** Secondary address line of the practitioner */
  address2?: Maybe<Scalars['String']['output']>;
  /** City of the practitioner's address */
  city?: Maybe<Scalars['String']['output']>;
  /** Country of the practitioner's address */
  country?: Maybe<Scalars['String']['output']>;
  /** Email address of the practitioner */
  email?: Maybe<Scalars['String']['output']>;
  /** First name of the practitioner */
  first_name: Scalars['String']['output'];
  /** FHIR resource id of the practitioner */
  id?: Maybe<Scalars['String']['output']>;
  /** Last name of the practitioner */
  last_name?: Maybe<Scalars['String']['output']>;
  /** Code identifying the contact's organization type */
  org_type_code?: Maybe<Scalars['String']['output']>;
  /** Display name of the contact's organization type */
  org_type_name?: Maybe<Scalars['String']['output']>;
  /** Phone number of the practitioner */
  phone?: Maybe<Scalars['String']['output']>;
  /** Postal code of the practitioner's address */
  postal_code?: Maybe<Scalars['String']['output']>;
  /** Name prefix or title of the practitioner */
  prefix?: Maybe<Scalars['String']['output']>;
  /** State or region of the practitioner's address */
  region?: Maybe<Scalars['String']['output']>;
  /** FHIR resource type of the record */
  resourceType?: Maybe<Scalars['String']['output']>;
  /** Code identifying the contact's role */
  role_code: Scalars['String']['output'];
  /** Display name of the contact's role */
  role_name: Scalars['String']['output'];
};

export type ContactModelInput = {
  /** Street address of the practitioner */
  address?: InputMaybe<Scalars['String']['input']>;
  /** Secondary address line of the practitioner */
  address2?: InputMaybe<Scalars['String']['input']>;
  /** City of the practitioner's address */
  city?: InputMaybe<Scalars['String']['input']>;
  /** Country of the practitioner's address */
  country?: InputMaybe<Scalars['String']['input']>;
  /** Email address of the practitioner */
  email?: InputMaybe<Scalars['String']['input']>;
  /** First name of the practitioner */
  first_name: Scalars['String']['input'];
  /** FHIR resource id of the practitioner */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Last name of the practitioner */
  last_name?: InputMaybe<Scalars['String']['input']>;
  /** Code identifying the contact's organization type */
  org_type_code?: InputMaybe<Scalars['String']['input']>;
  /** Display name of the contact's organization type */
  org_type_name?: InputMaybe<Scalars['String']['input']>;
  /** Phone number of the practitioner */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** Postal code of the practitioner's address */
  postal_code?: InputMaybe<Scalars['String']['input']>;
  /** Name prefix or title of the practitioner */
  prefix?: InputMaybe<Scalars['String']['input']>;
  /** State or region of the practitioner's address */
  region?: InputMaybe<Scalars['String']['input']>;
  /** FHIR resource type of the record */
  resourceType?: InputMaybe<Scalars['String']['input']>;
  /** Code identifying the contact's role */
  role_code: Scalars['String']['input'];
  /** Display name of the contact's role */
  role_name: Scalars['String']['input'];
  /** Type of contact being added to the care team */
  type: ContactType;
};

export type ContactPoint = {
  __typename?: 'ContactPoint';
  /** Period */
  period?: Maybe<Period>;
  /** Rank */
  rank?: Maybe<Scalars['Float']['output']>;
  /** phone | fax | email | pager | url | sms | other */
  system?: Maybe<Scalars['String']['output']>;
  /** Use */
  use?: Maybe<Scalars['String']['output']>;
  /** The actual contact point details */
  value?: Maybe<Scalars['String']['output']>;
};

export type ContactPointInput = {
  /** Period */
  period?: InputMaybe<PeriodInput>;
  /** Rank */
  rank?: InputMaybe<Scalars['Float']['input']>;
  /** phone | fax | email | pager | url | sms | other */
  system?: InputMaybe<Scalars['String']['input']>;
  /** Use */
  use?: InputMaybe<Scalars['String']['input']>;
  /** The actual contact point details */
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum ContactType {
  Organization = 'Organization',
  Practitioner = 'Practitioner'
}

/** ContractPlanModel */
export type ContractPlanModel = {
  __typename?: 'ContractPlanModel';
  /** Account the contract plan belongs to */
  account_id: Scalars['String']['output'];
  /** Maximum allowed usage under the plan */
  limit: Scalars['Int']['output'];
  /** Plan name */
  name: Scalars['String']['output'];
  /** Unique identifier of the contracted plan */
  plan_id: Scalars['String']['output'];
  /** User counts on the plan grouped by status (new, invited, active, total) */
  user_plans: UserPlanTypeModel;
};

export type Contributor = {
  __typename?: 'Contributor';
  /** Contact */
  contact?: Maybe<Array<ContactPoint>>;
  /** Name */
  name?: Maybe<Scalars['String']['output']>;
  /** Type */
  type?: Maybe<Scalars['String']['output']>;
};

export type ContributorInput = {
  /** Contact */
  contact?: InputMaybe<Array<ContactPointInput>>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Type */
  type?: InputMaybe<Scalars['String']['input']>;
};

export type CostException = {
  __typename?: 'CostException';
  /** Effective period of the cost exception */
  period?: Maybe<Period>;
  /** Category of the cost exception */
  type: CodeableConcept;
};

export type CostExceptionInput = {
  /** Effective period of the cost exception */
  period?: InputMaybe<PeriodInput>;
  /** Category of the cost exception */
  type: CodeableConceptInput;
};

export type CostToBeneficiary = {
  __typename?: 'CostToBeneficiary';
  /** Exceptions to the beneficiary cost */
  exception?: Maybe<Array<CostException>>;
  /** Category of the cost to the beneficiary */
  type?: Maybe<CodeableConcept>;
  /** Amount or percentage due from the beneficiary */
  valueQuantity?: Maybe<Quantity>;
};

export type CostToBeneficiaryInput = {
  /** Exceptions to the beneficiary cost */
  exception?: InputMaybe<Array<CostExceptionInput>>;
  /** Category of the cost to the beneficiary */
  type?: InputMaybe<CodeableConceptInput>;
  /** Amount or percentage due from the beneficiary */
  valueQuantity?: InputMaybe<QuantityInput>;
};

export type CoughScanResultModel = {
  __typename?: 'CoughScanResultModel';
  /** Likelihoods for detected pulmonary diseases */
  disease_likelihoods: Array<PulmonaryDiseaseModel>;
  /** Whether the cough indicates high infection risk */
  high_infection_risk: Scalars['Boolean']['output'];
  /** Whether an obstructive cough pattern was detected */
  obstructive_cough_pattern: Scalars['Boolean']['output'];
};

export type CoverageClass = {
  __typename?: 'CoverageClass';
  /** Human readable label for the coverage class */
  name?: Maybe<Scalars['String']['output']>;
  /** Type of coverage class such as group or plan */
  type: CodeableConcept;
  /** Value associated with the coverage class type */
  value: Scalars['String']['output'];
};

export type CoverageClassInput = {
  /** Human readable label for the coverage class */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Type of coverage class such as group or plan */
  type: CodeableConceptInput;
  /** Value associated with the coverage class type */
  value: Scalars['String']['input'];
};

/** CoverageModel */
export type CoverageModel = {
  __typename?: 'CoverageModel';
  associatedResources?: Maybe<Array<ResourceAssociationUnion>>;
  attachments?: Maybe<Array<Attachment>>;
  /** Plan beneficiary covered by this coverage */
  beneficiary: Reference;
  /** Additional coverage classifications */
  class?: Maybe<Array<CoverageClass>>;
  /** Contained */
  contained?: Maybe<Array<Resource>>;
  /** Contract details for the coverage */
  contract?: Maybe<Array<Reference>>;
  /** Patient payments for services or products */
  costToBeneficiary?: Maybe<Array<CostToBeneficiary>>;
  /** Curation metadata for this coverage resource */
  curationMeta?: Maybe<CurationMeta>;
  /** Dependent number of the beneficiary */
  dependent?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  /** Extension */
  extension?: Maybe<Array<Extension>>;
  /** Logical id of this artifact */
  id?: Maybe<Scalars['String']['output']>;
  /** Business identifier for the coverage */
  identifier?: Maybe<Array<Identifier>>;
  /** A set of rules under which this content was created */
  implicitRules?: Maybe<Scalars['String']['output']>;
  /** Language of the resource content */
  language?: Maybe<Scalars['String']['output']>;
  /** Metadata about the resource */
  meta?: Maybe<Meta>;
  /** Insurer network name */
  network?: Maybe<Scalars['String']['output']>;
  /** Relative order of the coverage for coordination of benefits */
  order?: Maybe<Scalars['Float']['output']>;
  /** Issuers of the insurance policy */
  payor: Array<Reference>;
  /** Coverage start and end dates */
  period?: Maybe<Period>;
  /** Owner of the insurance policy */
  policyHolder?: Maybe<Reference>;
  /** Beneficiary relationship to the subscriber */
  relationship?: Maybe<CodeableConcept>;
  /** FHIR resource type, always Coverage */
  resourceType?: Maybe<Scalars['String']['output']>;
  /** Coverage status: active, cancelled, draft or entered-in-error */
  status: Scalars['String']['output'];
  /** Whether reimbursement is due to the insurer */
  subrogation?: Maybe<Scalars['Boolean']['output']>;
  /** Subscriber to the insurance policy */
  subscriber?: Maybe<Reference>;
  /** ID assigned to the subscriber */
  subscriberId?: Maybe<Scalars['String']['output']>;
  /** Text */
  text?: Maybe<Narrative>;
  /** Coverage category such as medical or accident */
  type?: Maybe<CodeableConcept>;
};

export type CoverageModelInput = {
  /** Plan beneficiary covered by this coverage */
  beneficiary: ReferenceInput;
  /** Additional coverage classifications */
  class?: InputMaybe<Array<CoverageClassInput>>;
  /** Contained */
  contained?: InputMaybe<Array<ResourceInput>>;
  /** Contract details for the coverage */
  contract?: InputMaybe<Array<ReferenceInput>>;
  /** Patient payments for services or products */
  costToBeneficiary?: InputMaybe<Array<CostToBeneficiaryInput>>;
  /** Dependent number of the beneficiary */
  dependent?: InputMaybe<Scalars['String']['input']>;
  /** Extension */
  extension?: InputMaybe<Array<ExtensionInput>>;
  /** Logical id of this artifact */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Business identifier for the coverage */
  identifier?: InputMaybe<Array<IdentifierInput>>;
  /** A set of rules under which this content was created */
  implicitRules?: InputMaybe<Scalars['String']['input']>;
  /** Language of the resource content */
  language?: InputMaybe<Scalars['String']['input']>;
  /** Metadata about the resource */
  meta?: InputMaybe<MetaInput>;
  /** Insurer network name */
  network?: InputMaybe<Scalars['String']['input']>;
  /** Relative order of the coverage for coordination of benefits */
  order?: InputMaybe<Scalars['Float']['input']>;
  /** Issuers of the insurance policy */
  payor: Array<ReferenceInput>;
  /** Coverage start and end dates */
  period?: InputMaybe<PeriodInput>;
  /** Owner of the insurance policy */
  policyHolder?: InputMaybe<ReferenceInput>;
  /** Beneficiary relationship to the subscriber */
  relationship?: InputMaybe<CodeableConceptInput>;
  /** FHIR resource type, always Coverage */
  resourceType?: InputMaybe<Scalars['String']['input']>;
  /** Coverage status: active, cancelled, draft or entered-in-error */
  status: CoverageStatus;
  /** Whether reimbursement is due to the insurer */
  subrogation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Subscriber to the insurance policy */
  subscriber?: InputMaybe<ReferenceInput>;
  /** ID assigned to the subscriber */
  subscriberId?: InputMaybe<Scalars['String']['input']>;
  /** Text */
  text?: InputMaybe<NarrativeInput>;
  /** Coverage category such as medical or accident */
  type?: InputMaybe<CodeableConceptInput>;
};

export enum CoverageStatus {
  active = 'active',
  cancelled = 'cancelled',
  draft = 'draft',
  enteredInError = 'enteredInError'
}

export type CreateAccountModelInput = {
  /** Name of the account */
  account_name?: InputMaybe<Scalars['String']['input']>;
  /** Type of the account. Defaults to "individual" */
  account_type?: InputMaybe<AccountType>;
  /** Primary line address of the account */
  billing_address?: InputMaybe<Scalars['String']['input']>;
  /** Secondary line address of the account */
  billing_address2?: InputMaybe<Scalars['String']['input']>;
  /** City of the account */
  city?: InputMaybe<Scalars['String']['input']>;
  /** Country id of the account */
  country_id?: InputMaybe<Scalars['String']['input']>;
  /** Currency of the account */
  currency?: InputMaybe<Scalars['String']['input']>;
  /** The members in the account. Owner must not be part of this list */
  members?: InputMaybe<Array<CreateUserModelInput>>;
  /**
   * Features the organization is given. An empty list turns everything off,
   * which is not the same as leaving the organization unconfigured.
   */
  org_feature_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The owner of the account */
  owner: AccountOwnerInput;
  /** Account's parent ID */
  parent_id?: InputMaybe<Scalars['String']['input']>;
  /** Patient plans to create; array order becomes display order */
  patient_plans?: InputMaybe<Array<CustomPlanInput>>;
  /** Phone number of the account */
  phone_number?: InputMaybe<Scalars['String']['input']>;
  /** Region id of the account */
  region_id?: InputMaybe<Scalars['String']['input']>;
  /** MFA and Medly settings for the new account */
  settings?: InputMaybe<AccountSettingInput>;
  /** Account payment information */
  stripe_payment?: InputMaybe<StripePayment>;
  /** Zip postal of the account */
  zip_postal?: InputMaybe<Scalars['String']['input']>;
};

export type CreateAppVersionDraftInput = {
  /** Application the draft version is for */
  app: AppVersionApp;
  /** Whether the draft should be the minimum supported version */
  is_minimum_version?: Scalars['Boolean']['input'];
  /** Platform the draft version targets */
  platform: AppVersionPlatform;
  /** Release date for the draft, not in the future */
  release_date?: InputMaybe<Scalars['DateTime']['input']>;
  /** Release notes for the draft */
  release_notes?: InputMaybe<Scalars['String']['input']>;
  /** Semantic version number for the draft */
  version_number: Scalars['String']['input'];
};

export type CreateCuratorTaskModelInput = {
  /** User who created the curator task */
  created_user_id: Scalars['String']['input'];
  /** Detailed description of the curator task */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Due date for completing the task */
  due_date?: InputMaybe<Scalars['DateTime']['input']>;
  /** Name of the curator task */
  name: Scalars['String']['input'];
  /** Priority ranking of the curator task */
  priority: Scalars['Float']['input'];
  /** Linked FHIR resource reference id */
  resource?: InputMaybe<Scalars['String']['input']>;
  /** Whether the curator task is complete */
  status: Scalars['Boolean']['input'];
  /** Practitioner user assigned to the task */
  user_id?: InputMaybe<Scalars['String']['input']>;
  /** Vitall patient the curator task belongs to */
  vitall_patient_id: Scalars['String']['input'];
};

export type CreateCustomParameterInput = {
  /** Lower boundary of the parameter range */
  lower_bound?: InputMaybe<ParameterBoundaryInput>;
  /** Custom parameter id ?? Default parameter id */
  parameter_id: Scalars['String']['input'];
  /** Upper boundary of the parameter range */
  upper_bound?: InputMaybe<ParameterBoundaryInput>;
  /** Vitall patient the custom parameter belongs to */
  vitall_patient_id: Scalars['String']['input'];
};

export type CreateCustomParametersInput = {
  /** Optional category for the custom parameters */
  category?: InputMaybe<Scalars['String']['input']>;
  /** Observation code the custom parameters apply to */
  code: Scalars['String']['input'];
  /** Custom parameter definitions to create */
  parameters: Array<ParameterInput>;
  /** Vitall patient the custom parameters belong to */
  vitall_patient_id: Scalars['String']['input'];
};

export type CreateDiscernDocumentFromUploadInput = {
  /** FHIR Binary resource ID of the uploaded file */
  binary_resource_id: Scalars['String']['input'];
  /** Original filename of the uploaded document */
  filename: Scalars['String']['input'];
  /** Vitall patient to attach the document to */
  vitall_patient_id: Scalars['String']['input'];
};

export type CreateDocumentModelInput = {
  /** Optional document description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Human-readable document name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Document file size in bytes */
  size: Scalars['Float']['input'];
  /** Vitall patient identifier the document belongs to */
  vitall_patient_id?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePatientUserModelInput = {
  /** Patient's date of birth */
  date_of_birth?: InputMaybe<Scalars['String']['input']>;
  /** Patient's gender identity */
  gender?: InputMaybe<Scalars['String']['input']>;
  /** Patient's insurance identifier */
  insurance_id?: InputMaybe<Scalars['String']['input']>;
  /** Medical record number */
  mrn?: InputMaybe<Scalars['String']['input']>;
  phones?: InputMaybe<Array<PhoneContactInput>>;
  /**
   * Patient's primary phone number
   * @deprecated Use phones instead
   */
  primary_phone?: InputMaybe<Scalars['String']['input']>;
  /** Intake questionnaire responses for the patient */
  questionnaire?: InputMaybe<PatientQuestionnaireModelInput>;
  /** Patient's secondary email address */
  secondary_email?: InputMaybe<Scalars['String']['input']>;
  /**
   * Patient's secondary phone number
   * @deprecated Use phones instead
   */
  secondary_phone?: InputMaybe<Scalars['String']['input']>;
  /** Patient's biological sex */
  sex?: InputMaybe<Gender>;
};

export type CreatePermissionInput = {
  /** Name of the permission to create */
  permission_name: Scalars['String']['input'];
  /** PermissionScope */
  permission_scope: PermissionScope;
};

export type CreatePolicyInput = {
  /** Permission settings to attach to the new policy */
  permissions: Array<PermissionSetting>;
  /** Optional description for the new policy */
  policy_description?: InputMaybe<Scalars['String']['input']>;
  /** Name for the new policy */
  policy_name: Scalars['String']['input'];
};

export type CreatePractitionerUserModelInput = {
  /** Organizations the practitioner belongs to */
  organization_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Practitioner's primary phone number */
  primary_phone?: InputMaybe<Scalars['String']['input']>;
  /** FHIR coding for the practitioner's provider type */
  provider_type?: InputMaybe<CodingInput>;
  /** Practitioner's secondary email address */
  secondary_email?: InputMaybe<Scalars['String']['input']>;
};

export type CreateRoleInput = {
  /** Ordering rank for the new role */
  rank?: InputMaybe<Scalars['Int']['input']>;
  /** Description for the new role */
  role_description: Scalars['String']['input'];
  /** Name for the new role */
  role_name: Scalars['String']['input'];
  /** Account type scope for the new role */
  scope?: InputMaybe<AccountType>;
};

export type CreateRoutineInstanceStatusModelInput = {
  /** Timestamp when the status record was created */
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  /** Current status of the routine instance */
  status?: InputMaybe<Scalars['String']['input']>;
  /** Identifier of the routine task */
  task_id?: InputMaybe<Scalars['String']['input']>;
  /** Vitall patient identifier for the routine instance status */
  vitall_patient_id?: InputMaybe<Scalars['String']['input']>;
};

export type CreateShareLinkInput = {
  /** Required for share_type DigitalHealthAssessment, forbidden otherwise. Persisted alongside vitall_patient_id as the share's ownership record. */
  assessment_id?: InputMaybe<Scalars['String']['input']>;
  /** Optional expiry date for the share link */
  expires?: InputMaybe<Scalars['DateTime']['input']>;
  /** Recipient email addresses to send the share link to */
  recipients?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Identifier of the resource model to share */
  resource_model_id?: InputMaybe<Scalars['String']['input']>;
  /** Type of resource being shared */
  share_type: ShareType;
  /** Vitall patient id that owns the resource to share */
  vitall_patient_id: Scalars['String']['input'];
};

export type CreateShareLinkResponse = {
  __typename?: 'CreateShareLinkResponse';
  /** Generated URL for the created share link */
  share_link: Scalars['String']['output'];
};

export type CreateTitrationCarePlanInput = {
  /** Medications to include in the titration plan */
  medications: Array<TitrationMedicationInput>;
  /** FHIR Patient id the titration plan is created for */
  patient_id: Scalars['String']['input'];
  /** FHIR Practitioner id authoring the titration plan */
  practitioner_id: Scalars['String']['input'];
  /** Titration program to create the care plan for */
  program: TitrationProgram;
  /** Start date of the titration care plan */
  start_date: Scalars['DateTime']['input'];
};

export type CreateUserModelInput = {
  /** Whether the user completed CASL consent */
  casl_completed?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * DEPRECATED
   * @deprecated Relocated to patientInputs.date_of_birth
   */
  date_of_birth?: InputMaybe<Scalars['String']['input']>;
  /** User's login email address */
  email?: InputMaybe<Scalars['String']['input']>;
  /** User's first name */
  first_name: Scalars['String']['input'];
  /**
   * DEPRECATED
   * @deprecated Relocated to patientInputs.gender
   */
  gender?: InputMaybe<Scalars['String']['input']>;
  /** Group the user is assigned to */
  group_id?: InputMaybe<Scalars['String']['input']>;
  /** User's last name */
  last_name: Scalars['String']['input'];
  /** User's middle name */
  middle_name?: InputMaybe<Scalars['String']['input']>;
  /** User's initial password */
  password?: InputMaybe<Scalars['String']['input']>;
  /** Patient-specific fields when creating a patient user */
  patientInputs?: InputMaybe<CreatePatientUserModelInput>;
  /** Plan to apply to the user. Only applicable for Orgs */
  plan_id?: InputMaybe<Scalars['String']['input']>;
  /** Whether the user completed the privacy notice */
  pn_completed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Practitioner-specific fields when creating a practitioner user */
  practitionerInputs?: InputMaybe<CreatePractitionerUserModelInput>;
  /** URL of the user's profile picture */
  profile_picture?: InputMaybe<Scalars['String']['input']>;
  /**
   * DEPRECATED
   * @deprecated Relocated to patientInputs.questionnaire
   */
  questionnaire?: InputMaybe<PatientQuestionnaireModelInput>;
  /** Roles to assign to the user */
  roles?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Whether to send an invitation to the user */
  send_invite?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * DEPRECATED
   * @deprecated Relocated to patientInputs.sex
   */
  sex?: InputMaybe<Gender>;
  /** User's title or honorific */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Whether the user accepted the terms of care */
  toc_completed?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum CriticalityCode {
  high = 'high',
  low = 'low',
  unableToAssess = 'unableToAssess'
}

export type CurationMeta = {
  __typename?: 'CurationMeta';
  /** Timestamp when the resource was published */
  published_on?: Maybe<Scalars['DateTime']['output']>;
  /** Identifier of the underlying resource model */
  resource_model_id: Scalars['String']['output'];
  /** Display name of the curated resource */
  resource_name: Scalars['String']['output'];
  /** Number of curation revisions made */
  revisions: Scalars['Float']['output'];
  /** Source origin of the curated resource */
  source_type: ResourceSourceType;
  /** Current curation status of the resource */
  status: Scalars['String']['output'];
  /** Whether the curated resource has been viewed */
  viewed: Scalars['Boolean']['output'];
};

export type CurationMetaUnion = AllergyModel | AppointmentModel | ConditionModel | ConsentModel | CoverageModel | DiagnosticReportModel | EncounterModel | FamilyMemberHistoryModel | ImmunizationModel | MedicationStatementModel | ObservationModel | ProcedureModel;

export enum CurationStatus {
  Complete = 'Complete',
  Draft = 'Draft',
  Failed = 'Failed',
  InReview = 'InReview',
  NeedsReview = 'NeedsReview',
  New = 'New',
  Preparation = 'Preparation',
  Published = 'Published',
  Structuring = 'Structuring'
}

/** CuratorTaskModel */
export type CuratorTaskModel = {
  __typename?: 'CuratorTaskModel';
  /** Timestamp when the task was created */
  created_at: Scalars['DateTime']['output'];
  /** User who created the curator task */
  created_user_id?: Maybe<Scalars['String']['output']>;
  /** Unique identifier of the curator task */
  curator_task_id: Scalars['String']['output'];
  /** Detailed description of the curator task */
  description?: Maybe<Scalars['String']['output']>;
  /** Due date for completing the task */
  due_date?: Maybe<Scalars['DateTime']['output']>;
  /** Name of the curator task */
  name: Scalars['String']['output'];
  /** Priority ranking of the curator task */
  priority: Scalars['Float']['output'];
  /** Human-readable display name of the linked FHIR record */
  recordDescription?: Maybe<Scalars['String']['output']>;
  /** Linked FHIR resource reference id */
  resource?: Maybe<Scalars['String']['output']>;
  /** App deep-link route to the curator task's target FHIR record */
  route?: Maybe<Scalars['String']['output']>;
  /** Whether the curator task is complete */
  status: Scalars['Boolean']['output'];
  /** Timestamp when the task was last updated */
  updated_at: Scalars['DateTime']['output'];
  /** User assigned to this curator task */
  user?: Maybe<UserModel>;
  /** Practitioner user assigned to the task */
  user_id?: Maybe<Scalars['String']['output']>;
  /** Patient associated with this curator task */
  vitall_patient?: Maybe<VitallPatientModel>;
  /** Vitall patient the curator task belongs to */
  vitall_patient_id: Scalars['String']['output'];
};

export type CurrencyOptions = {
  __typename?: 'CurrencyOptions';
  /** Currency for these price options */
  currency: Scalars['String']['output'];
  /** When set, provides configuration for the amount to be adjusted by the customer during Checkout Sessions and Payment Links. */
  custom_unit_amount?: Maybe<CustomUnitAmount>;
  /** Specifies whether the price is considered inclusive of taxes or exclusive of taxes. One of `inclusive`, `exclusive`, or `unspecified`. Once specified as either `inclusive` or `exclusive`, it cannot be changed. */
  tax_behavior?: Maybe<TaxBehavior>;
  /** Each element represents a pricing tier. This parameter requires `billing_scheme` to be set to `tiered`. See also the documentation for `billing_scheme`. */
  tiers?: Maybe<Array<Tier>>;
  /** The unit amount, in the currency's smallest unit, to be charged, represented as a whole integer if possible. Only set if `billing_scheme=per_unit`. */
  unit_amount?: Maybe<Scalars['Float']['output']>;
  /** The unit amount, in the currency's smallest unit, to be charged, represented as a decimal string with at most 12 decimal places. Only set if `billing_scheme=per_unit`. */
  unit_amount_decimal?: Maybe<Scalars['String']['output']>;
};

export type CustomPlanInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  /**
   * Nullable because the frontend's request pipeline serialises an empty
   * array as null (stripEmptyStrings in the Apollo httpLink) — a plan with no
   * patient features arrives as null. Null therefore means no features.
   */
  feature_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  name: Scalars['String']['input'];
  /** Absent = create a new plan */
  plan_id?: InputMaybe<Scalars['String']['input']>;
  /** Patient seats reserved for this plan out of the org's purchased pool */
  seats: Scalars['Int']['input'];
};

/** CustomPlanModel */
export type CustomPlanModel = {
  __typename?: 'CustomPlanModel';
  account_id: Scalars['String']['output'];
  /** Patients currently assigned to the plan (User_Plan count) */
  assigned_seats: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  display_order: Scalars['Int']['output'];
  feature_ids: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  plan_id: Scalars['String']['output'];
  /** Patient seats reserved for this plan (Contract_Plan.limit; 0 when unset) */
  seats: Scalars['Int']['output'];
};

export type CustomUnitAmount = {
  __typename?: 'CustomUnitAmount';
  /** The maximum unit amount the customer can specify for this item. */
  maximum?: Maybe<Scalars['Float']['output']>;
  /** The minimum unit amount the customer can specify for this item. Must be at least the minimum charge amount. */
  minimum?: Maybe<Scalars['Float']['output']>;
  /** The starting unit amount which can be updated by the customer. */
  preset?: Maybe<Scalars['Float']['output']>;
};

/** CustomerData */
export type CustomerData = {
  __typename?: 'CustomerData';
  /** Customer billing address */
  address?: Maybe<StripeAddress>;
  /** Customer account balance in cents */
  balance: Scalars['Float']['output'];
  /** Customer creation timestamp */
  created: Scalars['Float']['output'];
  /** Customer default currency */
  currency?: Maybe<Scalars['String']['output']>;
  /** Customer default payment source */
  default_source?: Maybe<Scalars['String']['output']>;
  /** Whether the customer has an unpaid invoice */
  delinquent?: Maybe<Scalars['Boolean']['output']>;
  /** Customer description */
  desciption?: Maybe<Scalars['String']['output']>;
  /** Applied discount amount */
  discount?: Maybe<Scalars['Float']['output']>;
  /** Customer email address */
  email?: Maybe<Scalars['String']['output']>;
  /** Stripe customer identifier */
  id: Scalars['String']['output'];
  /** Prefix used on customer invoice numbers */
  invoice_prefix?: Maybe<Scalars['String']['output']>;
  /** Whether the customer exists in live mode */
  livemode: Scalars['Boolean']['output'];
  /** Customer full name */
  name?: Maybe<Scalars['String']['output']>;
  /** Stripe object type */
  object: Scalars['String']['output'];
  /** Customer phone number */
  phone?: Maybe<Scalars['String']['output']>;
  /** Customer shipping information */
  shipping?: Maybe<Scalars['String']['output']>;
};

export type DataRequirement = {
  __typename?: 'DataRequirement';
  /** Code filter */
  codeFilter?: Maybe<CodeFilter>;
  /** Date filter */
  dateFilter?: Maybe<DateFilter>;
  /** Limit */
  limit?: Maybe<Scalars['Float']['output']>;
  /** Must support */
  mustSupport?: Maybe<Array<Scalars['String']['output']>>;
  /** Profile */
  profile?: Maybe<Scalars['String']['output']>;
  /** Sort */
  sort?: Maybe<Array<Sort>>;
  /** Subject codeable concept */
  subjectCodeableConcept?: Maybe<CodeableConcept>;
  /** Subject reference */
  subjectReference?: Maybe<Reference>;
  /** Type */
  type?: Maybe<Scalars['String']['output']>;
};

export type DataRequirementInput = {
  /** Code filter */
  codeFilter?: InputMaybe<CodeFilterInput>;
  /** Date filter */
  dateFilter?: InputMaybe<DateFilterInput>;
  /** Limit */
  limit?: InputMaybe<Scalars['Float']['input']>;
  /** Must support */
  mustSupport?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Profile */
  profile?: InputMaybe<Scalars['String']['input']>;
  /** Sort */
  sort?: InputMaybe<Array<SortInput>>;
  /** Subject codeable concept */
  subjectCodeableConcept?: InputMaybe<CodeableConceptInput>;
  /** Subject reference */
  subjectReference?: InputMaybe<ReferenceInput>;
  /** Type */
  type?: InputMaybe<Scalars['String']['input']>;
};

export type DateFilter = {
  __typename?: 'DateFilter';
  /** Path */
  path?: Maybe<Scalars['String']['output']>;
  /** Search param */
  searchParam?: Maybe<Scalars['String']['output']>;
  /** Value date time */
  valueDateTime?: Maybe<Scalars['String']['output']>;
  /** Value duration */
  valueDuration?: Maybe<Quantity>;
  /** Value period */
  valuePeriod?: Maybe<Period>;
};

export type DateFilterInput = {
  /** Path */
  path?: InputMaybe<Scalars['String']['input']>;
  /** Search param */
  searchParam?: InputMaybe<Scalars['String']['input']>;
  /** Value date time */
  valueDateTime?: InputMaybe<Scalars['String']['input']>;
  /** Value duration */
  valueDuration?: InputMaybe<QuantityInput>;
  /** Value period */
  valuePeriod?: InputMaybe<PeriodInput>;
};

export enum DateSortType {
  DATE_ASCEND = 'DATE_ASCEND',
  DATE_DESCEND = 'DATE_DESCEND'
}

export enum DayOfWeek {
  fri = 'fri',
  mon = 'mon',
  sat = 'sat',
  sun = 'sun',
  thu = 'thu',
  tue = 'tue',
  wed = 'wed'
}

export type DeleteAccountAvatarInput = {
  /** ID of the account whose avatar is being deleted */
  account_id: Scalars['String']['input'];
  /** Type of avatar file being deleted */
  fileType?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteAccountInput = {
  /** ID of the account to delete */
  account_id: Scalars['String']['input'];
  /** Password confirming the account deletion */
  password: Scalars['String']['input'];
};

export type DeleteAlertSettingInput = {
  /** Account identifier scoping the alert setting */
  account_id: Scalars['String']['input'];
  /** Alert setting identifier to delete */
  alert_setting_id: Scalars['String']['input'];
  /** Vitall patient identifier the alert setting belongs to */
  vitall_patient_id: Scalars['String']['input'];
};

export type DeleteAllergyInput = {
  /** Id of the allergy record to delete */
  allergy_id: Scalars['String']['input'];
};

export type DeleteAppointmentInput = {
  /** ID of the appointment to delete */
  appointment_id: Scalars['String']['input'];
};

export type DeleteAttachmentInput = {
  /** Identifier of the attachment to delete */
  id: Scalars['String']['input'];
  /** Resource identifier the attachment belongs to, in the format <resourceType>/<resourceId> */
  resource: Scalars['String']['input'];
};

export type DeleteAvatarInput = {
  /** ID of the user whose avatar is being deleted */
  user_id: Scalars['String']['input'];
};

export type DeleteCareTeamMemberInput = {
  /** Identifier of the care team member to remove */
  member: Scalars['String']['input'];
  /** Identifier of the patient whose care team member to remove */
  patient_id: Scalars['String']['input'];
};

export type DeleteConditionInput = {
  /** Logical id of the condition to delete */
  condition_id: Scalars['String']['input'];
};

export type DeleteConsentInput = {
  /** Id of the consent to delete */
  consent_id: Scalars['String']['input'];
};

export type DeleteCoveragesInput = {
  /** ID of the coverage to delete */
  coverage_id: Scalars['String']['input'];
};

export type DeleteCustomParametersInput = {
  /** Optional category filter for the parameters to delete */
  category?: InputMaybe<Scalars['String']['input']>;
  /** Observation code the custom parameters apply to */
  code: Scalars['String']['input'];
  /** Optional identifiers of custom parameters to delete */
  parameter_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Vitall patient the custom parameters belong to */
  vitall_patient_id: Scalars['String']['input'];
};

export type DeleteDiagnosticReportInput = {
  /** ID of the diagnostic report to delete */
  diagnostic_report_id: Scalars['String']['input'];
};

export type DeleteDiscernDocumentInput = {
  /** ID of the Discern document to delete */
  discern_document_id: Scalars['String']['input'];
};

/** DeleteDiscernDocumentModel */
export type DeleteDiscernDocumentModel = {
  __typename?: 'DeleteDiscernDocumentModel';
  /** ID of the deleted Discern document */
  discern_document_id: Scalars['String']['output'];
  /** Vitall patient the deleted document belonged to */
  vitall_patient_id: Scalars['String']['output'];
};

export type DeleteEncounterInput = {
  /** Id of the encounter to delete */
  encounter_id: Scalars['String']['input'];
};

export type DeleteFamilyHistoryInput = {
  /** Id of the family member history record to delete */
  familymemberhistory_id: Scalars['String']['input'];
};

export type DeleteImmunizationInput = {
  /** FHIR id of the immunization to delete */
  immunization_id: Scalars['String']['input'];
};

export type DeleteMedStatementInput = {
  /** ID of the medication statement to delete */
  medication_statement_id: Scalars['String']['input'];
};

export type DeleteMedicationRequestInput = {
  /** Identifier of the medication request to delete */
  medication_request_id: Scalars['String']['input'];
};

export type DeleteNoteInput = {
  /** Identifier of the note to delete */
  note_id: Scalars['String']['input'];
  /** Resource identifier the note belongs to, in the format <resourceType>/<resourceId> */
  resource: Scalars['String']['input'];
};

export type DeleteObservationInput = {
  /** Id of the observation to delete */
  observation_id: Scalars['String']['input'];
};

export type DeletePacStudiesInput = {
  /** ID of the diagnostic report to remove studies from */
  diagnostic_report_id: Scalars['String']['input'];
  /** PACS study IDs to remove from the report */
  pacs_study_ids: Array<Scalars['String']['input']>;
};

export type DeleteProcedureInput = {
  /** Identifier of the procedure to delete */
  procedure_id: Scalars['String']['input'];
};

export type DeleteRelatedPersonInput = {
  /** FHIR logical id of the patient the related person belongs to */
  patient_id: Scalars['String']['input'];
  /** FHIR logical id of the related person to delete */
  relatedPerson_id: Scalars['String']['input'];
};

export type DeleteRoutineInstanceStatusInput = {
  /** Identifier of the routine instance to delete */
  instance_id: Scalars['String']['input'];
};

/** DeleteRoutineInstanceStatusResponse */
export type DeleteRoutineInstanceStatusResponse = {
  __typename?: 'DeleteRoutineInstanceStatusResponse';
  /** The deleted routine instance status record */
  data?: Maybe<RoutineInstanceStatusModel>;
  /** Human-readable result message for the deletion */
  message: Scalars['String']['output'];
  /** Whether the routine instance status deletion succeeded */
  success: Scalars['Boolean']['output'];
};

export type DeleteScanResultInput = {
  /** Id of the scan result to delete */
  result_id: Scalars['String']['input'];
};

export type DeleteTaskInput = {
  /** Id of the task to delete */
  task_id: Scalars['String']['input'];
};

export type DeleteTerraConnectionInput = {
  /** Identifier of the Terra connection to delete */
  terra_connection_id: Scalars['String']['input'];
};

export type DeleteUserPermissionGrantsInput = {
  /** User who is being denied permission */
  accessing_user_id: Scalars['String']['input'];
  /** User who is removing permission */
  user_id: Scalars['String']['input'];
};

export type Detail = {
  __typename?: 'Detail';
  /** Name of the property */
  type?: Maybe<Scalars['String']['output']>;
  /** Value base64 binary */
  valueBase64Binary?: Maybe<Scalars['String']['output']>;
  /** Value string */
  valueString?: Maybe<Scalars['String']['output']>;
};

export type Diagnosis = {
  __typename?: 'Diagnosis';
  /** Condition or procedure relevant to the encounter */
  condition: Reference;
  /** Ranking of the diagnosis for each role type */
  rank?: Maybe<Scalars['Float']['output']>;
  /** Role of this diagnosis within the encounter */
  use?: Maybe<CodeableConcept>;
};

export type DiagnosisInput = {
  /** Condition or procedure relevant to the encounter */
  condition: ReferenceInput;
  /** Ranking of the diagnosis for each role type */
  rank?: InputMaybe<Scalars['Float']['input']>;
  /** Role of this diagnosis within the encounter */
  use?: InputMaybe<CodeableConceptInput>;
};

export type DiagnosticReportInput = {
  /** Orders or requests this report fulfils */
  basedOn?: InputMaybe<Array<InputMaybe<ReferenceInput>>>;
  /** Service category of the report */
  category?: InputMaybe<Array<InputMaybe<CodeableConceptInput>>>;
  /** Name or code for this diagnostic report */
  code: CodeableConceptInput;
  /** Clinical conclusion of the test results */
  conclusion?: InputMaybe<Scalars['String']['input']>;
  /** Coded clinical conclusion of the results */
  conclusionCode?: InputMaybe<CodeableConceptInput>;
  /** Contained */
  contained?: InputMaybe<Array<ResourceInput>>;
  /** Clinically relevant time of the report */
  effectiveDateTime?: InputMaybe<Scalars['String']['input']>;
  /** Clinically relevant time period of the report */
  effectivePeriod?: InputMaybe<PeriodInput>;
  /** Encounter when the test was ordered */
  encounter?: InputMaybe<ReferenceInput>;
  /** Extension */
  extension?: InputMaybe<Array<ExtensionInput>>;
  /** Logical id of the diagnostic report */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Business identifiers for the report */
  identifier?: InputMaybe<Array<InputMaybe<IdentifierInput>>>;
  /** Imaging studies associated with the report */
  imagingStudy?: InputMaybe<Array<InputMaybe<ReferenceInput>>>;
  /** A set of rules under which this content was created */
  implicitRules?: InputMaybe<Scalars['String']['input']>;
  /** Date and time this version was issued */
  issued?: InputMaybe<Scalars['String']['input']>;
  /** Language of the resource content */
  language?: InputMaybe<Scalars['String']['input']>;
  /** Key images associated with this report */
  media?: InputMaybe<Array<InputMaybe<DiagnosticReportMediaInput>>>;
  /** Metadata about the resource */
  meta?: InputMaybe<MetaInput>;
  /** Diagnostic service responsible for the report */
  performer?: InputMaybe<Array<InputMaybe<ReferenceInput>>>;
  /** Entire report as issued attachments */
  presentedForm?: InputMaybe<Array<InputMaybe<AttachmentInput>>>;
  /** FHIR resource type, always DiagnosticReport */
  resourceType?: InputMaybe<Scalars['String']['input']>;
  /** Observations that make up the report */
  result?: InputMaybe<Array<InputMaybe<ReferenceInput>>>;
  /** Primary interpreters of the results */
  resultsInterpreter?: InputMaybe<Array<InputMaybe<ReferenceInput>>>;
  /** Specimens this report is based on */
  specimen?: InputMaybe<Array<InputMaybe<ReferenceInput>>>;
  /** Report status (registered, partial, final, etc.) */
  status: Scalars['String']['input'];
  /** Subject of the report, usually the patient */
  subject?: InputMaybe<ReferenceInput>;
  /** Text */
  text?: InputMaybe<NarrativeInput>;
};

export type DiagnosticReportMediaInput = {
  /** Comment explaining the image */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Reference to the image source */
  link: ReferenceInput;
};

/** DiagnosticReportModel */
export type DiagnosticReportModel = {
  __typename?: 'DiagnosticReportModel';
  associatedResources?: Maybe<Array<ResourceAssociationUnion>>;
  attachments?: Maybe<Array<Attachment>>;
  /** Orders or requests this report fulfils */
  basedOn?: Maybe<Array<Maybe<Reference>>>;
  /** Service category of the report */
  category?: Maybe<Array<CodeableConcept>>;
  /** Name or code for this diagnostic report */
  code: CodeableConcept;
  /** Clinical conclusion of the test results */
  conclusion?: Maybe<Scalars['String']['output']>;
  /** Coded clinical conclusion of the results */
  conclusionCode?: Maybe<CodeableConcept>;
  /** Contained */
  contained?: Maybe<Array<Resource>>;
  /** Curation metadata for this diagnostic report resource */
  curationMeta?: Maybe<CurationMeta>;
  displayName?: Maybe<Scalars['String']['output']>;
  /** Clinically relevant time of the report */
  effectiveDateTime?: Maybe<Scalars['String']['output']>;
  /** Clinically relevant time period of the report */
  effectivePeriod?: Maybe<Period>;
  /** Encounter when the test was ordered */
  encounter?: Maybe<Reference>;
  /** Resolved Encounter resource referenced by the report */
  encounterResource?: Maybe<EncounterModel>;
  /** Extension */
  extension?: Maybe<Array<Extension>>;
  /** Logical id of the diagnostic report */
  id?: Maybe<Scalars['String']['output']>;
  /** Business identifiers for the report */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /** Imaging studies associated with the report */
  imagingStudy?: Maybe<Array<Maybe<Reference>>>;
  /** Resolved ImagingStudy resources referenced by the report */
  imagingStudyResources?: Maybe<Array<ImagingStudyModel>>;
  /** A set of rules under which this content was created */
  implicitRules?: Maybe<Scalars['String']['output']>;
  /** Date and time this version was issued */
  issued?: Maybe<Scalars['String']['output']>;
  /** Language of the resource content */
  language?: Maybe<Scalars['String']['output']>;
  /** Key images associated with this report */
  media?: Maybe<Array<Maybe<Media>>>;
  /** Metadata about the resource */
  meta?: Maybe<Meta>;
  /** Diagnostic service responsible for the report */
  performer?: Maybe<Array<Maybe<Reference>>>;
  /** Entire report as issued attachments */
  presentedForm?: Maybe<Array<Maybe<Attachment>>>;
  /** FHIR resource type, always DiagnosticReport */
  resourceType?: Maybe<Scalars['String']['output']>;
  /** Observations that make up the report */
  result?: Maybe<Array<Maybe<Reference>>>;
  /** Resolved Observation resources referenced by the report result */
  resultResources?: Maybe<Array<ObservationModel>>;
  /** Primary interpreters of the results */
  resultsInterpreter?: Maybe<Array<Maybe<Reference>>>;
  /** Specimens this report is based on */
  specimen?: Maybe<Array<Maybe<Reference>>>;
  /** Report status (registered, partial, final, etc.) */
  status: Scalars['String']['output'];
  /** Subject of the report, usually the patient */
  subject?: Maybe<Reference>;
  /** Text */
  text?: Maybe<Narrative>;
};

export type DirectEmrApiConnection = {
  __typename?: 'DirectEmrApiConnection';
  /** Timestamp when the connection was created */
  created_at: Scalars['DateTime']['output'];
  /** Expiry timestamp of the EMR connection */
  expiry: Scalars['DateTime']['output'];
  /** Identifier of the connected EMR FHIR API endpoint */
  fhir_api_endpoint_id: Scalars['String']['output'];
  /** FHIR Patient resource identifier at the EMR */
  patient: Scalars['String']['output'];
  /** Timestamp when the connection was last updated */
  updated_at: Scalars['DateTime']['output'];
  /** Vitall patient identifier for this EMR connection */
  vitall_patient_id: Scalars['String']['output'];
};

export type DirectEmrApiEndpoint = {
  __typename?: 'DirectEmrApiEndpoint';
  /** City where the organization is located */
  city?: Maybe<Scalars['String']['output']>;
  /** Country where the organization is located */
  country?: Maybe<Scalars['String']['output']>;
  /** Type of EMR system for this endpoint */
  emr_type: EmrApiType;
  /** Unique identifier of the EMR FHIR API endpoint */
  fhir_api_endpoint_id: Scalars['String']['output'];
  /** Base URL of the organization's FHIR API */
  fhir_base_url: Scalars['String']['output'];
  /** URL of the organization's logo image */
  organization_logo_url?: Maybe<Scalars['String']['output']>;
  /** Name of the organization exposing the FHIR API */
  organization_name: Scalars['String']['output'];
  /** Region where the organization is located */
  region?: Maybe<Scalars['String']['output']>;
};

export type DisableMfaInput = {
  /** Verification code confirming the disable request */
  code: Scalars['String']['input'];
  /** MFA method to disable */
  method: MfaMethod;
};

/** DiscernDocumentModel */
export type DiscernDocumentModel = {
  __typename?: 'DiscernDocumentModel';
  /** FHIR Binary resource ID of the source file */
  binary_resource_id: Scalars['String']['output'];
  /** Whether auto-curation can be retried for this document */
  can_retry: Scalars['Boolean']['output'];
  /** Timestamp when the document was created */
  created_at: Scalars['DateTime']['output'];
  /** Unique identifier of the Discern document */
  discern_document_id: Scalars['String']['output'];
  /** Page grouping state for the document */
  grouping_state_json: Scalars['JSON']['output'];
  /** Auto-curation job associated with this document */
  job?: Maybe<DiscernJobModel>;
  /** Current processing status of the document */
  status: Scalars['String']['output'];
  /** Timestamp when the document was last updated */
  updated_at: Scalars['DateTime']['output'];
  /** Patient this Discern document belongs to */
  vitall_patient?: Maybe<VitallPatientModel>;
  /** Vitall patient the document belongs to */
  vitall_patient_id: Scalars['String']['output'];
};

/** DiscernJobModel */
export type DiscernJobModel = {
  __typename?: 'DiscernJobModel';
  /** Timestamp when the job was created */
  created_at: Scalars['DateTime']['output'];
  /** Discern document this job processes */
  discern_document_id: Scalars['String']['output'];
  /** Unique identifier of the Discern job */
  discern_job_id: Scalars['String']['output'];
  /** Timestamp when the job finished running */
  end_time?: Maybe<Scalars['DateTime']['output']>;
  /** External processing job identifier */
  job_id: Scalars['String']['output'];
  /** All discern results associated with this job */
  results: Array<DiscernResultModel>;
  /** Timestamp when the job started running */
  start_time?: Maybe<Scalars['DateTime']['output']>;
  /** Timestamp when the job was last updated */
  updated_at: Scalars['DateTime']['output'];
};

/** DiscernResultDetailsModel */
export type DiscernResultDetailsModel = {
  __typename?: 'DiscernResultDetailsModel';
  /** Detected bounding boxes for the document */
  bounding_boxes?: Maybe<Scalars['JSON']['output']>;
  /** OCR-extracted text data for the document */
  ocr_data?: Maybe<Scalars['JSON']['output']>;
};

/** DiscernResultModel */
export type DiscernResultModel = {
  __typename?: 'DiscernResultModel';
  /** Bounding box identifier for the result */
  bbox_id?: Maybe<Scalars['String']['output']>;
  /** Timestamp when the result was created */
  created_at: Scalars['DateTime']['output'];
  /** Bounding boxes, OCR data, and PDF URL for the Discern result */
  details?: Maybe<DiscernResultDetailsModel>;
  /** Discern job that produced this result */
  discern_job_id: Scalars['String']['output'];
  /** Unique identifier of the Discern result */
  discern_result_id: Scalars['String']['output'];
  /** Identifier of the Discern sub-job */
  discern_sub_job_id?: Maybe<Scalars['String']['output']>;
  /** Index of the group within the page group */
  group_index?: Maybe<Scalars['Int']['output']>;
  /** Page group the result belongs to */
  page_group: Scalars['String']['output'];
  /** Download URL for the Discern result PDF document */
  pdf_url?: Maybe<GetDownloadUrlResponse>;
  /** Clinical record date extracted from the result */
  record_date?: Maybe<Scalars['DateTime']['output']>;
  /** Name of the extracted FHIR resource */
  resource_name?: Maybe<Scalars['String']['output']>;
  /** S3 key where the result payload is stored */
  results_s3_key?: Maybe<Scalars['String']['output']>;
  /** Ordering sequence of the result */
  sequence?: Maybe<Scalars['Int']['output']>;
  /** Curation status of the result */
  status: DiscernResultStatus;
  /** Timestamp when the result was last updated */
  updated_at: Scalars['DateTime']['output'];
};


/** DiscernResultModel */
export type DiscernResultModelPdf_UrlArgs = {
  previewable: Scalars['Boolean']['input'];
};

export enum DiscernResultStatus {
  Complete = 'Complete',
  Delete = 'Delete',
  New = 'New',
  Processing = 'Processing'
}

export type DiscernUploadInput = {
  /** MIME content type of the file */
  contentType: Scalars['String']['input'];
  /** Original file name */
  name: Scalars['String']['input'];
  /** FHIR Patient ID the upload belongs to */
  patient_id: Scalars['String']['input'];
  /** File size in bytes */
  size: Scalars['Float']['input'];
};

export enum DocumentHealthStatus {
  InProgress = 'InProgress',
  Infected = 'Infected',
  Ok = 'Ok',
  Unknown = 'Unknown'
}

/** DocumentModel */
export type DocumentModel = {
  __typename?: 'DocumentModel';
  /** Timestamp when the document was created */
  created_at?: Maybe<Scalars['DateTime']['output']>;
  /** Optional document description */
  description?: Maybe<Scalars['String']['output']>;
  /** Unique document identifier */
  document_id: Scalars['String']['output'];
  /** Presigned S3 download URL for the uploaded document file */
  downloadUrl?: Maybe<GetDownloadUrlResponse>;
  /** Human-readable document name */
  name?: Maybe<Scalars['String']['output']>;
  /** S3 storage key for the document */
  s3_key?: Maybe<Scalars['String']['output']>;
  /** Document file size in bytes */
  size: Scalars['Float']['output'];
  /** Status associated with the document, resolved by status id */
  status?: Maybe<StatusModel>;
  /** Document health status identifier */
  status_id?: Maybe<Scalars['String']['output']>;
  /** Timestamp when the document was last updated */
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  /** Signed S3 upload session for the document, single or multipart by size */
  uploadData: MultipartUploadModel;
  /** Whether the document has been uploaded to storage */
  uploaded: Scalars['Boolean']['output'];
  /** Vitall patient identifier the document belongs to */
  vitall_patient_id?: Maybe<Scalars['String']['output']>;
};


/** DocumentModel */
export type DocumentModelDownloadUrlArgs = {
  previewable: Scalars['Boolean']['input'];
};

export type Dosage = {
  __typename?: 'Dosage';
  /** Additional instruction */
  additionalInstruction?: Maybe<Array<CodeableConcept>>;
  /** As needed boolean */
  asNeededBoolean?: Maybe<Scalars['Boolean']['output']>;
  /** As needed codeable concept */
  asNeededCodeableConcept?: Maybe<CodeableConcept>;
  /** Dose and rate */
  doseAndRate?: Maybe<Array<DoseAndRate>>;
  /** Extension */
  extension?: Maybe<Array<Extension>>;
  /** Max dose per administration */
  maxDosePerAdministration?: Maybe<Quantity>;
  /** Max dose per lifetime */
  maxDosePerLifetime?: Maybe<Quantity>;
  /** Max dose per period */
  maxDosePerPeriod?: Maybe<Ratio>;
  /** Method */
  method?: Maybe<CodeableConcept>;
  /** Patient instruction */
  patientInstruction?: Maybe<Scalars['String']['output']>;
  /** Route */
  route?: Maybe<CodeableConcept>;
  /** Sequence */
  sequence?: Maybe<Scalars['Float']['output']>;
  /** Site */
  site?: Maybe<CodeableConcept>;
  /** Text */
  text?: Maybe<Scalars['String']['output']>;
  /** Timing */
  timing?: Maybe<Timing>;
};

export type DosageInput = {
  /** Additional instruction */
  additionalInstruction?: InputMaybe<Array<CodeableConceptInput>>;
  /** As needed boolean */
  asNeededBoolean?: InputMaybe<Scalars['Boolean']['input']>;
  /** As needed codeable concept */
  asNeededCodeableConcept?: InputMaybe<CodeableConceptInput>;
  /** Dose and rate */
  doseAndRate?: InputMaybe<Array<DoseAndRateInput>>;
  /** Extension */
  extension?: InputMaybe<Array<ExtensionInput>>;
  /** Max dose per administration */
  maxDosePerAdministration?: InputMaybe<QuantityInput>;
  /** Max dose per lifetime */
  maxDosePerLifetime?: InputMaybe<QuantityInput>;
  /** Max dose per period */
  maxDosePerPeriod?: InputMaybe<RatioInput>;
  /** Method */
  method?: InputMaybe<CodeableConceptInput>;
  /** Patient instruction */
  patientInstruction?: InputMaybe<Scalars['String']['input']>;
  /** Route */
  route?: InputMaybe<CodeableConceptInput>;
  /** Sequence */
  sequence?: InputMaybe<Scalars['Float']['input']>;
  /** Site */
  site?: InputMaybe<CodeableConceptInput>;
  /** Text */
  text?: InputMaybe<Scalars['String']['input']>;
  /** Timing */
  timing?: InputMaybe<TimingInput>;
};

export type DoseAndRate = {
  __typename?: 'DoseAndRate';
  /** Dose quantity */
  doseQuantity?: Maybe<Quantity>;
  /** Dose range */
  doseRange?: Maybe<Range>;
  /** Rate quantity */
  rateQuantity?: Maybe<Quantity>;
  /** Rate range */
  rateRange?: Maybe<Range>;
  /** Rate ratio */
  rateRatio?: Maybe<Ratio>;
  /** Type */
  type?: Maybe<CodeableConcept>;
};

export type DoseAndRateInput = {
  /** Dose quantity */
  doseQuantity?: InputMaybe<QuantityInput>;
  /** Dose range */
  doseRange?: InputMaybe<RangeInput>;
  /** Rate quantity */
  rateQuantity?: InputMaybe<QuantityInput>;
  /** Rate range */
  rateRange?: InputMaybe<RangeInput>;
  /** Rate ratio */
  rateRatio?: InputMaybe<RatioInput>;
  /** Type */
  type?: InputMaybe<CodeableConceptInput>;
};

export type Education = {
  __typename?: 'Education';
  /** Educational material document identifier */
  documentType: Scalars['String']['output'];
  /** Educational material presentation date */
  presentationDate: Scalars['String']['output'];
  /** Educational material publication date */
  publicationDate: Scalars['String']['output'];
  /** Educational material reference pointer */
  reference?: Maybe<Scalars['String']['output']>;
};

export type EducationInput = {
  /** Educational material document identifier */
  documentType: Scalars['String']['input'];
  /** Educational material presentation date */
  presentationDate: Scalars['String']['input'];
  /** Educational material publication date */
  publicationDate: Scalars['String']['input'];
  /** Educational material reference pointer */
  reference?: InputMaybe<Scalars['String']['input']>;
};

export type EhrConnection = {
  __typename?: 'EhrConnection';
  account_id: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  ehr_connection_id: Scalars['String']['output'];
  ehr_vendor: EhrVendor;
  environment: EhrEnvironment;
  fhir_base_url: Scalars['String']['output'];
  fhir_version: FhirVersion;
  network?: Maybe<Scalars['String']['output']>;
  /** QIE's own zone id, recorded at registration. */
  qie_zone_id?: Maybe<Scalars['String']['output']>;
  qie_zone_name: Scalars['String']['output'];
  status: EhrConnectionStatus;
  updated_at: Scalars['DateTime']['output'];
};

export type EhrConnectionRefInput = {
  ehr_connection_id: Scalars['String']['input'];
};

export enum EhrConnectionStatus {
  Active = 'Active',
  Disabled = 'Disabled',
  Provisioning = 'Provisioning'
}

export enum EhrEnvironment {
  NonProd = 'NonProd',
  Production = 'Production',
  Sandbox = 'Sandbox'
}

/** One EHR patient the algorithm scored. */
export type EhrMatchCandidate = {
  __typename?: 'EhrMatchCandidate';
  /** The candidate's EHR patient id (MRN). Approve takes this value. */
  external_patient_id: Scalars['String']['output'];
  /** The candidate's compared fields. */
  fields: Array<EhrMatchFieldEvidence>;
  /** The algorithm's match confidence for this candidate, in [0,1]. */
  score: Scalars['Float']['output'];
};

/** Demographic field compared by the matching algorithm. */
export enum EhrMatchField {
  Address = 'Address',
  BirthDate = 'BirthDate',
  Email = 'Email',
  Family = 'Family',
  Gender = 'Gender',
  Given = 'Given',
  Phone = 'Phone',
  PostalCode = 'PostalCode'
}

/** One compared field of one candidate. */
export type EhrMatchFieldEvidence = {
  __typename?: 'EhrMatchFieldEvidence';
  /** The demographic field compared. */
  field: EhrMatchField;
  /** How the EHR's value compared with the Engage patient's. */
  result: EhrMatchFieldResult;
  /** The EHR's value, null when it has none. */
  value?: Maybe<Scalars['String']['output']>;
};

/** How a candidate's field compared with the Engage patient's. */
export enum EhrMatchFieldResult {
  Close = 'Close',
  Different = 'Different',
  Exact = 'Exact',
  Missing = 'Missing'
}

/** One Engage value QIE compared against. */
export type EhrMatchSubjectValue = {
  __typename?: 'EhrMatchSubjectValue';
  /** The demographic field. */
  field: EhrMatchField;
  /** The Engage value QIE received, null when the patient has none. */
  value?: Maybe<Scalars['String']['output']>;
};

export type EhrPatientLink = {
  __typename?: 'EhrPatientLink';
  created_at: Scalars['DateTime']['output'];
  ehr_connection_id: Scalars['String']['output'];
  /** Display name of the user who enrolled the patient. Set by ehrSyncPatientLinks and the review queue. */
  enrolled_by_name?: Maybe<Scalars['String']['output']>;
  enrolled_by_user_id?: Maybe<Scalars['String']['output']>;
  /** The external EHR's patient identifier / MRN. */
  external_patient_id?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  /** Name and version of the algorithm that produced match_score. */
  match_algorithm?: Maybe<Scalars['String']['output']>;
  /** Match confidence in [0, 1] from the last match, if one ran. */
  match_score?: Maybe<Scalars['Float']['output']>;
  /**
   * The Engage patient. Set by ehrSyncPatientLinks and the review queue; null
   * there when the patient no longer exists.
   */
  patient?: Maybe<EhrSyncPatientSummary>;
  /** When the match was reviewed. */
  reviewed_at?: Maybe<Scalars['DateTime']['output']>;
  /** Display name of the reviewer. Set by ehrSyncPatientLinks and the review queue. */
  reviewed_by_name?: Maybe<Scalars['String']['output']>;
  /** Who approved or rejected the match in the review queue. */
  reviewed_by_user_id?: Maybe<Scalars['String']['output']>;
  status: EhrPatientLinkStatus;
  updated_at: Scalars['DateTime']['output'];
  vitall_patient_id: Scalars['String']['output'];
};

export type EhrPatientLinkRefInput = {
  link_id: Scalars['String']['input'];
};

export enum EhrPatientLinkStatus {
  AutoLinked = 'AutoLinked',
  Linked = 'Linked',
  NeedsReview = 'NeedsReview',
  NoMatch = 'NoMatch',
  Paused = 'Paused',
  Pending = 'Pending',
  Rejected = 'Rejected',
  Unlinked = 'Unlinked'
}

export type EhrPatientMatchRecord = {
  __typename?: 'EhrPatientMatchRecord';
  /** The patient link. */
  ehr_patient_link_id: Scalars['String']['output'];
  /** The EHR patient the link points at, if any. */
  external_patient_id?: Maybe<Scalars['String']['output']>;
  /** The recorded score. */
  match_score?: Maybe<Scalars['Float']['output']>;
  /** The link's status after the match. */
  status: EhrPatientLinkStatus;
};

/** A reviewer's decision on a NeedsReview patient link. */
export enum EhrPatientReviewDecision {
  Approve = 'Approve',
  Reject = 'Reject'
}

/** A NeedsReview link with its match evidence, for the review queue. */
export type EhrReviewCase = {
  __typename?: 'EhrReviewCase';
  /** Version string of the algorithm that scored the match. */
  algorithm?: Maybe<Scalars['String']['output']>;
  /** Score at or above which QIE links without review. */
  auto_link_threshold: Scalars['Float']['output'];
  /** The link's stored match score, or the top candidate's score when it has none. */
  best_score?: Maybe<Scalars['Float']['output']>;
  /** Best first. */
  candidates: Array<EhrMatchCandidate>;
  /** The NeedsReview link, with its patient summary. */
  link: EhrPatientLink;
  /** When QIE ran the match. */
  matched_at: Scalars['DateTime']['output'];
  /** Score below which QIE records no match. */
  no_match_threshold: Scalars['Float']['output'];
  /** The Engage values QIE compared against, as it received them. */
  subject: Array<EhrMatchSubjectValue>;
};

export type EhrSyncConnection = {
  __typename?: 'EhrSyncConnection';
  /** Messages completed across all of the zone's channels. */
  completed_count: Scalars['Int']['output'];
  /** Lifecycle status stored on the registry row. */
  connection_status?: Maybe<EhrConnectionStatus>;
  /** When the zone was created in QIE. */
  created_at?: Maybe<Scalars['DateTime']['output']>;
  /** QIE user id that created the zone. */
  created_by_user_id?: Maybe<Scalars['String']['output']>;
  /** The QIE zone description. */
  description?: Maybe<Scalars['String']['output']>;
  /** Registry row (Ehr_Connection) for this connection. */
  ehr_connection_id: Scalars['String']['output'];
  /** EHR environment the connection targets, from the registry row. */
  ehr_environment?: Maybe<EhrEnvironment>;
  /** EHR vendor, from the registry row. */
  ehr_vendor?: Maybe<EhrVendor>;
  /**
   * Always unset.
   * @deprecated Use ehr_environment.
   */
  environment_label?: Maybe<Scalars['String']['output']>;
  /** Messages currently sitting in the error queues of the zone's channels, summed. Not a rolling count. */
  error_count: Scalars['Int']['output'];
  /** First channel needing attention: in the Error state or with messages in its error queue. */
  error_summary?: Maybe<EhrSyncConnectionError>;
  /** Human-readable go-live date. Unset: QIE does not record it; created_at is when the zone was made, which is not the same thing. */
  go_live_label?: Maybe<Scalars['String']['output']>;
  /** Recent sync runs, newest first. Unset: QIE keeps no run log. Its messageCount route can give daily counts per channel, which is a different shape. */
  history?: Maybe<Array<EhrSyncRun>>;
  /** QIE zone id registered for the connection, or ehr_connection_id when the registry row has no zone id. */
  id: Scalars['String']['output'];
  /** Latest time any of the zone's channels received a message, as QIE reports it. */
  last_received_at?: Maybe<Scalars['DateTime']['output']>;
  /** When the connection last completed a sync run with result Success. Unset when it never has. */
  last_sync_at?: Maybe<Scalars['DateTime']['output']>;
  /** When the zone was last modified in QIE. */
  modified_at?: Maybe<Scalars['DateTime']['output']>;
  /** QIE user id that last modified the zone. */
  modified_by_user_id?: Maybe<Scalars['String']['output']>;
  /** Hospital network, set when a network runs more than one EHR (e.g. 'UHN'). From the registry row. */
  network?: Maybe<Scalars['String']['output']>;
  /** Engage account id of the organization, from the registry row. */
  organization_id: Scalars['String']['output'];
  /** Organization display name: the Engage account name, else the QIE zone description, else the registered zone name. */
  organization_name: Scalars['String']['output'];
  /** Active patients in the connection's Engage account. */
  patient_count?: Maybe<Scalars['Int']['output']>;
  /** Zone name recorded at registration. Compare with the live zone when registry_state is ZoneNameMismatch. */
  qie_zone_name?: Maybe<Scalars['String']['output']>;
  /** Messages received across all of the zone's channels. */
  record_count: Scalars['Int']['output'];
  /** How the registry row and the QIE zone line up: zone missing, renamed, provisioning, disabled or active. */
  registry_state?: Maybe<EhrSyncRegistryState>;
  /** One entry per channel in the zone, then one per policy row whose channel is not found. */
  resources: Array<EhrSyncResource>;
  /** Patient links awaiting review (NeedsReview). */
  review_count?: Maybe<Scalars['Int']['output']>;
  /** Health aggregated from the zone's channel states. */
  status: EhrSyncConnectionStatus;
};

export type EhrSyncConnectionError = {
  __typename?: 'EhrSyncConnectionError';
  /** The channel's stopped nodes, error-queue depth and last error time, or a generic message when QIE gives none. */
  body: Scalars['String']['output'];
  /** Short headline naming the channel that needs attention. */
  title: Scalars['String']['output'];
};

export enum EhrSyncConnectionStatus {
  Connected = 'Connected',
  Degraded = 'Degraded',
  Failed = 'Failed',
  Pending = 'Pending'
}

export enum EhrSyncDirection {
  Bidirectional = 'Bidirectional',
  Inbound = 'Inbound',
  Outbound = 'Outbound'
}

export type EhrSyncEnrollCandidate = {
  __typename?: 'EhrSyncEnrollCandidate';
  /**
   * True when the patient has a link that enrolling would not reset (anything
   * but Unlinked, Rejected or NoMatch). The dialog disables these.
   */
  already_enrolled: Scalars['Boolean']['output'];
  /** The patient. */
  patient: EhrSyncPatientSummary;
};

export type EhrSyncEnrollCandidatesInput = {
  ehr_connection_id: Scalars['String']['input'];
  query: Scalars['String']['input'];
};

export type EhrSyncLinkedPatient = {
  __typename?: 'EhrSyncLinkedPatient';
  /** First address, lines joined with a newline, without the postal code. */
  address?: Maybe<Scalars['String']['output']>;
  /** Birth date, `YYYY-MM-DD`. */
  birth_date?: Maybe<Scalars['String']['output']>;
  /** The patient link. Pass it back to recordEhrPatientMatch. */
  ehr_patient_link_id: Scalars['String']['output'];
  /** Email address. */
  email?: Maybe<Scalars['String']['output']>;
  /**
   * The EHR patient id. On a Pending link it is the id entered at enrolment, if
   * any; QIE MUST still run matching against that record.
   */
  external_patient_id?: Maybe<Scalars['String']['output']>;
  /** Family name. */
  family?: Maybe<Scalars['String']['output']>;
  /** FHIR AdministrativeGender code (male, female, other, unknown). */
  gender?: Maybe<Scalars['String']['output']>;
  /** Given name. */
  given?: Maybe<Scalars['String']['output']>;
  /** First phone number on the patient record. */
  phone?: Maybe<Scalars['String']['output']>;
  /** Postal code of the first address. */
  postal_code?: Maybe<Scalars['String']['output']>;
  /** Pending (match it), AutoLinked or Linked (sync it). */
  status: EhrPatientLinkStatus;
  /** The Engage patient. */
  vitall_patient_id: Scalars['String']['output'];
};

export type EhrSyncPatientSummary = {
  __typename?: 'EhrSyncPatientSummary';
  /** Birth date, `YYYY-MM-DD`, from the FHIR Patient. */
  birth_date?: Maybe<Scalars['String']['output']>;
  /** Given name, from the patient's Engage user. */
  first_name?: Maybe<Scalars['String']['output']>;
  /** FHIR AdministrativeGender code (male, female, other, unknown). */
  gender?: Maybe<Scalars['String']['output']>;
  /** Family name, from the patient's Engage user. */
  last_name?: Maybe<Scalars['String']['output']>;
  /** The Engage patient. */
  vitall_patient_id: Scalars['String']['output'];
  /** The short numeric VITALL id shown in the UI. */
  vitall_user_id?: Maybe<Scalars['Int']['output']>;
};

/** How a monitored connection stands against this environment's EHR connection registry. Separate from the runtime status of its channels. */
export enum EhrSyncRegistryState {
  /** Registered as Active, or Provisioning with a channel running, and the zone matches by id and name. */
  Active = 'Active',
  /** Registered as Disabled. Takes precedence over the zone checks. */
  Disabled = 'Disabled',
  /** Registered as Provisioning and no channel is running yet. */
  Provisioning = 'Provisioning',
  /** The QIE zone with the registered id has a different name than the one registered, usually because it was renamed in QIE. */
  ZoneNameMismatch = 'ZoneNameMismatch',
  /** No QIE zone in this environment has the registered zone id. */
  ZoneNotFound = 'ZoneNotFound'
}

export type EhrSyncResource = {
  __typename?: 'EhrSyncResource';
  /** QIE channel id. Unset when the policy row's channel is not found in QIE. */
  channel_id?: Maybe<Scalars['String']['output']>;
  /** QIE channel name, as shown in the QIE UI. When the channel is not found, the name the policy row expects. */
  channel_name: Scalars['String']['output'];
  /** Messages this channel finished processing. */
  completed_count?: Maybe<Scalars['Int']['output']>;
  /** Direction the resource syncs, from the org's EHR perspective, as recorded on the policy row. Read-only; unset until something records it. */
  direction?: Maybe<EhrSyncDirection>;
  /** Ehr_Sync_Resource policy row for this resource. Unset when the channel has no policy row. */
  ehr_sync_resource_id?: Maybe<Scalars['String']['output']>;
  /** Whether the policy row enables syncing this resource. False when the channel has no policy row. */
  enabled: Scalars['Boolean']['output'];
  /** Messages sitting in the channel's error queue. Current depth, not a rolling count. */
  error_queue?: Maybe<Scalars['Int']['output']>;
  /** True when the interface/channel isn't built yet. Unset: a channel QIE lists exists by definition, so this needs a catalog of expected resources. */
  gated?: Maybe<Scalars['Boolean']['output']>;
  /** Messages waiting in the channel's inbound queue. */
  inbound_queue?: Maybe<Scalars['Int']['output']>;
  /** Whether the channel is enabled in QIE. Distinct from state: a disabled channel is not merely stopped. */
  is_enabled?: Maybe<Scalars['Boolean']['output']>;
  /** When the channel last errored a message. QIE reports the time only, not the error text. */
  last_error_at?: Maybe<Scalars['DateTime']['output']>;
  /** When the channel last received a message. */
  last_received_at?: Maybe<Scalars['DateTime']['output']>;
  /** Messages waiting in the channel's outbound queue. */
  outbound_queue?: Maybe<Scalars['Int']['output']>;
  /** Whether the channel and its policy row were both found, or which one is missing. */
  policy_state: EhrSyncResourcePolicyState;
  /** When the policy row last changed. Unset when there is no policy row. */
  policy_updated_at?: Maybe<Scalars['DateTime']['output']>;
  /** Messages the channel is processing right now. */
  processing_queue?: Maybe<Scalars['Int']['output']>;
  /** Messages received on this channel and not yet purged by QIE's retention policy. */
  received_count?: Maybe<Scalars['Int']['output']>;
  /** FHIR resource type this channel syncs, e.g. Patient. The policy row's resource_type, else the channel name. */
  resource_type: Scalars['String']['output'];
  /** Subset of the resource the channel is limited to. Unset: QIE does not report it. */
  scope?: Maybe<Scalars['String']['output']>;
  /** Runtime state of the channel, as QIE reports it. Unset when the channel is not found in QIE. */
  state?: Maybe<EhrSyncResourceState>;
  /** QIE's name for the state: STOPPED, PAUSED, RUNNING, ERROR or STOPPING. */
  state_description?: Maybe<Scalars['String']['output']>;
  /** Stopped nodes in the channel, as "{index}. {name}", e.g. "3. My Destination". */
  stopped_nodes?: Maybe<Array<Scalars['String']['output']>>;
  /** Free text the channel author set in the channel properties. */
  version_info?: Maybe<Scalars['String']['output']>;
};

export type EhrSyncResourceConfig = {
  __typename?: 'EhrSyncResourceConfig';
  account_id: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  /** Mirrors the QIE channel's direction; null until the channel is matched. */
  direction?: Maybe<EhrSyncDirection>;
  ehr_connection_id: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  /** The QIE channel that moves this resource type; filled by the monitoring join. */
  qie_channel_name?: Maybe<Scalars['String']['output']>;
  resource_type: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type EhrSyncResourcePolicy = {
  __typename?: 'EhrSyncResourcePolicy';
  /** The channel's direction, once known. Read only. */
  direction?: Maybe<EhrSyncDirection>;
  /** false means QIE MUST skip this resource on its next poll. */
  enabled: Scalars['Boolean']['output'];
  /** The QIE channel that moves this resource type, once known. */
  qie_channel_name?: Maybe<Scalars['String']['output']>;
  /** FHIR resource type, e.g. `Observation`. */
  resource_type: Scalars['String']['output'];
};

/** How a resource's QIE channel lines up with its sync policy row. */
export enum EhrSyncResourcePolicyState {
  /** A policy row exists but QIE has no matching channel. */
  ChannelNotFound = 'ChannelNotFound',
  /** A policy row exists and its channel is present in QIE. */
  Configured = 'Configured',
  /** New channel in QIE with no policy row. Treated as not enabled until someone enables it. */
  NoPolicy = 'NoPolicy'
}

export enum EhrSyncResourceState {
  Error = 'Error',
  Paused = 'Paused',
  Running = 'Running',
  Stopped = 'Stopped',
  Stopping = 'Stopping'
}

export enum EhrSyncResult {
  Failed = 'Failed',
  Partial = 'Partial',
  Success = 'Success'
}

export type EhrSyncRun = {
  __typename?: 'EhrSyncRun';
  /** When the run started. */
  at: Scalars['DateTime']['output'];
  /** Free-text notes on the run. */
  detail?: Maybe<Scalars['String']['output']>;
  /** Human-readable run duration. */
  duration_label?: Maybe<Scalars['String']['output']>;
  /** Outcome of the run. */
  result: EhrSyncResult;
  /** What started the run, e.g. schedule or manual. */
  trigger: Scalars['String']['output'];
};

export type EhrSyncRunRecord = {
  __typename?: 'EhrSyncRunRecord';
  /** Per-resource-type counts. */
  counts?: Maybe<Scalars['JSON']['output']>;
  /** The connection the run belongs to. */
  ehr_connection_id: Scalars['String']['output'];
  /** The run. */
  ehr_sync_run_id: Scalars['String']['output'];
  /** What went wrong, if anything. */
  error_summary?: Maybe<Scalars['String']['output']>;
  /** When the run finished, if it has. */
  finished_at?: Maybe<Scalars['DateTime']['output']>;
  /** QIE's message id for the run. */
  qie_message_id?: Maybe<Scalars['String']['output']>;
  /** Outcome of the run; absent while it is still running. */
  result?: Maybe<EhrSyncResult>;
  /** When the run started. */
  started_at: Scalars['DateTime']['output'];
  /** What started the run. */
  trigger: EhrSyncTrigger;
};

export enum EhrSyncTrigger {
  Manual = 'Manual',
  Review = 'Review',
  Schedule = 'Schedule'
}

export enum EhrVendor {
  Cerner = 'Cerner',
  Epic = 'Epic',
  Other = 'Other'
}

export type EhrZoneCheck = {
  __typename?: 'EhrZoneCheck';
  /** Channels in the zone, when it exists. */
  channel_count?: Maybe<Scalars['Int']['output']>;
  /** QIE's zone id, when the zone exists. */
  qie_zone_id?: Maybe<Scalars['String']['output']>;
  /** The name that was checked, trimmed. */
  qie_zone_name: Scalars['String']['output'];
  /** The organization the zone is already registered to, for AlreadyRegistered. */
  registered_account_name?: Maybe<Scalars['String']['output']>;
  /** What the check found. */
  result: EhrZoneCheckResult;
  /** This environment's zone prefix, e.g. `dev-`, for the OutsideEnvironment message. */
  zone_prefix?: Maybe<Scalars['String']['output']>;
};

export enum EhrZoneCheckResult {
  AlreadyRegistered = 'AlreadyRegistered',
  Found = 'Found',
  NotFound = 'NotFound',
  OutsideEnvironment = 'OutsideEnvironment'
}

export type EmailExistsInput = {
  /** Email address to check for existence */
  email: Scalars['String']['input'];
};

export type EmailInput = {
  /** User email address */
  email: Scalars['String']['input'];
};

export enum EmrApiType {
  Cerner = 'Cerner',
  Epic = 'Epic'
}

export type EmrConnectionInput = {
  /** Identifier of the EMR FHIR API endpoint to connect */
  fhir_api_endpoint_id: Scalars['String']['input'];
  /** Vitall patient identifier for the EMR connection */
  vitall_patient_id: Scalars['String']['input'];
};

/** EnableMFAResponseModel */
export type EnableMfaResponseModel = {
  __typename?: 'EnableMFAResponseModel';
  /** MFA setup code to register the authenticator */
  code: Scalars['String']['output'];
};

export type EnableMfaInput = {
  /** Verification code confirming setup */
  code?: InputMaybe<Scalars['String']['input']>;
  /** MFA method to enable */
  method: MfaMethod;
  /** Preferred MFA method to set */
  preferredMethod: MfaMethod;
};

export enum EncounterHistoryStatus {
  active = 'active',
  completed = 'completed',
  planned = 'planned',
  reserved = 'reserved'
}

export enum EncounterLocationStatus {
  active = 'active',
  completed = 'completed',
  planned = 'planned',
  reserved = 'reserved'
}

/** EncounterModel */
export type EncounterModel = {
  __typename?: 'EncounterModel';
  /** Accounts used for billing this encounter */
  account?: Maybe<Array<Reference>>;
  /** Appointment that scheduled this encounter */
  appointment?: Maybe<Array<Reference>>;
  associatedResources?: Maybe<Array<ResourceAssociationUnion>>;
  attachments?: Maybe<Array<Attachment>>;
  /** Service request that initiated this encounter */
  basedOn?: Maybe<Array<Reference>>;
  /** Classification of the patient encounter */
  class: Coding;
  /** List of past encounter classes */
  classHistory?: Maybe<Array<ClassHistory>>;
  /** Contained */
  contained?: Maybe<Array<Resource>>;
  /** Curation metadata for this encounter resource */
  curationMeta?: Maybe<CurationMeta>;
  /** Diagnoses relevant to this encounter */
  diagnosis?: Maybe<Array<Diagnosis>>;
  displayName?: Maybe<Scalars['String']['output']>;
  /** Episodes of care this encounter is recorded against */
  episodeOfCare?: Maybe<Array<Reference>>;
  /** Extension */
  extension?: Maybe<Array<Extension>>;
  /** Details about admission to a healthcare service */
  hospitalization?: Maybe<Hospitalization>;
  /** Logical id of this artifact */
  id?: Maybe<Scalars['String']['output']>;
  /** External identifiers for this encounter */
  identifier?: Maybe<Array<Identifier>>;
  /** A set of rules under which this content was created */
  implicitRules?: Maybe<Scalars['String']['output']>;
  /** Language of the resource content */
  language?: Maybe<Scalars['String']['output']>;
  /** Duration the encounter lasted, excluding absences */
  length?: Maybe<Quantity>;
  /** Locations where the patient has been */
  location?: Maybe<Array<Location>>;
  /** Location resources referenced by this encounter */
  locationResource?: Maybe<Array<LocationModel>>;
  /** Metadata about the resource */
  meta?: Maybe<Meta>;
  /** Another encounter this encounter is part of */
  partOf?: Maybe<Reference>;
  /** Participants involved in the encounter */
  participant?: Maybe<Array<EncounterParticipant>>;
  /** Start and end time of the encounter */
  period?: Maybe<Period>;
  /** Urgency of the encounter */
  priority?: Maybe<CodeableConcept>;
  /** Coded reason the encounter takes place */
  reasonCode?: Maybe<Array<CodeableConcept>>;
  /** Referenced reason the encounter takes place */
  reasonReference?: Maybe<Array<Reference>>;
  /** FHIR resource type, always Encounter */
  resourceType?: Maybe<Scalars['String']['output']>;
  /** Organization responsible for this encounter */
  serviceProvider?: Maybe<Reference>;
  /** Specific type of service provided */
  serviceType?: Maybe<CodeableConcept>;
  /** Current status of the encounter */
  status: Scalars['String']['output'];
  /** List of past encounter statuses */
  statusHistory?: Maybe<Array<StatusHistory>>;
  /** Patient or group present at the encounter */
  subject?: Maybe<Reference>;
  /** Text */
  text?: Maybe<Narrative>;
  /** Specific type of encounter */
  type?: Maybe<Array<CodeableConcept>>;
};

export type EncounterModelInput = {
  /** Accounts used for billing this encounter */
  account?: InputMaybe<Array<ReferenceInput>>;
  /** Appointment that scheduled this encounter */
  appointment?: InputMaybe<Array<ReferenceInput>>;
  /** Service request that initiated this encounter */
  basedOn?: InputMaybe<Array<ReferenceInput>>;
  /** Classification of the patient encounter */
  class: CodingInput;
  /** List of past encounter classes */
  classHistory?: InputMaybe<Array<ClassHistoryInput>>;
  /** Contained */
  contained?: InputMaybe<Array<ResourceInput>>;
  /** Diagnoses relevant to this encounter */
  diagnosis?: InputMaybe<Array<DiagnosisInput>>;
  /** Episodes of care this encounter is recorded against */
  episodeOfCare?: InputMaybe<Array<ReferenceInput>>;
  /** Extension */
  extension?: InputMaybe<Array<ExtensionInput>>;
  /** Details about admission to a healthcare service */
  hospitalization?: InputMaybe<HospitalizationInput>;
  /** Logical id of this artifact */
  id?: InputMaybe<Scalars['String']['input']>;
  /** External identifiers for this encounter */
  identifier?: InputMaybe<Array<IdentifierInput>>;
  /** A set of rules under which this content was created */
  implicitRules?: InputMaybe<Scalars['String']['input']>;
  /** Language of the resource content */
  language?: InputMaybe<Scalars['String']['input']>;
  /** Duration the encounter lasted, excluding absences */
  length?: InputMaybe<QuantityInput>;
  /** Locations where the patient has been */
  location?: InputMaybe<Array<LocationInput>>;
  /** Metadata about the resource */
  meta?: InputMaybe<MetaInput>;
  /** Another encounter this encounter is part of */
  partOf?: InputMaybe<ReferenceInput>;
  /** Participants involved in the encounter */
  participant?: InputMaybe<Array<EncounterParticipantInput>>;
  /** Start and end time of the encounter */
  period?: InputMaybe<PeriodInput>;
  /** Urgency of the encounter */
  priority?: InputMaybe<CodeableConceptInput>;
  /** Coded reason the encounter takes place */
  reasonCode?: InputMaybe<Array<CodeableConceptInput>>;
  /** Referenced reason the encounter takes place */
  reasonReference?: InputMaybe<Array<ReferenceInput>>;
  /** FHIR resource type, always Encounter */
  resourceType?: InputMaybe<Scalars['String']['input']>;
  /** Organization responsible for this encounter */
  serviceProvider?: InputMaybe<ReferenceInput>;
  /** Specific type of service provided */
  serviceType?: InputMaybe<CodeableConceptInput>;
  /** Current status of the encounter */
  status: EncounterStatus;
  /** List of past encounter statuses */
  statusHistory?: InputMaybe<Array<StatusHistoryInput>>;
  /** Patient or group present at the encounter */
  subject?: InputMaybe<ReferenceInput>;
  /** Text */
  text?: InputMaybe<NarrativeInput>;
  /** Specific type of encounter */
  type?: InputMaybe<Array<CodeableConceptInput>>;
};

export type EncounterParticipant = {
  __typename?: 'EncounterParticipant';
  /** Person involved in the encounter besides the patient */
  individual?: Maybe<Reference>;
  /** Period during which the participant took part */
  period?: Maybe<Period>;
  /** Role of the participant in the encounter */
  type?: Maybe<Array<CodeableConcept>>;
};

export type EncounterParticipantInput = {
  /** Person involved in the encounter besides the patient */
  individual?: InputMaybe<ReferenceInput>;
  /** Period during which the participant took part */
  period?: InputMaybe<PeriodInput>;
  /** Role of the participant in the encounter */
  type?: InputMaybe<Array<CodeableConceptInput>>;
};

export enum EncounterStatus {
  arrived = 'arrived',
  cancelled = 'cancelled',
  finished = 'finished',
  inProgress = 'inProgress',
  onleave = 'onleave',
  planned = 'planned',
  triaged = 'triaged'
}

export type EndTitrationCarePlanInput = {
  /** Date the titration program ends */
  end_date?: InputMaybe<Scalars['DateTime']['input']>;
  /** FHIR Patient id whose titration plan is ending */
  patient_id: Scalars['String']['input'];
  /** Titration program being ended */
  program: TitrationProgram;
  /** Optional note explaining why the program ended */
  reason_note?: InputMaybe<Scalars['String']['input']>;
  /** Reasons for ending the titration program */
  reasons: Array<EndTitrationDecision>;
};

export enum EndTitrationDecision {
  AbnormalBloodwork = 'AbnormalBloodwork',
  DecliningFurther = 'DecliningFurther',
  MaxDoseTolerated = 'MaxDoseTolerated',
  Other = 'Other'
}

export type EnrollEhrSyncPatientInput = {
  ehr_connection_id: Scalars['String']['input'];
  external_patient_id?: InputMaybe<Scalars['String']['input']>;
  vitall_patient_id: Scalars['String']['input'];
};

export type Evidence = {
  __typename?: 'Evidence';
  /** Code */
  code?: Maybe<Array<CodeableConcept>>;
  /** Detail */
  detail?: Maybe<Array<Reference>>;
};

export type EvidenceInput = {
  /** Code */
  code?: InputMaybe<Array<CodeableConceptInput>>;
  /** Detail */
  detail?: InputMaybe<Array<ReferenceInput>>;
};

export type ExchangeHandoffTokenInput = {
  /** The single-use token from the URL fragment */
  token: Scalars['String']['input'];
};

/** ExpectedUploadHeaders */
export type ExpectedUploadHeaders = {
  __typename?: 'ExpectedUploadHeaders';
  /** Content-Disposition header required on the upload request */
  contentDisposition: Scalars['String']['output'];
  /** Content-Type header required on the upload request */
  contentType: Scalars['String']['output'];
};

export type Expression = {
  __typename?: 'Expression';
  /** Description */
  description?: Maybe<Scalars['String']['output']>;
  /** Expression */
  expression?: Maybe<Scalars['String']['output']>;
  /** Language */
  language?: Maybe<Scalars['String']['output']>;
  /** Name */
  name?: Maybe<Scalars['String']['output']>;
  /** Reference */
  reference?: Maybe<Scalars['String']['output']>;
};

export type ExpressionInput = {
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Expression */
  expression?: InputMaybe<Scalars['String']['input']>;
  /** Language */
  language?: InputMaybe<Scalars['String']['input']>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Reference */
  reference?: InputMaybe<Scalars['String']['input']>;
};

export type Extension = {
  __typename?: 'Extension';
  /** Url */
  url: Scalars['String']['output'];
  /** Value address */
  valueAddress?: Maybe<Address>;
  /** Value age */
  valueAge?: Maybe<Age>;
  /** Value annotation */
  valueAnnotation?: Maybe<Annotation>;
  /** Value attachment */
  valueAttachment?: Maybe<Attachment>;
  /** Value base64 binary */
  valueBase64Binary?: Maybe<Scalars['String']['output']>;
  /** Value boolean */
  valueBoolean?: Maybe<Scalars['Boolean']['output']>;
  /** Value canonical */
  valueCanonical?: Maybe<Scalars['String']['output']>;
  /** Value code */
  valueCode?: Maybe<Scalars['String']['output']>;
  /** Value codeable concept */
  valueCodeableConcept?: Maybe<CodeableConcept>;
  /** Value codeable reference */
  valueCodeableReference?: Maybe<CodeableReference>;
  /** Value coding */
  valueCoding?: Maybe<Coding>;
  /** Value contact detail */
  valueContactDetail?: Maybe<ContactDetail>;
  /** Value contact point */
  valueContactPoint?: Maybe<ContactPoint>;
  /** Value contributor */
  valueContributor?: Maybe<Contributor>;
  /** Value count */
  valueCount?: Maybe<Quantity>;
  /** Value data requirement */
  valueDataRequirement?: Maybe<DataRequirement>;
  /** Value date */
  valueDate?: Maybe<Scalars['String']['output']>;
  /** Value date time */
  valueDateTime?: Maybe<Scalars['String']['output']>;
  /** Value decimal */
  valueDecimal?: Maybe<Scalars['Float']['output']>;
  /** Value distance */
  valueDistance?: Maybe<Quantity>;
  /** Value dosage */
  valueDosage?: Maybe<Dosage>;
  /** Value duration */
  valueDuration?: Maybe<Quantity>;
  /** Value expression */
  valueExpression?: Maybe<Expression>;
  /** Value human name */
  valueHumanName?: Maybe<HumanName>;
  /** Value id */
  valueId?: Maybe<Scalars['String']['output']>;
  /** Value identifier */
  valueIdentifier?: Maybe<Identifier>;
  /** Value instant */
  valueInstant?: Maybe<Scalars['String']['output']>;
  /** Value integer */
  valueInteger?: Maybe<Scalars['Float']['output']>;
  /** Value markdown */
  valueMarkdown?: Maybe<Scalars['String']['output']>;
  /** Value money */
  valueMoney?: Maybe<Money>;
  /** Value oid */
  valueOid?: Maybe<Scalars['String']['output']>;
  /** Value parameter definition */
  valueParameterDefinition?: Maybe<ParameterDefinition>;
  /** Value period */
  valuePeriod?: Maybe<Period>;
  /** Value positive int */
  valuePositiveInt?: Maybe<Scalars['Float']['output']>;
  /** Value quantity */
  valueQuantity?: Maybe<Quantity>;
  /** Value range */
  valueRange?: Maybe<Range>;
  /** Value ratio */
  valueRatio?: Maybe<Ratio>;
  /** Value ratio range */
  valueRatioRange?: Maybe<RatioRange>;
  /** Value reference */
  valueReference?: Maybe<Reference>;
  /** Value related artifact */
  valueRelatedArtifact?: Maybe<RelatedArtifact>;
  /** Value sampled data */
  valueSampledData?: Maybe<SampledData>;
  /** Value signature */
  valueSignature?: Maybe<Signature>;
  /** Value string */
  valueString?: Maybe<Scalars['String']['output']>;
  /** Value time */
  valueTime?: Maybe<Scalars['String']['output']>;
  /** Value timing */
  valueTiming?: Maybe<Timing>;
  /** Value trigger definition */
  valueTriggerDefinition?: Maybe<TriggerDefinition>;
  /** Value unsigned int */
  valueUnsignedInt?: Maybe<Scalars['Float']['output']>;
  /** Value uri */
  valueUri?: Maybe<Scalars['String']['output']>;
  /** Value url */
  valueUrl?: Maybe<Scalars['String']['output']>;
  /** Value usage context */
  valueUsageContext?: Maybe<UsageContext>;
  /** Value uuid */
  valueUuid?: Maybe<Scalars['String']['output']>;
};

export type ExtensionInput = {
  /** Url */
  url: Scalars['String']['input'];
  /** Value address */
  valueAddress?: InputMaybe<AddressInput>;
  /** Value age */
  valueAge?: InputMaybe<AgeInput>;
  /** Value annotation */
  valueAnnotation?: InputMaybe<AnnotationInput>;
  /** Value attachment */
  valueAttachment?: InputMaybe<AttachmentInput>;
  /** Value base64 binary */
  valueBase64Binary?: InputMaybe<Scalars['String']['input']>;
  /** Value boolean */
  valueBoolean?: InputMaybe<Scalars['Boolean']['input']>;
  /** Value canonical */
  valueCanonical?: InputMaybe<Scalars['String']['input']>;
  /** Value code */
  valueCode?: InputMaybe<Scalars['String']['input']>;
  /** Value codeable concept */
  valueCodeableConcept?: InputMaybe<CodeableConceptInput>;
  /** Value codeable reference */
  valueCodeableReference?: InputMaybe<CodeableReferenceInput>;
  /** Value coding */
  valueCoding?: InputMaybe<CodingInput>;
  /** Value contact detail */
  valueContactDetail?: InputMaybe<ContactDetailInput>;
  /** Value contact point */
  valueContactPoint?: InputMaybe<ContactPointInput>;
  /** Value contributor */
  valueContributor?: InputMaybe<ContributorInput>;
  /** Value count */
  valueCount?: InputMaybe<QuantityInput>;
  /** Value data requirement */
  valueDataRequirement?: InputMaybe<DataRequirementInput>;
  /** Value date */
  valueDate?: InputMaybe<Scalars['String']['input']>;
  /** Value date time */
  valueDateTime?: InputMaybe<Scalars['String']['input']>;
  /** Value decimal */
  valueDecimal?: InputMaybe<Scalars['Float']['input']>;
  /** Value distance */
  valueDistance?: InputMaybe<QuantityInput>;
  /** Value dosage */
  valueDosage?: InputMaybe<DosageInput>;
  /** Value duration */
  valueDuration?: InputMaybe<QuantityInput>;
  /** Value expression */
  valueExpression?: InputMaybe<ExpressionInput>;
  /** Value human name */
  valueHumanName?: InputMaybe<HumanNameInput>;
  /** Value id */
  valueId?: InputMaybe<Scalars['String']['input']>;
  /** Value identifier */
  valueIdentifier?: InputMaybe<IdentifierInput>;
  /** Value instant */
  valueInstant?: InputMaybe<Scalars['String']['input']>;
  /** Value integer */
  valueInteger?: InputMaybe<Scalars['Float']['input']>;
  /** Value markdown */
  valueMarkdown?: InputMaybe<Scalars['String']['input']>;
  /** Value money */
  valueMoney?: InputMaybe<MoneyInput>;
  /** Value oid */
  valueOid?: InputMaybe<Scalars['String']['input']>;
  /** Value parameter definition */
  valueParameterDefinition?: InputMaybe<ParameterDefinitionInput>;
  /** Value period */
  valuePeriod?: InputMaybe<PeriodInput>;
  /** Value positive int */
  valuePositiveInt?: InputMaybe<Scalars['Float']['input']>;
  /** Value quantity */
  valueQuantity?: InputMaybe<QuantityInput>;
  /** Value range */
  valueRange?: InputMaybe<RangeInput>;
  /** Value ratio */
  valueRatio?: InputMaybe<RatioInput>;
  /** Value ratio range */
  valueRatioRange?: InputMaybe<RatioRangeInput>;
  /** Value reference */
  valueReference?: InputMaybe<ReferenceInput>;
  /** Value related artifact */
  valueRelatedArtifact?: InputMaybe<RelatedArtifactInput>;
  /** Value sampled data */
  valueSampledData?: InputMaybe<SampledDataInput>;
  /** Value signature */
  valueSignature?: InputMaybe<SignatureInput>;
  /** Value string */
  valueString?: InputMaybe<Scalars['String']['input']>;
  /** Value time */
  valueTime?: InputMaybe<Scalars['String']['input']>;
  /** Value timing */
  valueTiming?: InputMaybe<TimingInput>;
  /** Value trigger definition */
  valueTriggerDefinition?: InputMaybe<TriggerDefinitionInput>;
  /** Value unsigned int */
  valueUnsignedInt?: InputMaybe<Scalars['Float']['input']>;
  /** Value uri */
  valueUri?: InputMaybe<Scalars['String']['input']>;
  /** Value url */
  valueUrl?: InputMaybe<Scalars['String']['input']>;
  /** Value usage context */
  valueUsageContext?: InputMaybe<UsageContextInput>;
  /** Value uuid */
  valueUuid?: InputMaybe<Scalars['String']['input']>;
};

export type FamilyMemberHistoryCondition = {
  __typename?: 'FamilyMemberHistoryCondition';
  /** Condition suffered by the family member */
  code: CodeableConcept;
  /** Whether the condition contributed to the cause of death */
  contributedToDeath?: Maybe<Scalars['Boolean']['output']>;
  /** Extra information about the condition. */
  note?: Maybe<Array<Annotation>>;
  /** Age at which the condition first manifested */
  onsetAge?: Maybe<Quantity>;
  /** Period during which the condition first manifested */
  onsetPeriod?: Maybe<Period>;
  /** Age range over which the condition first manifested */
  onsetRange?: Maybe<Range>;
  /** Free-text description of when the condition first manifested */
  onsetString?: Maybe<Scalars['String']['output']>;
  /** Outcome of the condition, e.g. deceased or permanent disability */
  outcome?: Maybe<CodeableConcept>;
};

export type FamilyMemberHistoryConditionInput = {
  /** Condition suffered by the family member */
  code: CodeableConceptInput;
  /** Whether the condition contributed to the cause of death */
  contributedToDeath?: InputMaybe<Scalars['Boolean']['input']>;
  /** Extra information about the condition - see `FamilyMemberHistoryCondition.note`. */
  note?: InputMaybe<Array<AnnotationInput>>;
  /** Age at which the condition first manifested */
  onsetAge?: InputMaybe<QuantityInput>;
  /** Period during which the condition first manifested */
  onsetPeriod?: InputMaybe<PeriodInput>;
  /** Age range over which the condition first manifested */
  onsetRange?: InputMaybe<RangeInput>;
  /** Free-text description of when the condition first manifested */
  onsetString?: InputMaybe<Scalars['String']['input']>;
  /** Outcome of the condition, e.g. deceased or permanent disability */
  outcome?: InputMaybe<CodeableConceptInput>;
};

/** FamilyMemberHistoryModel */
export type FamilyMemberHistoryModel = {
  __typename?: 'FamilyMemberHistoryModel';
  /** Approximate age of the family member */
  ageAge?: Maybe<Scalars['Float']['output']>;
  /** Approximate age range of the family member */
  ageRange?: Maybe<Range>;
  /** Free-text approximation of the family member's age */
  ageString?: Maybe<Scalars['String']['output']>;
  associatedResources?: Maybe<Array<ResourceAssociationUnion>>;
  attachments?: Maybe<Array<Attachment>>;
  /** Approximate date of the family member's birth */
  bornDate?: Maybe<Scalars['String']['output']>;
  /** Approximate period of the family member's birth */
  bornPeriod?: Maybe<Period>;
  /** Free-text approximation of the family member's birth */
  bornString?: Maybe<Scalars['String']['output']>;
  /** Conditions suffered by the family member */
  condition?: Maybe<Array<FamilyMemberHistoryCondition>>;
  /** Contained */
  contained?: Maybe<Array<Resource>>;
  /** Curation metadata for this family member history resource */
  curationMeta?: Maybe<CurationMeta>;
  /** Reason history data is absent, e.g. subject-unknown or withheld */
  dataAbsentReason?: Maybe<CodeableConcept>;
  /** When the history was recorded or last updated */
  date?: Maybe<Scalars['String']['output']>;
  /** Age at which the family member died */
  deceasedAge?: Maybe<Scalars['Float']['output']>;
  /** Whether the family member is deceased */
  deceasedBoolean?: Maybe<Scalars['Boolean']['output']>;
  /** Date on which the family member died */
  deceasedDate?: Maybe<Scalars['String']['output']>;
  /** Age range within which the family member died */
  deceasedRange?: Maybe<Range>;
  /** Free-text description of the family member's death */
  deceasedString?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  /** Whether the family member's age is estimated */
  estimatedAge?: Maybe<Scalars['Boolean']['output']>;
  /** Extension */
  extension?: Maybe<Array<Extension>>;
  /** Logical id of this FHIR resource */
  id?: Maybe<Scalars['String']['output']>;
  /** External identifiers for this record */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /** A set of rules under which this content was created */
  implicitRules?: Maybe<Scalars['String']['output']>;
  /** External protocols or definitions this record instantiates */
  instantiatesUri?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Language of the resource content */
  language?: Maybe<Scalars['String']['output']>;
  /** Metadata about the resource */
  meta?: Maybe<Meta>;
  /** Name of the family member described */
  name?: Maybe<Scalars['String']['output']>;
  /** General clinical notes about the family member history */
  note?: Maybe<Array<Annotation>>;
  /** Patient whose family history this record describes */
  patient: Reference;
  /** Reason the family member history was performed */
  reasonCode?: Maybe<CodeableConcept>;
  /** Resources justifying why the family member history was performed */
  reasonReference?: Maybe<Array<Maybe<Reference>>>;
  /** Relationship of the family member to the patient */
  relationship: CodeableConcept;
  /** FHIR resource type, always "FamilyMemberHistory" */
  resourceType?: Maybe<Scalars['String']['output']>;
  /** Sex of the family member: male, female, other or unknown */
  sex?: Maybe<CodeableConcept>;
  /** Record status: partial, completed, entered-in-error or health-unknown */
  status: Scalars['String']['output'];
  /** Text */
  text?: Maybe<Narrative>;
};

export type FamilyMemberHistoryModelInput = {
  /** Approximate age of the family member */
  ageAge?: InputMaybe<Scalars['Float']['input']>;
  /** Approximate age range of the family member */
  ageRange?: InputMaybe<RangeInput>;
  /** Free-text approximation of the family member's age */
  ageString?: InputMaybe<Scalars['String']['input']>;
  /** Approximate date of the family member's birth */
  bornDate?: InputMaybe<Scalars['String']['input']>;
  /** Approximate period of the family member's birth */
  bornPeriod?: InputMaybe<PeriodInput>;
  /** Free-text approximation of the family member's birth */
  bornString?: InputMaybe<Scalars['String']['input']>;
  /** Conditions suffered by the family member */
  condition?: InputMaybe<Array<FamilyMemberHistoryConditionInput>>;
  /** Contained */
  contained?: InputMaybe<Array<ResourceInput>>;
  /** Reason history data is absent, e.g. subject-unknown or withheld */
  dataAbsentReason?: InputMaybe<CodeableConceptInput>;
  /** When the history was recorded or last updated */
  date?: InputMaybe<Scalars['String']['input']>;
  /** Age at which the family member died */
  deceasedAge?: InputMaybe<Scalars['Float']['input']>;
  /** Whether the family member is deceased */
  deceasedBoolean?: InputMaybe<Scalars['Boolean']['input']>;
  /** Date on which the family member died */
  deceasedDate?: InputMaybe<Scalars['String']['input']>;
  /** Age range within which the family member died */
  deceasedRange?: InputMaybe<RangeInput>;
  /** Free-text description of the family member's death */
  deceasedString?: InputMaybe<Scalars['String']['input']>;
  /** Whether the family member's age is estimated */
  estimatedAge?: InputMaybe<Scalars['Boolean']['input']>;
  /** Extension */
  extension?: InputMaybe<Array<ExtensionInput>>;
  /** Logical id of this FHIR resource */
  id?: InputMaybe<Scalars['String']['input']>;
  /** External identifiers for this record */
  identifier?: InputMaybe<Array<InputMaybe<IdentifierInput>>>;
  /** A set of rules under which this content was created */
  implicitRules?: InputMaybe<Scalars['String']['input']>;
  /** External protocols or definitions this record instantiates */
  instantiatesUri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Language of the resource content */
  language?: InputMaybe<Scalars['String']['input']>;
  /** Metadata about the resource */
  meta?: InputMaybe<MetaInput>;
  /** Name of the family member described */
  name?: InputMaybe<Scalars['String']['input']>;
  /** General clinical notes about the family member history */
  note?: InputMaybe<Array<AnnotationInput>>;
  /** Patient whose family history this record describes */
  patient: ReferenceInput;
  /** Reason the family member history was performed */
  reasonCode?: InputMaybe<CodeableConceptInput>;
  /** Resources justifying why the family member history was performed */
  reasonReference?: InputMaybe<Array<InputMaybe<ReferenceInput>>>;
  /** Relationship of the family member to the patient */
  relationship: CodeableConceptInput;
  /** FHIR resource type, always FamilyMemberHistory */
  resourceType?: InputMaybe<Scalars['String']['input']>;
  /** Sex of the family member: male, female, other or unknown */
  sex?: InputMaybe<CodeableConceptInput>;
  /** Record status: partial, completed, entered-in-error or health-unknown */
  status: FamilyMemberHistoryStatus;
  /** Text */
  text?: InputMaybe<NarrativeInput>;
};

export enum FamilyMemberHistoryStatus {
  completed = 'completed',
  enteredInError = 'enteredInError',
  healthUnknown = 'healthUnknown',
  partial = 'partial'
}

export type Feature = {
  __typename?: 'Feature';
  /** Name of the enabled feature */
  feature: Scalars['String']['output'];
};

export enum FeedbackEmailType {
  Client_Feedback = 'Client_Feedback',
  Emr_Connection = 'Emr_Connection',
  Information_Request = 'Information_Request',
  Registrar_Feedback = 'Registrar_Feedback'
}

export enum FhirVersion {
  DSTU2 = 'DSTU2',
  R4 = 'R4'
}

/** FieldChange */
export type FieldChange = {
  __typename?: 'FieldChange';
  /** Value after the change */
  after?: Maybe<Scalars['String']['output']>;
  /** Value before the change */
  before?: Maybe<Scalars['String']['output']>;
  /** Name of the changed field */
  field: Scalars['String']['output'];
};

export type FileInput = {
  /** MIME content type of the file */
  contentType: Scalars['String']['input'];
  /** Original file name */
  name: Scalars['String']['input'];
  /** File size in bytes */
  size: Scalars['Float']['input'];
};

export type FileUploadSession = {
  __typename?: 'FileUploadSession';
  /** Headers the client must send on each single-part PUT */
  expectedHeaders?: Maybe<ExpectedUploadHeaders>;
  /** Whether the session uses multipart transfer */
  is_multipart: Scalars['Boolean']['output'];
  /** S3 multipart upload identifier, if multipart */
  multipart_upload_id?: Maybe<Scalars['String']['output']>;
  /** Presigned parts for a multipart upload */
  parts: Array<PartModel>;
  /** Destination S3 object key for the upload */
  s3_key: Scalars['String']['output'];
  /** Unique upload session identifier */
  session_id: Scalars['String']['output'];
};

export type FocalDevice = {
  __typename?: 'FocalDevice';
  /** Kind of change made to the focal device */
  action?: Maybe<CodeableConcept>;
  /** Device that was manipulated during the procedure */
  manipulated: Reference;
};

export type FocalDeviceInput = {
  /** Kind of change made to the focal device */
  action?: InputMaybe<CodeableConceptInput>;
  /** Device that was manipulated during the procedure */
  manipulated: ReferenceInput;
};

export enum Gender {
  female = 'female',
  male = 'male',
  other = 'other',
  unknown = 'unknown'
}

export type GetAccountInput = {
  /** ID of the account to retrieve */
  account_id: Scalars['String']['input'];
};

export type GetAccountSettingInput = {
  /** Identifier of the account to fetch settings for */
  account_id: Scalars['String']['input'];
};

export type GetAlertRecipientSettingInput = {
  /** Account identifier to look up alert recipient settings for */
  account_id?: InputMaybe<Scalars['String']['input']>;
  /** User identifier to look up alert recipient settings for */
  user_id?: InputMaybe<Scalars['String']['input']>;
};

/** GetAllCuratorTaskResponse */
export type GetAllCuratorTaskResponse = {
  __typename?: 'GetAllCuratorTaskResponse';
  /** List of matching curator tasks */
  data?: Maybe<Array<CuratorTaskModel>>;
  /** Human-readable result message for the fetch */
  message: Scalars['String']['output'];
  /** Whether the fetch operation succeeded */
  success: Scalars['Boolean']['output'];
};

export type GetAllCuratorTasksModelInput = {
  /** Filter curator tasks by due-date status */
  date_filter: TaskDateFilter;
  /** Filter curator tasks by ownership scope (all or mine) */
  ownership: TaskOwnership;
};

export type GetAllResourceModelsModelInput = {
  /** Identifier of the patient whose resources to fetch */
  patient_id: Scalars['String']['input'];
  /** Curation status to filter resources by */
  status: CurationStatus;
};

export type GetAllUsersInput = {
  /** Filter users by account identifier */
  account_id?: InputMaybe<Scalars['String']['input']>;
  /** Filter users by these roles */
  roles?: InputMaybe<Array<RoleName>>;
};

/** GetAllergyModel */
export type GetAllergyModel = {
  __typename?: 'GetAllergyModel';
  /** Page of allergy records returned */
  data?: Maybe<Array<AllergyModel>>;
  /** Current page number of the result set */
  page?: Maybe<Scalars['Float']['output']>;
  /** Total number of matching allergy records */
  total?: Maybe<Scalars['Float']['output']>;
};

/** GetAppointmentModel */
export type GetAppointmentModel = {
  __typename?: 'GetAppointmentModel';
  /** Page of appointment records */
  data?: Maybe<Array<AppointmentModel>>;
  /** Current page number of results */
  page?: Maybe<Scalars['Float']['output']>;
  /** Total number of matching appointments */
  total?: Maybe<Scalars['Float']['output']>;
};

export type GetAssessmentInput = {
  /** Unique identifier for the assessment. */
  assessment_id: Scalars['String']['input'];
  /** Unique identifier for the patient. */
  vitall_patient_id: Scalars['String']['input'];
};

export type GetCareTeamInput = {
  /** Filter care teams by category */
  category?: InputMaybe<CareTeamCategory>;
  /** Identifier of the patient whose care team to fetch */
  patient_id: Scalars['String']['input'];
};

export type GetChatRoomInput = {
  /** Used in Medly practitioner dashboard */
  fhir_patient_id?: InputMaybe<Scalars['String']['input']>;
};

/** GetChatTokenConfigResponse */
export type GetChatTokenConfigResponse = {
  __typename?: 'GetChatTokenConfigResponse';
  /** Chat service connection configuration. */
  config: ChatConfigurationModel;
  /** Authentication token for the chat session. */
  token: Scalars['String']['output'];
  /** XMPP username for the authenticated chat user. */
  xmpp_username: Scalars['String']['output'];
};

/** GetConditionModel */
export type GetConditionModel = {
  __typename?: 'GetConditionModel';
  /** Conditions returned for the current page */
  data?: Maybe<Array<ConditionModel>>;
  /** Current page number of the result set */
  page?: Maybe<Scalars['Float']['output']>;
  /** Total number of matching conditions */
  total?: Maybe<Scalars['Float']['output']>;
};

/** GetConsentModel */
export type GetConsentModel = {
  __typename?: 'GetConsentModel';
  /** Page of consent records */
  data?: Maybe<Array<ConsentModel>>;
  /** Current page number of the result set */
  page?: Maybe<Scalars['Float']['output']>;
  /** Total number of matching consent records */
  total?: Maybe<Scalars['Float']['output']>;
};

/** GetCoverageModel */
export type GetCoverageModel = {
  __typename?: 'GetCoverageModel';
  /** Coverage records for the current page */
  data?: Maybe<Array<CoverageModel>>;
  /** Current page number of the paginated results */
  page?: Maybe<Scalars['Float']['output']>;
  /** Total number of coverage records matching the query */
  total?: Maybe<Scalars['Float']['output']>;
};

export type GetCoveragesInput = {
  /** Number of records to return per page */
  count?: InputMaybe<Scalars['Int']['input']>;
  /** Page number to retrieve */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Subscriber whose coverages to retrieve */
  subscriber: Scalars['String']['input'];
};

export type GetCuratorTaskInput = {
  /** Unique identifier of the curator task to fetch */
  curator_task_id: Scalars['String']['input'];
};

export type GetCuratorTasksForPatientInput = {
  /** Vitall patient whose curator tasks are fetched */
  vitall_patient_id: Scalars['String']['input'];
};

export type GetCuratorTasksInput = {
  /** Filter criteria for querying curator tasks */
  filters: GetAllCuratorTasksModelInput;
};

/** GetDiagnosticReportModel */
export type GetDiagnosticReportModel = {
  __typename?: 'GetDiagnosticReportModel';
  /** Diagnostic reports for the current page */
  data?: Maybe<Array<DiagnosticReportModel>>;
  /** Current page of results */
  page?: Maybe<Scalars['Float']['output']>;
  /** Total number of matching reports */
  total?: Maybe<Scalars['Float']['output']>;
};

export type GetDiscernDocumentInput = {
  /** ID of the Discern document to fetch */
  discern_document_id: Scalars['String']['input'];
};

export type GetDiscernDocumentsInput = {
  /** Filter documents created on or after this date */
  date_from?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter documents created on or before this date */
  date_to?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter documents by patient name */
  patient_name?: InputMaybe<Scalars['String']['input']>;
  /** Number of documents to skip for pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Filter documents by processing status */
  status?: InputMaybe<Scalars['String']['input']>;
  /** Maximum number of documents to return */
  take?: InputMaybe<Scalars['Int']['input']>;
  /** Filter documents by Vitall patient ID */
  vitall_patient_id?: InputMaybe<Scalars['String']['input']>;
};

export type GetDiscernResultInput = {
  /** ID of the Discern result to fetch */
  discern_result_id: Scalars['String']['input'];
};

export type GetDocumentInput = {
  /** Identifier of the document to retrieve */
  document_id: Scalars['String']['input'];
};

export type GetDocumentsInput = {
  /** Vitall patient identifier to list documents for */
  vitall_patient_id: Scalars['String']['input'];
};

export type GetDownloadUrlResponse = {
  __typename?: 'GetDownloadUrlResponse';
  /** Health status of the document */
  status: DocumentHealthStatus;
  /** Presigned URL to download the document */
  url?: Maybe<Scalars['String']['output']>;
};

export type GetEhrSyncConnectionInput = {
  /** Connection id, which is the QIE zone id. */
  id: Scalars['String']['input'];
};

export type GetEmergencyAccessRecordsInput = {
  /** Patient date of birth for emergency access guard */
  dob: Scalars['String']['input'];
  /** Patient last name for emergency access guard */
  last_name: Scalars['String']['input'];
  /** Vitall user identifier for emergency access */
  vitall_user_id: Scalars['String']['input'];
};

export type GetEmrConnectionsInput = {
  /** Vitall patient identifier to fetch EMR connections for */
  vitall_patient_id: Scalars['String']['input'];
};

export type GetEmrIntegrationsInput = {
  /** Filter integrations by city names */
  cities?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Number of results per page */
  count?: InputMaybe<Scalars['Int']['input']>;
  /** Page number for paginated results */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Free-text search query for EMR integrations */
  query?: InputMaybe<Scalars['String']['input']>;
  /** Filter integrations by region names */
  regions?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** GetEncounterModel */
export type GetEncounterModel = {
  __typename?: 'GetEncounterModel';
  /** Encounters on the current page */
  data?: Maybe<Array<EncounterModel>>;
  /** Current page number of results */
  page?: Maybe<Scalars['Float']['output']>;
  /** Total number of matching encounters */
  total?: Maybe<Scalars['Float']['output']>;
};

/** GetFamilyMemberHistoryModel */
export type GetFamilyMemberHistoryModel = {
  __typename?: 'GetFamilyMemberHistoryModel';
  /** Family member history records for the current page */
  data?: Maybe<Array<FamilyMemberHistoryModel>>;
  /** Current page number of results */
  page?: Maybe<Scalars['Float']['output']>;
  /** Total number of matching family member history records */
  total?: Maybe<Scalars['Float']['output']>;
};

export type GetGeneticInfoObservationsModelInput = {
  /** Genetic observation code to filter by */
  code?: InputMaybe<Scalars['String']['input']>;
  /** Number of records to return per page */
  count?: InputMaybe<Scalars['Int']['input']>;
  /** Exclude unpublished observations when true */
  filterUnpublished?: InputMaybe<Scalars['Boolean']['input']>;
  /** Page number to retrieve */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** FHIR Patient resource id to list records for */
  patient: Scalars['String']['input'];
  /** Sort direction for records by date */
  sort?: InputMaybe<DateSortType>;
};

export type GetHealthSummaryRecordsInput = {
  /** Patient FHIR resource identifier */
  patient: Scalars['String']['input'];
};

/** GetImmunizationModel */
export type GetImmunizationModel = {
  __typename?: 'GetImmunizationModel';
  /** Immunization records for the current page */
  data?: Maybe<Array<ImmunizationModel>>;
  /** Current page number of the result set */
  page?: Maybe<Scalars['Float']['output']>;
  /** Total number of matching immunization records */
  total?: Maybe<Scalars['Float']['output']>;
};

export type GetLatestObservationsInput = {
  /** Patient id whose latest observations to fetch */
  patient: Scalars['String']['input'];
};

/** GetLatestObservationsModel */
export type GetLatestObservationsModel = {
  __typename?: 'GetLatestObservationsModel';
  /** Latest blood pressure observation */
  blood_pressure?: Maybe<ObservationModel>;
  /** Latest blood sugar observation */
  blood_sugar?: Maybe<ObservationModel>;
  /** Latest chest circumference observation in cm */
  body_chest_cm?: Maybe<ObservationModel>;
  /** Latest body fat percentage observation */
  body_fat_percentage?: Maybe<ObservationModel>;
  /** Latest body height observation */
  body_height?: Maybe<ObservationModel>;
  /** Latest hip circumference observation in cm */
  body_hips_cm?: Maybe<ObservationModel>;
  /** Latest body mass index observation */
  body_mass_index?: Maybe<ObservationModel>;
  /** Latest thigh circumference observation in cm */
  body_thigh_cm?: Maybe<ObservationModel>;
  /** Latest waist circumference observation in cm */
  body_waist_cm?: Maybe<ObservationModel>;
  /** Latest waist-to-height ratio observation */
  body_waist_height?: Maybe<ObservationModel>;
  /** Latest waist-to-hip ratio observation */
  body_waist_hip?: Maybe<ObservationModel>;
  /** Latest body weight observation */
  body_weight?: Maybe<ObservationModel>;
  /** Latest cardiovascular score observation */
  cardiovascular_score?: Maybe<ObservationModel>;
  /** Latest distance travelled observation */
  distance?: Maybe<ObservationModel>;
  /** Latest energy burned observation */
  energy_burned?: Maybe<ObservationModel>;
  /** Latest fitness average heart rate observation */
  fitness_average_heart_rate?: Maybe<ObservationModel>;
  /** Latest focus score observation */
  focus_score?: Maybe<ObservationModel>;
  /** Latest heart rate observation */
  heart_rate?: Maybe<ObservationModel>;
  /** Latest heart rate variability observation */
  hrv?: Maybe<ObservationModel>;
  /** Latest immunity score observation */
  immunity_score?: Maybe<ObservationModel>;
  /** Latest muscle mass observation */
  muscle_mass?: Maybe<ObservationModel>;
  /** Latest oxygen saturation observation */
  oxygen_saturation?: Maybe<ObservationModel>;
  /** Latest pain level observation */
  pain?: Maybe<ObservationModel>;
  /** Latest respiration rate observation */
  respiration?: Maybe<ObservationModel>;
  /** Latest respiratory score observation */
  respiratory_score?: Maybe<ObservationModel>;
  /** Latest resting heart rate observation */
  resting_heart_rate?: Maybe<ObservationModel>;
  /** Latest sleep average heart rate observation */
  sleep_average_heart_rate?: Maybe<ObservationModel>;
  /** Latest sleep duration observation */
  sleep_duration?: Maybe<ObservationModel>;
  /** Latest sleep quality score observation */
  sleep_quality_score?: Maybe<ObservationModel>;
  /** Latest sleep score observation */
  sleep_score?: Maybe<ObservationModel>;
  /** Latest step count observation */
  steps?: Maybe<ObservationModel>;
  /** Latest stress index observation */
  stress_index?: Maybe<ObservationModel>;
  /** Latest stress score observation */
  stress_score?: Maybe<ObservationModel>;
  /** Latest body temperature observation */
  temperature?: Maybe<ObservationModel>;
};

export type GetLatestRecordsInput = {
  /** Identifier of the patient to fetch latest records for */
  patient_id: Scalars['String']['input'];
};

/** GetMedicationRequestModel */
export type GetMedicationRequestModel = {
  __typename?: 'GetMedicationRequestModel';
  /** Medication requests on the current page */
  data?: Maybe<Array<MedicationRequestModel>>;
  /** Current page number of the result set */
  page?: Maybe<Scalars['Float']['output']>;
  /** Total number of matching medication requests */
  total?: Maybe<Scalars['Float']['output']>;
};

/** GetMedicationStatementModel */
export type GetMedicationStatementModel = {
  __typename?: 'GetMedicationStatementModel';
  /** Page of medication statement records */
  data?: Maybe<Array<MedicationStatementModel>>;
  /** Current page number of the result set */
  page?: Maybe<Scalars['Float']['output']>;
  /** Total number of matching medication statements */
  total?: Maybe<Scalars['Float']['output']>;
};

export type GetMetricAlertStatsInput = {
  /** Account ID scoping the metric alert stats */
  account_id?: InputMaybe<Scalars['String']['input']>;
  /** Observation category of the metric */
  category?: InputMaybe<Scalars['String']['input']>;
  /** Observation code identifying the metric */
  code: Scalars['String']['input'];
  /** Alert statuses to include when aggregating stats */
  statuses: Array<AlertStatus>;
  /** Vitall patient ID whose metric alert stats are requested */
  vitall_patient_id: Scalars['String']['input'];
};

/** GetObservationModel */
export type GetObservationModel = {
  __typename?: 'GetObservationModel';
  /** Page of observation records */
  data?: Maybe<Array<ObservationModel>>;
  /** Current page number of results */
  page?: Maybe<Scalars['Float']['output']>;
  /** Total number of matching observations */
  total?: Maybe<Scalars['Float']['output']>;
};

export type GetObservationsModelInput = {
  /** Observation code to filter by */
  code?: InputMaybe<Scalars['String']['input']>;
  /** Maximum number of observations to return */
  count?: InputMaybe<Scalars['Int']['input']>;
  /** Lower date range limit */
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  /** Upper date range limit */
  dateTo?: InputMaybe<Scalars['String']['input']>;
  /** Exclude unpublished observations when true */
  filterUnpublished?: InputMaybe<Scalars['Boolean']['input']>;
  /** Patient id whose observations to fetch */
  patient: Scalars['String']['input'];
  /** Sort direction by observation date */
  sort?: InputMaybe<DateSortType>;
};

export type GetOperationInput = {
  /** Operation name */
  operation: Scalars['String']['input'];
};

export type GetPatientInput = {
  /** FHIR logical id of the patient to fetch */
  patient_id: Scalars['String']['input'];
};

/** GetPatientModel */
export type GetPatientModel = {
  __typename?: 'GetPatientModel';
  /** Page of patient records */
  data?: Maybe<Array<PatientModel>>;
  /** Current page number of results */
  page?: Maybe<Scalars['Float']['output']>;
  /** Total number of matching patients */
  total?: Maybe<Scalars['Float']['output']>;
};

export type GetPatientUsersInput = {
  /** Identifier of the patient user to fetch */
  user_id?: InputMaybe<Scalars['String']['input']>;
};

export type GetPermissionInput = {
  /** Identifier of the permission to retrieve */
  permission_id: Scalars['String']['input'];
};

export type GetPolicyInput = {
  /** Identifier of the policy to fetch */
  policy_id: Scalars['String']['input'];
};

/** GetProcedureModel */
export type GetProcedureModel = {
  __typename?: 'GetProcedureModel';
  /** Page of procedure records */
  data?: Maybe<Array<ProcedureModel>>;
  /** Current page number of the result set */
  page?: Maybe<Scalars['Float']['output']>;
  /** Total number of matching procedures */
  total?: Maybe<Scalars['Float']['output']>;
};

export type GetQuestionnaireModel = {
  __typename?: 'GetQuestionnaireModel';
  /** The requested questionnaire definition */
  questionnaire: QuestionnaireModel;
  /** Patient's existing response to the questionnaire, if any */
  responses?: Maybe<QuestionnaireResponseModel>;
};

export type GetQuestionnaireModelInput = {
  /** Identifier of the questionnaire to fetch */
  identifier: Scalars['String']['input'];
  /** Patient id to load associated responses for */
  patient?: InputMaybe<Scalars['String']['input']>;
};

export type GetRecordInput = {
  /** FHIR Patient resource id */
  patient_id: Scalars['String']['input'];
  /** FHIR record resource id */
  record_id: Scalars['String']['input'];
};

export type GetReferenceRangesInput = {
  /** Optional category to filter reference ranges */
  category?: InputMaybe<Scalars['String']['input']>;
  /** Observation codes to look up reference ranges for */
  codes: Array<Scalars['String']['input']>;
  /** Optional parameter type to filter reference ranges */
  parameter_type?: InputMaybe<ParameterType>;
  /** Optional risk levels to filter reference ranges */
  risks?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Vitall patient identifier to fetch reference ranges for */
  vitall_patient_id: Scalars['String']['input'];
};

/** GetRelatedPersonModel */
export type GetRelatedPersonModel = {
  __typename?: 'GetRelatedPersonModel';
  /** Related person records for the current page */
  data?: Maybe<Array<RelatedPersonModel>>;
  /** Current page number of the result set */
  page?: Maybe<Scalars['Float']['output']>;
  /** Total number of related persons matching the query */
  total?: Maybe<Scalars['Float']['output']>;
};

export type GetRoleInput = {
  /** Unique identifier of the role to fetch */
  role_id: Scalars['String']['input'];
};

export type GetRoutineInstanceStatusInput = {
  /** Vitall patient identifier to fetch routine instance statuses for */
  vitall_patient_id: Scalars['String']['input'];
};

export type GetScanProfileInput = {
  /** FHIR patient id */
  patient: Scalars['String']['input'];
};

export type GetScanResultInput = {
  /** FHIR Patient resource id */
  patient_id: Scalars['String']['input'];
  /** FHIR record resource id */
  record_id: Scalars['String']['input'];
  /** Type of scan to retrieve */
  scan_type: ScanType;
};

export type GetSharedResourceInput = {
  /** Cursor used for pagination */
  cursor?: InputMaybe<Scalars['String']['input']>;
  /** Share link identifying the resource to fetch */
  share_link: Scalars['String']['input'];
};

export type GetSharedResourceResponse = {
  __typename?: 'GetSharedResourceResponse';
  /** Cursor for fetching the next page of results */
  cursor?: Maybe<Scalars['String']['output']>;
  /** When the share link expires, if set */
  expiry?: Maybe<Scalars['DateTime']['output']>;
  /** Whether more pages of results are available */
  has_more?: Maybe<Scalars['Boolean']['output']>;
  /** Vitall patient id the shared resource belongs to */
  patient_id?: Maybe<Scalars['String']['output']>;
  /** Shared FHIR resources associated with this share */
  resource: Array<SharingAssociationUnion>;
  /** Title describing the shared resource */
  share_title: Scalars['String']['output'];
  /** Type of resource being shared */
  share_type: ShareType;
  /** Display name of the person who shared the resource */
  sharer_name?: Maybe<Scalars['String']['output']>;
};

export type GetStripeTaxInput = {
  /** Stripe card token identifier for tax calculation */
  tokenId: Scalars['String']['input'];
};

/** GetTaskModel */
export type GetTaskModel = {
  __typename?: 'GetTaskModel';
  /** Page of task resources */
  data?: Maybe<Array<TaskModel>>;
  /** Current page number of results */
  page?: Maybe<Scalars['Float']['output']>;
  /** Total number of matching tasks */
  total?: Maybe<Scalars['Float']['output']>;
};

export type GetTerraActivityInput = {
  /** Summary id of the activity to fetch */
  summary_id: Scalars['String']['input'];
  /** Terra connection the activity belongs to */
  terra_connection_id: Scalars['String']['input'];
};

export type GetTitrationCarePlanInput = {
  /** FHIR CarePlan id to look up the titration plan by */
  care_plan_id?: InputMaybe<Scalars['String']['input']>;
  /** FHIR Patient id to look up the titration plan by */
  patient_id?: InputMaybe<Scalars['String']['input']>;
};

export type GetUserInput = {
  /** Identifier of the user to fetch */
  user_id: Scalars['String']['input'];
};

/** GetUserNotificationConnectionsResponse */
export type GetUserNotificationConnectionsResponse = {
  __typename?: 'GetUserNotificationConnectionsResponse';
  /** List of the user's notification connections */
  connections: Array<UserNotificationConnection>;
};

export type GetUserNotificationsInput = {
  /** ID of the user whose notifications to fetch */
  user_id: Scalars['String']['input'];
};

export type GetVitallPatientRecordInput = {
  /** FHIR patient ID (prefixed with Patient/ or only uuid) */
  patient_id?: InputMaybe<Scalars['String']['input']>;
  /** User id to look up the patient record by */
  user_id?: InputMaybe<Scalars['String']['input']>;
  /** Vitall patient id to look up the record by */
  vitall_patient_id?: InputMaybe<Scalars['String']['input']>;
};

export type GetVitallPractitionerInput = {
  /** FHIR Practitioner resource id to look up */
  fhir_practitioner_id: Scalars['String']['input'];
};

/** GoalTargetModel */
export type GoalTargetModel = {
  __typename?: 'GoalTargetModel';
  /** Target value to be achieved as a boolean */
  detailBoolean?: Maybe<Scalars['Boolean']['output']>;
  /** Target value to be achieved as a coded concept */
  detailCodeableConcept?: Maybe<CodeableConcept>;
  /** Target value to be achieved as an integer */
  detailInteger?: Maybe<Scalars['Int']['output']>;
  /** Target value to be achieved as a quantity */
  detailQuantity?: Maybe<Quantity>;
  /** Target value to be achieved as a range */
  detailRange?: Maybe<Range>;
  /** Target value to be achieved as a ratio */
  detailRatio?: Maybe<Ratio>;
  /** Target value to be achieved as a string */
  detailString?: Maybe<Scalars['String']['output']>;
  /** Date by which the goal target should be reached */
  dueDate?: Maybe<Scalars['String']['output']>;
  /** Duration within which the goal target should be reached */
  dueDuration?: Maybe<Scalars['String']['output']>;
  /** Parameter whose value is being tracked for the target */
  measure?: Maybe<CodeableConcept>;
};

/** GroupModel */
export type GroupModel = {
  __typename?: 'GroupModel';
  /** Unique identifier of the group */
  group_id: Scalars['String']['output'];
  /** Human-readable name of the group */
  group_name: Scalars['String']['output'];
};

export type HandoffTokenModel = {
  __typename?: 'HandoffTokenModel';
  /** When the token stops working */
  expiresAt: Scalars['DateTime']['output'];
  /** URL to open in the Engage PWA. Carries the single-use token in the fragment. */
  url: Scalars['String']['output'];
};

export type Hospitalization = {
  __typename?: 'Hospitalization';
  /** Source from which the patient was admitted */
  admitSource?: Maybe<CodeableConcept>;
  /** Location or organization the patient is discharged to */
  destination?: Maybe<Reference>;
  /** Diet preferences reported by the patient */
  dietPreference?: Maybe<Array<CodeableConcept>>;
  /** Category of location after discharge */
  dischargeDisposition?: Maybe<CodeableConcept>;
  /** Location or organization the patient came from before admission */
  origin?: Maybe<Reference>;
  /** Pre-admission identifier */
  preAdmissionIdentifier?: Maybe<Identifier>;
  /** Type of hospital re-admission, if any */
  reAdmission?: Maybe<CodeableConcept>;
  /** Special arrangements made for the patient */
  specialArrangement?: Maybe<Array<CodeableConcept>>;
  /** Special courtesies extended to the patient */
  specialCourtesy?: Maybe<Array<CodeableConcept>>;
};

export type HospitalizationInput = {
  /** Source from which the patient was admitted */
  admitSource?: InputMaybe<CodeableConceptInput>;
  /** Location or organization the patient is discharged to */
  destination?: InputMaybe<ReferenceInput>;
  /** Diet preferences reported by the patient */
  dietPreference?: InputMaybe<Array<CodeableConceptInput>>;
  /** Category of location after discharge */
  dischargeDisposition?: InputMaybe<CodeableConceptInput>;
  /** Location or organization the patient came from before admission */
  origin?: InputMaybe<ReferenceInput>;
  /** Pre-admission identifier */
  preAdmissionIdentifier?: InputMaybe<IdentifierInput>;
  /** Type of hospital re-admission, if any */
  reAdmission?: InputMaybe<CodeableConceptInput>;
  /** Special arrangements made for the patient */
  specialArrangement?: InputMaybe<Array<CodeableConceptInput>>;
  /** Special courtesies extended to the patient */
  specialCourtesy?: InputMaybe<Array<CodeableConceptInput>>;
};

export type HoursOfOperation = {
  __typename?: 'HoursOfOperation';
  /** Whether the location is open all day */
  allDay?: Maybe<Scalars['Boolean']['output']>;
  /** Time the location closes */
  closingTime?: Maybe<Scalars['String']['output']>;
  /** Days of the week the location is open */
  daysOfWeek?: Maybe<Array<DayOfWeek>>;
  /** Time the location opens */
  openingTime?: Maybe<Scalars['String']['output']>;
};

export type HoursOfOperationInput = {
  /** Whether the location is open all day */
  allDay?: InputMaybe<Scalars['Boolean']['input']>;
  /** Time the location closes */
  closingTime?: InputMaybe<Scalars['String']['input']>;
  /** Days of the week the location is open */
  daysOfWeek?: InputMaybe<Array<DayOfWeek>>;
  /** Time the location opens */
  openingTime?: InputMaybe<Scalars['String']['input']>;
};

export type HumanName = {
  __typename?: 'HumanName';
  /** Family */
  family?: Maybe<Scalars['String']['output']>;
  /** Given */
  given?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Period */
  period?: Maybe<Period>;
  /** Prefix */
  prefix?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Suffix */
  suffix?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Text */
  text?: Maybe<Scalars['String']['output']>;
  /** Use */
  use?: Maybe<Scalars['String']['output']>;
};

export type HumanNameInput = {
  /** Family */
  family?: InputMaybe<Scalars['String']['input']>;
  /** Given */
  given?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Period */
  period?: InputMaybe<PeriodInput>;
  /** Prefix */
  prefix?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Suffix */
  suffix?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Text */
  text?: InputMaybe<Scalars['String']['input']>;
  /** Use */
  use?: InputMaybe<Scalars['String']['input']>;
};

export type Identifier = {
  __typename?: 'Identifier';
  /** Time period when id is/was valid for use */
  period?: Maybe<Period>;
  /** The namespace for the identifier value */
  system?: Maybe<Scalars['String']['output']>;
  /** Description of identifier */
  type?: Maybe<CodeableConcept>;
  /** usual | official | temp | secondary | old (If known) */
  use?: Maybe<Scalars['String']['output']>;
  /** The value that is unique */
  value?: Maybe<Scalars['String']['output']>;
};

export type IdentifierInput = {
  /** Time period when id is/was valid for use */
  period?: InputMaybe<PeriodInput>;
  /** The namespace for the identifier value */
  system?: InputMaybe<Scalars['String']['input']>;
  /** Description of identifier */
  type?: InputMaybe<CodeableConceptInput>;
  /** usual | official | temp | secondary | old (If known) */
  use?: InputMaybe<Scalars['String']['input']>;
  /** The value that is unique */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type ImagingStudyModel = {
  __typename?: 'ImagingStudyModel';
  associatedResources?: Maybe<Array<ResourceAssociationUnion>>;
  attachments?: Maybe<Array<Attachment>>;
  /** Requests this study fulfills */
  basedOn?: Maybe<Array<Maybe<Reference>>>;
  /** Contained */
  contained?: Maybe<Array<Resource>>;
  /** Institution-generated description of the study */
  description?: Maybe<Scalars['String']['output']>;
  /** MedDream DICOM viewer session token for this imaging study */
  dicom_viewer_token?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  /** Encounter associated with this imaging study */
  encounter?: Maybe<Reference>;
  /** Study access endpoint references */
  endpoint?: Maybe<Array<Maybe<Reference>>>;
  /** Extension */
  extension?: Maybe<Array<Extension>>;
  /** Logical id of the ImagingStudy resource */
  id?: Maybe<Scalars['String']['output']>;
  /** Identifiers for the whole study */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /** A set of rules under which this content was created */
  implicitRules?: Maybe<Scalars['String']['output']>;
  /** Practitioners who interpreted the images */
  interpreter?: Maybe<Array<Maybe<Reference>>>;
  /** Language of the resource content */
  language?: Maybe<Scalars['String']['output']>;
  /** Location where the imaging study occurred */
  location?: Maybe<Reference>;
  /** Metadata about the resource */
  meta?: Maybe<Meta>;
  /** All modalities across the study series */
  modality?: Maybe<Array<Maybe<Coding>>>;
  /** User-defined comments on the study */
  note?: Maybe<Array<Maybe<Annotation>>>;
  /** Number of instances related to this study */
  numberOfInstances?: Maybe<Scalars['Float']['output']>;
  /** Number of series related to this study */
  numberOfSeries?: Maybe<Scalars['Float']['output']>;
  /** Coded performed procedures */
  procedureCode?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Reference to the performed Procedure */
  procedureReference?: Maybe<Reference>;
  /** Coded reasons the study was requested */
  reasonCode?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** References explaining why the study was performed */
  reasonReference?: Maybe<Array<Maybe<Reference>>>;
  /** Referring physician; Practitioner or PractitionerRole */
  referrer?: Maybe<Reference>;
  /** FHIR resource type, always ImagingStudy */
  resourceType?: Maybe<Scalars['String']['output']>;
  /** Series of instances that make up the study */
  series?: Maybe<Array<Maybe<ImagingStudySeries>>>;
  /** When the study was started */
  started?: Maybe<Scalars['String']['output']>;
  /** Study status: registered, available, cancelled, entered-in-error or unknown */
  status: ImagingStudyStatus;
  /** Subject of the study; Device, Group or Patient */
  subject: Reference;
  /** Text */
  text?: Maybe<Narrative>;
};

export type ImagingStudySeries = {
  __typename?: 'ImagingStudySeries';
  associatedResources?: Maybe<Array<ResourceAssociationUnion>>;
  attachments?: Maybe<Array<Attachment>>;
  /** Body part examined in the series */
  bodySite?: Maybe<Coding>;
  /** Contained */
  contained?: Maybe<Array<Resource>>;
  /** Short human readable summary of the series */
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  /** Series access endpoint references */
  endpoint?: Maybe<Array<Maybe<Reference>>>;
  /** Extension */
  extension?: Maybe<Array<Extension>>;
  /** Logical id of this artifact */
  id?: Maybe<Scalars['String']['output']>;
  /** A set of rules under which this content was created */
  implicitRules?: Maybe<Scalars['String']['output']>;
  /** SOP instances belonging to the series */
  instance?: Maybe<Array<Maybe<ImagingStudySeriesInstance>>>;
  /** Language of the resource content */
  language?: Maybe<Scalars['String']['output']>;
  /** Laterality of the body part examined */
  laterality?: Maybe<Coding>;
  /** Metadata about the resource */
  meta?: Maybe<Meta>;
  /** Modality of the instances in the series */
  modality: Coding;
  /** Numeric identifier of this series */
  number?: Maybe<Scalars['Float']['output']>;
  /** Number of instances related to this series */
  numberOfInstances?: Maybe<Scalars['Float']['output']>;
  /** Actors who performed the series */
  performer?: Maybe<Array<Maybe<ImagingStudySeriesPerformer>>>;
  /** The FHIR resource type, e.g. Patient, Observation, etc. */
  resourceType?: Maybe<Scalars['String']['output']>;
  /** Specimens imaged in the series */
  specimen?: Maybe<Array<Maybe<Reference>>>;
  /** When the series started */
  started?: Maybe<Scalars['String']['output']>;
  /** Text */
  text?: Maybe<Narrative>;
  /** DICOM Series Instance UID for the series */
  uid: Scalars['String']['output'];
};

export type ImagingStudySeriesInstance = {
  __typename?: 'ImagingStudySeriesInstance';
  /** Position of this instance within the series */
  number?: Maybe<Scalars['Float']['output']>;
  /** DICOM SOP class type of the instance */
  sopClass: Coding;
  /** Human readable description of the instance */
  title?: Maybe<Scalars['String']['output']>;
  /** DICOM SOP Instance UID */
  uid: Scalars['String']['output'];
};

export type ImagingStudySeriesPerformer = {
  __typename?: 'ImagingStudySeriesPerformer';
  /** Actor who performed the imaging series */
  actor: Reference;
  /** Type of performance for the series performer */
  function?: Maybe<CodeableConcept>;
};

export enum ImagingStudyStatus {
  available = 'available',
  cancelled = 'cancelled',
  enteredInError = 'enteredInError',
  registered = 'registered',
  unknown = 'unknown'
}

/** ImmunizationModel */
export type ImmunizationModel = {
  __typename?: 'ImmunizationModel';
  associatedResources?: Maybe<Array<ResourceAssociationUnion>>;
  attachments?: Maybe<Array<Attachment>>;
  /** Contained */
  contained?: Maybe<Array<Resource>>;
  /** Curation metadata for this immunization resource */
  curationMeta?: Maybe<CurationMeta>;
  displayName?: Maybe<Scalars['String']['output']>;
  /** Amount of vaccine administered */
  doseQuantity?: Maybe<Quantity>;
  /** Patient education material provided */
  education?: Maybe<Array<Education>>;
  /** Encounter the immunization was part of */
  encounter?: Maybe<Reference>;
  /** Vaccine expiration date */
  expirationDate?: Maybe<Scalars['String']['output']>;
  /** Extension */
  extension?: Maybe<Array<Extension>>;
  /** Funding source for the vaccine */
  fundingSource?: Maybe<CodeableConcept>;
  /** FHIR logical id of the immunization resource */
  id?: Maybe<Scalars['String']['output']>;
  /** A set of rules under which this content was created */
  implicitRules?: Maybe<Scalars['String']['output']>;
  /** Whether the administered dose was subpotent */
  isSubpotent?: Maybe<Scalars['Boolean']['output']>;
  /** Language of the resource content */
  language?: Maybe<Scalars['String']['output']>;
  /** Location where the immunization occurred */
  location?: Maybe<Reference>;
  /** Resolved FHIR Location where the immunization was administered */
  locationResource?: Maybe<LocationModel>;
  /** Vaccine lot number */
  lotNumber?: Maybe<Scalars['String']['output']>;
  /** Vaccine manufacturer reference */
  manufacturer?: Maybe<Reference>;
  /** Metadata about the resource */
  meta?: Maybe<Meta>;
  /** Vaccine administration date-time */
  occurrenceDateTime?: Maybe<Scalars['String']['output']>;
  /** Vaccine administration date as free text */
  occurrenceString?: Maybe<Scalars['String']['output']>;
  /** Patient who was immunized */
  patient: Reference;
  /** Practitioners who performed the immunization */
  performer?: Maybe<Array<Performer>>;
  /** Whether the data was captured from a primary source */
  primarySource?: Maybe<Scalars['Boolean']['output']>;
  /** Patient eligibility for a vaccination program */
  programEligibility?: Maybe<Array<CodeableConcept>>;
  /** Protocol followed by the provider */
  protocolApplied?: Maybe<Array<ProtocolApplied>>;
  /** Reactions following the immunization */
  reaction?: Maybe<Array<Reaction>>;
  /** Coded reasons the immunization occurred */
  reasonCode?: Maybe<Array<CodeableConcept>>;
  /** Referenced resources explaining why immunization occurred */
  reasonReference?: Maybe<Array<Reference>>;
  /** When the immunization was first captured in the patient record */
  recorded?: Maybe<Scalars['String']['output']>;
  /** Source of a secondarily reported record */
  reportOrigin?: Maybe<CodeableConcept>;
  /** FHIR resource type, always Immunization */
  resourceType?: Maybe<Scalars['String']['output']>;
  /** Route by which the vaccine entered the body */
  route?: Maybe<CodeableConcept>;
  /** Body site where the vaccine was administered */
  site?: Maybe<CodeableConcept>;
  /** Immunization status: completed, entered-in-error, or not-done */
  status: Scalars['String']['output'];
  /** Reason the immunization was not administered */
  statusReason?: Maybe<CodeableConcept>;
  /** Reasons the dose was subpotent */
  subpotentReason?: Maybe<Array<CodeableConcept>>;
  /** Text */
  text?: Maybe<Narrative>;
  /** Vaccine product administered */
  vaccineCode: CodeableConcept;
};

export type ImmunizationModelInput = {
  /** Contained */
  contained?: InputMaybe<Array<ResourceInput>>;
  /** Amount of vaccine administered */
  doseQuantity?: InputMaybe<QuantityInput>;
  /** Patient education material provided */
  education?: InputMaybe<Array<EducationInput>>;
  /** Encounter the immunization was part of */
  encounter?: InputMaybe<ReferenceInput>;
  /** Vaccine expiration date */
  expirationDate?: InputMaybe<Scalars['String']['input']>;
  /** Extension */
  extension?: InputMaybe<Array<ExtensionInput>>;
  /** Funding source for the vaccine */
  fundingSource?: InputMaybe<CodeableConceptInput>;
  /** FHIR logical id of the immunization resource */
  id?: InputMaybe<Scalars['String']['input']>;
  /** A set of rules under which this content was created */
  implicitRules?: InputMaybe<Scalars['String']['input']>;
  /** Whether the administered dose was subpotent */
  isSubpotent?: InputMaybe<Scalars['Boolean']['input']>;
  /** Language of the resource content */
  language?: InputMaybe<Scalars['String']['input']>;
  /** Location where the immunization occurred */
  location?: InputMaybe<ReferenceInput>;
  /** Vaccine lot number */
  lotNumber?: InputMaybe<Scalars['String']['input']>;
  /** Vaccine manufacturer reference */
  manufacturer?: InputMaybe<ReferenceInput>;
  /** Metadata about the resource */
  meta?: InputMaybe<MetaInput>;
  /** Vaccine administration date-time */
  occurrenceDateTime?: InputMaybe<Scalars['String']['input']>;
  /** Vaccine administration date as free text */
  occurrenceString?: InputMaybe<Scalars['String']['input']>;
  /** Patient who was immunized */
  patient: ReferenceInput;
  /** Practitioners who performed the immunization */
  performer?: InputMaybe<Array<PerformerInput>>;
  /** Whether the data was captured from a primary source */
  primarySource?: InputMaybe<Scalars['Boolean']['input']>;
  /** Patient eligibility for a vaccination program */
  programEligibility?: InputMaybe<Array<CodeableConceptInput>>;
  /** Protocol followed by the provider */
  protocolApplied?: InputMaybe<Array<ProtocolAppliedInput>>;
  /** Reactions following the immunization */
  reaction?: InputMaybe<Array<ReactionInput>>;
  /** Coded reasons the immunization occurred */
  reasonCode?: InputMaybe<Array<CodeableConceptInput>>;
  /** Referenced resources explaining why immunization occurred */
  reasonReference?: InputMaybe<Array<ReferenceInput>>;
  /** When the immunization was first captured in the patient record */
  recorded?: InputMaybe<Scalars['String']['input']>;
  /** Source of a secondarily reported record */
  reportOrigin?: InputMaybe<CodeableConceptInput>;
  /** FHIR resource type, always Immunization */
  resourceType?: InputMaybe<Scalars['String']['input']>;
  /** Route by which the vaccine entered the body */
  route?: InputMaybe<CodeableConceptInput>;
  /** Body site where the vaccine was administered */
  site?: InputMaybe<CodeableConceptInput>;
  /** Immunization status: completed, entered-in-error, or not-done */
  status: ImmunizationStatus;
  /** Reason the immunization was not administered */
  statusReason?: InputMaybe<CodeableConceptInput>;
  /** Reasons the dose was subpotent */
  subpotentReason?: InputMaybe<Array<CodeableConceptInput>>;
  /** Text */
  text?: InputMaybe<NarrativeInput>;
  /** Vaccine product administered */
  vaccineCode: CodeableConceptInput;
};

export enum ImmunizationStatus {
  completed = 'completed',
  enteredInError = 'enteredInError',
  notDone = 'notDone'
}

export type InitiateAssessmentInput = {
  /** Type of assessment to initiate. */
  type: AssessmentType;
  /** Unique identifier for the patient. */
  vitall_patient_id: Scalars['String']['input'];
};

export type InputModel = {
  __typename?: 'InputModel';
  /** Label for the input */
  type?: Maybe<CodeableConcept>;
  /** Value address */
  valueAddress?: Maybe<Address>;
  /** Value age */
  valueAge?: Maybe<Age>;
  /** Value annotation */
  valueAnnotation?: Maybe<Annotation>;
  /** Value attachment */
  valueAttachment?: Maybe<Attachment>;
  /** Value base64 binary */
  valueBase64Binary?: Maybe<Scalars['String']['output']>;
  /** Value boolean */
  valueBoolean?: Maybe<Scalars['Boolean']['output']>;
  /** Value canonical */
  valueCanonical?: Maybe<Scalars['String']['output']>;
  /** Value code */
  valueCode?: Maybe<Scalars['String']['output']>;
  /** Value codeable concept */
  valueCodeableConcept?: Maybe<CodeableConcept>;
  /** Value coding */
  valueCoding?: Maybe<Coding>;
  /** Value contact detail */
  valueContactDetail?: Maybe<ContactDetail>;
  /** Value contact point */
  valueContactPoint?: Maybe<ContactPoint>;
  /** Value contributor */
  valueContributor?: Maybe<Contributor>;
  /** Value count */
  valueCount?: Maybe<Quantity>;
  /** Value data requirement */
  valueDataRequirement?: Maybe<Contributor>;
  /** Value date */
  valueDate?: Maybe<Scalars['String']['output']>;
  /** Value date time */
  valueDateTime?: Maybe<Scalars['String']['output']>;
  /** Value decimal */
  valueDecimal?: Maybe<Scalars['Float']['output']>;
  /** Value distance */
  valueDistance?: Maybe<Quantity>;
  /** Value dosage */
  valueDosage?: Maybe<Dosage>;
  /** Value duration */
  valueDuration?: Maybe<Quantity>;
  /** Value expression */
  valueExpression?: Maybe<Expression>;
  /** Value human name */
  valueHumanName?: Maybe<HumanName>;
  /** Value id */
  valueId?: Maybe<Scalars['String']['output']>;
  /** Value identifier */
  valueIdentifier?: Maybe<Identifier>;
  /** Value instant */
  valueInstant?: Maybe<Scalars['String']['output']>;
  /** Value integer */
  valueInteger?: Maybe<Scalars['Float']['output']>;
  /** Value markdown */
  valueMarkdown?: Maybe<Scalars['String']['output']>;
  /** Value meta */
  valueMeta?: Maybe<Meta>;
  /** Value money */
  valueMoney?: Maybe<Money>;
  /** Value oid */
  valueOid?: Maybe<Scalars['String']['output']>;
  /** Value parameter definition */
  valueParameterDefinition?: Maybe<ParameterDefinition>;
  /** Value period */
  valuePeriod?: Maybe<Money>;
  /** Value positive int */
  valuePositiveInt?: Maybe<Scalars['Float']['output']>;
  /** Value quantity */
  valueQuantity?: Maybe<Quantity>;
  /** Value range */
  valueRange?: Maybe<Range>;
  /** Value ratio */
  valueRatio?: Maybe<Ratio>;
  /** Value reference */
  valueReference?: Maybe<Reference>;
  /** Value related artifact */
  valueRelatedArtifact?: Maybe<RelatedArtifact>;
  /** Value sampled data */
  valueSampledData?: Maybe<SampleData>;
  /** Value signature */
  valueSignature?: Maybe<Signature>;
  /** Value string */
  valueString?: Maybe<Scalars['String']['output']>;
  /** Value time */
  valueTime?: Maybe<Scalars['String']['output']>;
  /** Value timing */
  valueTiming?: Maybe<Timing>;
  /** Value trigger definition */
  valueTriggerDefinition?: Maybe<TriggerDefinition>;
  /** Value unsigned int */
  valueUnsignedInt?: Maybe<Scalars['Float']['output']>;
  /** Value uri */
  valueUri?: Maybe<Scalars['String']['output']>;
  /** Value url */
  valueUrl?: Maybe<Scalars['String']['output']>;
  /** Value usage context */
  valueUsageContext?: Maybe<UsageContext>;
  /** Value uuid */
  valueUuid?: Maybe<Scalars['String']['output']>;
};

export type InputModelInput = {
  /** Label for the input */
  type?: InputMaybe<CodeableConceptInput>;
  /** Value address */
  valueAddress?: InputMaybe<AddressInput>;
  /** Value age */
  valueAge?: InputMaybe<AgeInput>;
  /** Value annotation */
  valueAnnotation?: InputMaybe<AnnotationInput>;
  /** Value attachment */
  valueAttachment?: InputMaybe<AttachmentInput>;
  /** Value base64 binary */
  valueBase64Binary?: InputMaybe<Scalars['String']['input']>;
  /** Value boolean */
  valueBoolean?: InputMaybe<Scalars['Boolean']['input']>;
  /** Value canonical */
  valueCanonical?: InputMaybe<Scalars['String']['input']>;
  /** Value code */
  valueCode?: InputMaybe<Scalars['String']['input']>;
  /** Value codeable concept */
  valueCodeableConcept?: InputMaybe<CodeableConceptInput>;
  /** Value coding */
  valueCoding?: InputMaybe<CodingInput>;
  /** Value contact detail */
  valueContactDetail?: InputMaybe<ContactDetailInput>;
  /** Value contact point */
  valueContactPoint?: InputMaybe<ContactPointInput>;
  /** Value contributor */
  valueContributor?: InputMaybe<ContributorInput>;
  /** Value count */
  valueCount?: InputMaybe<QuantityInput>;
  /** Value data requirement */
  valueDataRequirement?: InputMaybe<ContributorInput>;
  /** Value date */
  valueDate?: InputMaybe<Scalars['String']['input']>;
  /** Value date time */
  valueDateTime?: InputMaybe<Scalars['String']['input']>;
  /** Value decimal */
  valueDecimal?: InputMaybe<Scalars['Float']['input']>;
  /** Value distance */
  valueDistance?: InputMaybe<QuantityInput>;
  /** Value dosage */
  valueDosage?: InputMaybe<DosageInput>;
  /** Value duration */
  valueDuration?: InputMaybe<QuantityInput>;
  /** Value expression */
  valueExpression?: InputMaybe<ExpressionInput>;
  /** Value human name */
  valueHumanName?: InputMaybe<HumanNameInput>;
  /** Value id */
  valueId?: InputMaybe<Scalars['String']['input']>;
  /** Value identifier */
  valueIdentifier?: InputMaybe<IdentifierInput>;
  /** Value instant */
  valueInstant?: InputMaybe<Scalars['String']['input']>;
  /** Value integer */
  valueInteger?: InputMaybe<Scalars['Float']['input']>;
  /** Value markdown */
  valueMarkdown?: InputMaybe<Scalars['String']['input']>;
  /** Value meta */
  valueMeta?: InputMaybe<MetaInput>;
  /** Value money */
  valueMoney?: InputMaybe<MoneyInput>;
  /** Value oid */
  valueOid?: InputMaybe<Scalars['String']['input']>;
  /** Value parameter definition */
  valueParameterDefinition?: InputMaybe<ParameterDefinitionInput>;
  /** Value period */
  valuePeriod?: InputMaybe<MoneyInput>;
  /** Value positive int */
  valuePositiveInt?: InputMaybe<Scalars['Float']['input']>;
  /** Value quantity */
  valueQuantity?: InputMaybe<QuantityInput>;
  /** Value range */
  valueRange?: InputMaybe<RangeInput>;
  /** Value ratio */
  valueRatio?: InputMaybe<RatioInput>;
  /** Value reference */
  valueReference?: InputMaybe<ReferenceInput>;
  /** Value related artifact */
  valueRelatedArtifact?: InputMaybe<RelatedArtifactInput>;
  /** Value sampled data */
  valueSampledData?: InputMaybe<SampleDataInput>;
  /** Value signature */
  valueSignature?: InputMaybe<SignatureInput>;
  /** Value string */
  valueString?: InputMaybe<Scalars['String']['input']>;
  /** Value time */
  valueTime?: InputMaybe<Scalars['String']['input']>;
  /** Value timing */
  valueTiming?: InputMaybe<TimingInput>;
  /** Value trigger definition */
  valueTriggerDefinition?: InputMaybe<TriggerDefinitionInput>;
  /** Value unsigned int */
  valueUnsignedInt?: InputMaybe<Scalars['Float']['input']>;
  /** Value uri */
  valueUri?: InputMaybe<Scalars['String']['input']>;
  /** Value url */
  valueUrl?: InputMaybe<Scalars['String']['input']>;
  /** Value usage context */
  valueUsageContext?: InputMaybe<UsageContextInput>;
  /** Value uuid */
  valueUuid?: InputMaybe<Scalars['String']['input']>;
};

/** Issue */
export type Issue = {
  __typename?: 'Issue';
  /** Error or warning code */
  code: Scalars['String']['output'];
  /** Additional details about the error */
  details?: Maybe<CodeableConcept>;
  /** Additional details about the error */
  diagnostics?: Maybe<Scalars['String']['output']>;
  /** FHIRPath of element(s) related to issue */
  expression?: Maybe<Array<Scalars['String']['output']>>;
  /** Deprecated: Path of element(s) related to issue */
  location?: Maybe<Array<Scalars['String']['output']>>;
  /** Severity level of the outcome issue */
  severity: IssueSeverity;
};

export enum IssueSeverity {
  error = 'error',
  fatal = 'fatal',
  information = 'information',
  warning = 'warning'
}

export type JobDetails = {
  __typename?: 'JobDetails';
  /** Document associated with the import job */
  document: DocumentModel;
  /** Identifier of the document being imported */
  document_id: Scalars['String']['output'];
  /** Group associated with the import job */
  group: GroupModel;
  /** Identifier of the group the import job belongs to */
  group_id: Scalars['String']['output'];
  /** Unique identifier of the import job */
  job_id: Scalars['String']['output'];
};

/** LicenseModel */
export type LicenseModel = {
  __typename?: 'LicenseModel';
  /** Whether assessments are enabled for this license */
  enabled_assessments: Scalars['Boolean']['output'];
  /** Whether custom branding is enabled for this license */
  enabled_branding: Scalars['Boolean']['output'];
  /** Whether patient communications are enabled for this license */
  enabled_patient_comms: Scalars['Boolean']['output'];
  /** Unique identifier of the license */
  license_id: Scalars['String']['output'];
  /** Maximum number of practitioners allowed under this license */
  limit_practitioners?: Maybe<Scalars['Int']['output']>;
  /** Display name of the license tier */
  name: Scalars['String']['output'];
};

export type ListAccountsInput = {
  /** Account type to filter the list by */
  account_type: AccountType;
};

export type ListAlertNotificationsInput = {
  /** ID of the alert whose notifications are listed */
  alert_id: Scalars['String']['input'];
};

export type ListAlertRecipientSettingsInput = {
  /** Account identifier whose alert recipient settings to list */
  account_id: Scalars['String']['input'];
  /** Filter recipients by alert recipient type */
  recipient_type?: InputMaybe<AlertRecipientType>;
};

export type ListAlertSettingsInput = {
  /** Account identifier scoping the alert settings */
  account_id: Scalars['String']['input'];
  /** Vitall patient identifier to list alert settings for */
  vitall_patient_id: Scalars['String']['input'];
};

export type ListAlertsInput = {
  /** Account ID to filter alerts by */
  account_id?: InputMaybe<Scalars['String']['input']>;
  /** Alert statuses to include in the results */
  status?: InputMaybe<Array<AlertStatus>>;
  /** Vitall patient ID to filter alerts by */
  vitall_patient_id?: InputMaybe<Scalars['String']['input']>;
};

export type ListAppVersionsInput = {
  /** Filter versions by application */
  app?: InputMaybe<AppVersionApp>;
  /** Filter versions by platform */
  platform?: InputMaybe<AppVersionPlatform>;
  /** Filter versions by publication status */
  status?: InputMaybe<AppVersionStatus>;
};

export type ListAppointmentsInput = {
  /** Number of records to return per page */
  count?: InputMaybe<Scalars['Int']['input']>;
  /** Filters to narrow the appointment list */
  filters?: InputMaybe<AppointmentFilterInput>;
  /** Page number to retrieve */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** FHIR Patient resource id to list records for */
  patient: Scalars['String']['input'];
  /** Sort direction for records by date */
  sort?: InputMaybe<DateSortType>;
};

export type ListAssessmentsInput = {
  /** Cursor used for pagination */
  cursor?: InputMaybe<Scalars['String']['input']>;
  /** Type of assessment to filter the list by. */
  type: AssessmentType;
  /** Unique identifier for the patient. */
  vitall_patient_id: Scalars['String']['input'];
};

/** ListAssessmentsModel */
export type ListAssessmentsModel = {
  __typename?: 'ListAssessmentsModel';
  /** Cursor used for pagination */
  cursor?: Maybe<Scalars['String']['output']>;
  /** Paginated list of assessments. */
  data: Array<AssessmentModel>;
  /** Whether more records are available beyond this page */
  hasMore: Scalars['Boolean']['output'];
};

export type ListChatRoomsInput = {
  /** FHIR clinic IDs to filter chat rooms by. */
  fhir_clinic_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** FHIR practitioner IDs to filter chat rooms by. */
  fhir_practitioner_ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ListEhrSyncConnectionsInput = {
  /** Only connections with this EHR vendor. */
  ehr_vendor?: InputMaybe<EhrVendor>;
  /** Free-text search over organization name. */
  query?: InputMaybe<Scalars['String']['input']>;
  /** Only connections in this status. */
  status?: InputMaybe<EhrSyncConnectionStatus>;
};

export type ListImportJobsInput = {
  /** Maximum number of import jobs to return */
  limit: Scalars['Float']['input'];
  /** Token for fetching the next page of import jobs */
  token?: InputMaybe<Scalars['String']['input']>;
};

export type ListPermissionControlSetsInput = {
  /** User who is being granted permission */
  accessing_user_id: Scalars['String']['input'];
  /** User who is granting permission */
  user_id: Scalars['String']['input'];
};

export type ListPermissionsInput = {
  /** Optional scope to filter permissions by */
  scope?: InputMaybe<Scalars['String']['input']>;
};

export type ListPractitionersInput = {
  /** Filter practitioners by address */
  address?: InputMaybe<Scalars['String']['input']>;
  /** Filter practitioners by email address */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Filter practitioners by name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Filter practitioners by phone number */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** Filter practitioners by postal code */
  postal_code?: InputMaybe<Scalars['String']['input']>;
};

export type ListPurchasedPlansInput = {
  /** Account to list purchased plans for */
  account_id: Scalars['String']['input'];
};

export type ListRecordsInput = {
  /** Number of records to return per page */
  count?: InputMaybe<Scalars['Int']['input']>;
  /** Page number to retrieve */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** FHIR Patient resource id to list records for */
  patient: Scalars['String']['input'];
  /** Sort direction for records by date */
  sort?: InputMaybe<DateSortType>;
};

export type ListScanAppConnectionsInput = {
  /** Vitall patient id to list scan app connections for */
  vitall_patient_id: Scalars['String']['input'];
};

export type ListScanResultsInput = {
  /** Cursor used for pagination */
  cursor?: InputMaybe<Scalars['String']['input']>;
  /** Set to true to include scan results from all account members */
  include_members?: InputMaybe<Scalars['Boolean']['input']>;
  /** Type of scan to filter results by */
  scan_type: ScanType;
  /** Vitall patient id to list scan results for */
  vitall_patient_id: Scalars['String']['input'];
};

export type ListScanResultsResponse = {
  __typename?: 'ListScanResultsResponse';
  /** Cursor for fetching the next page */
  cursor: Scalars['String']['output'];
  /** Page of scan results */
  data: Array<ScanResultModel>;
  /** Whether more scan results are available */
  hasMore: Scalars['Boolean']['output'];
};

export type ListSharedResourcesInput = {
  /** Vitall patient id whose shared resources to list */
  user_id: Scalars['String']['input'];
};

export type ListStatusesInput = {
  /** Domain model to list statuses for */
  model: StatusType;
};

export type ListTerraActivitiesInput = {
  /** Optional filters to narrow the activity results */
  filters?: InputMaybe<TerraActivityFilters>;
  /** Vitall patient whose activities to list */
  vitall_patient_id: Scalars['String']['input'];
};

export type ListTerraActivitiesResponse = {
  __typename?: 'ListTerraActivitiesResponse';
  /** Cursor for fetching the next page */
  cursor: Scalars['String']['output'];
  /** Page of Terra activities */
  data: Array<ActivityModel>;
  /** Whether more activities are available */
  hasMore: Scalars['Boolean']['output'];
};

export type ListTerraConnectionsInput = {
  /** Vitall patient whose connections to list */
  vitall_patient_id: Scalars['String']['input'];
};

/** ListUserImportJobs */
export type ListUserImportJobs = {
  __typename?: 'ListUserImportJobs';
  /** Token for fetching the next page of import jobs */
  PaginationToken?: Maybe<Scalars['String']['output']>;
  /** List of user import jobs */
  UserImportJobs?: Maybe<Array<UserImportJob>>;
};

export type Location = {
  __typename?: 'Location';
  /** Location where the encounter takes place */
  location: Reference;
  /** Period the patient was present at the location */
  period?: Maybe<Period>;
  /** Physical type of the location in the hierarchy */
  physicalType?: Maybe<CodeableConcept>;
  /** Status of the patient's presence at this location */
  status?: Maybe<EncounterLocationStatus>;
};

export type LocationInput = {
  /** Location where the encounter takes place */
  location: ReferenceInput;
  /** Period the patient was present at the location */
  period?: InputMaybe<PeriodInput>;
  /** Physical type of the location in the hierarchy */
  physicalType?: InputMaybe<CodeableConceptInput>;
  /** Status of the patient's presence at this location */
  status?: InputMaybe<EncounterLocationStatus>;
};

export enum LocationModeCode {
  instance = 'instance',
  kind = 'kind'
}

/** LocationModel */
export type LocationModel = {
  __typename?: 'LocationModel';
  /** Physical address of the location */
  address?: Maybe<Address>;
  /** Alternate names the location is or was known as */
  alias?: Maybe<Array<Scalars['String']['output']>>;
  associatedResources?: Maybe<Array<ResourceAssociationUnion>>;
  attachments?: Maybe<Array<Attachment>>;
  /** Description of open or closed exceptions to the usual hours */
  availabilityExceptions?: Maybe<Scalars['String']['output']>;
  /** Contained */
  contained?: Maybe<Array<Resource>>;
  /** Additional details identifying the location beyond its name */
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  /** Technical endpoints providing access to services for the location */
  endpoint?: Maybe<Array<Reference>>;
  /** Extension */
  extension?: Maybe<Array<Extension>>;
  /** Days and times during a week the location is usually open */
  hoursOfOperation?: Maybe<Array<HoursOfOperation>>;
  /** Logical id of this artifact */
  id?: Maybe<Scalars['String']['output']>;
  /** Unique codes or numbers identifying the location to its users */
  identifier?: Maybe<Array<Identifier>>;
  /** A set of rules under which this content was created */
  implicitRules?: Maybe<Scalars['String']['output']>;
  /** Language of the resource content */
  language?: Maybe<Scalars['String']['output']>;
  /** Organization responsible for provisioning and upkeep */
  managingOrganization?: Maybe<Reference>;
  /** Metadata about the resource */
  meta?: Maybe<Meta>;
  /** Whether this describes a specific instance or a kind of location */
  mode?: Maybe<LocationModeCode>;
  /** Human-readable name of the location */
  name?: Maybe<Scalars['String']['output']>;
  /** Operational status of the location, typically for a bed or room */
  operationalStatus?: Maybe<Coding>;
  /** Another location this one is physically part of */
  partOf?: Maybe<Reference>;
  /** Physical form of the location */
  physicalType?: Maybe<CodeableConcept>;
  /** Absolute geographic coordinates of the location */
  position?: Maybe<Position>;
  /** FHIR resource type, always Location */
  resourceType?: Maybe<Scalars['String']['output']>;
  /** Location availability status: active, suspended, or inactive */
  status?: Maybe<LocationStatusCode>;
  /** Contact details of the location */
  telecom?: Maybe<Array<ContactPoint>>;
  /** Text */
  text?: Maybe<Narrative>;
  /** Type of function performed at the location */
  type?: Maybe<Array<CodeableConcept>>;
};

export type LocationModelInput = {
  /** Physical address of the location */
  address?: InputMaybe<AddressInput>;
  /** Alternate names the location is or was known as */
  alias?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Description of open or closed exceptions to the usual hours */
  availabilityExceptions?: InputMaybe<Scalars['String']['input']>;
  /** Contained */
  contained?: InputMaybe<Array<ResourceInput>>;
  /** Additional details identifying the location beyond its name */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Technical endpoints providing access to services for the location */
  endpoint?: InputMaybe<Array<ReferenceInput>>;
  /** Extension */
  extension?: InputMaybe<Array<ExtensionInput>>;
  /** Days and times during a week the location is usually open */
  hoursOfOperation?: InputMaybe<Array<HoursOfOperationInput>>;
  /** Logical id of this artifact */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Unique codes or numbers identifying the location to its users */
  identifier?: InputMaybe<Array<IdentifierInput>>;
  /** A set of rules under which this content was created */
  implicitRules?: InputMaybe<Scalars['String']['input']>;
  /** Language of the resource content */
  language?: InputMaybe<Scalars['String']['input']>;
  /** Organization responsible for provisioning and upkeep */
  managingOrganization?: InputMaybe<ReferenceInput>;
  /** Metadata about the resource */
  meta?: InputMaybe<MetaInput>;
  /** Whether this describes a specific instance or a kind of location */
  mode?: InputMaybe<LocationModeCode>;
  /** Human-readable name of the location */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Operational status of the location, typically for a bed or room */
  operationalStatus?: InputMaybe<CodingInput>;
  /** Another location this one is physically part of */
  partOf?: InputMaybe<ReferenceInput>;
  /** Physical form of the location */
  physicalType?: InputMaybe<CodeableConceptInput>;
  /** Absolute geographic coordinates of the location */
  position?: InputMaybe<PositionInput>;
  /** FHIR resource type, always Location */
  resourceType?: InputMaybe<Scalars['String']['input']>;
  /** Location availability status: active, suspended, or inactive */
  status?: InputMaybe<LocationStatusCode>;
  /** Contact details of the location */
  telecom?: InputMaybe<Array<ContactPointInput>>;
  /** Text */
  text?: InputMaybe<NarrativeInput>;
  /** Type of function performed at the location */
  type?: InputMaybe<Array<CodeableConceptInput>>;
};

export enum LocationStatusCode {
  active = 'active',
  inactive = 'inactive',
  suspended = 'suspended'
}

export type LoginInput = {
  /** Account password */
  password: Scalars['String']['input'];
  /** Login username or email */
  username: Scalars['String']['input'];
};

export type LogoutResponseModel = {
  __typename?: 'LogoutResponseModel';
  /** Logout confirmation message */
  message: Scalars['String']['output'];
};

export type Media = {
  __typename?: 'Media';
  /** Comment explaining the image */
  comment?: Maybe<Scalars['String']['output']>;
  /** Reference to the image source */
  link: Reference;
};

export type MedicationIngredient = {
  __typename?: 'MedicationIngredient';
  /** Whether this is an active ingredient */
  isActive?: Maybe<Scalars['Boolean']['output']>;
  /** Ingredient expressed as a coded concept */
  itemCodeableConcept?: Maybe<CodeableConcept>;
  /** Ingredient expressed as a reference to another resource */
  itemReference?: Maybe<Reference>;
  /** Quantity of ingredient present in the medication */
  strength?: Maybe<Ratio>;
};

export type MedicationIngredientInput = {
  /** Whether this is an active ingredient */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Ingredient expressed as a coded concept */
  itemCodeableConcept?: InputMaybe<CodeableConceptInput>;
  /** Ingredient expressed as a reference to another resource */
  itemReference?: InputMaybe<ReferenceInput>;
  /** Quantity of ingredient present in the medication */
  strength?: InputMaybe<RatioInput>;
};

/** MedicationModel */
export type MedicationModel = {
  __typename?: 'MedicationModel';
  /** Amount of drug contained in the package */
  amount?: Maybe<Ratio>;
  associatedResources?: Maybe<Array<ResourceAssociationUnion>>;
  attachments?: Maybe<Array<Attachment>>;
  /** Codes that identify this medication */
  code?: Maybe<CodeableConcept>;
  /** Contained */
  contained?: Maybe<Array<Resource>>;
  displayName?: Maybe<Scalars['String']['output']>;
  /** Extension */
  extension?: Maybe<Array<Extension>>;
  /** Dose form such as powder, tablets, or capsule */
  form?: Maybe<CodeableConcept>;
  /** Logical id of this artifact */
  id?: Maybe<Scalars['String']['output']>;
  /** Business identifiers for this medication */
  identifier?: Maybe<Array<Identifier>>;
  /** A set of rules under which this content was created */
  implicitRules?: Maybe<Scalars['String']['output']>;
  /** Active or inactive ingredients of the medication */
  ingredient?: Maybe<Array<MedicationIngredient>>;
  /** Language of the resource content */
  language?: Maybe<Scalars['String']['output']>;
  /** Reference to the manufacturer of the medication */
  manufacturer?: Maybe<Reference>;
  /** Metadata about the resource */
  meta?: Maybe<Meta>;
  /** FHIR resource type, always Medication */
  resourceType?: Maybe<Scalars['String']['output']>;
  /** Medication status: active, inactive, or entered-in-error */
  status?: Maybe<Scalars['String']['output']>;
  /** Text */
  text?: Maybe<Narrative>;
};

export type MedicationModelInput = {
  /** Amount of drug contained in the package */
  amount?: InputMaybe<RatioInput>;
  /** Codes that identify this medication */
  code?: InputMaybe<CodeableConceptInput>;
  /** Contained */
  contained?: InputMaybe<Array<ResourceInput>>;
  /** Extension */
  extension?: InputMaybe<Array<ExtensionInput>>;
  /** Dose form such as powder, tablets, or capsule */
  form?: InputMaybe<CodeableConceptInput>;
  /** Logical id of this artifact */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Business identifiers for this medication */
  identifier?: InputMaybe<Array<IdentifierInput>>;
  /** A set of rules under which this content was created */
  implicitRules?: InputMaybe<Scalars['String']['input']>;
  /** Active or inactive ingredients of the medication */
  ingredient?: InputMaybe<Array<MedicationIngredientInput>>;
  /** Language of the resource content */
  language?: InputMaybe<Scalars['String']['input']>;
  /** Reference to the manufacturer of the medication */
  manufacturer?: InputMaybe<ReferenceInput>;
  /** Metadata about the resource */
  meta?: InputMaybe<MetaInput>;
  /** FHIR resource type, always Medication */
  resourceType?: InputMaybe<Scalars['String']['input']>;
  /** Medication status: active, inactive, or entered-in-error */
  status?: InputMaybe<Scalars['String']['input']>;
  /** Text */
  text?: InputMaybe<NarrativeInput>;
};

export type MedicationRequestDispenseRequest = {
  __typename?: 'MedicationRequestDispenseRequest';
  /** Minimum period between dispenses */
  dispenseInterval?: Maybe<Quantity>;
  /** Expected duration each dispense should last */
  expectedSupplyDuration?: Maybe<Quantity>;
  /** First fill details for the dispense */
  initialFill?: Maybe<MedicationRequestInitialFill>;
  /** Number of refills authorized after the initial fill */
  numberOfRepeatsAllowed?: Maybe<Scalars['Float']['output']>;
  /** Intended dispensing pharmacy or performer */
  performer?: Maybe<Reference>;
  /** Amount of medication to supply per dispense */
  quantity?: Maybe<Quantity>;
  /** Time period the prescription is valid for dispensing */
  validityPeriod?: Maybe<Period>;
};

export type MedicationRequestDispenseRequestInput = {
  /** Minimum period between dispenses */
  dispenseInterval?: InputMaybe<QuantityInput>;
  /** Expected duration each dispense should last */
  expectedSupplyDuration?: InputMaybe<QuantityInput>;
  /** First fill details for the dispense */
  initialFill?: InputMaybe<MedicationRequestInitialFillInput>;
  /** Number of refills authorized after the initial fill */
  numberOfRepeatsAllowed?: InputMaybe<Scalars['Float']['input']>;
  /** Intended dispensing pharmacy or performer */
  performer?: InputMaybe<ReferenceInput>;
  /** Amount of medication to supply per dispense */
  quantity?: InputMaybe<QuantityInput>;
  /** Time period the prescription is valid for dispensing */
  validityPeriod?: InputMaybe<PeriodInput>;
};

export type MedicationRequestInitialFill = {
  __typename?: 'MedicationRequestInitialFill';
  /** Duration the first fill lasts */
  duration?: Maybe<Quantity>;
  /** Quantity dispensed in the first fill */
  quantity?: Maybe<Quantity>;
};

export type MedicationRequestInitialFillInput = {
  /** Duration the first fill lasts */
  duration?: InputMaybe<QuantityInput>;
  /** Quantity dispensed in the first fill */
  quantity?: InputMaybe<QuantityInput>;
};

export enum MedicationRequestIntent {
  fillerOrder = 'fillerOrder',
  instanceOrder = 'instanceOrder',
  option = 'option',
  order = 'order',
  originalOrder = 'originalOrder',
  plan = 'plan',
  proposal = 'proposal',
  reflexOrder = 'reflexOrder'
}

/** MedicationRequestModel */
export type MedicationRequestModel = {
  __typename?: 'MedicationRequestModel';
  associatedResources?: Maybe<Array<ResourceAssociationUnion>>;
  attachments?: Maybe<Array<Attachment>>;
  /** Date and time the request was authored */
  authoredOn?: Maybe<Scalars['String']['output']>;
  /** Plans or requests this order fulfills */
  basedOn?: Maybe<Array<Reference>>;
  /** Category of the medication request, such as inpatient or outpatient */
  category?: Maybe<Array<CodeableConcept>>;
  /**
   * Medication contained inline in this request. Narrows
   * DomainResource.contained: a MedicationRequest only ever contains the
   * referenced Medication (see medicationReference / #contained-med).
   */
  contained?: Maybe<Array<MedicationModel>>;
  /** Overall pattern of medication administration */
  courseOfTherapyType?: Maybe<CodeableConcept>;
  /** Detected clinical issues associated with the request */
  detectedIssue?: Maybe<Array<Reference>>;
  /** Details of how the medication should be dispensed */
  dispenseRequest?: Maybe<MedicationRequestDispenseRequest>;
  displayName?: Maybe<Scalars['String']['output']>;
  /** Whether the request is to not perform the medication */
  doNotPerform?: Maybe<Scalars['Boolean']['output']>;
  /** Instructions on how the medication should be taken */
  dosageInstruction?: Maybe<Array<Dosage>>;
  /** Encounter during which the request was created */
  encounter?: Maybe<Reference>;
  /** History of provenance events for the request */
  eventHistory?: Maybe<Array<Reference>>;
  /** Extension */
  extension?: Maybe<Array<Extension>>;
  /** Shared identifier grouping related requests */
  groupIdentifier?: Maybe<Identifier>;
  /** Logical id of this artifact */
  id?: Maybe<Scalars['String']['output']>;
  /** External identifiers for this medication request */
  identifier?: Maybe<Array<Identifier>>;
  /** A set of rules under which this content was created */
  implicitRules?: Maybe<Scalars['String']['output']>;
  /** Canonical URLs of protocols this request instantiates */
  instantiatesCanonical?: Maybe<Array<Scalars['String']['output']>>;
  /** External URLs of protocols this request instantiates */
  instantiatesUri?: Maybe<Array<Scalars['String']['output']>>;
  /** Insurance or coverage for the medication */
  insurance?: Maybe<Array<Reference>>;
  /** Whether the request is a proposal, plan, or order */
  intent: MedicationRequestIntent;
  /** Language of the resource content */
  language?: Maybe<Scalars['String']['output']>;
  /** Medication to be taken, as a coded concept */
  medicationCodeableConcept?: Maybe<CodeableConcept>;
  /** Medication to be taken, as a resource reference */
  medicationReference?: Maybe<Reference>;
  /** Metadata about the resource */
  meta?: Maybe<Meta>;
  /** Additional notes about the medication request */
  note?: Maybe<Array<Annotation>>;
  /** Intended performer of the medication administration */
  performer?: Maybe<Reference>;
  /** Type of performer expected to administer the medication */
  performerType?: Maybe<CodeableConcept>;
  /** Prior prescription this request replaces */
  priorPrescription?: Maybe<Reference>;
  /** Urgency of the medication request */
  priority?: Maybe<MedicationRequestPriority>;
  /** Coded reasons the medication was ordered */
  reasonCode?: Maybe<Array<CodeableConcept>>;
  /** Condition or observation references supporting the order */
  reasonReference?: Maybe<Array<Reference>>;
  /** Person who entered the request on behalf of the requester */
  recorder?: Maybe<Reference>;
  /** Whether the record is reported rather than primary */
  reportedBoolean?: Maybe<Scalars['Boolean']['output']>;
  /** Source that reported this medication request */
  reportedReference?: Maybe<Reference>;
  /** Practitioner or organization that requested the medication */
  requester?: Maybe<Reference>;
  /** FHIR resource type, always MedicationRequest */
  resourceType?: Maybe<Scalars['String']['output']>;
  /** Lifecycle status of the medication request */
  status: MedicationRequestStatus;
  /** Reason for the current status */
  statusReason?: Maybe<CodeableConcept>;
  /** Patient the medication request is for */
  subject: Reference;
  /** Whether substitution is allowed and why */
  substitution?: Maybe<MedicationRequestSubstitution>;
  /** Supporting information for the medication request */
  supportingInformation?: Maybe<Array<Reference>>;
  /** Text */
  text?: Maybe<Narrative>;
};

export type MedicationRequestModelInput = {
  /** Date and time the request was authored */
  authoredOn?: InputMaybe<Scalars['String']['input']>;
  /** Plans or requests this order fulfills */
  basedOn?: InputMaybe<Array<ReferenceInput>>;
  /** Category of the medication request, such as inpatient or outpatient */
  category?: InputMaybe<Array<CodeableConceptInput>>;
  /**
   * Medication contained inline in this request. Narrows
   * DomainResource.contained: a MedicationRequest only ever contains the
   * referenced Medication (see medicationReference / #contained-med).
   */
  contained?: InputMaybe<Array<MedicationModelInput>>;
  /** Overall pattern of medication administration */
  courseOfTherapyType?: InputMaybe<CodeableConceptInput>;
  /** Detected clinical issues associated with the request */
  detectedIssue?: InputMaybe<Array<ReferenceInput>>;
  /** Details of how the medication should be dispensed */
  dispenseRequest?: InputMaybe<MedicationRequestDispenseRequestInput>;
  /** Whether the request is to not perform the medication */
  doNotPerform?: InputMaybe<Scalars['Boolean']['input']>;
  /** Instructions on how the medication should be taken */
  dosageInstruction?: InputMaybe<Array<DosageInput>>;
  /** Encounter during which the request was created */
  encounter?: InputMaybe<ReferenceInput>;
  /** History of provenance events for the request */
  eventHistory?: InputMaybe<Array<ReferenceInput>>;
  /** Extension */
  extension?: InputMaybe<Array<ExtensionInput>>;
  /** Shared identifier grouping related requests */
  groupIdentifier?: InputMaybe<IdentifierInput>;
  /** Logical id of this artifact */
  id?: InputMaybe<Scalars['String']['input']>;
  /** External identifiers for this medication request */
  identifier?: InputMaybe<Array<IdentifierInput>>;
  /** A set of rules under which this content was created */
  implicitRules?: InputMaybe<Scalars['String']['input']>;
  /** Canonical URLs of protocols this request instantiates */
  instantiatesCanonical?: InputMaybe<Array<Scalars['String']['input']>>;
  /** External URLs of protocols this request instantiates */
  instantiatesUri?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Insurance or coverage for the medication */
  insurance?: InputMaybe<Array<ReferenceInput>>;
  /** Whether the request is a proposal, plan, or order */
  intent: MedicationRequestIntent;
  /** Language of the resource content */
  language?: InputMaybe<Scalars['String']['input']>;
  /** Medication to be taken, as a coded concept */
  medicationCodeableConcept?: InputMaybe<CodeableConceptInput>;
  /** Medication to be taken, as a resource reference */
  medicationReference?: InputMaybe<ReferenceInput>;
  /** Metadata about the resource */
  meta?: InputMaybe<MetaInput>;
  /** Additional notes about the medication request */
  note?: InputMaybe<Array<AnnotationInput>>;
  /** Intended performer of the medication administration */
  performer?: InputMaybe<ReferenceInput>;
  /** Type of performer expected to administer the medication */
  performerType?: InputMaybe<CodeableConceptInput>;
  /** Prior prescription this request replaces */
  priorPrescription?: InputMaybe<ReferenceInput>;
  /** Urgency of the medication request */
  priority?: InputMaybe<MedicationRequestPriority>;
  /** Coded reasons the medication was ordered */
  reasonCode?: InputMaybe<Array<CodeableConceptInput>>;
  /** Condition or observation references supporting the order */
  reasonReference?: InputMaybe<Array<ReferenceInput>>;
  /** Person who entered the request on behalf of the requester */
  recorder?: InputMaybe<ReferenceInput>;
  /** Whether the record is reported rather than primary */
  reportedBoolean?: InputMaybe<Scalars['Boolean']['input']>;
  /** Source that reported this medication request */
  reportedReference?: InputMaybe<ReferenceInput>;
  /** Practitioner or organization that requested the medication */
  requester?: InputMaybe<ReferenceInput>;
  /** FHIR resource type, always MedicationRequest */
  resourceType?: InputMaybe<Scalars['String']['input']>;
  /** Lifecycle status of the medication request */
  status: MedicationRequestStatus;
  /** Reason for the current status */
  statusReason?: InputMaybe<CodeableConceptInput>;
  /** Patient the medication request is for */
  subject: ReferenceInput;
  /** Whether substitution is allowed and why */
  substitution?: InputMaybe<MedicationRequestSubstitutionInput>;
  /** Supporting information for the medication request */
  supportingInformation?: InputMaybe<Array<ReferenceInput>>;
  /** Text */
  text?: InputMaybe<NarrativeInput>;
};

export enum MedicationRequestPriority {
  asap = 'asap',
  routine = 'routine',
  stat = 'stat',
  urgent = 'urgent'
}

export enum MedicationRequestStatus {
  active = 'active',
  cancelled = 'cancelled',
  completed = 'completed',
  draft = 'draft',
  enteredInError = 'enteredInError',
  onHold = 'onHold',
  stopped = 'stopped',
  unknown = 'unknown'
}

export type MedicationRequestSubstitution = {
  __typename?: 'MedicationRequestSubstitution';
  /** Whether generic substitution is allowed */
  allowedBoolean?: Maybe<Scalars['Boolean']['output']>;
  /** Coded rule for whether substitution is allowed */
  allowedCodeableConcept?: Maybe<CodeableConcept>;
  /** Reason for the substitution decision */
  reason?: Maybe<CodeableConcept>;
};

export type MedicationRequestSubstitutionInput = {
  /** Whether generic substitution is allowed */
  allowedBoolean?: InputMaybe<Scalars['Boolean']['input']>;
  /** Coded rule for whether substitution is allowed */
  allowedCodeableConcept?: InputMaybe<CodeableConceptInput>;
  /** Reason for the substitution decision */
  reason?: InputMaybe<CodeableConceptInput>;
};

/** MedicationStatementModel */
export type MedicationStatementModel = {
  __typename?: 'MedicationStatementModel';
  associatedResources?: Maybe<Array<ResourceAssociationUnion>>;
  attachments?: Maybe<Array<Attachment>>;
  /** Plan, proposal or order this statement fulfils */
  basedOn?: Maybe<Array<Reference>>;
  /** Type of medication usage */
  category?: Maybe<CodeableConcept>;
  /** Inline Medication resource referenced by medicationReference */
  contained?: Maybe<Array<MedicationModel>>;
  /** Encounter or episode associated with this statement */
  context?: Maybe<Reference>;
  /** Curation metadata for this medication statement resource */
  curationMeta?: Maybe<CurationMeta>;
  /** When the statement was asserted */
  dateAsserted?: Maybe<Scalars['String']['output']>;
  /** Additional supporting information sources */
  derivedFrom?: Maybe<Array<Reference>>;
  displayName?: Maybe<Scalars['String']['output']>;
  /** Details of how the medication is or was taken */
  dosage?: Maybe<Array<Dosage>>;
  /** Date/time when the medication was taken */
  effectiveDateTime?: Maybe<Scalars['String']['output']>;
  /** Interval over which the medication was taken */
  effectivePeriod?: Maybe<Period>;
  /** Extension */
  extension?: Maybe<Array<Extension>>;
  /** Logical id of this artifact */
  id?: Maybe<Scalars['String']['output']>;
  /** External identifiers for this medication statement */
  identifier?: Maybe<Array<Identifier>>;
  /** A set of rules under which this content was created */
  implicitRules?: Maybe<Scalars['String']['output']>;
  /** Person or organization that provided the information */
  informationSource?: Maybe<Reference>;
  /** Language of the resource content */
  language?: Maybe<Scalars['String']['output']>;
  /** Medication taken, expressed as a codeable concept */
  medicationCodeableConcept?: Maybe<CodeableConcept>;
  /** Medication taken, expressed as a resource reference */
  medicationReference?: Maybe<Reference>;
  /** Metadata about the resource */
  meta?: Maybe<Meta>;
  /** Further free-text notes about the statement */
  note?: Maybe<Array<Annotation>>;
  /** Larger event this statement is part of */
  partOf?: Maybe<Array<Reference>>;
  /** Reason the medication is or was being taken */
  reasonCode?: Maybe<Array<CodeableConcept>>;
  /** Condition or observation supporting why the medication is taken */
  reasonReference?: Maybe<Array<Reference>>;
  /** FHIR resource type, always MedicationStatement */
  resourceType?: Maybe<Scalars['String']['output']>;
  /** Status: active, completed, entered-in-error, intended, stopped, on-hold, unknown or not-taken */
  status: Scalars['String']['output'];
  /** Reason for the current status */
  statusReason?: Maybe<Array<CodeableConcept>>;
  /** Patient or subject who is or was taking the medication */
  subject: Reference;
  /** Text */
  text?: Maybe<Narrative>;
};

export type MedicationStatementModelInput = {
  /** Plan, proposal or order this statement fulfils */
  basedOn?: InputMaybe<Array<ReferenceInput>>;
  /** Type of medication usage */
  category?: InputMaybe<CodeableConceptInput>;
  /** Inline Medication resource referenced by medicationReference */
  contained?: InputMaybe<Array<MedicationModelInput>>;
  /** Encounter or episode associated with this statement */
  context?: InputMaybe<ReferenceInput>;
  /** When the statement was asserted */
  dateAsserted?: InputMaybe<Scalars['String']['input']>;
  /** Additional supporting information sources */
  derivedFrom?: InputMaybe<Array<ReferenceInput>>;
  /** Details of how the medication is or was taken */
  dosage?: InputMaybe<Array<DosageInput>>;
  /** Date/time when the medication was taken */
  effectiveDateTime?: InputMaybe<Scalars['String']['input']>;
  /** Interval over which the medication was taken */
  effectivePeriod?: InputMaybe<PeriodInput>;
  /** Extension */
  extension?: InputMaybe<Array<ExtensionInput>>;
  /** Logical id of this artifact */
  id?: InputMaybe<Scalars['String']['input']>;
  /** External identifiers for this medication statement */
  identifier?: InputMaybe<Array<IdentifierInput>>;
  /** A set of rules under which this content was created */
  implicitRules?: InputMaybe<Scalars['String']['input']>;
  /** Person or organization that provided the information */
  informationSource?: InputMaybe<ReferenceInput>;
  /** Language of the resource content */
  language?: InputMaybe<Scalars['String']['input']>;
  /** Medication taken, expressed as a codeable concept */
  medicationCodeableConcept?: InputMaybe<CodeableConceptInput>;
  /** Medication taken, expressed as a resource reference */
  medicationReference?: InputMaybe<ReferenceInput>;
  /** Metadata about the resource */
  meta?: InputMaybe<MetaInput>;
  /** Further free-text notes about the statement */
  note?: InputMaybe<Array<AnnotationInput>>;
  /** Larger event this statement is part of */
  partOf?: InputMaybe<Array<ReferenceInput>>;
  /** Reason the medication is or was being taken */
  reasonCode?: InputMaybe<Array<CodeableConceptInput>>;
  /** Condition or observation supporting why the medication is taken */
  reasonReference?: InputMaybe<Array<ReferenceInput>>;
  /** FHIR resource type, always MedicationStatement */
  resourceType?: InputMaybe<Scalars['String']['input']>;
  /** Status: active, completed, entered-in-error, intended, stopped, on-hold, unknown or not-taken */
  status: StatementStatus;
  /** Reason for the current status */
  statusReason?: InputMaybe<Array<CodeableConceptInput>>;
  /** Patient or subject who is or was taking the medication */
  subject: ReferenceInput;
  /** Text */
  text?: InputMaybe<NarrativeInput>;
};

export type Meta = {
  __typename?: 'Meta';
  /** When the resource version last changed */
  lastUpdated?: Maybe<Scalars['String']['output']>;
  /** Profiles this resource claims to conform to */
  profile?: Maybe<Array<Scalars['String']['output']>>;
  /** Security Labels applied to this resource */
  security?: Maybe<Array<Coding>>;
  /** Identifies where the resource comes from */
  source?: Maybe<Scalars['String']['output']>;
  /** Tags applied to this resource */
  tag?: Maybe<Array<Coding>>;
  /** Version specific identifier */
  versionId?: Maybe<Scalars['String']['output']>;
};

export type MetaInput = {
  /** When the resource version last changed */
  lastUpdated?: InputMaybe<Scalars['String']['input']>;
  /** Profiles this resource claims to conform to */
  profile?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Security Labels applied to this resource */
  security?: InputMaybe<Array<CodingInput>>;
  /** Identifies where the resource comes from */
  source?: InputMaybe<Scalars['String']['input']>;
  /** Tags applied to this resource */
  tag?: InputMaybe<Array<CodingInput>>;
  /** Version specific identifier */
  versionId?: InputMaybe<Scalars['String']['input']>;
};

export type MetricAlertInput = {
  /** Observation category of the metric */
  category?: InputMaybe<Scalars['String']['input']>;
  /** Observation code identifying the metric */
  code: Scalars['String']['input'];
  /** Vitall patient ID the metric alert belongs to */
  vitall_patient_id: Scalars['String']['input'];
};

export enum MfaMethod {
  EMAIL_OTP = 'EMAIL_OTP',
  NONE = 'NONE',
  SMS_MFA = 'SMS_MFA',
  SOFTWARE_TOKEN_MFA = 'SOFTWARE_TOKEN_MFA'
}

/** MfaResponseModel */
export type MfaResponseModel = {
  __typename?: 'MfaResponseModel';
  /** MFA operation status message */
  message: Scalars['String']['output'];
};

export type Money = {
  __typename?: 'Money';
  /** Currency */
  currency?: Maybe<Scalars['String']['output']>;
  /** Value */
  value?: Maybe<Scalars['Float']['output']>;
};

export type MoneyInput = {
  /** Currency */
  currency?: InputMaybe<Scalars['String']['input']>;
  /** Value */
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type MultipartFileUploadSessionInput = {
  /** Original file name for the upload */
  filename?: InputMaybe<Scalars['String']['input']>;
  /** Multipart upload details needed to complete the upload */
  multipartUploadInfo: MultipartUploadModelInput;
  /** FHIR Patient ID the upload belongs to */
  patient_id?: InputMaybe<Scalars['String']['input']>;
  /** Unique upload session identifier */
  session_id: Scalars['String']['input'];
};

/** MultipartUploadModel */
export type MultipartUploadModel = {
  __typename?: 'MultipartUploadModel';
  /**
   * Headers the client MUST send on each presigned PUT request. These values
   * are signed into the presigned URL, so S3 rejects uploads whose headers
   * don't match byte-for-byte. Populated only for single-part uploads;
   * multipart uploads set their metadata at initiation time server-side.
   */
  expectedHeaders?: Maybe<ExpectedUploadHeaders>;
  /** Whether the upload uses multipart transfer */
  isMultipart: Scalars['Boolean']['output'];
  /** S3 multipart upload identifier, if multipart */
  multipartUploadId?: Maybe<Scalars['String']['output']>;
  /** Presigned parts to upload for a multipart transfer */
  parts: Array<PartModel>;
};

export type MultipartUploadModelInput = {
  /** Whether the upload uses multipart transfer */
  isMultipart: Scalars['Boolean']['input'];
  /** S3 multipart upload identifier, if multipart */
  multipartUploadId?: InputMaybe<Scalars['String']['input']>;
  /** Uploaded parts with their ETags to complete the upload */
  parts?: InputMaybe<Array<MultipartUploadPartModelInput>>;
};

export type MultipartUploadPartModelInput = {
  /** ETag returned by S3 for the uploaded part */
  ETag: Scalars['String']['input'];
  /** Part number within the multipart upload */
  PartNumber: Scalars['Float']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Add a policy to an operation. If the operation does not exist, it will be created. */
  addPolicyToOperation: OperationModel;
  /** Attach a policy to a role after verifying it exists */
  addPolicyToRole: RoleModel;
  /** Assign a role to a user after verifying the role exists */
  addRoleToUser: UserModel;
  /** Admin changes a user's email from current to new address */
  adminChangeEmail: UserModel;
  /** Updates a user's first/middle/last name (can only be performed by an admin) */
  adminChangeName: UpdateUserResponse;
  /** Admin changes a user's phone number by user id */
  adminChangePhone: UserModel;
  /** Admin updates a user's notification preference */
  adminUpdateUserNotificationPreference: UserNotificationPreference;
  assignPatientPlans: Array<PatientPlanAssignmentModel>;
  /** Assigns a curator or practitioner user to a Vitall patient */
  assignUserToPatient: UpdateVitallPatientResponse;
  /** Start a Terra wearable integration session for a patient */
  authenticateConnection: TerraConnectionSession;
  /** Begin recipient auth by emailing a share access code */
  beginShareAuth: BeginShareAuthResponse;
  /** Broadcast an announcement message to targeted chat rooms */
  broadcastChatAnnouncement: BroadcastChatAnnouncementResult;
  /** Updates a user's name */
  changeName: UpdateUserResponse;
  /** Changes the authenticated user's password */
  changePassword: ChangePasswordModel;
  /** Initiates changing the authenticated user's email address */
  changeUserEmail: UpdateUserAttributesResponse;
  /** Initiates changing the authenticated user's phone number */
  changeUserPhone: UpdateUserAttributesResponse;
  /** Finalize an account avatar upload and return the updated account */
  completeAccountAvatarUpload?: Maybe<AccountOrSettingWrapper>;
  /** Finalize an avatar upload and return the updated user */
  completeAvatarUpload?: Maybe<UserModel>;
  /** Finalize a Discern multipart upload and clean up the session */
  completeDiscernFileUpload: Scalars['Boolean']['output'];
  /** Finalize a FHIR upload, create the Binary, and return its S3 key */
  completeFhirFileUpload?: Maybe<Scalars['String']['output']>;
  /** Finalize a PACS upload and post the DICOM study */
  completePacsFileUpload?: Maybe<Scalars['Boolean']['output']>;
  /** Complete recipient auth and return a share access token */
  completeShareAuth: CompleteShareAuthResponse;
  /** Confirm password reset with verification code and new password */
  confirmPassword: ChangePasswordModel;
  /** Create a new draft app version */
  createAppVersionDraft: AppVersionModel;
  /** Create a share link for a completed DHA */
  createDhaShareLink: CreateShareLinkResponse;
  /** Create a Discern document immediately after file upload */
  createDiscernDocumentFromUpload: DiscernDocumentModel;
  createEngageHandoffToken: HandoffTokenModel;
  /** Create a permission with a name and scope */
  createPermission: PermissionModel;
  /** Creates a new policy with name, description, and permissions */
  createPolicy: PolicyModel;
  /** Create a new role with name, description, rank, and scope */
  createRole: RoleModel;
  /** Create a share link for a patient resource */
  createShareLink: CreateShareLinkResponse;
  /** Creates a new GDMT titration care plan for a patient */
  createTitrationCarePlan: TitrationCarePlanEntry;
  /** Disconnect an existing Terra wearable integration */
  deauthenticateConnection: Scalars['Boolean']['output'];
  /** Deletes an account after verifying the caller's credentials */
  deleteAccount: UpdateAccountResponse;
  /** Remove an account's avatar and return the updated account */
  deleteAccountAvatar?: Maybe<AccountOrSettingWrapper>;
  /** Deletes an alert setting and returns whether it succeeded */
  deleteAlertSetting: Scalars['Boolean']['output'];
  /** Delete a patient's AllergyIntolerance FHIR record */
  deleteAllergyRecord: OperationOutcomeModel;
  /** Deletes an appointment FHIR record by ID */
  deleteAppointmentRecord: OperationOutcomeModel;
  /** Remove an attachment from a FHIR resource */
  deleteAttachment: Scalars['Boolean']['output'];
  /** Remove a user's avatar and return the updated user */
  deleteAvatar?: Maybe<UserModel>;
  /** Deletes a body measurement Observation record for a patient */
  deleteBodyObservationRecord: OperationOutcomeModel;
  /** Removes a member from a patient's care team */
  deleteCareTeamMember: OperationOutcomeModel;
  /** Deletes a patient's FHIR Condition record */
  deleteConditionRecord: OperationOutcomeModel;
  /** Delete a patient's FHIR Consent record */
  deleteConsentRecord: OperationOutcomeModel;
  /** Deletes an insurance Coverage FHIR record by its ID */
  deleteCoverageRecord: OperationOutcomeModel;
  /** Delete a curator task record by id (curator or admin only) */
  deleteCuratorTaskRecord: UpdateCuratorTaskResponse;
  /** Archives custom reference range parameters */
  deleteCustomParameters: Scalars['Boolean']['output'];
  /** Deletes a patient's direct EMR API connection */
  deleteDirectEmrApiConnection: DirectEmrApiConnection;
  /** Delete a Discern document by id */
  deleteDiscernDocument: DeleteDiscernDocumentModel;
  /** Deletes an emergency visit Encounter FHIR resource */
  deleteEmergencyVisitRecord: OperationOutcomeModel;
  /** Deletes a patient's FamilyMemberHistory record */
  deleteFamilyMemberHistoryRecord: OperationOutcomeModel;
  /** Deletes a fitness Observation record for a patient */
  deleteFitnessObservationRecord: OperationOutcomeModel;
  /** Deletes a genetic information Observation record for a patient */
  deleteGeneticObservationRecord: OperationOutcomeModel;
  /** Delete a hospitalization Encounter record for a patient */
  deleteHospitalizationRecord: OperationOutcomeModel;
  /** Delete an imaging test DiagnosticReport resource */
  deleteImagingTest: OperationOutcomeModel;
  /** Deletes an immunization FHIR record for a patient */
  deleteImmunizationRecord: OperationOutcomeModel;
  /** Delete a lab report DiagnosticReport resource */
  deleteLabReport: OperationOutcomeModel;
  /** Delete a patient's legal directive Consent record */
  deleteLegalDirectiveRecord: OperationOutcomeModel;
  /** Deletes a patient's MedicationRequest FHIR record */
  deleteMedicationRequestRecord: OperationOutcomeModel;
  /** Deletes a patient's FHIR MedicationStatement record */
  deleteMedicationStatementRecord: OperationOutcomeModel;
  /** Removes a note extension from a FHIR resource */
  deleteNote: NotesResourcesUnion;
  /** Removes PACS imaging studies from a diagnostic report */
  deletePacsStudies?: Maybe<DiagnosticReportModel>;
  /** Delete a FHIR Procedure record for a patient */
  deleteProcedureRecord: OperationOutcomeModel;
  /** Deletes a related person record for a patient */
  deleteRelatedPersonRecord: OperationOutcomeModel;
  /** Deletes a routine instance status record by instance id */
  deleteRoutineInstanceStatusRecord: DeleteRoutineInstanceStatusResponse;
  /** Delete a scan result by its identifier */
  deleteScanResult: Scalars['Boolean']['output'];
  /** Deletes a sleep Observation record for a patient */
  deleteSleepObservationRecord: OperationOutcomeModel;
  /** Deletes a FHIR Task record by its id */
  deleteTaskRecord: OperationOutcomeModel;
  /** Deletes a user by id, returning success as a boolean */
  deleteUser: Scalars['Boolean']['output'];
  /** Revoke a user's permission grants over another user's data */
  deleteUserPermissionGrants?: Maybe<UserModel>;
  /** Deletes a vital sign Observation record for a patient */
  deleteVitalSignObservationRecord: OperationOutcomeModel;
  /** Disables MFA for the authenticated user */
  disableMfa: CompleteMfaResponseModel;
  /** Admin or curator disables a user account by email */
  disableUser: UserModel;
  /** Enables MFA for the authenticated user */
  enableMfa: CompleteMfaResponseModel;
  /** Admin or curator enables a user account by email */
  enableUser: UserModel;
  /** Ends an active titration care plan and returns the affected resource IDs */
  endTitrationCarePlan: Array<Scalars['String']['output']>;
  enrollEhrSyncPatient: EhrPatientLink;
  exchangeHandoffToken: AuthModel;
  /** Start password reset by emailing reset instructions */
  forgotPassword: ChangePasswordModel;
  /** Start an upload session for an account avatar image */
  initiateAccountAvatarUpload: FileUploadSession;
  /** Initiates an assessment for a patient. */
  initiateAssessment: AssessmentCredentials;
  /** Start an upload session for a user avatar image */
  initiateAvatarUpload: FileUploadSession;
  /** Start an upload session for a Discern PDF under a patient folder */
  initiateDiscernFileUpload: FileUploadSession;
  /** Start an upload session for a FHIR Binary file */
  initiateFhirFileUpload: FileUploadSession;
  /** Authenticates the user with the Ethora chat messenger and returns their token and config */
  initiateMessengerAuth: GetChatTokenConfigResponse;
  /** Start an upload session for a PACS DICOM study tied to a diagnostic report */
  initiatePacsFileUpload: FileUploadSession;
  /** Authenticate a user and set auth session cookies */
  login?: Maybe<AuthModel>;
  /** Signs the user out and clears refresh token cookies */
  logout: LogoutResponseModel;
  /** Create a new FHIR AllergyIntolerance record for a patient */
  postAllergyRecord: AllergyModel;
  /** Creates a new FHIR appointment record with its location */
  postAppointmentRecord: AppointmentModel;
  /** Attach an uploaded S3 document to a FHIR resource */
  postAttachment: Array<Attachment>;
  /** Creates a body measurement observation record for a patient */
  postBodyObservationRecord: ObservationModel;
  /** Creates a new FHIR Condition record for a patient */
  postConditionRecord: ConditionModel;
  /** Creates a new patient consent FHIR record */
  postConsentRecord: ConsentModel;
  /** Creates a new insurance coverage record for a patient */
  postCoverageRecord: CoverageModel;
  /** Creates a new curator task record */
  postCuratorTaskRecord: CuratorTaskModel;
  /** Creates a direct EMR API connection for a patient */
  postDirectEmrApiConnection: DirectEmrApiConnection;
  /** Creates an emergency visit Encounter record with its location */
  postEmergencyVisitsEncounterRecord: EncounterModel;
  /** Creates a new FHIR FamilyMemberHistory record for a patient */
  postFamilyMemberHistoryRecord: FamilyMemberHistoryModel;
  /** Auto-curate and post FHIR resources for a patient */
  postFhirResource: Array<Scalars['String']['output']>;
  /** Creates a fitness activity observation record for a patient */
  postFitnessObservationRecord: ObservationModel;
  /** Creates a new genetic information Observation record */
  postGeneticObservationRecord: ObservationModel;
  /** Creates a hospitalization Encounter record with its location */
  postHospitalizationsEncounterRecord: EncounterModel;
  /** Creates an imaging test diagnostic report resource */
  postImagingTest: DiagnosticReportModel;
  /** Creates a new immunization record for a patient */
  postImmunizationRecord: ImmunizationModel;
  /** Creates a lab report diagnostic report resource */
  postLabReport: DiagnosticReportModel;
  /** Creates a laboratory result observation record for a patient */
  postLaboratoryObservationRecord: ObservationModel;
  /** Creates a new legal directive consent FHIR record */
  postLegalDirectiveRecord: ConsentModel;
  /** Creates a new MedicationRequest FHIR resource */
  postMedicationRequestRecord: MedicationRequestModel;
  /** Create a new FHIR MedicationStatement record for a patient */
  postMedicationStatementRecord: MedicationStatementModel;
  /** Adds a note extension to a FHIR resource */
  postNote: NotesResourcesUnion;
  /** Attaches PACS imaging studies to a diagnostic report */
  postPacsStudies?: Maybe<DiagnosticReportModel>;
  /** Creates a new permission for a user or role */
  postPermission?: Maybe<Scalars['Boolean']['output']>;
  /** Create a FHIR Procedure record with its location */
  postProcedureRecord: ProcedureModel;
  /** Submit or update a patient's questionnaire responses by questionnaire identifier */
  postQuestionnaireResponses: QuestionnaireResponseModel;
  /** Creates a new FHIR RelatedPerson record for a patient */
  postRelatedPersonRecord: RelatedPersonModel;
  /** Create a two-way association between FHIR resources */
  postResourceAssociation: ResourceAssociationUnion;
  /** Creates a new routine instance status record for a patient task */
  postRoutineInstanceStatusRecord: RoutineInstanceStatusModel;
  /** Store scan results in S3 and map them into FHIR resources */
  postScanResults: Scalars['Boolean']['output'];
  /** Creates a sleep observation record for a patient */
  postSleepObservationRecord: ObservationModel;
  /** Creates a new FHIR Task record from the provided input */
  postTaskRecord: TaskModel;
  /** Starts a bulk user import job for a group */
  postUserImportJob: UserImportJob;
  /** Grants a user's permission control settings for an accessing user */
  postUserPermissionGrants: UserModel;
  /** Add a new user with roles to an existing account */
  postUserRecord: UserModel;
  /** Creates a vital sign observation record for a patient */
  postVitalSignObservationRecord: ObservationModel;
  /** Publish a draft app version to make it live */
  publishAppVersion: AppVersionModel;
  /** QIE only. Records the match result for a Pending patient link. */
  recordEhrPatientMatch: EhrPatientMatchRecord;
  /** QIE only. Records a sync run; the same qie_message_id updates the existing run. */
  recordEhrSyncRun: EhrSyncRunRecord;
  /** Exchange a refresh token cookie for new access and id tokens */
  refreshToken: RefreshModel;
  /** Register a new root or child account with an owner and optional members */
  registerAccount: RegisterSingleModel;
  registerEhrConnection: EhrConnection;
  /** Detach a policy from a role after verifying it exists */
  removePolicyFromRole: RoleModel;
  /** Remove a two-way association between FHIR resources */
  removeResourceAssociation: ResourceAssociationUnion;
  /** Remove a role from a user after verifying the role exists */
  removeRoleFromUser: UserModel;
  /** Revoke a recipient's access to a shared resource */
  removeSharedResourceAccess: RevokeShareAuthResponse;
  /** Resend the account verification code to the user's email */
  resendCode: MfaResponseModel;
  /** Resends the account setup invitation to a user's email */
  resendSetupInvitation: Scalars['Boolean']['output'];
  /** Admin or curator resets a user's password by email */
  resetUserPassword: Scalars['Boolean']['output'];
  /** Respond to an MFA or auth challenge to complete sign-in */
  respondToAuthChallenge: AuthModel;
  /** VITALL only. Approves (Linked) or rejects (Rejected) a NeedsReview link. */
  reviewEhrPatientLink: EhrPatientLink;
  saveCustomPlans: Array<CustomPlanModel>;
  /** Send a verification code to an alert recipient setting */
  sendAlertCode: AlertRecipientSettingModel;
  /** Sends an account-disabled notification email to the user */
  sendDisableUserEmail: Scalars['Boolean']['output'];
  /** Sends a verification code to the user's email */
  sendEmailVerificationCode: MfaResponseModel;
  /** Sends an account-enabled notification email to the user */
  sendEnableUserEmail: Scalars['Boolean']['output'];
  /** Sends a feedback, EMR connection, or information request email from the logged-in user */
  sendFeedbackEmail: Scalars['Boolean']['output'];
  /** Sends email invites to all members of a group */
  sendGroupEmailInvite: Scalars['Boolean']['output'];
  /** Sends an SMS MFA code to the user's phone number */
  sendSmsMfaCode: MfaResponseModel;
  /** Generates a TOTP secret for setting up authenticator MFA */
  sendTotpMfaCode: EnableMfaResponseModel;
  /** Bulk marks matching patient resource models as viewed and returns the updated count */
  setBulkResourceViewedStatus: Scalars['Int']['output'];
  /** Upserts a patient's custom reference range parameter for a metric */
  setCustomParameter: ReferenceRangeModel;
  /** Creates custom reference range parameters for a patient */
  setCustomParameters: Array<ReferenceRangeModel>;
  /** Marks uploaded patient documents as completed after upload */
  setDocumentsUploaded: Array<DocumentModel>;
  setEhrPatientLinkPaused: EhrPatientLink;
  /** Sets the user's preferred MFA method */
  setPreferredMfaMethod: MfaResponseModel;
  /** Marks a FHIR resource as viewed and returns the updated resource */
  setResourceViewedStatus: ViewedStatusResourcesUnion;
  /** Start or retry auto curation for a patient document */
  startAutoCuration: DiscernDocumentModel;
  unenrollEhrSyncPatient: Scalars['Boolean']['output'];
  /** Updates an account's billing address and syncs it to Stripe */
  updateAccountBillingAddress: UpdateAccountResponse;
  /** Upsert the license plan for an account */
  updateAccountLicense: AccountSettingModel;
  /** Updates an organization account profile record */
  updateAccountRecord: UpdateAccountResponse;
  /** Update branding, MFA, and feature settings for an account */
  updateAccountSetting: AccountSettingModel;
  /** Toggle the user-added email notification setting for an account */
  updateAccountUserAddedEmailNotificationSetting: AccountSettingModel;
  /** Update or create alert recipient settings for a recipient */
  updateAlertRecipientSetting: AlertRecipientSettingModel;
  /** Creates or updates the current user's alert setting */
  updateAlertSetting: AlertSettingModel;
  /** Updates the status of patient health alerts */
  updateAlerts: Array<UpdatedAlertModel>;
  /** Updates an existing patient allergy intolerance record */
  updateAllergyRecord: AllergyModel;
  /** Update an existing draft app version */
  updateAppVersionDraft: AppVersionModel;
  /** Updates an existing FHIR Appointment record and its location */
  updateAppointmentRecord: AppointmentModel;
  /** Updates an existing body-measurement Observation record */
  updateBodyObservationRecord: ObservationModel;
  /** Update a patient's care team participants and organizations */
  updateCareTeam: PatientCareTeamModel;
  /** Updates an existing patient condition FHIR record */
  updateConditionRecord: ConditionModel;
  /** Updates a patient's consent FHIR record */
  updateConsentRecord: ConsentModel;
  /** Updates an existing insurance Coverage record by id */
  updateCoverageRecord: CoverageModel;
  /** Update the curation status of a FHIR resource */
  updateCurationStatus?: Maybe<CurationMetaUnion>;
  /** Updates an existing curator task record */
  updateCuratorTaskRecord: UpdateCuratorTaskResponse;
  /** Update a Discern document's status or page grouping state */
  updateDiscernDocument: DiscernDocumentModel;
  /** Update the status of a Discern result, marking it complete */
  updateDiscernResultStatus: DiscernResultModel;
  /** Update a document record's name, description, and status */
  updateDocumentRecord: UpdateDocumentResponse;
  /** Toggles emergency access for a Vitall patient */
  updateEmergencyAccess: UpdateVitallPatientResponse;
  /** Updates an emergency visit Encounter and its locations */
  updateEmergencyVisitsEncounterRecord: EncounterModel;
  /** Updates an existing FHIR FamilyMemberHistory record */
  updateFamilyMemberHistoryRecord: FamilyMemberHistoryModel;
  /** Updates an existing fitness activity Observation record */
  updateFitnessObservationRecord: ObservationModel;
  /** Updates an existing genetic information Observation record */
  updateGeneticObservationRecord: ObservationModel;
  /** Updates an existing user group's name by group id */
  updateGroup: GroupModel;
  /** Update a hospitalization Encounter record and its locations */
  updateHospitalizationsEncounterRecord: EncounterModel;
  /** Updates an imaging test diagnostic report and its related records */
  updateImagingTest: DiagnosticReportModel;
  /** Updates an existing immunization record and its location */
  updateImmunizationRecord: ImmunizationModel;
  /** Updates a lab report diagnostic report and its related records */
  updateLabReport: DiagnosticReportModel;
  /** Updates an existing laboratory-result Observation record */
  updateLaboratoryObservationRecord: ObservationModel;
  /** Updates a patient's legal directive consent record */
  updateLegalDirectiveRecord: ConsentModel;
  /** Update an existing FHIR MedicationRequest record */
  updateMedicationRequestRecord: MedicationRequestModel;
  /** Updates an existing FHIR MedicationStatement record for a patient */
  updateMedicationStatementRecord: MedicationStatementModel;
  /** Update an existing operation's name */
  updateOperation: OperationModel;
  updateOrgFeatures: Array<OrgFeatureModel>;
  /** Updates an existing FHIR Patient record */
  updatePatientRecord: PatientModel;
  updatePatientSeats: PatientSeatSummaryModel;
  /** Update an existing permission's name or scope */
  updatePermission: PermissionModel;
  /** Updates an existing policy's name and description */
  updatePolicy: PolicyModel;
  /** Replaces the set of permissions assigned to a policy */
  updatePolicyPermissions: PolicyModel;
  /** Updates an existing FHIR Procedure record and its location */
  updateProcedureRecord: ProcedureModel;
  /** Updates a Vitall patient's profile status */
  updateProfileStatus: UpdateVitallPatientResponse;
  /** Upsert an account's purchased contract plan limits */
  updatePurchasedPlan: ContractPlanModel;
  /** Updates the source type of a resource's curation metadata */
  updateRecordSource?: Maybe<CurationMeta>;
  /** Updates an existing RelatedPerson FHIR record */
  updateRelatedPersonRecord: RelatedPersonModel;
  /** Update an existing role's description, rank, or scope */
  updateRole: RoleModel;
  /** Updates an existing sleep Observation record */
  updateSleepObservationRecord: ObservationModel;
  /** Update a Stripe customer's name and payment source */
  updateStripeCustomer: UpdateStripeCustomerResponse;
  /** Update an existing FHIR Task record for a patient */
  updateTaskRecord: TaskModel;
  /** Update a user's notification connection email preference */
  updateUserNotificationConnection: UserNotificationConnection;
  /** Update a user's email notification preference by identifier */
  updateUserNotificationPreference: UserNotificationPreference;
  /** Updates an existing vital-sign Observation record */
  updateVitalSignObservationRecord: ObservationModel;
  updateVitallConsent: UpdateUserResponse;
  /** Upload record documents for a patient, tagging curator uploads as originals */
  uploadClientRecords: Array<DocumentModel>;
  /** Upload a CSV document for a group's user import job */
  uploadImportJobCsv: DocumentModel;
  upsertEhrSyncResource: EhrSyncResourceConfig;
  /** Create or update a patient's scan profile demographics */
  upsertScanProfile: ScanProfile;
  /** Verifies the confirmation code for an alert recipient setting */
  verifyAlertCode: AlertRecipientSettingModel;
  /** Confirms an email change with a verification code */
  verifyUserEmail: Scalars['String']['output'];
  /** Confirms a phone number change with a verification code */
  verifyUserPhone: Scalars['String']['output'];
};


export type MutationAddPolicyToOperationArgs = {
  input: OperationPolicyInput;
};


export type MutationAddPolicyToRoleArgs = {
  input: RolePolicyInput;
};


export type MutationAddRoleToUserArgs = {
  input: UserRoleInput;
};


export type MutationAdminChangeEmailArgs = {
  input: AdminChangeEmailInput;
};


export type MutationAdminChangeNameArgs = {
  input: ChangeUserNameInput;
};


export type MutationAdminChangePhoneArgs = {
  input: AdminChangePhoneInput;
};


export type MutationAdminUpdateUserNotificationPreferenceArgs = {
  input: UpdateNotificationPreferenceInput;
};


export type MutationAssignPatientPlansArgs = {
  input: AssignPatientPlansInput;
};


export type MutationAssignUserToPatientArgs = {
  input: UpdatePatientAssignedUserInput;
};


export type MutationAuthenticateConnectionArgs = {
  input: PostTerraConnectionInput;
};


export type MutationBeginShareAuthArgs = {
  input: BeginShareAuthInput;
};


export type MutationBroadcastChatAnnouncementArgs = {
  input: BroadcastChatAnnouncementInput;
};


export type MutationChangeNameArgs = {
  input: ChangeUserNameInput;
};


export type MutationChangePasswordArgs = {
  input: ChangePasswordInput;
};


export type MutationChangeUserEmailArgs = {
  input: ChangeEmailInput;
};


export type MutationChangeUserPhoneArgs = {
  input: ChangePhoneInput;
};


export type MutationCompleteAccountAvatarUploadArgs = {
  input: MultipartFileUploadSessionInput;
};


export type MutationCompleteAvatarUploadArgs = {
  input: MultipartFileUploadSessionInput;
};


export type MutationCompleteDiscernFileUploadArgs = {
  input: MultipartFileUploadSessionInput;
};


export type MutationCompleteFhirFileUploadArgs = {
  input: MultipartFileUploadSessionInput;
};


export type MutationCompletePacsFileUploadArgs = {
  input: MultipartFileUploadSessionInput;
};


export type MutationCompleteShareAuthArgs = {
  input: CompleteShareAuthInput;
};


export type MutationConfirmPasswordArgs = {
  input: ConfirmPasswordInput;
};


export type MutationCreateAppVersionDraftArgs = {
  input: CreateAppVersionDraftInput;
};


export type MutationCreateDhaShareLinkArgs = {
  input: CreateShareLinkInput;
};


export type MutationCreateDiscernDocumentFromUploadArgs = {
  input: CreateDiscernDocumentFromUploadInput;
};


export type MutationCreatePermissionArgs = {
  input: CreatePermissionInput;
};


export type MutationCreatePolicyArgs = {
  input: CreatePolicyInput;
};


export type MutationCreateRoleArgs = {
  input: CreateRoleInput;
};


export type MutationCreateShareLinkArgs = {
  input: CreateShareLinkInput;
};


export type MutationCreateTitrationCarePlanArgs = {
  input: CreateTitrationCarePlanInput;
};


export type MutationDeauthenticateConnectionArgs = {
  input: DeleteTerraConnectionInput;
};


export type MutationDeleteAccountArgs = {
  input: DeleteAccountInput;
};


export type MutationDeleteAccountAvatarArgs = {
  input: DeleteAccountAvatarInput;
};


export type MutationDeleteAlertSettingArgs = {
  input: DeleteAlertSettingInput;
};


export type MutationDeleteAllergyRecordArgs = {
  input: DeleteAllergyInput;
};


export type MutationDeleteAppointmentRecordArgs = {
  input: DeleteAppointmentInput;
};


export type MutationDeleteAttachmentArgs = {
  input: DeleteAttachmentInput;
};


export type MutationDeleteAvatarArgs = {
  input: DeleteAvatarInput;
};


export type MutationDeleteBodyObservationRecordArgs = {
  input: DeleteObservationInput;
};


export type MutationDeleteCareTeamMemberArgs = {
  input: DeleteCareTeamMemberInput;
};


export type MutationDeleteConditionRecordArgs = {
  input: DeleteConditionInput;
};


export type MutationDeleteConsentRecordArgs = {
  input: DeleteConsentInput;
};


export type MutationDeleteCoverageRecordArgs = {
  input: DeleteCoveragesInput;
};


export type MutationDeleteCuratorTaskRecordArgs = {
  input: GetCuratorTaskInput;
};


export type MutationDeleteCustomParametersArgs = {
  input: DeleteCustomParametersInput;
};


export type MutationDeleteDirectEmrApiConnectionArgs = {
  input: EmrConnectionInput;
};


export type MutationDeleteDiscernDocumentArgs = {
  input: DeleteDiscernDocumentInput;
};


export type MutationDeleteEmergencyVisitRecordArgs = {
  input: DeleteEncounterInput;
};


export type MutationDeleteFamilyMemberHistoryRecordArgs = {
  input: DeleteFamilyHistoryInput;
};


export type MutationDeleteFitnessObservationRecordArgs = {
  input: DeleteObservationInput;
};


export type MutationDeleteGeneticObservationRecordArgs = {
  input: DeleteObservationInput;
};


export type MutationDeleteHospitalizationRecordArgs = {
  input: DeleteEncounterInput;
};


export type MutationDeleteImagingTestArgs = {
  input: DeleteDiagnosticReportInput;
};


export type MutationDeleteImmunizationRecordArgs = {
  input: DeleteImmunizationInput;
};


export type MutationDeleteLabReportArgs = {
  input: DeleteDiagnosticReportInput;
};


export type MutationDeleteLegalDirectiveRecordArgs = {
  input: DeleteConsentInput;
};


export type MutationDeleteMedicationRequestRecordArgs = {
  input: DeleteMedicationRequestInput;
};


export type MutationDeleteMedicationStatementRecordArgs = {
  input: DeleteMedStatementInput;
};


export type MutationDeleteNoteArgs = {
  input: DeleteNoteInput;
};


export type MutationDeletePacsStudiesArgs = {
  input: DeletePacStudiesInput;
};


export type MutationDeleteProcedureRecordArgs = {
  input: DeleteProcedureInput;
};


export type MutationDeleteRelatedPersonRecordArgs = {
  input: DeleteRelatedPersonInput;
};


export type MutationDeleteRoutineInstanceStatusRecordArgs = {
  input: DeleteRoutineInstanceStatusInput;
};


export type MutationDeleteScanResultArgs = {
  input: DeleteScanResultInput;
};


export type MutationDeleteSleepObservationRecordArgs = {
  input: DeleteObservationInput;
};


export type MutationDeleteTaskRecordArgs = {
  input: DeleteTaskInput;
};


export type MutationDeleteUserArgs = {
  input: GetUserInput;
};


export type MutationDeleteUserPermissionGrantsArgs = {
  input: DeleteUserPermissionGrantsInput;
};


export type MutationDeleteVitalSignObservationRecordArgs = {
  input: DeleteObservationInput;
};


export type MutationDisableMfaArgs = {
  input: DisableMfaInput;
};


export type MutationDisableUserArgs = {
  input: EmailInput;
};


export type MutationEnableMfaArgs = {
  input: EnableMfaInput;
};


export type MutationEnableUserArgs = {
  input: EmailInput;
};


export type MutationEndTitrationCarePlanArgs = {
  input: EndTitrationCarePlanInput;
};


export type MutationEnrollEhrSyncPatientArgs = {
  input: EnrollEhrSyncPatientInput;
};


export type MutationExchangeHandoffTokenArgs = {
  input: ExchangeHandoffTokenInput;
};


export type MutationForgotPasswordArgs = {
  input: EmailInput;
};


export type MutationInitiateAccountAvatarUploadArgs = {
  input: AccountAvatarUploadInput;
};


export type MutationInitiateAssessmentArgs = {
  input: InitiateAssessmentInput;
};


export type MutationInitiateAvatarUploadArgs = {
  input: AvatarUploadInput;
};


export type MutationInitiateDiscernFileUploadArgs = {
  input: DiscernUploadInput;
};


export type MutationInitiateFhirFileUploadArgs = {
  input: FileInput;
};


export type MutationInitiatePacsFileUploadArgs = {
  input: PacsFileInput;
};


export type MutationLoginArgs = {
  input: LoginInput;
};


export type MutationPostAllergyRecordArgs = {
  input: AllergyModelInput;
};


export type MutationPostAppointmentRecordArgs = {
  input: PostAppointmentInput;
};


export type MutationPostAttachmentArgs = {
  input: PostAttachmentInput;
};


export type MutationPostBodyObservationRecordArgs = {
  input: ObservationModelInput;
  triggerAlert?: Scalars['Boolean']['input'];
};


export type MutationPostConditionRecordArgs = {
  input: ConditionModelInput;
};


export type MutationPostConsentRecordArgs = {
  input: ConsentModelInput;
};


export type MutationPostCoverageRecordArgs = {
  input: CoverageModelInput;
};


export type MutationPostCuratorTaskRecordArgs = {
  input: CreateCuratorTaskModelInput;
};


export type MutationPostDirectEmrApiConnectionArgs = {
  input: PostEmrConnectionInput;
};


export type MutationPostEmergencyVisitsEncounterRecordArgs = {
  input: PostEmergencyVisitInput;
};


export type MutationPostFamilyMemberHistoryRecordArgs = {
  input: FamilyMemberHistoryModelInput;
};


export type MutationPostFhirResourceArgs = {
  input: PostFhirResourceInput;
};


export type MutationPostFitnessObservationRecordArgs = {
  input: ObservationModelInput;
  triggerAlert?: Scalars['Boolean']['input'];
};


export type MutationPostGeneticObservationRecordArgs = {
  input: ObservationModelInput;
};


export type MutationPostHospitalizationsEncounterRecordArgs = {
  input: PostHospitalizationInput;
};


export type MutationPostImagingTestArgs = {
  input: PostDiagnosticReportInput;
};


export type MutationPostImmunizationRecordArgs = {
  input: PostImmunizationInput;
};


export type MutationPostLabReportArgs = {
  input: PostDiagnosticReportInput;
};


export type MutationPostLaboratoryObservationRecordArgs = {
  input: ObservationModelInput;
  triggerAlert?: Scalars['Boolean']['input'];
};


export type MutationPostLegalDirectiveRecordArgs = {
  input: ConsentModelInput;
};


export type MutationPostMedicationRequestRecordArgs = {
  input: MedicationRequestModelInput;
};


export type MutationPostMedicationStatementRecordArgs = {
  input: MedicationStatementModelInput;
};


export type MutationPostNoteArgs = {
  input: PostNoteInput;
};


export type MutationPostPacsStudiesArgs = {
  input: PostPacStudiesInput;
};


export type MutationPostPermissionArgs = {
  input: PostPermissionInput;
};


export type MutationPostProcedureRecordArgs = {
  input: PostProcedureInput;
};


export type MutationPostQuestionnaireResponsesArgs = {
  input: PostQuestionnaireResponsesInput;
};


export type MutationPostRelatedPersonRecordArgs = {
  input: RelatedPersonModelInput;
};


export type MutationPostResourceAssociationArgs = {
  input: ResourceAssociationInput;
};


export type MutationPostRoutineInstanceStatusRecordArgs = {
  input: CreateRoutineInstanceStatusModelInput;
};


export type MutationPostScanResultsArgs = {
  input: PostScanResultsInput;
};


export type MutationPostSleepObservationRecordArgs = {
  input: ObservationModelInput;
  triggerAlert?: Scalars['Boolean']['input'];
};


export type MutationPostTaskRecordArgs = {
  input: TaskModelInput;
};


export type MutationPostUserImportJobArgs = {
  input: PostImportJobInput;
};


export type MutationPostUserPermissionGrantsArgs = {
  input: PostUserPermissionGrantsInput;
};


export type MutationPostUserRecordArgs = {
  account_id: Scalars['String']['input'];
  input: CreateUserModelInput;
};


export type MutationPostVitalSignObservationRecordArgs = {
  input: ObservationModelInput;
  triggerAlert?: Scalars['Boolean']['input'];
};


export type MutationPublishAppVersionArgs = {
  input: PublishAppVersionInput;
};


export type MutationRecordEhrPatientMatchArgs = {
  input: RecordEhrPatientMatchInput;
};


export type MutationRecordEhrSyncRunArgs = {
  input: RecordEhrSyncRunInput;
};


export type MutationRegisterAccountArgs = {
  input: CreateAccountModelInput;
};


export type MutationRegisterEhrConnectionArgs = {
  input: RegisterEhrConnectionInput;
};


export type MutationRemovePolicyFromRoleArgs = {
  input: RolePolicyInput;
};


export type MutationRemoveResourceAssociationArgs = {
  input: ResourceAssociationInput;
};


export type MutationRemoveRoleFromUserArgs = {
  input: UserRoleInput;
};


export type MutationRemoveSharedResourceAccessArgs = {
  input: RevokeShareAuthInput;
};


export type MutationResendCodeArgs = {
  input: EmailInput;
};


export type MutationResendSetupInvitationArgs = {
  input: EmailInput;
};


export type MutationResetUserPasswordArgs = {
  input: EmailInput;
};


export type MutationRespondToAuthChallengeArgs = {
  input: RespondToAuthChallengeInput;
};


export type MutationReviewEhrPatientLinkArgs = {
  input: ReviewEhrPatientLinkInput;
};


export type MutationSaveCustomPlansArgs = {
  input: SaveCustomPlansInput;
};


export type MutationSendAlertCodeArgs = {
  input: SendAlertSettingCodeInput;
};


export type MutationSendDisableUserEmailArgs = {
  input: SendDisableEnableUserEmailInput;
};


export type MutationSendEnableUserEmailArgs = {
  input: SendEnableUserEmailInput;
};


export type MutationSendFeedbackEmailArgs = {
  input: SendFeedbackEmailInput;
};


export type MutationSendGroupEmailInviteArgs = {
  input: SendGroupInviteInput;
};


export type MutationSendSmsMfaCodeArgs = {
  input: SendSmsMfaCodeInput;
};


export type MutationSetBulkResourceViewedStatusArgs = {
  input: SetBulkResourceViewedStatusInput;
};


export type MutationSetCustomParameterArgs = {
  input: CreateCustomParameterInput;
};


export type MutationSetCustomParametersArgs = {
  input: CreateCustomParametersInput;
};


export type MutationSetDocumentsUploadedArgs = {
  input: SetDocumentsUploadedInput;
};


export type MutationSetEhrPatientLinkPausedArgs = {
  input: SetEhrPatientLinkPausedInput;
};


export type MutationSetPreferredMfaMethodArgs = {
  input: SetPreferredMfaInput;
};


export type MutationSetResourceViewedStatusArgs = {
  input: SetResourceViewedStatusInput;
};


export type MutationStartAutoCurationArgs = {
  input: StartAutoCurationInput;
};


export type MutationUnenrollEhrSyncPatientArgs = {
  input: EhrPatientLinkRefInput;
};


export type MutationUpdateAccountBillingAddressArgs = {
  input: UpdateAccountBillingAddressModelInput;
};


export type MutationUpdateAccountLicenseArgs = {
  input: UpdateAccountLicenseInput;
};


export type MutationUpdateAccountRecordArgs = {
  input: UpdateAccountModelInput;
};


export type MutationUpdateAccountSettingArgs = {
  input: UpdateAccountSettingInput;
};


export type MutationUpdateAccountUserAddedEmailNotificationSettingArgs = {
  input: UpdateAccountUserAddedEmailNotificationSettingInput;
};


export type MutationUpdateAlertRecipientSettingArgs = {
  input: UpdateAlertRecipientSettingInput;
};


export type MutationUpdateAlertSettingArgs = {
  input: UpsertAlertSettingInput;
};


export type MutationUpdateAlertsArgs = {
  input: UpdateAlertsInput;
};


export type MutationUpdateAllergyRecordArgs = {
  input: UpdateAllergyInput;
};


export type MutationUpdateAppVersionDraftArgs = {
  input: UpdateAppVersionDraftInput;
};


export type MutationUpdateAppointmentRecordArgs = {
  input: UpdateAppointmentInput;
};


export type MutationUpdateBodyObservationRecordArgs = {
  input: UpdateObservationInput;
};


export type MutationUpdateCareTeamArgs = {
  input: UpdateCareTeamInput;
};


export type MutationUpdateConditionRecordArgs = {
  input: UpdateConditionInput;
};


export type MutationUpdateConsentRecordArgs = {
  input: UpdateConsentInput;
};


export type MutationUpdateCoverageRecordArgs = {
  input: UpdateCoveragesInput;
};


export type MutationUpdateCurationStatusArgs = {
  input: UpdateCurationStatusInput;
};


export type MutationUpdateCuratorTaskRecordArgs = {
  input: UpdateCuratorTaskInput;
};


export type MutationUpdateDiscernDocumentArgs = {
  input: UpdateDiscernDocumentInput;
};


export type MutationUpdateDiscernResultStatusArgs = {
  input: UpdateDiscernResultStatusInput;
};


export type MutationUpdateDocumentRecordArgs = {
  input: UpdateDocumentInput;
};


export type MutationUpdateEmergencyAccessArgs = {
  input: UpdatePatientEmergencyAccessInput;
};


export type MutationUpdateEmergencyVisitsEncounterRecordArgs = {
  input: UpdateEmergencyVisitInput;
};


export type MutationUpdateFamilyMemberHistoryRecordArgs = {
  input: UpdateFamilyHistoryInput;
};


export type MutationUpdateFitnessObservationRecordArgs = {
  input: UpdateObservationInput;
};


export type MutationUpdateGeneticObservationRecordArgs = {
  input: UpdateObservationInput;
};


export type MutationUpdateGroupArgs = {
  input: UpdateGroupInput;
};


export type MutationUpdateHospitalizationsEncounterRecordArgs = {
  input: UpdateHospitalizationInput;
};


export type MutationUpdateImagingTestArgs = {
  input: UpdateDiagnosticReportInput;
};


export type MutationUpdateImmunizationRecordArgs = {
  input: UpdateImmunizationInput;
};


export type MutationUpdateLabReportArgs = {
  input: UpdateDiagnosticReportInput;
};


export type MutationUpdateLaboratoryObservationRecordArgs = {
  input: UpdateObservationInput;
};


export type MutationUpdateLegalDirectiveRecordArgs = {
  input: UpdateConsentInput;
};


export type MutationUpdateMedicationRequestRecordArgs = {
  input: UpdateMedicationRequestInput;
};


export type MutationUpdateMedicationStatementRecordArgs = {
  input: UpdateMedStatementInput;
};


export type MutationUpdateOperationArgs = {
  input: UpdateOperationInput;
};


export type MutationUpdateOrgFeaturesArgs = {
  input: OrgFeatureSelectionInput;
};


export type MutationUpdatePatientRecordArgs = {
  input: UpdatePatientInput;
};


export type MutationUpdatePatientSeatsArgs = {
  input: UpdatePatientSeatsInput;
};


export type MutationUpdatePermissionArgs = {
  input: UpdatePermissionInput;
};


export type MutationUpdatePolicyArgs = {
  input: UpdatePolicyInput;
};


export type MutationUpdatePolicyPermissionsArgs = {
  input: SetPolicyPermissionsInput;
};


export type MutationUpdateProcedureRecordArgs = {
  input: UpdateProcedureInput;
};


export type MutationUpdateProfileStatusArgs = {
  input: UpdatePatientProfileStatusInput;
};


export type MutationUpdatePurchasedPlanArgs = {
  input: UpsertPurchasedPlansInput;
};


export type MutationUpdateRecordSourceArgs = {
  input: UpdateRecordSourceInput;
};


export type MutationUpdateRelatedPersonRecordArgs = {
  input: UpdateRelatedPersonInput;
};


export type MutationUpdateRoleArgs = {
  input: UpdateRoleInput;
};


export type MutationUpdateSleepObservationRecordArgs = {
  input: UpdateObservationInput;
};


export type MutationUpdateStripeCustomerArgs = {
  input: UpdateStripeCustomerModelInput;
};


export type MutationUpdateTaskRecordArgs = {
  input: UpdateTaskInput;
};


export type MutationUpdateUserNotificationConnectionArgs = {
  input: UpdateNotificationConnectionInput;
};


export type MutationUpdateUserNotificationPreferenceArgs = {
  input: UpdateNotificationPreferenceInput;
};


export type MutationUpdateVitalSignObservationRecordArgs = {
  input: UpdateObservationInput;
};


export type MutationUpdateVitallConsentArgs = {
  input: ChangeUserConsentInput;
};


export type MutationUploadClientRecordsArgs = {
  input: PostDocumentsInput;
};


export type MutationUploadImportJobCsvArgs = {
  input: UploadImportJobCsvInput;
};


export type MutationUpsertEhrSyncResourceArgs = {
  input: UpsertEhrSyncResourceInput;
};


export type MutationUpsertScanProfileArgs = {
  input: UpsertScanProfileInput;
};


export type MutationVerifyAlertCodeArgs = {
  input: VerifyAlertSettingCodeInput;
};


export type MutationVerifyUserEmailArgs = {
  input: VerifyEmailInput;
};


export type MutationVerifyUserPhoneArgs = {
  input: VerifyPhoneInput;
};

export type Narrative = {
  __typename?: 'Narrative';
  /** Div */
  div: Scalars['String']['output'];
  /** Status */
  status: Scalars['String']['output'];
};

export type NarrativeInput = {
  /** Div */
  div: Scalars['String']['input'];
  /** Status */
  status: Scalars['String']['input'];
};

export type Network = {
  __typename?: 'Network';
  /** Identifier for the network access point of the user device */
  address?: Maybe<Scalars['String']['output']>;
  /** The type of network access point */
  type?: Maybe<Scalars['String']['output']>;
};

/** NextPayment */
export type NextPayment = {
  __typename?: 'NextPayment';
  /** Next payment amount */
  amount?: Maybe<Scalars['Float']['output']>;
  /** Next payment currency */
  currency?: Maybe<Scalars['String']['output']>;
  /** Next payment date timestamp */
  date?: Maybe<Scalars['Float']['output']>;
};

export type NotesResourcesUnion = AllergyModel | AppointmentModel | ConditionModel | DiagnosticReportModel | EncounterModel | FamilyMemberHistoryModel | ImmunizationModel | MedicationStatementModel | ObservationModel | ProcedureModel;

/** NotificationSetting */
export type NotificationSetting = {
  __typename?: 'NotificationSetting';
  /** Category grouping for the notification setting */
  category: Scalars['String']['output'];
  /** Human-readable description of the notification setting */
  description: Scalars['String']['output'];
  /** Unique identifier of the notification setting */
  identifier: Scalars['String']['output'];
  /** Display name of the notification setting */
  name: Scalars['String']['output'];
  /** User's preference for this notification setting */
  preference: UserNotificationPreference;
};

/** ObservationAlertModel */
export type ObservationAlertModel = {
  __typename?: 'ObservationAlertModel';
  /** Account ID the alert is associated with */
  account_id?: Maybe<Scalars['String']['output']>;
  /** Unique identifier of the alert */
  alert_id: Scalars['String']['output'];
  /** Observation codes associated with the alert */
  codes?: Maybe<Array<Scalars['String']['output']>>;
  /** Timestamp when the alert was created */
  created_at: Scalars['DateTime']['output'];
  /** ID of the FHIR Observation that raised the alert */
  observation_id?: Maybe<Scalars['String']['output']>;
  /** Current status of the alert */
  status: AlertStatus;
  /** Timestamp when the alert was last updated */
  updated_at: Scalars['DateTime']['output'];
  /** Vitall patient ID the alert belongs to */
  vitall_patient_id?: Maybe<Scalars['String']['output']>;
};

export type ObservationComponent = {
  __typename?: 'ObservationComponent';
  /** Type of this component observation (code / type) */
  code: CodeableConcept;
  /** Why the component result is missing */
  dataAbsentReason?: Maybe<CodeableConcept>;
  /** Interpretation flags for the component (high, low, normal) */
  interpretation?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Reference ranges guiding interpretation of the component result */
  referenceRange?: Maybe<Array<Maybe<ReferenceRange>>>;
  /** Component result as an attachment */
  valueAttachment?: Maybe<Attachment>;
  /** Component result as a boolean */
  valueBoolean?: Maybe<Scalars['Boolean']['output']>;
  /** Component result as a coded concept */
  valueCodeableConcept?: Maybe<CodeableConcept>;
  /** Component result as a date-time */
  valueDateTime?: Maybe<Scalars['String']['output']>;
  /** Component result as an integer */
  valueInteger?: Maybe<Scalars['Float']['output']>;
  /** Component result as a time period */
  valuePeriod?: Maybe<Period>;
  /** Component result as a measured quantity */
  valueQuantity?: Maybe<Quantity>;
  /** Component result as a numeric range */
  valueRange?: Maybe<Range>;
  /** Component result as a ratio */
  valueRatio?: Maybe<Ratio>;
  /** Component result as sampled waveform data */
  valueSampledData?: Maybe<SampledData>;
  /** Component result as free text */
  valueString?: Maybe<Scalars['String']['output']>;
  /** Component result as a time of day */
  valueTime?: Maybe<Scalars['String']['output']>;
};

export type ObservationComponentInput = {
  /** Type of this component observation (code / type) */
  code: CodeableConceptInput;
  /** Why the component result is missing */
  dataAbsentReason?: InputMaybe<CodeableConceptInput>;
  /** Interpretation flags for the component (high, low, normal) */
  interpretation?: InputMaybe<Array<InputMaybe<CodeableConceptInput>>>;
  /** Reference ranges guiding interpretation of the component result */
  referenceRange?: InputMaybe<Array<InputMaybe<ReferenceRangeInput>>>;
  /** Component result as an attachment */
  valueAttachment?: InputMaybe<AttachmentInput>;
  /** Component result as a boolean */
  valueBoolean?: InputMaybe<Scalars['Boolean']['input']>;
  /** Component result as a coded concept */
  valueCodeableConcept?: InputMaybe<CodeableConceptInput>;
  /** Component result as a date-time */
  valueDateTime?: InputMaybe<Scalars['String']['input']>;
  /** Component result as an integer */
  valueInteger?: InputMaybe<Scalars['Float']['input']>;
  /** Component result as a time period */
  valuePeriod?: InputMaybe<PeriodInput>;
  /** Component result as a measured quantity */
  valueQuantity?: InputMaybe<QuantityInput>;
  /** Component result as a numeric range */
  valueRange?: InputMaybe<RangeInput>;
  /** Component result as a ratio */
  valueRatio?: InputMaybe<RatioInput>;
  /** Component result as sampled waveform data */
  valueSampledData?: InputMaybe<SampledDataInput>;
  /** Component result as free text */
  valueString?: InputMaybe<Scalars['String']['input']>;
  /** Component result as a time of day */
  valueTime?: InputMaybe<Scalars['String']['input']>;
};

/** ObservationModel */
export type ObservationModel = {
  __typename?: 'ObservationModel';
  /** Health alert raised for this Observation */
  alert?: Maybe<ObservationAlertModel>;
  associatedResources?: Maybe<Array<ResourceAssociationUnion>>;
  attachments?: Maybe<Array<Attachment>>;
  /** Plans, proposals or orders this observation fulfills */
  basedOn?: Maybe<Array<Maybe<Reference>>>;
  /** Body part where the observation was made */
  bodySite?: Maybe<CodeableConcept>;
  /** Observed body structure reference */
  bodyStructure?: Maybe<Reference>;
  /** Classification of the type of observation */
  category?: Maybe<Array<CodeableConcept>>;
  /** Type of observation (code / type) */
  code: CodeableConcept;
  /** Component sub-observation results */
  component?: Maybe<Array<Maybe<ObservationComponent>>>;
  /** Contained */
  contained?: Maybe<Array<Resource>>;
  /** Curation metadata for this observation resource */
  curationMeta?: Maybe<CurationMeta>;
  /** Why the observation result is missing */
  dataAbsentReason?: Maybe<CodeableConcept>;
  /** Related resources this observation was derived from */
  derivedFrom?: Maybe<Array<Maybe<Reference>>>;
  /** Device used to make the measurement */
  device?: Maybe<Reference>;
  displayName?: Maybe<Scalars['String']['output']>;
  /** Clinically relevant date-time of the observation */
  effectiveDateTime?: Maybe<Scalars['String']['output']>;
  /** Clinically relevant instant of the observation */
  effectiveInstant?: Maybe<Scalars['String']['output']>;
  /** Clinically relevant time period of the observation */
  effectivePeriod?: Maybe<Period>;
  /** Clinically relevant timing schedule of the observation */
  effectiveTiming?: Maybe<Timing>;
  /** Encounter during which the observation was made */
  encounter?: Maybe<Reference>;
  /** Encounter resource referenced by this Observation */
  encounterResource?: Maybe<EncounterModel>;
  /** Extension */
  extension?: Maybe<Array<Extension>>;
  /** What the observation is about when not the subject of record */
  focus?: Maybe<Array<Maybe<Reference>>>;
  /** Related resources belonging to this observation group */
  hasMember?: Maybe<Array<Maybe<Reference>>>;
  /** FHIR resource id of the observation */
  id?: Maybe<Scalars['String']['output']>;
  /** Business identifiers for the observation */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /** A set of rules under which this content was created */
  implicitRules?: Maybe<Scalars['String']['output']>;
  /** Reference to the ObservationDefinition this instantiates */
  instantiatesReference?: Maybe<Reference>;
  /** Interpretation flags for the result (high, low, normal) */
  interpretation?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Instant this version was made available */
  issued?: Maybe<Scalars['String']['output']>;
  /** Language of the resource content */
  language?: Maybe<Scalars['String']['output']>;
  /** Metadata about the resource */
  meta?: Maybe<Meta>;
  /** How the observation was performed */
  method?: Maybe<CodeableConcept>;
  /** Comments about the observation */
  note?: Maybe<Array<Maybe<Annotation>>>;
  /** Larger events this observation is part of */
  partOf?: Maybe<Array<Maybe<Reference>>>;
  /** Who is responsible for the observation */
  performer?: Maybe<Array<Maybe<Reference>>>;
  /** Reference ranges guiding interpretation of the result */
  referenceRange?: Maybe<Array<Maybe<ReferenceRange>>>;
  /** FHIR resource type, always "Observation" */
  resourceType?: Maybe<Scalars['String']['output']>;
  /** Specimen the observation was made on */
  specimen?: Maybe<Reference>;
  /** Status of the observation (registered, preliminary, final, amended) */
  status: Scalars['String']['output'];
  /** Who or what the observation is about */
  subject?: Maybe<Reference>;
  /** Text */
  text?: Maybe<Narrative>;
  /** Observations that triggered this observation */
  triggeredBy?: Maybe<Array<Maybe<TriggeringObservation>>>;
  /** Observation result as an attachment */
  valueAttachment?: Maybe<Attachment>;
  /** Observation result as a boolean */
  valueBoolean?: Maybe<Scalars['Boolean']['output']>;
  /** Observation result as a coded concept */
  valueCodeableConcept?: Maybe<CodeableConcept>;
  /** Observation result as a date-time */
  valueDateTime?: Maybe<Scalars['String']['output']>;
  /** Observation result as an integer */
  valueInteger?: Maybe<Scalars['Float']['output']>;
  /** Observation result as a time period */
  valuePeriod?: Maybe<Period>;
  /** Observation result as a measured quantity */
  valueQuantity?: Maybe<Quantity>;
  /** Observation result as a numeric range */
  valueRange?: Maybe<Range>;
  /** Observation result as a ratio */
  valueRatio?: Maybe<Ratio>;
  /** Observation result as sampled waveform data */
  valueSampledData?: Maybe<SampledData>;
  /** Observation result as free text */
  valueString?: Maybe<Scalars['String']['output']>;
  /** Observation result as a time of day */
  valueTime?: Maybe<Scalars['String']['output']>;
};

export type ObservationModelInput = {
  /** Plans, proposals or orders this observation fulfills */
  basedOn?: InputMaybe<Array<InputMaybe<ReferenceInput>>>;
  /** Body part where the observation was made */
  bodySite?: InputMaybe<CodeableConceptInput>;
  /** Observed body structure reference */
  bodyStructure?: InputMaybe<ReferenceInput>;
  /** Classification of the type of observation */
  category?: InputMaybe<Array<CodeableConceptInput>>;
  /** Type of observation (code / type) */
  code: CodeableConceptInput;
  /** Component sub-observation results */
  component?: InputMaybe<Array<InputMaybe<ObservationComponentInput>>>;
  /** Contained */
  contained?: InputMaybe<Array<ResourceInput>>;
  /** Why the observation result is missing */
  dataAbsentReason?: InputMaybe<CodeableConceptInput>;
  /** Related resources this observation was derived from */
  derivedFrom?: InputMaybe<Array<InputMaybe<ReferenceInput>>>;
  /** Device used to make the measurement */
  device?: InputMaybe<ReferenceInput>;
  /** Clinically relevant date-time of the observation */
  effectiveDateTime?: InputMaybe<Scalars['String']['input']>;
  /** Clinically relevant instant of the observation */
  effectiveInstant?: InputMaybe<Scalars['String']['input']>;
  /** Clinically relevant time period of the observation */
  effectivePeriod?: InputMaybe<PeriodInput>;
  /** Clinically relevant timing schedule of the observation */
  effectiveTiming?: InputMaybe<TimingInput>;
  /** Encounter during which the observation was made */
  encounter?: InputMaybe<ReferenceInput>;
  /** Extension */
  extension?: InputMaybe<Array<ExtensionInput>>;
  /** What the observation is about when not the subject of record */
  focus?: InputMaybe<Array<InputMaybe<ReferenceInput>>>;
  /** Related resources belonging to this observation group */
  hasMember?: InputMaybe<Array<InputMaybe<ReferenceInput>>>;
  /** FHIR resource id of the observation */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Business identifiers for the observation */
  identifier?: InputMaybe<Array<InputMaybe<IdentifierInput>>>;
  /** A set of rules under which this content was created */
  implicitRules?: InputMaybe<Scalars['String']['input']>;
  /** Reference to the ObservationDefinition this instantiates */
  instantiatesReference?: InputMaybe<ReferenceInput>;
  /** Interpretation flags for the result (high, low, normal) */
  interpretation?: InputMaybe<Array<InputMaybe<CodeableConceptInput>>>;
  /** Instant this version was made available */
  issued?: InputMaybe<Scalars['String']['input']>;
  /** Language of the resource content */
  language?: InputMaybe<Scalars['String']['input']>;
  /** Metadata about the resource */
  meta?: InputMaybe<MetaInput>;
  /** How the observation was performed */
  method?: InputMaybe<CodeableConceptInput>;
  /** Comments about the observation */
  note?: InputMaybe<Array<InputMaybe<AnnotationInput>>>;
  /** Larger events this observation is part of */
  partOf?: InputMaybe<Array<InputMaybe<ReferenceInput>>>;
  /** Who is responsible for the observation */
  performer?: InputMaybe<Array<InputMaybe<ReferenceInput>>>;
  /** Reference ranges guiding interpretation of the result */
  referenceRange?: InputMaybe<Array<InputMaybe<ReferenceRangeInput>>>;
  /** FHIR resource type, always Observation */
  resourceType?: InputMaybe<Scalars['String']['input']>;
  /** Specimen the observation was made on */
  specimen?: InputMaybe<ReferenceInput>;
  /** Status of the observation (registered, preliminary, final, amended) */
  status: Scalars['String']['input'];
  /** Who or what the observation is about */
  subject?: InputMaybe<ReferenceInput>;
  /** Text */
  text?: InputMaybe<NarrativeInput>;
  /** Observations that triggered this observation */
  triggeredBy?: InputMaybe<Array<InputMaybe<TriggeringObservationInput>>>;
  /** Observation result as an attachment */
  valueAttachment?: InputMaybe<AttachmentInput>;
  /** Observation result as a boolean */
  valueBoolean?: InputMaybe<Scalars['Boolean']['input']>;
  /** Observation result as a coded concept */
  valueCodeableConcept?: InputMaybe<CodeableConceptInput>;
  /** Observation result as a date-time */
  valueDateTime?: InputMaybe<Scalars['String']['input']>;
  /** Observation result as an integer */
  valueInteger?: InputMaybe<Scalars['Float']['input']>;
  /** Observation result as a time period */
  valuePeriod?: InputMaybe<PeriodInput>;
  /** Observation result as a measured quantity */
  valueQuantity?: InputMaybe<QuantityInput>;
  /** Observation result as a numeric range */
  valueRange?: InputMaybe<RangeInput>;
  /** Observation result as a ratio */
  valueRatio?: InputMaybe<RatioInput>;
  /** Observation result as sampled waveform data */
  valueSampledData?: InputMaybe<SampledDataInput>;
  /** Observation result as free text */
  valueString?: InputMaybe<Scalars['String']['input']>;
  /** Observation result as a time of day */
  valueTime?: InputMaybe<Scalars['String']['input']>;
};

export type OperationModel = {
  __typename?: 'OperationModel';
  /** Timestamp when the operation was created */
  created_at: Scalars['DateTime']['output'];
  /** Operation name */
  operation: Scalars['String']['output'];
  /** Policies attached to this operation */
  policies?: Maybe<Array<PolicyModel>>;
  /** Timestamp when the operation was last updated */
  updated_at: Scalars['DateTime']['output'];
};

/** OperationOutcomeModel */
export type OperationOutcomeModel = {
  __typename?: 'OperationOutcomeModel';
  /** Logical id of this artifact */
  id?: Maybe<Scalars['String']['output']>;
  /** A set of rules under which this content was created */
  implicitRules?: Maybe<Scalars['String']['output']>;
  /** Business identifier */
  issue: Array<Issue>;
  /** Language of the resource content */
  language?: Maybe<Scalars['String']['output']>;
  /** Metadata about the resource */
  meta?: Maybe<Meta>;
  /** FHIR resource type, always OperationOutcome */
  resourceType?: Maybe<Scalars['String']['output']>;
};

export type OperationPolicyInput = {
  /** Operation name to evaluate against the policy */
  operation: Scalars['String']['input'];
  /** Identifier of the policy to fetch */
  policy_id: Scalars['String']['input'];
};

/** OrgFeatureChangeModel */
export type OrgFeatureChangeModel = {
  __typename?: 'OrgFeatureChangeModel';
  /** Org plans using the feature; always empty on the enable side */
  affected_plans: Array<PlanReferenceModel>;
  display_name: Scalars['String']['output'];
  feature_id: Scalars['String']['output'];
};

/** OrgFeatureChangePreviewModel */
export type OrgFeatureChangePreviewModel = {
  __typename?: 'OrgFeatureChangePreviewModel';
  to_disable: Array<OrgFeatureChangeModel>;
  to_enable: Array<OrgFeatureChangeModel>;
};

/** OrgFeatureModel */
export type OrgFeatureModel = {
  __typename?: 'OrgFeatureModel';
  category: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  display_name: Scalars['String']['output'];
  display_order: Scalars['Int']['output'];
  feature_id: Scalars['String']['output'];
  is_available_for_plan: Scalars['Boolean']['output'];
  is_enabled: Scalars['Boolean']['output'];
  /** Stable catalog key, e.g. records_management */
  name: Scalars['String']['output'];
  patient_display_name?: Maybe<Scalars['String']['output']>;
};

export type OrgFeatureSelectionInput = {
  account_id: Scalars['String']['input'];
  /**
   * The full desired end state — a feature absent here is disabled. Shared by
   * preview and update so the dialog cannot describe a different change.
   *
   * Nullable because the frontend's request pipeline serialises an empty array
   * as null (stripEmptyStrings in the Apollo httpLink), so "disable every
   * feature" arrives as null. Null therefore means an empty selection, exactly
   * as CreateAccountModelInput.org_feature_ids already treats it.
   */
  feature_ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OrgScopedInput = {
  account_id: Scalars['String']['input'];
};

/** OrganizationContactModel */
export type OrganizationContactModel = {
  __typename?: 'OrganizationContactModel';
  /** Visiting or postal address for the contact */
  address?: Maybe<Address>;
  /** A name associated with the contact */
  name?: Maybe<HumanName>;
  /** Type of contact from the FHIR contactentity-type value set */
  purpose?: Maybe<CodeableConcept>;
  /** Contact details (telephone, email, etc.) for the contact */
  telecom?: Maybe<Array<ContactPoint>>;
};

export type OutputModel = {
  __typename?: 'OutputModel';
  /** Label for the input */
  type?: Maybe<CodeableConcept>;
  /** Value address */
  valueAddress?: Maybe<Address>;
  /** Value age */
  valueAge?: Maybe<Age>;
  /** Value annotation */
  valueAnnotation?: Maybe<Annotation>;
  /** Value attachment */
  valueAttachment?: Maybe<Attachment>;
  /** Value base64 binary */
  valueBase64Binary?: Maybe<Scalars['String']['output']>;
  /** Value boolean */
  valueBoolean?: Maybe<Scalars['Boolean']['output']>;
  /** Value canonical */
  valueCanonical?: Maybe<Scalars['String']['output']>;
  /** Value code */
  valueCode?: Maybe<Scalars['String']['output']>;
  /** Value codeable concept */
  valueCodeableConcept?: Maybe<CodeableConcept>;
  /** Value coding */
  valueCoding?: Maybe<Coding>;
  /** Value contact detail */
  valueContactDetail?: Maybe<ContactDetail>;
  /** Value contact point */
  valueContactPoint?: Maybe<ContactPoint>;
  /** Value contributor */
  valueContributor?: Maybe<Contributor>;
  /** Value count */
  valueCount?: Maybe<Quantity>;
  /** Value data requirement */
  valueDataRequirement?: Maybe<Contributor>;
  /** Value date */
  valueDate?: Maybe<Scalars['String']['output']>;
  /** Value date time */
  valueDateTime?: Maybe<Scalars['String']['output']>;
  /** Value decimal */
  valueDecimal?: Maybe<Scalars['Float']['output']>;
  /** Value distance */
  valueDistance?: Maybe<Quantity>;
  /** Value dosage */
  valueDosage?: Maybe<Dosage>;
  /** Value duration */
  valueDuration?: Maybe<Quantity>;
  /** Value expression */
  valueExpression?: Maybe<Expression>;
  /** Value human name */
  valueHumanName?: Maybe<HumanName>;
  /** Value id */
  valueId?: Maybe<Scalars['String']['output']>;
  /** Value identifier */
  valueIdentifier?: Maybe<Identifier>;
  /** Value instant */
  valueInstant?: Maybe<Scalars['String']['output']>;
  /** Value integer */
  valueInteger?: Maybe<Scalars['Float']['output']>;
  /** Value markdown */
  valueMarkdown?: Maybe<Scalars['String']['output']>;
  /** Value meta */
  valueMeta?: Maybe<Meta>;
  /** Value money */
  valueMoney?: Maybe<Money>;
  /** Value oid */
  valueOid?: Maybe<Scalars['String']['output']>;
  /** Value parameter definition */
  valueParameterDefinition?: Maybe<ParameterDefinition>;
  /** Value period */
  valuePeriod?: Maybe<Money>;
  /** Value positive int */
  valuePositiveInt?: Maybe<Scalars['Float']['output']>;
  /** Value quantity */
  valueQuantity?: Maybe<Quantity>;
  /** Value range */
  valueRange?: Maybe<Range>;
  /** Value ratio */
  valueRatio?: Maybe<Ratio>;
  /** Value reference */
  valueReference?: Maybe<Reference>;
  /** Value related artifact */
  valueRelatedArtifact?: Maybe<RelatedArtifact>;
  /** Value sampled data */
  valueSampledData?: Maybe<SampleData>;
  /** Value signature */
  valueSignature?: Maybe<Signature>;
  /** Value string */
  valueString?: Maybe<Scalars['String']['output']>;
  /** Value time */
  valueTime?: Maybe<Scalars['String']['output']>;
  /** Value timing */
  valueTiming?: Maybe<Timing>;
  /** Value trigger definition */
  valueTriggerDefinition?: Maybe<TriggerDefinition>;
  /** Value unsigned int */
  valueUnsignedInt?: Maybe<Scalars['Float']['output']>;
  /** Value uri */
  valueUri?: Maybe<Scalars['String']['output']>;
  /** Value url */
  valueUrl?: Maybe<Scalars['String']['output']>;
  /** Value usage context */
  valueUsageContext?: Maybe<UsageContext>;
  /** Value uuid */
  valueUuid?: Maybe<Scalars['String']['output']>;
};

export type OutputModelInput = {
  /** Label for the input */
  type?: InputMaybe<CodeableConceptInput>;
  /** Value address */
  valueAddress?: InputMaybe<AddressInput>;
  /** Value age */
  valueAge?: InputMaybe<AgeInput>;
  /** Value annotation */
  valueAnnotation?: InputMaybe<AnnotationInput>;
  /** Value attachment */
  valueAttachment?: InputMaybe<AttachmentInput>;
  /** Value base64 binary */
  valueBase64Binary?: InputMaybe<Scalars['String']['input']>;
  /** Value boolean */
  valueBoolean?: InputMaybe<Scalars['Boolean']['input']>;
  /** Value canonical */
  valueCanonical?: InputMaybe<Scalars['String']['input']>;
  /** Value code */
  valueCode?: InputMaybe<Scalars['String']['input']>;
  /** Value codeable concept */
  valueCodeableConcept?: InputMaybe<CodeableConceptInput>;
  /** Value coding */
  valueCoding?: InputMaybe<CodingInput>;
  /** Value contact detail */
  valueContactDetail?: InputMaybe<ContactDetailInput>;
  /** Value contact point */
  valueContactPoint?: InputMaybe<ContactPointInput>;
  /** Value contributor */
  valueContributor?: InputMaybe<ContributorInput>;
  /** Value count */
  valueCount?: InputMaybe<QuantityInput>;
  /** Value data requirement */
  valueDataRequirement?: InputMaybe<ContributorInput>;
  /** Value date */
  valueDate?: InputMaybe<Scalars['String']['input']>;
  /** Value date time */
  valueDateTime?: InputMaybe<Scalars['String']['input']>;
  /** Value decimal */
  valueDecimal?: InputMaybe<Scalars['Float']['input']>;
  /** Value distance */
  valueDistance?: InputMaybe<QuantityInput>;
  /** Value dosage */
  valueDosage?: InputMaybe<DosageInput>;
  /** Value duration */
  valueDuration?: InputMaybe<QuantityInput>;
  /** Value expression */
  valueExpression?: InputMaybe<ExpressionInput>;
  /** Value human name */
  valueHumanName?: InputMaybe<HumanNameInput>;
  /** Value id */
  valueId?: InputMaybe<Scalars['String']['input']>;
  /** Value identifier */
  valueIdentifier?: InputMaybe<IdentifierInput>;
  /** Value instant */
  valueInstant?: InputMaybe<Scalars['String']['input']>;
  /** Value integer */
  valueInteger?: InputMaybe<Scalars['Float']['input']>;
  /** Value markdown */
  valueMarkdown?: InputMaybe<Scalars['String']['input']>;
  /** Value meta */
  valueMeta?: InputMaybe<MetaInput>;
  /** Value money */
  valueMoney?: InputMaybe<MoneyInput>;
  /** Value oid */
  valueOid?: InputMaybe<Scalars['String']['input']>;
  /** Value parameter definition */
  valueParameterDefinition?: InputMaybe<ParameterDefinitionInput>;
  /** Value period */
  valuePeriod?: InputMaybe<MoneyInput>;
  /** Value positive int */
  valuePositiveInt?: InputMaybe<Scalars['Float']['input']>;
  /** Value quantity */
  valueQuantity?: InputMaybe<QuantityInput>;
  /** Value range */
  valueRange?: InputMaybe<RangeInput>;
  /** Value ratio */
  valueRatio?: InputMaybe<RatioInput>;
  /** Value reference */
  valueReference?: InputMaybe<ReferenceInput>;
  /** Value related artifact */
  valueRelatedArtifact?: InputMaybe<RelatedArtifactInput>;
  /** Value sampled data */
  valueSampledData?: InputMaybe<SampleDataInput>;
  /** Value signature */
  valueSignature?: InputMaybe<SignatureInput>;
  /** Value string */
  valueString?: InputMaybe<Scalars['String']['input']>;
  /** Value time */
  valueTime?: InputMaybe<Scalars['String']['input']>;
  /** Value timing */
  valueTiming?: InputMaybe<TimingInput>;
  /** Value trigger definition */
  valueTriggerDefinition?: InputMaybe<TriggerDefinitionInput>;
  /** Value unsigned int */
  valueUnsignedInt?: InputMaybe<Scalars['Float']['input']>;
  /** Value uri */
  valueUri?: InputMaybe<Scalars['String']['input']>;
  /** Value url */
  valueUrl?: InputMaybe<Scalars['String']['input']>;
  /** Value usage context */
  valueUsageContext?: InputMaybe<UsageContextInput>;
  /** Value uuid */
  valueUuid?: InputMaybe<Scalars['String']['input']>;
};

export type PacsFileInput = {
  /** MIME content type of the file */
  contentType: Scalars['String']['input'];
  /** FHIR DiagnosticReport ID the PACS file attaches to */
  diagnostic_report_id: Scalars['String']['input'];
  /** Original file name */
  name: Scalars['String']['input'];
  /** File size in bytes */
  size: Scalars['Float']['input'];
};

export type PacsStudyInput = {
  /** DICOM UID of the study */
  dicom_uid: Scalars['String']['input'];
  /** ID of the study on the PACS server */
  pacs_id: Scalars['String']['input'];
  /** Name of the study */
  study_name: Scalars['String']['input'];
};

export type PaginationInput = {
  /** Number of records to return per page */
  count?: InputMaybe<Scalars['Int']['input']>;
  /** Page number to retrieve */
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type ParameterBoundary = {
  __typename?: 'ParameterBoundary';
  /** Whether the boundary value is inclusive */
  inclusive: Scalars['Boolean']['output'];
  /** Numeric value of the boundary */
  value: Scalars['Float']['output'];
};

export type ParameterBoundaryInput = {
  /** Whether the boundary value is inclusive */
  inclusive: Scalars['Boolean']['input'];
  /** Numeric value of the boundary */
  value: Scalars['Float']['input'];
};

export type ParameterDefinition = {
  __typename?: 'ParameterDefinition';
  /** Documentation */
  documentation?: Maybe<Scalars['String']['output']>;
  /** the fhir docs say this is a string */
  max?: Maybe<Scalars['String']['output']>;
  /** Min */
  min?: Maybe<Scalars['Float']['output']>;
  /** Name */
  name?: Maybe<Scalars['String']['output']>;
  /** Profile */
  profile?: Maybe<Scalars['String']['output']>;
  /** Type */
  type?: Maybe<Scalars['String']['output']>;
  /** Use */
  use?: Maybe<Scalars['String']['output']>;
};

export type ParameterDefinitionInput = {
  /** Documentation */
  documentation?: InputMaybe<Scalars['String']['input']>;
  /** the fhir docs say this is a string */
  max?: InputMaybe<Scalars['String']['input']>;
  /** Min */
  min?: InputMaybe<Scalars['Float']['input']>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Profile */
  profile?: InputMaybe<Scalars['String']['input']>;
  /** Type */
  type?: InputMaybe<Scalars['String']['input']>;
  /** Use */
  use?: InputMaybe<Scalars['String']['input']>;
};

export type ParameterInput = {
  /** Lower boundary of the parameter range */
  lower_bound?: InputMaybe<ParameterBoundaryInput>;
  /** Custom parameter id ?? Default parameter id */
  parameter_id: Scalars['String']['input'];
  /** Upper boundary of the parameter range */
  upper_bound?: InputMaybe<ParameterBoundaryInput>;
};

export type ParameterModel = {
  __typename?: 'ParameterModel';
  /** Observation code the parameter applies to */
  code: Scalars['String']['output'];
  /** Lower boundary of the parameter range */
  lower_bound?: Maybe<ParameterBoundary>;
  /** Unique identifier of the parameter */
  parameter_id: Scalars['String']['output'];
  /** Upper boundary of the parameter range */
  upper_bound?: Maybe<ParameterBoundary>;
  /** Vitall patient this custom parameter belongs to, if any */
  vitall_patient_id?: Maybe<Scalars['String']['output']>;
};

export enum ParameterType {
  custom = 'custom',
  default = 'default'
}

/** PartModel */
export type PartModel = {
  __typename?: 'PartModel';
  /** Part number within the multipart upload */
  part: Scalars['Float']['output'];
  /** Presigned S3 URL for uploading this part */
  presigned_url: Scalars['String']['output'];
};

export type Participant = {
  __typename?: 'Participant';
  /** Actor */
  actor?: Maybe<Reference>;
  /** Period */
  period?: Maybe<Period>;
  /** Required */
  required?: Maybe<ParticipantRequiredCode>;
  /** Status */
  status: ParticipantStatusCode;
  /** Type */
  type?: Maybe<Array<CodeableConceptParticipantType>>;
};

export type ParticipantInput = {
  /** Actor */
  actor?: InputMaybe<ReferenceInput>;
  /** Period */
  period?: InputMaybe<PeriodInput>;
  /** Required */
  required?: InputMaybe<ParticipantRequiredCode>;
  /** Status */
  status: ParticipantStatusCode;
  /** Type */
  type?: InputMaybe<Array<CodeableConceptParticipantTypeInput>>;
};

export enum ParticipantRequiredCode {
  informationOnly = 'informationOnly',
  optional = 'optional',
  required = 'required'
}

export enum ParticipantStatusCode {
  accepted = 'accepted',
  declined = 'declined',
  needsAction = 'needsAction',
  tentative = 'tentative'
}

export enum ParticipantTypeCode {
  ADM = 'ADM',
  ATND = 'ATND',
  CALLBCK = 'CALLBCK',
  CON = 'CON',
  DIS = 'DIS',
  ESC = 'ESC',
  LOC = 'LOC',
  PART = 'PART',
  PAT = 'PAT',
  PPRF = 'PPRF',
  REF = 'REF',
  SPRF = 'SPRF'
}

/** PatientCareTeamModel */
export type PatientCareTeamModel = {
  __typename?: 'PatientCareTeamModel';
  /** Category of the patient's care team */
  category?: Maybe<CareTeamCategory>;
  /** Identifier of the care team */
  id: Scalars['String']['output'];
  /** Free-text note about the care team */
  note?: Maybe<Scalars['String']['output']>;
  /** FHIR Organization ids associated with the care team */
  organization_ids?: Maybe<Array<Scalars['String']['output']>>;
  /** Contacts participating in the patient's care team */
  participants?: Maybe<Array<ContactModel>>;
  /** Identifier of the patient this care team is for */
  patient_id: Scalars['String']['output'];
  /** FHIR resource type, always CareTeam */
  resourceType?: Maybe<Scalars['String']['output']>;
};

/** PatientModel */
export type PatientModel = {
  __typename?: 'PatientModel';
  /** Whether this patient's record is in active use */
  active?: Maybe<Scalars['Boolean']['output']>;
  /** Addresses for the patient */
  address?: Maybe<Array<Maybe<Address>>>;
  associatedResources?: Maybe<Array<ResourceAssociationUnion>>;
  attachments?: Maybe<Array<Attachment>>;
  /** Patient's date of birth */
  birthDate?: Maybe<Scalars['String']['output']>;
  /** Languages the patient can communicate in */
  communication?: Maybe<Array<Maybe<CommunicationType>>>;
  /** Patient's emergency and related contacts */
  contact?: Maybe<Array<Maybe<Contact>>>;
  /** Contained */
  contained?: Maybe<Array<Resource>>;
  /** Whether the patient is deceased */
  deceasedBoolean?: Maybe<Scalars['Boolean']['output']>;
  /** Date and time the patient died */
  deceasedDateTime?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  /** Extension */
  extension?: Maybe<Array<Extension>>;
  /** Patient gender: male, female, other or unknown */
  gender?: Maybe<Gender>;
  /** Patient's nominated primary care providers */
  generalPractitioner?: Maybe<Array<Maybe<Reference>>>;
  /** FHIR logical id of the patient resource */
  id?: Maybe<Scalars['String']['output']>;
  /** Business identifiers for this patient */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /** A set of rules under which this content was created */
  implicitRules?: Maybe<Scalars['String']['output']>;
  /** Language of the resource content */
  language?: Maybe<Scalars['String']['output']>;
  /** Organization that is custodian of the patient record */
  managingOrganization?: Maybe<Reference>;
  /** Marital (civil) status of the patient */
  maritalStatus?: Maybe<CodeableConcept>;
  /** Metadata about the resource */
  meta?: Maybe<Meta>;
  /** Whether the patient is part of a multiple birth */
  multipleBirthBoolean?: Maybe<Scalars['Boolean']['output']>;
  /** Birth order for a multiple birth */
  multipleBirthInteger?: Maybe<Scalars['Float']['output']>;
  /** Names associated with the patient */
  name: Array<HumanName>;
  /** Images of the patient */
  photo?: Maybe<Array<Maybe<Attachment>>>;
  /** Curation metadata for the patient record */
  recordMeta?: Maybe<RecordMeta>;
  /** FHIR resource type, always "Patient" */
  resourceType?: Maybe<Scalars['String']['output']>;
  /** Contact details for the patient */
  telecom?: Maybe<Array<Maybe<ContactPoint>>>;
  /** Text */
  text?: Maybe<Narrative>;
};

export type PatientModelInput = {
  /** Whether this patient's record is in active use */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Addresses for the patient */
  address?: InputMaybe<Array<InputMaybe<AddressInput>>>;
  /** Patient's date of birth */
  birthDate?: InputMaybe<Scalars['String']['input']>;
  /** Languages the patient can communicate in */
  communication?: InputMaybe<Array<InputMaybe<CommunicationTypeInput>>>;
  /** Patient's emergency and related contacts */
  contact?: InputMaybe<Array<InputMaybe<ContactInput>>>;
  /** Contained */
  contained?: InputMaybe<Array<ResourceInput>>;
  /** Whether the patient is deceased */
  deceasedBoolean?: InputMaybe<Scalars['Boolean']['input']>;
  /** Date and time the patient died */
  deceasedDateTime?: InputMaybe<Scalars['String']['input']>;
  /** Extension */
  extension?: InputMaybe<Array<ExtensionInput>>;
  /** Patient gender: male, female, other or unknown */
  gender?: InputMaybe<Gender>;
  /** Patient's nominated primary care providers */
  generalPractitioner?: InputMaybe<Array<InputMaybe<ReferenceInput>>>;
  /** Logical id of this artifact */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Business identifiers for this patient */
  identifier?: InputMaybe<Array<InputMaybe<IdentifierInput>>>;
  /** A set of rules under which this content was created */
  implicitRules?: InputMaybe<Scalars['String']['input']>;
  /** Language of the resource content */
  language?: InputMaybe<Scalars['String']['input']>;
  /** Organization that is custodian of the patient record */
  managingOrganization?: InputMaybe<ReferenceInput>;
  /** Marital (civil) status of the patient */
  maritalStatus?: InputMaybe<CodeableConceptInput>;
  /** Metadata about the resource */
  meta?: InputMaybe<MetaInput>;
  /** Whether the patient is part of a multiple birth */
  multipleBirthBoolean?: InputMaybe<Scalars['Boolean']['input']>;
  /** Birth order for a multiple birth */
  multipleBirthInteger?: InputMaybe<Scalars['Float']['input']>;
  /** Names associated with the patient */
  name: Array<HumanNameInput>;
  /** Images of the patient */
  photo?: InputMaybe<Array<InputMaybe<AttachmentInput>>>;
  /** FHIR resource type, always Patient */
  resourceType?: InputMaybe<Scalars['String']['input']>;
  /** Contact details for the patient */
  telecom?: InputMaybe<Array<InputMaybe<ContactPointInput>>>;
  /** Text */
  text?: InputMaybe<NarrativeInput>;
};

/** PatientPlanAssignmentModel */
export type PatientPlanAssignmentModel = {
  __typename?: 'PatientPlanAssignmentModel';
  /** Null once the user has been unassigned */
  plan_id?: Maybe<Scalars['String']['output']>;
  plan_name?: Maybe<Scalars['String']['output']>;
  user_id: Scalars['String']['output'];
};

export type PatientQuestionnaireModelInput = {
  /** Questionnaire identifier */
  identifier: Scalars['String']['input'];
  /** Questionnaire answers keyed by link ID */
  input: Scalars['JSON']['input'];
};

/** PatientSeatSummaryModel */
export type PatientSeatSummaryModel = {
  __typename?: 'PatientSeatSummaryModel';
  account_id: Scalars['String']['output'];
  /** Seats reserved across the org's custom plans */
  allocated: Scalars['Int']['output'];
  /** total - allocated, floored at 0; null while total is unset */
  remaining?: Maybe<Scalars['Int']['output']>;
  /** Purchased pool (Account_Setting.limit_patients); null = not configured */
  total?: Maybe<Scalars['Int']['output']>;
};

/** PaymentMethod */
export type PaymentMethod = {
  __typename?: 'PaymentMethod';
  /** Card brand */
  brand: Scalars['String']['output'];
  /** Card expiration month */
  exp_month: Scalars['Float']['output'];
  /** Card expiration year */
  exp_year: Scalars['Float']['output'];
  /** Last four digits of the card */
  last4: Scalars['String']['output'];
};

export type Performer = {
  __typename?: 'Performer';
  /** Individual or organization who was performing */
  actor: Reference;
  /** What type of performance was done */
  function?: Maybe<CodeableConcept>;
  /** Organization the device or practitioner was acting for */
  onBehalfOf?: Maybe<Reference>;
};

export type PerformerInput = {
  /** Individual or organization who was performing */
  actor: ReferenceInput;
  /** What type of performance was done */
  function?: InputMaybe<CodeableConceptInput>;
  /** Organization the device or practitioner was acting for */
  onBehalfOf?: InputMaybe<ReferenceInput>;
};

export type Period = {
  __typename?: 'Period';
  /** End time with inclusive boundary, if not ongoing */
  end?: Maybe<Scalars['String']['output']>;
  /** Starting time with inclusive boundary */
  start?: Maybe<Scalars['String']['output']>;
};

export type PeriodInput = {
  /** End time with inclusive boundary, if not ongoing */
  end?: InputMaybe<Scalars['String']['input']>;
  /** Starting time with inclusive boundary */
  start?: InputMaybe<Scalars['String']['input']>;
};

export type PermissionControl = {
  __typename?: 'PermissionControl';
  /** Optional description of the permission control */
  description?: Maybe<Scalars['String']['output']>;
  /** Human-readable name of the permission control */
  name: Scalars['String']['output'];
  /** Control nodes defining scoped enablement */
  nodes: Array<PermissionControlNode>;
  /** Unique identifier of the permission control */
  permission_control_id: Scalars['String']['output'];
};

export type PermissionControlNode = {
  __typename?: 'PermissionControlNode';
  /** Value is dependent on user-user permission grants */
  is_enabled: Scalars['Boolean']['output'];
  /** Scope this control node applies to */
  scope: PermissionControlScope;
};

export type PermissionControlResponse = {
  /** Control nodes with their enablement settings */
  nodes: Array<PermissionControlResponseNode>;
  /** Identifier of the permission control being set */
  permission_control_id: Scalars['String']['input'];
};

export type PermissionControlResponseNode = {
  /** Whether this control node is enabled */
  is_enabled: Scalars['Boolean']['input'];
  /** Scope this control node applies to */
  scope: PermissionControlScope;
};

export enum PermissionControlScope {
  read = 'read',
  write = 'write'
}

export type PermissionControlSet = {
  __typename?: 'PermissionControlSet';
  /** Permission controls grouped in this set */
  controls: Array<PermissionControl>;
  /** Optional description of the control set */
  description?: Maybe<Scalars['String']['output']>;
  /** Human-readable name of the control set */
  name: Scalars['String']['output'];
  /** Unique identifier of the permission control set */
  permission_control_set_id: Scalars['String']['output'];
};

export type PermissionModel = {
  __typename?: 'PermissionModel';
  /** Timestamp when the permission was created */
  created_at: Scalars['DateTime']['output'];
  /** Unique identifier of the permission */
  permission_id: Scalars['String']['output'];
  /** Human-readable name of the permission */
  permission_name: Scalars['String']['output'];
  /** PermissionScope */
  permission_scope: Scalars['String']['output'];
  /** Timestamp when the permission was last updated */
  updated_at: Scalars['DateTime']['output'];
};

export enum PermissionScope {
  accessManagement = 'accessManagement',
  account = 'account',
  activity = 'activity',
  admin = 'admin',
  alert = 'alert',
  alertRecipientSetting = 'alertRecipientSetting',
  alertSetting = 'alertSetting',
  allergyIntolerance = 'allergyIntolerance',
  appVersion = 'appVersion',
  appointment = 'appointment',
  assessment = 'assessment',
  auditLogs = 'auditLogs',
  auth = 'auth',
  billing = 'billing',
  body = 'body',
  careTeam = 'careTeam',
  condition = 'condition',
  consent = 'consent',
  coverage = 'coverage',
  curatorTask = 'curatorTask',
  discern = 'discern',
  document = 'document',
  ehrSync = 'ehrSync',
  emergencyAccess = 'emergencyAccess',
  emergencyVisit = 'emergencyVisit',
  emrConnection = 'emrConnection',
  familyMemberHistory = 'familyMemberHistory',
  feedback = 'feedback',
  fitness = 'fitness',
  genetic = 'genetic',
  healthScore = 'healthScore',
  healthSummary = 'healthSummary',
  hospitalization = 'hospitalization',
  imagingTest = 'imagingTest',
  immunization = 'immunization',
  labReport = 'labReport',
  legalDirective = 'legalDirective',
  license = 'license',
  medication = 'medication',
  messenger = 'messenger',
  note = 'note',
  notification = 'notification',
  patient = 'patient',
  plan = 'plan',
  practitioner = 'practitioner',
  procedure = 'procedure',
  profileSecurity = 'profileSecurity',
  questionnaire = 'questionnaire',
  record = 'record',
  referenceRange = 'referenceRange',
  relatedPerson = 'relatedPerson',
  resourceModel = 'resourceModel',
  routine = 'routine',
  scanApp = 'scanApp',
  settings = 'settings',
  sharing = 'sharing',
  sleep = 'sleep',
  smartDevice = 'smartDevice',
  status = 'status',
  system = 'system',
  timeline = 'timeline',
  titrationCarePlan = 'titrationCarePlan',
  user = 'user',
  vitalSign = 'vitalSign',
  vitallPatient = 'vitallPatient'
}

export type PermissionSetting = {
  /** Whether the permission is enabled */
  is_enabled: Scalars['Boolean']['input'];
  /** Identifier of the permission being configured */
  permission_id: Scalars['String']['input'];
  /** Scope applied to the permission setting */
  permission_scope?: InputMaybe<Scalars['String']['input']>;
};

export type PhoneContactInput = {
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  use: PhoneContactUse;
  value: Scalars['String']['input'];
};

export enum PhoneContactUse {
  Fax = 'Fax',
  Home = 'Home',
  Mobile = 'Mobile',
  Work = 'Work'
}

export type PlanAssignmentInput = {
  /** Null unassigns the user's plan */
  plan_id?: InputMaybe<Scalars['String']['input']>;
  user_id: Scalars['String']['input'];
};

export type PlanCreditModel = {
  __typename?: 'PlanCreditModel';
  /** Unique identifier of this plan credit allocation */
  id: Scalars['String']['output'];
  /** Reset interval for the credit allowance */
  interval?: Maybe<Scalars['String']['output']>;
  /** Maximum number of credits allowed per interval */
  limit?: Maybe<Scalars['Int']['output']>;
  /** Credits still available in the current interval */
  remaining?: Maybe<Scalars['Int']['output']>;
  /** Date the remaining credits will reset */
  reset_date?: Maybe<Scalars['DateTime']['output']>;
  /** Identifier of the user this credit belongs to */
  user_id: Scalars['String']['output'];
};

/** PlanModel */
export type PlanModel = {
  __typename?: 'PlanModel';
  /** Display name of the plan */
  name: Scalars['String']['output'];
  /** Unique identifier of the plan */
  plan_id: Scalars['String']['output'];
};

/** PlanReferenceModel */
export type PlanReferenceModel = {
  __typename?: 'PlanReferenceModel';
  name: Scalars['String']['output'];
  plan_id: Scalars['String']['output'];
};

export enum PlanType {
  PATIENT = 'PATIENT'
}

export type PolicyModel = {
  __typename?: 'PolicyModel';
  /** Timestamp when the policy was created */
  created_at: Scalars['DateTime']['output'];
  /** Permissions granted by this policy */
  permissions?: Maybe<Array<PolicyPermissionModel>>;
  /** Description of what the policy grants */
  policy_description?: Maybe<Scalars['String']['output']>;
  /** Unique identifier of the policy */
  policy_id: Scalars['String']['output'];
  /** Human-readable name of the policy */
  policy_name?: Maybe<Scalars['String']['output']>;
  /** Timestamp when the policy was last updated */
  updated_at: Scalars['DateTime']['output'];
};

export type PolicyPermissionModel = {
  __typename?: 'PolicyPermissionModel';
  /** PermissionSettingScope */
  access_level?: Maybe<Scalars['String']['output']>;
  /** Timestamp when the permission was created */
  created_at: Scalars['DateTime']['output'];
  /** Whether this permission is enabled for the policy */
  is_enabled: Scalars['Boolean']['output'];
  /** Unique identifier of the permission */
  permission_id: Scalars['String']['output'];
  /** Human-readable name of the permission */
  permission_name: Scalars['String']['output'];
  /** PermissionScope */
  permission_scope: Scalars['String']['output'];
  /** Timestamp when the permission was last updated */
  updated_at: Scalars['DateTime']['output'];
};

export type Position = {
  __typename?: 'Position';
  /** Altitude */
  altitude?: Maybe<Scalars['Float']['output']>;
  /** Latitude */
  latitude: Scalars['Float']['output'];
  /** Longitude */
  longitude: Scalars['Float']['output'];
};

export type PositionInput = {
  /** Altitude */
  altitude?: InputMaybe<Scalars['Float']['input']>;
  /** Latitude */
  latitude: Scalars['Float']['input'];
  /** Longitude */
  longitude: Scalars['Float']['input'];
};

export type PostAppointmentInput = {
  /** Appointment payload to create */
  appointment: AppointmentModelInput;
  /** Location associated with the record */
  location?: InputMaybe<LocationModelInput>;
};

export type PostAttachmentInput = {
  /** Resource identifier to attach the file to, in the format <resourceType>/<resourceId> */
  resource: Scalars['String']['input'];
  /** S3 object key of the uploaded attachment file */
  s3_key: Scalars['String']['input'];
  /** Display title of the attachment */
  title: Scalars['String']['input'];
};

export type PostDiagnosticReportInput = {
  /** Diagnostic report to create */
  diagnosticReport: DiagnosticReportInput;
  /** Encounter to associate with the report */
  encounter?: InputMaybe<EncounterModelInput>;
  /** Location to associate with the report */
  location?: InputMaybe<LocationModelInput>;
};

export type PostDocumentsInput = {
  /** Documents to create for the patient */
  documents: Array<CreateDocumentModelInput>;
  /** Vitall patient identifier the documents belong to */
  vitall_patient_id: Scalars['String']['input'];
};

export type PostEmergencyVisitInput = {
  /** Encounter resource for the emergency visit to create */
  encounter: EncounterModelInput;
  /** Location associated with the record */
  location?: InputMaybe<LocationModelInput>;
};

export type PostEmrConnectionInput = {
  /** OAuth authorization code from the EMR provider */
  authorization_code: Scalars['String']['input'];
  /** Identifier of the EMR FHIR API endpoint to connect */
  fhir_api_endpoint_id: Scalars['String']['input'];
  /** Vitall patient identifier for the EMR connection */
  vitall_patient_id: Scalars['String']['input'];
};

export type PostFhirResourceInput = {
  /** Raw FHIR resource payload to create during auto-curation */
  body: Scalars['JSON']['input'];
  /** FHIR Patient resource id */
  patient_id: Scalars['String']['input'];
};

export type PostHospitalizationInput = {
  /** Encounter resource for the hospitalization to create */
  encounter: EncounterModelInput;
  /** Location associated with the record */
  location?: InputMaybe<LocationModelInput>;
};

export type PostImmunizationInput = {
  /** Immunization resource to create */
  immunization: ImmunizationModelInput;
  /** Location associated with the record */
  location?: InputMaybe<LocationModelInput>;
};

export type PostImportJobInput = {
  /** Base64-encoded file of users to import */
  base64File: Scalars['String']['input'];
  /** Group to import users into */
  groupName: Scalars['String']['input'];
  /** Name for the import job */
  jobName: Scalars['String']['input'];
  /** Parent account identifier for the imported users */
  parentAccountId?: InputMaybe<Scalars['String']['input']>;
};

export type PostNoteInput = {
  /** Resource identifier to attach the note to, in the format <resourceType>/<resourceId> */
  resource: Scalars['String']['input'];
  /** Text content of the note */
  text: Scalars['String']['input'];
};

export type PostPacStudiesInput = {
  /** ID of the diagnostic report to attach studies to */
  diagnostic_report_id: Scalars['String']['input'];
  /** PACS studies to attach to the report */
  pacs_studies: Array<PacsStudyInput>;
};

export type PostPermissionInput = {
  /** Access level granted by this permission */
  accessLevel: PermissionControlScope;
  /** Whether account admins are allowed the permission */
  accountAdminAllowed: Scalars['Boolean']['input'];
  /** Whether clients are allowed the permission */
  clientAllowed: Scalars['Boolean']['input'];
  /** Control set name this permission belongs to */
  controlSetName?: InputMaybe<Scalars['String']['input']>;
  /** Whether curator admins are allowed the permission */
  curatorAdminAllowed: Scalars['Boolean']['input'];
  /** Whether curators are allowed the permission */
  curatorAllowed: Scalars['Boolean']['input'];
  /** Whether the permission can be granted to others */
  isGrantable: Scalars['Boolean']['input'];
  /** Whether the operation is publicly accessible */
  isPublic: Scalars['Boolean']['input'];
  /** Name of the GraphQL operation guarded */
  operation: Scalars['String']['input'];
  /** Whether org admins are allowed the permission */
  orgAdminAllowed: Scalars['Boolean']['input'];
  /** Whether patients are allowed the permission */
  patientAllowed: Scalars['Boolean']['input'];
  /** Permission key required for the operation */
  permission: Scalars['String']['input'];
  /** Whether practitioners are allowed the permission */
  practitionerAllowed: Scalars['Boolean']['input'];
  /** Scope of the practitioner role permission, ALL or ORG */
  practitionerRolePermissionScope?: InputMaybe<Scalars['String']['input']>;
  /** Scope in which the permission applies */
  scope: PermissionScope;
  /** Whether system admins are allowed the permission */
  sysAdminAllowed: Scalars['Boolean']['input'];
  /** GraphQL operation type, Mutation or Query */
  type: Scalars['String']['input'];
  /** Whether standard users are allowed the permission */
  userAllowed: Scalars['Boolean']['input'];
  /** Scope of the Vitall role permission, ALL or ORG */
  vitallRolePermissionScope?: InputMaybe<Scalars['String']['input']>;
};

export type PostProcedureInput = {
  /** Location associated with the record */
  location?: InputMaybe<LocationModelInput>;
  /** Procedure resource to create */
  procedure: ProcedureModelInput;
};

export type PostQuestionnaireResponsesInput = {
  /** Patient resource id the responses belong to */
  patient: Scalars['String']['input'];
  /** Questionnaire resource identifier */
  questionnaire_identifier: Scalars['String']['input'];
  /** Questionnaire response payload to persist */
  responses: QuestionnaireResponseModelInput;
};

export type PostScanResultsInput = {
  /** Raw scan result details payload */
  scan_details: Scalars['JSON']['input'];
  /** Type of scan performed */
  scan_type: ScanType;
  /** User-provided responses captured during the scan */
  user_responses: Scalars['JSON']['input'];
  /** Vitall patient id the scan results belong to */
  vitall_patient_id: Scalars['String']['input'];
};

export type PostTerraConnectionInput = {
  /** Wearable provider integration to connect */
  integration: Scalars['String']['input'];
  /** Vitall patient to create the connection for */
  vitall_patient_id: Scalars['String']['input'];
};

export type PostUserPermissionGrantsInput = {
  /** User who is being granted permission */
  accessing_user_id: Scalars['String']['input'];
  /** Permission control grants to apply */
  grants: Array<PermissionControlResponse>;
  /** Control set the grants belong to */
  permission_control_set_id: Scalars['String']['input'];
  /** User who is granting permission */
  user_id: Scalars['String']['input'];
};

/** PractitionerModel */
export type PractitionerModel = {
  __typename?: 'PractitionerModel';
  /** Whether this practitioner's record is in active use */
  active?: Maybe<Scalars['Boolean']['output']>;
  /** Addresses of the practitioner not specific to a role */
  address?: Maybe<Array<Address>>;
  associatedResources?: Maybe<Array<ResourceAssociationUnion>>;
  attachments?: Maybe<Array<Attachment>>;
  /** Date on which the practitioner was born */
  birthDate?: Maybe<Scalars['String']['output']>;
  /** Contained */
  contained?: Maybe<Array<Resource>>;
  displayName?: Maybe<Scalars['String']['output']>;
  /** Extension */
  extension?: Maybe<Array<Extension>>;
  /** Practitioner's gender: male, female, other, or unknown */
  gender?: Maybe<Gender>;
  /** FHIR resource id of the practitioner */
  id?: Maybe<Scalars['String']['output']>;
  /** Identifiers for the practitioner */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /** A set of rules under which this content was created */
  implicitRules?: Maybe<Scalars['String']['output']>;
  /** Whether this practitioner maps to a Vitall platform user */
  is_vitall_user?: Maybe<Scalars['Boolean']['output']>;
  /** Language of the resource content */
  language?: Maybe<Scalars['String']['output']>;
  /** Metadata about the resource */
  meta?: Maybe<Meta>;
  /** Names associated with the practitioner */
  name?: Maybe<Array<HumanName>>;
  /** Photos of the practitioner */
  photo?: Maybe<Array<Attachment>>;
  /** Certifications, licenses, or training for providing care */
  qualification?: Maybe<Array<Qualification>>;
  /** FHIR resource type, always "Practitioner" */
  resourceType?: Maybe<Scalars['String']['output']>;
  /** Contact details for the practitioner */
  telecom?: Maybe<Array<ContactPoint>>;
  /** Text */
  text?: Maybe<Narrative>;
};

export type PriceMetadata = {
  __typename?: 'PriceMetadata';
  /** One-time fee applied alongside the price */
  oneTimeFee?: Maybe<Scalars['Float']['output']>;
  /** Identifier of a paired price */
  pairedPrice?: Maybe<Scalars['String']['output']>;
  /** Plan type associated with the price */
  planType?: Maybe<PlanType>;
};

export enum PriceType {
  one_time = 'one_time',
  recurring = 'recurring'
}

/** ProcedureModel */
export type ProcedureModel = {
  __typename?: 'ProcedureModel';
  /** Who asserted the procedure occurred */
  asserter?: Maybe<Reference>;
  associatedResources?: Maybe<Array<ResourceAssociationUnion>>;
  attachments?: Maybe<Array<Attachment>>;
  /** Target body sites of the procedure */
  bodySite?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Classification of the procedure */
  category?: Maybe<CodeableConcept>;
  /** Coded identification of the procedure performed */
  code: CodeableConcept;
  /** Complications following the procedure */
  complication?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Conditions resulting from the procedure */
  complicationDetail?: Maybe<Array<Reference>>;
  /** Contained */
  contained?: Maybe<Array<Resource>>;
  /** Curation metadata for this procedure resource */
  curationMeta?: Maybe<CurationMeta>;
  /** Raw serialized procedure data payload */
  data?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  /** Encounter during which this procedure was created */
  encounter?: Maybe<Reference>;
  /** Extension */
  extension?: Maybe<Array<Extension>>;
  /** Devices manipulated, implanted, or removed during the procedure */
  focalDevice?: Maybe<Array<Maybe<FocalDevice>>>;
  /** Instructions for follow up after the procedure */
  followUp?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Logical id of this artifact */
  id?: Maybe<Scalars['String']['output']>;
  /** External identifiers for this procedure */
  identifier?: Maybe<Array<Identifier>>;
  /** A set of rules under which this content was created */
  implicitRules?: Maybe<Scalars['String']['output']>;
  /** URIs of protocols or definitions this procedure instantiates */
  instantiatesUri?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Language of the resource content */
  language?: Maybe<Scalars['String']['output']>;
  /** Location where the procedure happened */
  location?: Maybe<Reference>;
  /** Resolved Location resource where the procedure was performed */
  locationResource?: Maybe<Array<LocationModel>>;
  /** Metadata about the resource */
  meta?: Maybe<Meta>;
  /** Additional notes about the procedure */
  note?: Maybe<Array<Maybe<Annotation>>>;
  /** Result or outcome of the procedure */
  outcome?: Maybe<CodeableConcept>;
  /** Patient age when the procedure was performed */
  performedAge?: Maybe<Age>;
  /** Date and time the procedure occurred */
  performedDateTime?: Maybe<Scalars['String']['output']>;
  /** Period over which the procedure was performed */
  performedPeriod?: Maybe<Period>;
  /** Age range during which the procedure was performed */
  performedRange?: Maybe<Range>;
  /** Textual description of when the procedure occurred */
  performedString?: Maybe<Scalars['String']['output']>;
  /** Timing schedule for when the procedure was performed */
  performedTiming?: Maybe<Timing>;
  /** People who performed the procedure */
  performer?: Maybe<Array<Performer>>;
  /** Coded reasons the procedure was performed */
  reasonCode?: Maybe<Array<CodeableConcept>>;
  /** References justifying why the procedure was performed */
  reasonReference?: Maybe<Array<Maybe<Reference>>>;
  /** When the procedure was first captured in the record */
  recorded?: Maybe<Scalars['String']['output']>;
  /** Who recorded the procedure */
  recorder?: Maybe<Reference>;
  /** Any report resulting from the procedure */
  report?: Maybe<Reference>;
  /** Whether the procedure was reported rather than primary record */
  reportedBoolean?: Maybe<Scalars['Boolean']['output']>;
  /** Reference to who reported the procedure */
  reportedReference?: Maybe<Reference>;
  /** FHIR resource type, always Procedure */
  resourceType?: Maybe<Scalars['String']['output']>;
  /** Procedure status such as in-progress or completed */
  status: Scalars['String']['output'];
  /** Reason for the current procedure status */
  statusReason?: Maybe<CodeableConcept>;
  /** Patient or entity the procedure was performed on */
  subject: Reference;
  /** Extra information relevant to the procedure */
  supportingInfo?: Maybe<Array<Maybe<Reference>>>;
  /** Text */
  text?: Maybe<Narrative>;
  /** Coded items used during the procedure */
  usedCode?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** Items referenced that were used during the procedure */
  usedReference?: Maybe<Array<Maybe<Reference>>>;
};

export type ProcedureModelInput = {
  /** Who asserted the procedure occurred */
  asserter?: InputMaybe<ReferenceInput>;
  /** Target body sites of the procedure */
  bodySite?: InputMaybe<Array<InputMaybe<CodeableConceptInput>>>;
  /** Classification of the procedure */
  category?: InputMaybe<CodeableConceptInput>;
  /** Coded identification of the procedure performed */
  code: CodeableConceptInput;
  /** Complications following the procedure */
  complication?: InputMaybe<Array<InputMaybe<CodeableConceptInput>>>;
  /** Conditions resulting from the procedure */
  complicationDetail?: InputMaybe<Array<ReferenceInput>>;
  /** Contained */
  contained?: InputMaybe<Array<ResourceInput>>;
  /** Raw serialized procedure data payload */
  data?: InputMaybe<Scalars['String']['input']>;
  /** Encounter during which this procedure was created */
  encounter?: InputMaybe<ReferenceInput>;
  /** Extension */
  extension?: InputMaybe<Array<ExtensionInput>>;
  /** Devices manipulated, implanted, or removed during the procedure */
  focalDevice?: InputMaybe<Array<InputMaybe<FocalDeviceInput>>>;
  /** Instructions for follow up after the procedure */
  followUp?: InputMaybe<Array<InputMaybe<CodeableConceptInput>>>;
  /** Logical id of this artifact */
  id?: InputMaybe<Scalars['String']['input']>;
  /** External identifiers for this procedure */
  identifier?: InputMaybe<Array<IdentifierInput>>;
  /** A set of rules under which this content was created */
  implicitRules?: InputMaybe<Scalars['String']['input']>;
  /** URIs of protocols or definitions this procedure instantiates */
  instantiatesUri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Language of the resource content */
  language?: InputMaybe<Scalars['String']['input']>;
  /** Location where the procedure happened */
  location?: InputMaybe<ReferenceInput>;
  /** Metadata about the resource */
  meta?: InputMaybe<MetaInput>;
  /** Additional notes about the procedure */
  note?: InputMaybe<Array<InputMaybe<AnnotationInput>>>;
  /** Result or outcome of the procedure */
  outcome?: InputMaybe<CodeableConceptInput>;
  /** Patient age when the procedure was performed */
  performedAge?: InputMaybe<AgeInput>;
  /** Date and time the procedure occurred */
  performedDateTime?: InputMaybe<Scalars['String']['input']>;
  /** Period over which the procedure was performed */
  performedPeriod?: InputMaybe<PeriodInput>;
  /** Age range during which the procedure was performed */
  performedRange?: InputMaybe<RangeInput>;
  /** Textual description of when the procedure occurred */
  performedString?: InputMaybe<Scalars['String']['input']>;
  /** Timing schedule for when the procedure was performed */
  performedTiming?: InputMaybe<TimingInput>;
  /** People who performed the procedure */
  performer?: InputMaybe<Array<PerformerInput>>;
  /** Coded reasons the procedure was performed */
  reasonCode?: InputMaybe<Array<InputMaybe<CodeableConceptInput>>>;
  /** References justifying why the procedure was performed */
  reasonReference?: InputMaybe<Array<InputMaybe<ReferenceInput>>>;
  /** When the procedure was first captured in the record */
  recorded?: InputMaybe<Scalars['String']['input']>;
  /** Who recorded the procedure */
  recorder?: InputMaybe<ReferenceInput>;
  /** Any report resulting from the procedure */
  report?: InputMaybe<ReferenceInput>;
  /** Whether the procedure was reported rather than primary record */
  reportedBoolean?: InputMaybe<Scalars['Boolean']['input']>;
  /** Reference to who reported the procedure */
  reportedReference?: InputMaybe<ReferenceInput>;
  /** FHIR resource type, always Procedure */
  resourceType?: InputMaybe<Scalars['String']['input']>;
  /** Procedure status such as in-progress or completed */
  status: ProcedureStatus;
  /** Reason for the current procedure status */
  statusReason?: InputMaybe<CodeableConceptInput>;
  /** Patient or entity the procedure was performed on */
  subject: ReferenceInput;
  /** Extra information relevant to the procedure */
  supportingInfo?: InputMaybe<Array<InputMaybe<ReferenceInput>>>;
  /** Text */
  text?: InputMaybe<NarrativeInput>;
  /** Coded items used during the procedure */
  usedCode?: InputMaybe<Array<InputMaybe<CodeableConceptInput>>>;
  /** Items referenced that were used during the procedure */
  usedReference?: InputMaybe<Array<InputMaybe<ReferenceInput>>>;
};

export enum ProcedureStatus {
  completed = 'completed',
  enteredInError = 'enteredInError',
  inProgress = 'inProgress',
  notDone = 'notDone',
  onHold = 'onHold',
  preparation = 'preparation',
  stopped = 'stopped',
  unknown = 'unknown'
}

export type ProtocolApplied = {
  __typename?: 'ProtocolApplied';
  /** Who is responsible for publishing the recommendations */
  authority?: Maybe<Reference>;
  /** Dose number positive int */
  doseNumberPositiveInt?: Maybe<Scalars['Float']['output']>;
  /** Dose number string */
  doseNumberString?: Maybe<Scalars['String']['output']>;
  /** Name of vaccine series */
  series?: Maybe<Scalars['String']['output']>;
  /** Series doses positive int */
  seriesDosesPositiveInt?: Maybe<Scalars['Float']['output']>;
  /** Series doses string */
  seriesDosesString?: Maybe<Scalars['String']['output']>;
  /** Vaccine preventatable disease being targetted */
  targetDisease?: Maybe<CodeableConcept>;
};

export type ProtocolAppliedInput = {
  /** Who is responsible for publishing the recommendations */
  authority?: InputMaybe<ReferenceInput>;
  /** Dose number positive int */
  doseNumberPositiveInt?: InputMaybe<Scalars['Float']['input']>;
  /** Dose number string */
  doseNumberString?: InputMaybe<Scalars['String']['input']>;
  /** Name of vaccine series */
  series?: InputMaybe<Scalars['String']['input']>;
  /** Series doses positive int */
  seriesDosesPositiveInt?: InputMaybe<Scalars['Float']['input']>;
  /** Series doses string */
  seriesDosesString?: InputMaybe<Scalars['String']['input']>;
  /** Vaccine preventatable disease being targetted */
  targetDisease?: InputMaybe<CodeableConceptInput>;
};

export type PublishAppVersionInput = {
  /** Identifier of the draft version to publish */
  app_version_id: Scalars['String']['input'];
};

export type PulmonaryDiseaseModel = {
  __typename?: 'PulmonaryDiseaseModel';
  /** Diagnostic code for the pulmonary disease */
  disease_code: Scalars['String']['output'];
  /** Name of the pulmonary disease */
  disease_name: Scalars['String']['output'];
  /** Likelihood score for the pulmonary disease */
  likelihood?: Maybe<Scalars['Float']['output']>;
};

export type QieConnectionRefInput = {
  /** The Ehr_Connection the calling QIE channel serves. */
  ehr_connection_id: Scalars['String']['input'];
};

export type Qualification = {
  __typename?: 'Qualification';
  /** Coded representation of the qualification */
  code: CodeableConcept;
  /** A language the practitioner can use in patient communication */
  communication?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** An identifier for this qualification for the practitioner */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /** (Organization) Organization that regulates and issues the qualification */
  issuer?: Maybe<Reference>;
  /** Period during which the qualification is valid */
  period?: Maybe<Period>;
};

export type Quantity = {
  __typename?: 'Quantity';
  /** Coded form of the unit */
  code?: Maybe<Scalars['String']['output']>;
  /** < | <= | >= | > - how to understand the value */
  comparator?: Maybe<Scalars['String']['output']>;
  /** System that defines coded unit form */
  system?: Maybe<Scalars['String']['output']>;
  /** Unit representation */
  unit?: Maybe<Scalars['String']['output']>;
  /** Numerical value (with implicit precision) */
  value?: Maybe<Scalars['Float']['output']>;
};

export type QuantityInput = {
  /** Coded form of the unit */
  code?: InputMaybe<Scalars['String']['input']>;
  /** < | <= | >= | > - how to understand the value */
  comparator?: InputMaybe<Scalars['String']['input']>;
  /** System that defines coded unit form */
  system?: InputMaybe<Scalars['String']['input']>;
  /** Unit representation */
  unit?: InputMaybe<Scalars['String']['input']>;
  /** Numerical value (with implicit precision) */
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type Query = {
  __typename?: 'Query';
  /** Admin listing of a user's notification settings with email preferences */
  adminGetUserNotificationPreferences: Array<NotificationSetting>;
  /** Checks whether the client app version is supported */
  checkAppVersion: CheckAppVersionResult;
  /** VITALL only. Checks a QIE zone name the way registerEhrConnection would, without registering it. */
  checkEhrZone: EhrZoneCheck;
  /** Patients in a connection's account matching a name or VITALL id, for the enrol dialog. */
  ehrSyncEnrollCandidates: Array<EhrSyncEnrollCandidate>;
  /** QIE only. Pending, AutoLinked and Linked patient links for a connection, with demographics for matching. */
  ehrSyncLinkedPatients: Array<EhrSyncLinkedPatient>;
  ehrSyncPatientLinks: Array<EhrPatientLink>;
  ehrSyncResourceConfig: Array<EhrSyncResourceConfig>;
  /** QIE only. Which resource types a connection syncs. QIE MUST skip a resource whose enabled is false. */
  ehrSyncResourcePolicy: Array<EhrSyncResourcePolicy>;
  /** Checks whether an email is already registered to a user */
  emailExists: Scalars['Boolean']['output'];
  /** Retrieve a user's access management details by user ID */
  getAccessManagement: UserModel;
  /** Retrieve a single account by its account ID */
  getAccountRecord: AccountModel;
  /** Retrieve the account setting for a given account */
  getAccountSetting?: Maybe<AccountSettingModel>;
  /** Retrieves a single alert recipient setting by input criteria */
  getAlertRecipientSetting: AlertRecipientSettingModel;
  /** Open alert count and latest update time for a metric */
  getAlertStats: AlertStatsModel;
  /** Retrieve all curator task records matching the given filters */
  getAllCuratorTaskRecords: GetAllCuratorTaskResponse;
  /** Retrieve all curator task records for a given patient */
  getAllCuratorTaskRecordsForPatient: GetAllCuratorTaskResponse;
  /** Returns all user groups; restricted to admins and curators. */
  getAllGroups: Array<GroupModel>;
  /** List all non-patient users (admin or curator only) */
  getAllNonPatientUsers: Array<UserModel>;
  /** List patient users visible within the caller's scope */
  getAllPatientUsers: Array<UserModel>;
  /** List patients with pagination for admins or curators */
  getAllPatients: GetPatientModel;
  /** List resource models matching the given filter input */
  getAllResourceModels: Array<ResourceModel>;
  /** List users accessible within the caller's permission scope */
  getAllUsers: Array<UserModel>;
  /** Fetches a single allergy intolerance record for a patient */
  getAllergy?: Maybe<AllergyModel>;
  /** Fetches a single FHIR Appointment by patient and record id */
  getAppointment?: Maybe<AppointmentModel>;
  /** Retrieves a single assessment for a patient by id */
  getAssessment: AssessmentModel;
  /** Get a single body measurement Observation by record id */
  getBodyObservation?: Maybe<ObservationModel>;
  /** Fetches a patient's care team, optionally filtered by category */
  getCareTeam?: Maybe<PatientCareTeamModel>;
  /** Fetch a single chat room for the current user */
  getChatRoom: ChatRoomModel;
  /** Fetches a single FHIR Condition record for a patient by id */
  getCondition?: Maybe<ConditionModel>;
  /** Fetch a single patient consent record by id */
  getConsent?: Maybe<ConsentModel>;
  /** Retrieve a single curator task record by ID for admins or curators */
  getCuratorTaskRecord: UpdateCuratorTaskResponse;
  /** Returns the OAuth authorization URL for connecting a patient to a direct EMR API endpoint */
  getDirectEmrApiAuthorizationURL: Scalars['String']['output'];
  /** Get a single Discern document by its ID */
  getDiscernDocument: DiscernDocumentModel;
  /** Fetches a single Discern result by its identifier */
  getDiscernResult: DiscernResultModel;
  /** Retrieve a single document record by its document id */
  getDocumentRecord: DocumentModel;
  getEhrSyncConnection?: Maybe<EhrSyncConnection>;
  /** Fetches a single emergency visit Encounter by record id */
  getEmergencyVisitEncounter?: Maybe<EncounterModel>;
  /** Fetch a single FamilyMemberHistory record by patient and record id */
  getFamilyMemberHistory?: Maybe<FamilyMemberHistoryModel>;
  /** Get a single fitness Observation by record id */
  getFitnessObservation?: Maybe<ObservationModel>;
  /** Retrieves a single genetic-information Observation by record ID */
  getGeneticObservation?: Maybe<ObservationModel>;
  /** Single hospitalization Encounter by patient and record id */
  getHospitalizationEncounter?: Maybe<EncounterModel>;
  /** Fetch a single imaging study for a patient by record id */
  getImagingStudy: ImagingStudyModel;
  /** Get a single imaging test diagnostic report by patient and record id */
  getImagingTest: DiagnosticReportModel;
  /** Single immunization record by patient and record id */
  getImmunization?: Maybe<ImmunizationModel>;
  /** Get a single lab diagnostic report by patient and record id */
  getLabReport: DiagnosticReportModel;
  /** Timestamp of the patient's most recent FHIR record update */
  getLastRecordUpdate?: Maybe<Scalars['String']['output']>;
  /** Fetch a single MedicationRequest by patient and record id */
  getMedicationRequest?: Maybe<MedicationRequestModel>;
  /** Fetches a single medication statement by patient and record ID */
  getMedicationStatement?: Maybe<MedicationStatementModel>;
  /** Fetch the most recent resource model records for a patient */
  getMostRecentRecords: Array<ResourceModel>;
  /** Retrieve a single operation by its identifier */
  getOperation: OperationModel;
  /** Retrieve patient records via emergency access authorization */
  getPatientEmergencyAccessRecords: AllPatientRecordsModel;
  /** Retrieve a patient's active health summary FHIR records */
  getPatientHealthSummaryRecords: AllPatientRecordsModel;
  /** Fetch a single patient FHIR record by patient ID */
  getPatientRecord: PatientModel;
  getPatientSeatSummary: PatientSeatSummaryModel;
  /** Retrieve a patient's full timeline of FHIR records */
  getPatientTimelineRecords: AllPatientRecordsModel;
  /** Get a single permission by its identifier */
  getPermission: PermissionModel;
  /** Retrieve a single policy by its ID */
  getPolicy: PolicyModel;
  /** List available Stripe prices */
  getPrices: Array<StripePrice>;
  /** Fetch a single Procedure resource by patient and record id */
  getProcedure?: Maybe<ProcedureModel>;
  /** Fetch a FHIR questionnaire by identifier with the patient's prior responses */
  getQuestionnaire: GetQuestionnaireModel;
  /** Counts of unviewed records for a patient */
  getRecordViewedStatusCounts?: Maybe<RecordViewedStatusCountModel>;
  /** Fetch reference ranges applicable to a patient's observations */
  getReferenceRanges: Array<ReferenceRangeModel>;
  /** Fetches a single allowed role by its role_id */
  getRole: RoleModel;
  /** Retrieves routine instance status records for a patient */
  getRoutineInstanceStatusRecord: Array<RoutineInstanceStatusModel>;
  /** Fetches a presigned S3 asset for a record by its id */
  getS3AssetRecord: S3AssetModel;
  /** Retrieves the scan profile for a given patient */
  getScanProfile: ScanProfile;
  /** Fetches a single scan result by patient, record, and type */
  getScanResult: ScanResultModel;
  /** Retrieves shared FHIR resources for a recipient via a share link and token */
  getSharedResource: GetSharedResourceResponse;
  /** Get a single sleep Observation by record id */
  getSleepObservation?: Maybe<ObservationModel>;
  /** Retrieves the Stripe customer for a given account */
  getStripeCustomer: StripeCustomer;
  /** Fetch a single FHIR Task by patient and record id */
  getTask?: Maybe<TaskModel>;
  /** Retrieves the Stripe tax rate for a given payment token */
  getTax?: Maybe<TaxRate>;
  /** Fetch a single Terra activity by summary and connection */
  getTerraActivity: ActivityModel;
  /** Fetches the titration care plan entry for a patient */
  getTitrationCarePlan?: Maybe<TitrationCarePlanEntry>;
  /** Lists a user's notification connections */
  getUserNotificationConnections: GetUserNotificationConnectionsResponse;
  /** Lists a user's notification settings with email preferences */
  getUserNotificationPreferences: Array<NotificationSetting>;
  /** Retrieve a single user record by user ID */
  getUserRecord: UserModel;
  /** Retrieve settings for the specified user */
  getUserSettings: UserSettings;
  /** Get a single vital-sign Observation by record id */
  getVitalSignObservation?: Maybe<ObservationModel>;
  /** Retrieve a Vitall patient record by patient or user id */
  getVitallPatientRecord?: Maybe<VitallPatientModel>;
  /** Retrieves a Vitall practitioner by their FHIR practitioner id */
  getVitallPractitioner: VitallPractitionerModel;
  /** List accounts filtered by account type */
  listAccounts: Array<AccountModel>;
  /** Lists notification logs for a given health alert */
  listAlertNotifications: Array<AlertNotificationModel>;
  /** Lists alert recipient settings for an account and recipient type */
  listAlertRecipientSettings: Array<AlertRecipientSettingModel>;
  /** Lists alert settings matching the provided filter input */
  listAlertSettings: Array<AlertSettingModel>;
  /** Lists health alerts matching the given filter input */
  listAlerts: Array<AlertModel>;
  /** Lists a patient's paginated allergy intolerance records */
  listAllergies: GetAllergyModel;
  /** Lists summarized app version records */
  listAppVersionSummaries: Array<AppVersionSummaryModel>;
  /** Lists app versions, optionally filtered by the given input */
  listAppVersions: Array<AppVersionModel>;
  /** Lists paginated FHIR Appointment resources for a patient */
  listAppointments: GetAppointmentModel;
  /** Lists a patient's completed assessments, paginated by cursor */
  listAssessments: ListAssessmentsModel;
  /** Returns a paginated, filtered list of audit log entries */
  listAuditLogs: AuditLogsResponse;
  /** List a patient's blood type Observations */
  listBloodTypeObservations: GetObservationModel;
  /** List a patient's body measurement Observations */
  listBodyObservations: GetObservationModel;
  /** List all chat rooms in the current user's organization */
  listChatRooms: Array<ChatRoomModel>;
  /** Lists a patient's FHIR Condition resources with pagination */
  listConditions: GetConditionModel;
  /** List a patient's consent FHIR resources with pagination */
  listConsents: GetConsentModel;
  /** Lists paginated insurance Coverage resources for a subscriber */
  listCoverages: GetCoverageModel;
  listCustomPlans: Array<CustomPlanModel>;
  /** Lists a patient's active direct EMR API connections */
  listDirectEmrApiConnections: Array<DirectEmrApiConnection>;
  /** Lists available direct EMR API integration endpoints, optionally filtered */
  listDirectEmrApiIntegrations: Array<DirectEmrApiEndpoint>;
  /** List Discern documents, optionally scoped to a patient */
  listDiscernDocuments: Array<DiscernDocumentModel>;
  /** List all documents belonging to a Vitall patient */
  listDocuments: Array<DocumentModel>;
  listEhrConnections: Array<EhrConnection>;
  /** VITALL only. NeedsReview links of a connection, oldest match first. */
  listEhrPatientLinksForReview: Array<EhrReviewCase>;
  listEhrSyncConnections: Array<EhrSyncConnection>;
  /** Lists a patient's emergency visit Encounter resources */
  listEmergencyVisitEncounters: GetEncounterModel;
  /** List a patient's FamilyMemberHistory records, paginated and sorted by date */
  listFamilyMemberHistories: GetFamilyMemberHistoryModel;
  listFeatureCatalog: Array<OrgFeatureModel>;
  /** List a patient's fitness Observations */
  listFitnessObservations: GetObservationModel;
  /** Lists a patient's genetic-information Observations with pagination */
  listGeneticObservations: GetObservationModel;
  /** List a patient's health-score Observations */
  listHealthScoreObservations: GetObservationModel;
  /** Paginated list of hospitalization Encounters for a patient */
  listHospitalizationEncounters: GetEncounterModel;
  /** List a patient's imaging and tests diagnostic reports */
  listImagingDiagnosticReports: GetDiagnosticReportModel;
  /** Paginated list of immunizations for a patient */
  listImmunizations: GetImmunizationModel;
  /** List a patient's laboratory diagnostic reports */
  listLabResultDiagnosticReports: GetDiagnosticReportModel;
  /** List laboratory Observations for a lab report by code */
  listLaboratoryObservations: GetObservationModel;
  /** List the latest body measurement observations for a patient */
  listLatestBodyObservations: GetLatestObservationsModel;
  /** List the latest fitness observations for a patient */
  listLatestFitnessObservations: GetLatestObservationsModel;
  /** List the latest health score observations for a patient */
  listLatestHealthScoreObservations: GetLatestObservationsModel;
  /** List the latest sleep observations for a patient */
  listLatestSleepObservations: GetLatestObservationsModel;
  /** List the latest vital sign observations for a patient */
  listLatestVitalSignObservations: GetLatestObservationsModel;
  /** List a patient's advance directive legal consents */
  listLegalDirectives: GetConsentModel;
  /** Retrieves all available licenses */
  listLicenses: Array<LicenseModel>;
  /** List a patient's MedicationRequest resources, paginated */
  listMedicationRequests: GetMedicationRequestModel;
  /** Lists paginated medication statements for a patient */
  listMedicationStatements: GetMedicationStatementModel;
  /** List all operations with their attached policies */
  listOperations: Array<OperationModel>;
  listOrgFeatures: Array<OrgFeatureModel>;
  /** List permissions, optionally filtered by scope */
  listPermissions: Array<PermissionModel>;
  /** Lists all available license plans */
  listPlans: Array<PlanModel>;
  /** List all authorization policies */
  listPolicies: Array<PolicyModel>;
  /** Search FHIR practitioners by name, email, phone, or address */
  listPractitioners: Array<PractitionerModel>;
  /** List a patient's FHIR Procedure resources with pagination */
  listProcedures: GetProcedureModel;
  /** List all purchased contract plans for an account */
  listPurchasedPlans: Array<ContractPlanModel>;
  /** List available reference range options for selection */
  listReferenceRangeOptions: Array<ReferenceRangeOptionModel>;
  /** List paginated RelatedPerson FHIR resources for a patient */
  listRelatedPersons: GetRelatedPersonModel;
  /** Lists all roles the authenticated user is allowed to access */
  listRoles: Array<RoleModel>;
  /** Lists a patient's latest scan app connections */
  listScanAppConnections: Array<ScanAppConnection>;
  /** Lists a patient's scan results, filtered by scan type */
  listScanResults: ListScanResultsResponse;
  /** Lists the shared resource history for a given user */
  listSharedResourceHistory: Array<SharedResourceHistory>;
  /** List a patient's sleep Observations */
  listSleepObservations: GetObservationModel;
  /** Lists available statuses for the given model type */
  listStatuses: Array<StatusModel>;
  /** List Stripe invoices for the account's customer */
  listStripeInvoices: Array<StripeInvoice>;
  /** Lists all supported app platforms */
  listSupportedAppPlatforms: Array<SupportedAppPlatformModel>;
  /** Retrieve a paginated list of FHIR Tasks for a patient */
  listTasks: GetTaskModel;
  /** List a patient's Terra activities with pagination cursor */
  listTerraActivities: ListTerraActivitiesResponse;
  /** Lists a patient's Terra wearable device integrations */
  listTerraConnections: Array<TerraIntegration>;
  /** Lists paginated user import jobs */
  listUserImportJobs: ListUserImportJobs;
  /** Lists a user's access management permission control sets with per-scope enablement */
  listUserPermissionControlSets: Array<PermissionControlSet>;
  /** List a patient's vital-signs Observations */
  listVitalSignObservations: GetObservationModel;
  previewOrgFeatureChange: OrgFeatureChangePreviewModel;
  /** Sends an encounter-reported email and creates a curator task for the patient */
  sendRecordReportedEmail: Scalars['Boolean']['output'];
  /** Validate a Stripe coupon code and return the coupon */
  validateCoupon: StripeCoupon;
};


export type QueryAdminGetUserNotificationPreferencesArgs = {
  input: GetUserNotificationsInput;
};


export type QueryCheckAppVersionArgs = {
  input: CheckAppVersionInput;
};


export type QueryCheckEhrZoneArgs = {
  input: CheckEhrZoneInput;
};


export type QueryEhrSyncEnrollCandidatesArgs = {
  input: EhrSyncEnrollCandidatesInput;
};


export type QueryEhrSyncLinkedPatientsArgs = {
  input: QieConnectionRefInput;
};


export type QueryEhrSyncPatientLinksArgs = {
  input: EhrConnectionRefInput;
};


export type QueryEhrSyncResourceConfigArgs = {
  input: EhrConnectionRefInput;
};


export type QueryEhrSyncResourcePolicyArgs = {
  input: QieConnectionRefInput;
};


export type QueryEmailExistsArgs = {
  input: EmailExistsInput;
};


export type QueryGetAccessManagementArgs = {
  input: GetUserInput;
};


export type QueryGetAccountRecordArgs = {
  input: GetAccountInput;
};


export type QueryGetAccountSettingArgs = {
  input: GetAccountSettingInput;
};


export type QueryGetAlertRecipientSettingArgs = {
  input: GetAlertRecipientSettingInput;
};


export type QueryGetAlertStatsArgs = {
  input: GetMetricAlertStatsInput;
};


export type QueryGetAllCuratorTaskRecordsArgs = {
  input: GetCuratorTasksInput;
};


export type QueryGetAllCuratorTaskRecordsForPatientArgs = {
  input: GetCuratorTasksForPatientInput;
};


export type QueryGetAllPatientUsersArgs = {
  input?: InputMaybe<GetPatientUsersInput>;
};


export type QueryGetAllPatientsArgs = {
  input: PaginationInput;
};


export type QueryGetAllResourceModelsArgs = {
  input: GetAllResourceModelsModelInput;
};


export type QueryGetAllUsersArgs = {
  input?: InputMaybe<GetAllUsersInput>;
};


export type QueryGetAllergyArgs = {
  input: GetRecordInput;
};


export type QueryGetAppointmentArgs = {
  input: GetRecordInput;
};


export type QueryGetAssessmentArgs = {
  input: GetAssessmentInput;
};


export type QueryGetBodyObservationArgs = {
  input: GetRecordInput;
};


export type QueryGetCareTeamArgs = {
  input: GetCareTeamInput;
};


export type QueryGetChatRoomArgs = {
  input: GetChatRoomInput;
};


export type QueryGetConditionArgs = {
  input: GetRecordInput;
};


export type QueryGetConsentArgs = {
  input: GetRecordInput;
};


export type QueryGetCuratorTaskRecordArgs = {
  input: GetCuratorTaskInput;
};


export type QueryGetDirectEmrApiAuthorizationUrlArgs = {
  input: EmrConnectionInput;
};


export type QueryGetDiscernDocumentArgs = {
  input: GetDiscernDocumentInput;
};


export type QueryGetDiscernResultArgs = {
  input: GetDiscernResultInput;
};


export type QueryGetDocumentRecordArgs = {
  input: GetDocumentInput;
};


export type QueryGetEhrSyncConnectionArgs = {
  input: GetEhrSyncConnectionInput;
};


export type QueryGetEmergencyVisitEncounterArgs = {
  input: GetRecordInput;
};


export type QueryGetFamilyMemberHistoryArgs = {
  input: GetRecordInput;
};


export type QueryGetFitnessObservationArgs = {
  input: GetRecordInput;
};


export type QueryGetGeneticObservationArgs = {
  input: GetRecordInput;
};


export type QueryGetHospitalizationEncounterArgs = {
  input: GetRecordInput;
};


export type QueryGetImagingStudyArgs = {
  input: GetRecordInput;
};


export type QueryGetImagingTestArgs = {
  input: GetRecordInput;
};


export type QueryGetImmunizationArgs = {
  input: GetRecordInput;
};


export type QueryGetLabReportArgs = {
  input: GetRecordInput;
};


export type QueryGetLastRecordUpdateArgs = {
  input: GetPatientInput;
};


export type QueryGetMedicationRequestArgs = {
  input: GetRecordInput;
};


export type QueryGetMedicationStatementArgs = {
  input: GetRecordInput;
};


export type QueryGetMostRecentRecordsArgs = {
  input: GetLatestRecordsInput;
};


export type QueryGetOperationArgs = {
  input: GetOperationInput;
};


export type QueryGetPatientEmergencyAccessRecordsArgs = {
  input: GetEmergencyAccessRecordsInput;
};


export type QueryGetPatientHealthSummaryRecordsArgs = {
  input: GetHealthSummaryRecordsInput;
};


export type QueryGetPatientRecordArgs = {
  input: GetPatientInput;
};


export type QueryGetPatientSeatSummaryArgs = {
  input: OrgScopedInput;
};


export type QueryGetPatientTimelineRecordsArgs = {
  input: GetHealthSummaryRecordsInput;
};


export type QueryGetPermissionArgs = {
  input: GetPermissionInput;
};


export type QueryGetPolicyArgs = {
  input: GetPolicyInput;
};


export type QueryGetProcedureArgs = {
  input: GetRecordInput;
};


export type QueryGetQuestionnaireArgs = {
  input: GetQuestionnaireModelInput;
};


export type QueryGetRecordViewedStatusCountsArgs = {
  input: GetLatestRecordsInput;
};


export type QueryGetReferenceRangesArgs = {
  input: GetReferenceRangesInput;
};


export type QueryGetRoleArgs = {
  input: GetRoleInput;
};


export type QueryGetRoutineInstanceStatusRecordArgs = {
  input: GetRoutineInstanceStatusInput;
};


export type QueryGetS3AssetRecordArgs = {
  input: GetRecordInput;
};


export type QueryGetScanProfileArgs = {
  input: GetScanProfileInput;
};


export type QueryGetScanResultArgs = {
  input: GetScanResultInput;
};


export type QueryGetSharedResourceArgs = {
  input: GetSharedResourceInput;
};


export type QueryGetSleepObservationArgs = {
  input: GetRecordInput;
};


export type QueryGetStripeCustomerArgs = {
  input: StripeCustomerInput;
};


export type QueryGetTaskArgs = {
  input: GetRecordInput;
};


export type QueryGetTaxArgs = {
  input: GetStripeTaxInput;
};


export type QueryGetTerraActivityArgs = {
  input: GetTerraActivityInput;
};


export type QueryGetTitrationCarePlanArgs = {
  input: GetTitrationCarePlanInput;
};


export type QueryGetUserNotificationConnectionsArgs = {
  input: GetUserNotificationsInput;
};


export type QueryGetUserNotificationPreferencesArgs = {
  input: GetUserNotificationsInput;
};


export type QueryGetUserRecordArgs = {
  input: GetUserInput;
};


export type QueryGetUserSettingsArgs = {
  input: GetUserInput;
};


export type QueryGetVitalSignObservationArgs = {
  input: GetRecordInput;
};


export type QueryGetVitallPatientRecordArgs = {
  input: GetVitallPatientRecordInput;
};


export type QueryGetVitallPractitionerArgs = {
  input: GetVitallPractitionerInput;
};


export type QueryListAccountsArgs = {
  input: ListAccountsInput;
};


export type QueryListAlertNotificationsArgs = {
  input: ListAlertNotificationsInput;
};


export type QueryListAlertRecipientSettingsArgs = {
  input: ListAlertRecipientSettingsInput;
};


export type QueryListAlertSettingsArgs = {
  input: ListAlertSettingsInput;
};


export type QueryListAlertsArgs = {
  input: ListAlertsInput;
};


export type QueryListAllergiesArgs = {
  input: ListRecordsInput;
};


export type QueryListAppVersionsArgs = {
  input?: InputMaybe<ListAppVersionsInput>;
};


export type QueryListAppointmentsArgs = {
  input: ListAppointmentsInput;
};


export type QueryListAssessmentsArgs = {
  input: ListAssessmentsInput;
};


export type QueryListAuditLogsArgs = {
  input: AuditLogInput;
};


export type QueryListBloodTypeObservationsArgs = {
  input: GetObservationsModelInput;
};


export type QueryListBodyObservationsArgs = {
  input: GetObservationsModelInput;
};


export type QueryListChatRoomsArgs = {
  input: ListChatRoomsInput;
};


export type QueryListConditionsArgs = {
  input: ListRecordsInput;
};


export type QueryListConsentsArgs = {
  input: ListRecordsInput;
};


export type QueryListCoveragesArgs = {
  input: GetCoveragesInput;
};


export type QueryListCustomPlansArgs = {
  input: OrgScopedInput;
};


export type QueryListDirectEmrApiConnectionsArgs = {
  input: GetEmrConnectionsInput;
};


export type QueryListDirectEmrApiIntegrationsArgs = {
  input?: InputMaybe<GetEmrIntegrationsInput>;
};


export type QueryListDiscernDocumentsArgs = {
  input?: InputMaybe<GetDiscernDocumentsInput>;
};


export type QueryListDocumentsArgs = {
  input: GetDocumentsInput;
};


export type QueryListEhrPatientLinksForReviewArgs = {
  input: EhrConnectionRefInput;
};


export type QueryListEhrSyncConnectionsArgs = {
  input?: InputMaybe<ListEhrSyncConnectionsInput>;
};


export type QueryListEmergencyVisitEncountersArgs = {
  input: ListRecordsInput;
};


export type QueryListFamilyMemberHistoriesArgs = {
  input: ListRecordsInput;
};


export type QueryListFitnessObservationsArgs = {
  input: GetObservationsModelInput;
};


export type QueryListGeneticObservationsArgs = {
  input: GetGeneticInfoObservationsModelInput;
};


export type QueryListHealthScoreObservationsArgs = {
  input: GetObservationsModelInput;
};


export type QueryListHospitalizationEncountersArgs = {
  input: ListRecordsInput;
};


export type QueryListImagingDiagnosticReportsArgs = {
  input: ListRecordsInput;
};


export type QueryListImmunizationsArgs = {
  input: ListRecordsInput;
};


export type QueryListLabResultDiagnosticReportsArgs = {
  input: ListRecordsInput;
};


export type QueryListLaboratoryObservationsArgs = {
  input: GetObservationsModelInput;
};


export type QueryListLatestBodyObservationsArgs = {
  input: GetLatestObservationsInput;
};


export type QueryListLatestFitnessObservationsArgs = {
  input: GetLatestObservationsInput;
};


export type QueryListLatestHealthScoreObservationsArgs = {
  input: GetLatestObservationsInput;
};


export type QueryListLatestSleepObservationsArgs = {
  input: GetLatestObservationsInput;
};


export type QueryListLatestVitalSignObservationsArgs = {
  input: GetLatestObservationsInput;
};


export type QueryListLegalDirectivesArgs = {
  input: ListRecordsInput;
};


export type QueryListMedicationRequestsArgs = {
  input: ListRecordsInput;
};


export type QueryListMedicationStatementsArgs = {
  input: ListRecordsInput;
};


export type QueryListOrgFeaturesArgs = {
  input: OrgScopedInput;
};


export type QueryListPermissionsArgs = {
  input: ListPermissionsInput;
};


export type QueryListPractitionersArgs = {
  input: ListPractitionersInput;
};


export type QueryListProceduresArgs = {
  input: ListRecordsInput;
};


export type QueryListPurchasedPlansArgs = {
  input: ListPurchasedPlansInput;
};


export type QueryListRelatedPersonsArgs = {
  input: ListRecordsInput;
};


export type QueryListScanAppConnectionsArgs = {
  input: ListScanAppConnectionsInput;
};


export type QueryListScanResultsArgs = {
  input: ListScanResultsInput;
};


export type QueryListSharedResourceHistoryArgs = {
  input: ListSharedResourcesInput;
};


export type QueryListSleepObservationsArgs = {
  input: GetObservationsModelInput;
};


export type QueryListStatusesArgs = {
  input: ListStatusesInput;
};


export type QueryListStripeInvoicesArgs = {
  input: StripeCustomerInput;
};


export type QueryListTasksArgs = {
  input: ListRecordsInput;
};


export type QueryListTerraActivitiesArgs = {
  input: ListTerraActivitiesInput;
};


export type QueryListTerraConnectionsArgs = {
  input: ListTerraConnectionsInput;
};


export type QueryListUserImportJobsArgs = {
  input: ListImportJobsInput;
};


export type QueryListUserPermissionControlSetsArgs = {
  input: ListPermissionControlSetsInput;
};


export type QueryListVitalSignObservationsArgs = {
  input: GetObservationsModelInput;
};


export type QueryPreviewOrgFeatureChangeArgs = {
  input: OrgFeatureSelectionInput;
};


export type QuerySendRecordReportedEmailArgs = {
  input: SendRecordReportedEmailInput;
};


export type QueryValidateCouponArgs = {
  input: ValidateCouponInput;
};

/** QuestionnaireAnswerOption */
export type QuestionnaireAnswerOption = {
  __typename?: 'QuestionnaireAnswerOption';
  /** Whether option is selected by default */
  initialSelected?: Maybe<Scalars['Boolean']['output']>;
  /** Coded answer value for this option */
  valueCoding?: Maybe<Coding>;
  /** Date answer value for this option */
  valueDate?: Maybe<Scalars['String']['output']>;
  /** value[x]: Answer value. One of these 6: */
  valueInteger?: Maybe<Scalars['Int']['output']>;
  /** Reference answer value for this option */
  valueReference?: Maybe<Reference>;
  /** String answer value for this option */
  valueString?: Maybe<Scalars['String']['output']>;
  /** Time answer value for this option */
  valueTime?: Maybe<Scalars['String']['output']>;
};

/** QuestionnaireEnableWhen */
export type QuestionnaireEnableWhen = {
  __typename?: 'QuestionnaireEnableWhen';
  /** answer[x]: Value for question comparison based on operator One of these 10: */
  answerBoolean?: Maybe<Scalars['Boolean']['output']>;
  /** Coded value compared against the question answer */
  answerCoding?: Maybe<Coding>;
  /** Date value compared against the question answer */
  answerDate?: Maybe<Scalars['String']['output']>;
  /** DateTime value compared against the question answer */
  answerDateTime?: Maybe<Scalars['String']['output']>;
  /** Decimal value compared against the question answer */
  answerDecimal?: Maybe<Scalars['Float']['output']>;
  /** Integer value compared against the question answer */
  answerInteger?: Maybe<Scalars['Int']['output']>;
  /** Quantity value compared against the question answer */
  answerQuantity?: Maybe<Quantity>;
  /** Reference value compared against the question answer */
  answerReference?: Maybe<Reference>;
  /** String value compared against the question answer */
  answerString?: Maybe<Scalars['String']['output']>;
  /** Time value compared against the question answer */
  answerTime?: Maybe<Scalars['String']['output']>;
  /** exists | = | != | > | < | >= | <= */
  operator: Scalars['String']['output'];
  /** Question that determines whether item is enabled */
  question: Scalars['String']['output'];
};

/** QuestionnaireInitialItem */
export type QuestionnaireInitialItem = {
  __typename?: 'QuestionnaireInitialItem';
  /** Attachment initial answer value */
  valueAttachment?: Maybe<Attachment>;
  /** value[x]: Answer value. One of these 12: */
  valueBoolean?: Maybe<Scalars['Boolean']['output']>;
  /** Coded initial answer value */
  valueCoding?: Maybe<Coding>;
  /** Date initial answer value */
  valueDate?: Maybe<Scalars['String']['output']>;
  /** DateTime initial answer value */
  valueDateTime?: Maybe<Scalars['String']['output']>;
  /** Decimal initial answer value */
  valueDecimal?: Maybe<Scalars['Float']['output']>;
  /** Integer initial answer value */
  valueInteger?: Maybe<Scalars['Int']['output']>;
  /** Quantity initial answer value */
  valueQuantity?: Maybe<Quantity>;
  /** Reference initial answer value */
  valueReference?: Maybe<Reference>;
  /** String initial answer value */
  valueString?: Maybe<Scalars['String']['output']>;
  /** Time initial answer value */
  valueTime?: Maybe<Scalars['String']['output']>;
  /** URI initial answer value */
  valueUri?: Maybe<Scalars['String']['output']>;
};

/** QuestionnaireItemModel */
export type QuestionnaireItemModel = {
  __typename?: 'QuestionnaireItemModel';
  /** Explicit list of permitted answers for the item */
  answerOption?: Maybe<Array<QuestionnaireAnswerOption>>;
  /** ValueSet containing permitted answers */
  answerValueSet?: Maybe<Scalars['String']['output']>;
  /** Corresponding concept for this item in a terminology */
  code?: Maybe<Array<Coding>>;
  /** ElementDefinition - details for the item */
  definition?: Maybe<Scalars['String']['output']>;
  /** all | any */
  enableBehavior?: Maybe<Scalars['String']['output']>;
  /** Conditions under which the item is enabled */
  enableWhen?: Maybe<Array<QuestionnaireEnableWhen>>;
  /** Initial answer value(s) when the item is first rendered */
  initial?: Maybe<Array<QuestionnaireInitialItem>>;
  /** Nested child items within this item */
  item?: Maybe<Array<QuestionnaireItemModel>>;
  /** Unique id for item in questionnaire (should be 255 characters or less) */
  linkId: Scalars['String']['output'];
  /** No more than these many characters */
  maxLength?: Maybe<Scalars['Int']['output']>;
  /** Text prefix shown before the item, such as a section number */
  prefix?: Maybe<Scalars['String']['output']>;
  /** Don't allow human editing */
  readOnly?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the item may repeat */
  repeats?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the item must be included in data results */
  required?: Maybe<Scalars['Boolean']['output']>;
  /** Primary text for the item */
  text?: Maybe<Scalars['String']['output']>;
  /** Question type (decimal, boolean, date, etc.) */
  type: Scalars['String']['output'];
};

/** QuestionnaireModel */
export type QuestionnaireModel = {
  __typename?: 'QuestionnaireModel';
  /** When the questionnaire was approved by publisher */
  approvalDate?: Maybe<Scalars['String']['output']>;
  associatedResources?: Maybe<Array<ResourceAssociationUnion>>;
  attachments?: Maybe<Array<Attachment>>;
  /** Concept that represents the overall questionnaire */
  code?: Maybe<Array<Coding>>;
  /** Contact details for the publisher */
  contact?: Maybe<Array<ContactDetail>>;
  /** Contained */
  contained?: Maybe<Array<Resource>>;
  /** Use and/or publishing restrictions */
  copyright?: Maybe<Scalars['String']['output']>;
  /** Copyright holder and year(s) */
  copyrightLabel?: Maybe<Scalars['String']['output']>;
  /** Date last changed */
  date?: Maybe<Scalars['String']['output']>;
  /** Instantiates protocol or definition */
  derivedFrom?: Maybe<Array<Scalars['String']['output']>>;
  /** Natural language description of the questionnaire */
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  /** When the questionnaire is expected to be used */
  effectivePeriod?: Maybe<Period>;
  /** For testing purposes, not real usage */
  experimental?: Maybe<Scalars['Boolean']['output']>;
  /** Extension */
  extension?: Maybe<Array<Extension>>;
  /** Logical id of the questionnaire resource */
  id?: Maybe<Scalars['String']['output']>;
  /** Additional business identifiers for the questionnaire */
  identifier?: Maybe<Array<Identifier>>;
  /** A set of rules under which this content was created */
  implicitRules?: Maybe<Scalars['String']['output']>;
  /** Top-level questions and sections within the questionnaire */
  item?: Maybe<Array<QuestionnaireItemModel>>;
  /** Intended jurisdictions for the questionnaire */
  jurisdiction?: Maybe<Array<CodeableConcept>>;
  /** Language of the resource content */
  language?: Maybe<Scalars['String']['output']>;
  /** When the questionnaire was last reviewed by the publisher */
  lastReviewDate?: Maybe<Scalars['String']['output']>;
  /** Metadata about the resource */
  meta?: Maybe<Meta>;
  /** Name for this questionnaire (computer friendly) */
  name?: Maybe<Scalars['String']['output']>;
  /** Name of the publisher (organization or individual) */
  publisher?: Maybe<Scalars['String']['output']>;
  /** Why this questionnaire is defined */
  purpose?: Maybe<Scalars['String']['output']>;
  /** FHIR resource type, always Questionnaire */
  resourceType?: Maybe<Scalars['String']['output']>;
  /** draft | active | retired | unknown */
  status: Scalars['String']['output'];
  /** Resource that can be subject of QuestionnaireResponse */
  subjectType: Array<Scalars['String']['output']>;
  /** Text */
  text?: Maybe<Narrative>;
  /** Name for this questionnaire (human friendly) */
  title?: Maybe<Scalars['String']['output']>;
  /** Contexts the questionnaire content is intended to support */
  useContext?: Maybe<Array<UsageContext>>;
  /** Business version of the questionnaire */
  version?: Maybe<Scalars['String']['output']>;
};

/** QuestionnaireResponseAnswerModel */
export type QuestionnaireResponseAnswerModel = {
  __typename?: 'QuestionnaireResponseAnswerModel';
  /** Nested items following this answer */
  item?: Maybe<Array<QuestionnaireResponseItemModel>>;
  /** Attachment answer to the question */
  valueAttachment?: Maybe<Attachment>;
  /** value[x]: Single-valued answer to the question. One of the following: */
  valueBoolean?: Maybe<Scalars['Boolean']['output']>;
  /** Coded answer to the question */
  valueCoding?: Maybe<Coding>;
  /** Date answer to the question */
  valueDate?: Maybe<Scalars['String']['output']>;
  /** DateTime answer to the question */
  valueDateTime?: Maybe<Scalars['String']['output']>;
  /** Decimal answer to the question */
  valueDecimal?: Maybe<Scalars['Float']['output']>;
  /** Integer answer to the question */
  valueInteger?: Maybe<Scalars['Int']['output']>;
  /** Quantity answer to the question */
  valueQuantity?: Maybe<Money>;
  /** Reference answer to the question */
  valueReference?: Maybe<Reference>;
  /** String answer to the question */
  valueString?: Maybe<Scalars['String']['output']>;
  /** Time answer to the question */
  valueTime?: Maybe<Scalars['String']['output']>;
  /** URI answer to the question */
  valueUri?: Maybe<Scalars['String']['output']>;
};

export type QuestionnaireResponseAnswerModelInput = {
  /** Nested items following this answer */
  item?: InputMaybe<Array<QuestionnaireResponseItemModelInput>>;
  /** Attachment answer to the question */
  valueAttachment?: InputMaybe<AttachmentInput>;
  /** value[x]: Single-valued answer to the question. One of the following: */
  valueBoolean?: InputMaybe<Scalars['Boolean']['input']>;
  /** Coded answer to the question */
  valueCoding?: InputMaybe<CodingInput>;
  /** Date answer to the question */
  valueDate?: InputMaybe<Scalars['String']['input']>;
  /** DateTime answer to the question */
  valueDateTime?: InputMaybe<Scalars['String']['input']>;
  /** Decimal answer to the question */
  valueDecimal?: InputMaybe<Scalars['Float']['input']>;
  /** Integer answer to the question */
  valueInteger?: InputMaybe<Scalars['Int']['input']>;
  /** Quantity answer to the question */
  valueQuantity?: InputMaybe<MoneyInput>;
  /** Reference answer to the question */
  valueReference?: InputMaybe<ReferenceInput>;
  /** String answer to the question */
  valueString?: InputMaybe<Scalars['String']['input']>;
  /** Time answer to the question */
  valueTime?: InputMaybe<Scalars['String']['input']>;
  /** URI answer to the question */
  valueUri?: InputMaybe<Scalars['String']['input']>;
};

/** QuestionnaireResponseItemModel */
export type QuestionnaireResponseItemModel = {
  __typename?: 'QuestionnaireResponseItemModel';
  /** Answers to this question */
  answer?: Maybe<Array<QuestionnaireResponseAnswerModel>>;
  /** ElementDefinition - details for the item */
  definition?: Maybe<Scalars['String']['output']>;
  /** Nested groups or questions under this item */
  item?: Maybe<Array<QuestionnaireResponseItemModel>>;
  /** Pointer to specific item from Questionnaire */
  linkId: Scalars['String']['output'];
  /** Name for group or question text */
  text?: Maybe<Scalars['String']['output']>;
};

export type QuestionnaireResponseItemModelInput = {
  /** Answers to this question */
  answer?: InputMaybe<Array<QuestionnaireResponseAnswerModelInput>>;
  /** ElementDefinition - details for the item */
  definition?: InputMaybe<Scalars['String']['input']>;
  /** Nested groups or questions under this item */
  item?: InputMaybe<Array<QuestionnaireResponseItemModelInput>>;
  /** Pointer to specific item from Questionnaire */
  linkId: Scalars['String']['input'];
  /** Name for group or question text */
  text?: InputMaybe<Scalars['String']['input']>;
};

/** QuestionnaireResponseModel */
export type QuestionnaireResponseModel = {
  __typename?: 'QuestionnaireResponseModel';
  associatedResources?: Maybe<Array<ResourceAssociationUnion>>;
  attachments?: Maybe<Array<Attachment>>;
  /** Person who received and recorded the answers */
  author?: Maybe<Reference>;
  /** Date the answers were gathered */
  authored?: Maybe<Scalars['String']['output']>;
  /** (CarePlan | ServiceRequest) Request fulfilled by this QuestionnaireResponse */
  basedOn?: Maybe<Array<Reference>>;
  /** Contained */
  contained?: Maybe<Array<Resource>>;
  displayName?: Maybe<Scalars['String']['output']>;
  /** Encounter created as part of */
  encounter?: Maybe<Reference>;
  /** Extension */
  extension?: Maybe<Array<Extension>>;
  /** Logical id of this QuestionnaireResponse resource */
  id?: Maybe<Scalars['String']['output']>;
  /** Unique id for this set of answers */
  identifier?: Maybe<Array<Identifier>>;
  /** A set of rules under which this content was created */
  implicitRules?: Maybe<Scalars['String']['output']>;
  /** Groups and questions */
  item?: Maybe<Array<QuestionnaireResponseItemModel>>;
  /** Language of the resource content */
  language?: Maybe<Scalars['String']['output']>;
  /** Metadata about the resource */
  meta?: Maybe<Meta>;
  /** (Observation | Procedure) Part of this action */
  partOf?: Maybe<Array<Reference>>;
  /** FHIR resource type, always QuestionnaireResponse */
  resourceType?: Maybe<Scalars['String']['output']>;
  /** The person who answered the questions */
  source?: Maybe<Reference>;
  /** in-progress | completed | amended | entered-in-error | stopped */
  status: Scalars['String']['output'];
  /** The subject of the questions */
  subject?: Maybe<Reference>;
  /** Text */
  text?: Maybe<Narrative>;
};

export type QuestionnaireResponseModelInput = {
  /** The individual or device that received and recorded the answers */
  author?: InputMaybe<ReferenceInput>;
  /** Date the answers were gathered */
  authored?: InputMaybe<Scalars['String']['input']>;
  /** (CarePlan | ServiceRequest) Request fulfilled by this QuestionnaireResponse */
  basedOn?: InputMaybe<Array<ReferenceInput>>;
  /** Contained */
  contained?: InputMaybe<Array<ResourceInput>>;
  /** Encounter the questionnaire response is part of */
  encounter?: InputMaybe<ReferenceInput>;
  /** Extension */
  extension?: InputMaybe<Array<ExtensionInput>>;
  /** Logical id of this artifact */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Business identifier for this set of answers */
  identifier?: InputMaybe<Array<IdentifierInput>>;
  /** A set of rules under which this content was created */
  implicitRules?: InputMaybe<Scalars['String']['input']>;
  /** Groups and questions */
  item?: InputMaybe<Array<QuestionnaireResponseItemModelInput>>;
  /** Language of the resource content */
  language?: InputMaybe<Scalars['String']['input']>;
  /** Metadata about the resource */
  meta?: InputMaybe<MetaInput>;
  /** (Observation | Procedure) Part of referenced event */
  partOf?: InputMaybe<Array<ReferenceInput>>;
  /** FHIR resource type, always QuestionnaireResponse */
  resourceType?: InputMaybe<Scalars['String']['input']>;
  /** The individual or device that answered the questions */
  source?: InputMaybe<ReferenceInput>;
  /** in-progress | completed | amended | entered-in-error | stopped */
  status: Scalars['String']['input'];
  /** Subject the questions relate to */
  subject: ReferenceInput;
  /** Text */
  text?: InputMaybe<NarrativeInput>;
};

export type Range = {
  __typename?: 'Range';
  /** High limit */
  high?: Maybe<Quantity>;
  /** Low limit */
  low?: Maybe<Quantity>;
};

export type RangeInput = {
  /** High limit */
  high?: InputMaybe<QuantityInput>;
  /** Low limit */
  low?: InputMaybe<QuantityInput>;
};

export type Ratio = {
  __typename?: 'Ratio';
  /** Denominator value */
  denominator?: Maybe<Quantity>;
  /** Numerator value */
  numerator?: Maybe<Quantity>;
};

export type RatioInput = {
  /** Denominator value */
  denominator?: InputMaybe<QuantityInput>;
  /** Numerator value */
  numerator?: InputMaybe<QuantityInput>;
};

export type RatioRange = {
  __typename?: 'RatioRange';
  /** Denominator */
  denominator?: Maybe<Quantity>;
  /** High numerator */
  highNumerator?: Maybe<Quantity>;
  /** Low numerator */
  lowNumerator?: Maybe<Quantity>;
};

export type RatioRangeInput = {
  /** Denominator */
  denominator?: InputMaybe<QuantityInput>;
  /** High numerator */
  highNumerator?: InputMaybe<QuantityInput>;
  /** Low numerator */
  lowNumerator?: InputMaybe<QuantityInput>;
};

export type Reaction = {
  __typename?: 'Reaction';
  /** When reaction started */
  date: Scalars['String']['output'];
  /** Additional information on reaction */
  detail: Reference;
  /** Indicates self-reported reaction */
  reported: Scalars['Boolean']['output'];
};

export type ReactionInput = {
  /** When reaction started */
  date: Scalars['String']['input'];
  /** Additional information on reaction */
  detail: ReferenceInput;
  /** Indicates self-reported reaction */
  reported: Scalars['Boolean']['input'];
};

export type RecordEhrPatientMatchInput = {
  /** Name and version of the algorithm that produced the score, e.g. `qie-match 1.2`. */
  algorithm: Scalars['String']['input'];
  /** Match evidence in the version 1 shape. Contains PHI. */
  evidence: Scalars['JSON']['input'];
  /**
   * The EHR patient the link now points at. Required for AutoLinked, where it
   * MUST be the first candidate; ignored otherwise.
   */
  external_patient_id?: InputMaybe<Scalars['String']['input']>;
  /** The patient link that was matched. MUST be Pending. */
  link_id: Scalars['String']['input'];
  /** Best candidate's score in [0, 1]. MUST equal the first candidate's score in evidence. */
  score?: InputMaybe<Scalars['Float']['input']>;
  /** Outcome of the match: AutoLinked, NeedsReview or NoMatch. */
  status: EhrPatientLinkStatus;
};

export type RecordEhrSyncRunInput = {
  /** Per-resource-type counts, e.g. `{ "Observation": 12 }`. Values MUST be non-negative integers. */
  counts?: InputMaybe<Scalars['JSON']['input']>;
  /** The connection the run belongs to. */
  ehr_connection_id: Scalars['String']['input'];
  /** Short, PHI-free description of what went wrong. */
  error_summary?: InputMaybe<Scalars['String']['input']>;
  /** When the run finished; omitted while it is still running. */
  finished_at?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * QIE's message id for the run. Reporting the same id again updates that
   * run instead of creating a second one.
   */
  qie_message_id?: InputMaybe<Scalars['String']['input']>;
  /** Outcome of the run; omitted while it is still running. */
  result?: InputMaybe<EhrSyncResult>;
  /** When the run started. */
  started_at: Scalars['DateTime']['input'];
  /** What started the run. */
  trigger: EhrSyncTrigger;
};

export type RecordMeta = {
  __typename?: 'RecordMeta';
  /** Count of completed records */
  Complete: Scalars['Float']['output'];
  /** Count of draft records */
  Draft: Scalars['Float']['output'];
  /** Count of records currently in review */
  InReview: Scalars['Float']['output'];
  /** Count of records needing review */
  NeedsReview: Scalars['Float']['output'];
  /** Count of new records */
  New: Scalars['Float']['output'];
  /** Count of records in preparation */
  Preparation: Scalars['Float']['output'];
  /** Count of published records */
  Published: Scalars['Float']['output'];
  /** Count of records being structured */
  Structuring: Scalars['Float']['output'];
};

export type RecordViewedStatusCountModel = {
  __typename?: 'RecordViewedStatusCountModel';
  /** Count of unviewed allergy records */
  allergy: Scalars['Int']['output'];
  /** Count of unviewed appointment records */
  appointment: Scalars['Int']['output'];
  /** Count of unviewed body measurement records */
  body: Scalars['Int']['output'];
  /** Count of unviewed consent records */
  consent: Scalars['Int']['output'];
  /** Count of unviewed diagnostic report records */
  diagnosticReport: Scalars['Int']['output'];
  /** Count of unviewed emergency visit records */
  emergencyVisit: Scalars['Int']['output'];
  /** Count of unviewed encounter records */
  encounter: Scalars['Int']['output'];
  /** Count of unviewed family history records */
  familyHistory: Scalars['Int']['output'];
  /** Count of unviewed genetic information records */
  geneticInformation: Scalars['Int']['output'];
  /** Count of unviewed hospitalization records */
  hospitalization: Scalars['Int']['output'];
  /** Count of unviewed imaging test records */
  imagingTests: Scalars['Int']['output'];
  /** Count of unviewed immunization records */
  immunization: Scalars['Int']['output'];
  /** Count of unviewed insurance records */
  insurance: Scalars['Int']['output'];
  /** Count of unviewed lab report records */
  labReport: Scalars['Int']['output'];
  /** Count of unviewed lab result records */
  labResult: Scalars['Int']['output'];
  /** Count of unviewed legal directive records */
  legalDirective: Scalars['Int']['output'];
  /** Count of unviewed medical condition records */
  medicalCondition: Scalars['Int']['output'];
  /** Count of unviewed medication records */
  medication: Scalars['Int']['output'];
  /** Count of unviewed observation records */
  observation: Scalars['Int']['output'];
  /** Count of unviewed routine records */
  routine: Scalars['Int']['output'];
  /** Count of unviewed surgery records */
  surgery: Scalars['Int']['output'];
  /** Count of unviewed vital sign records */
  vitalSign: Scalars['Int']['output'];
};

export type RecurringData = {
  __typename?: 'RecurringData';
  /** Billing interval unit */
  interval: Scalars['String']['output'];
  /** Number of intervals between billings */
  interval_count: Scalars['Float']['output'];
  /** How usage is measured for the recurring price */
  usage_type: Scalars['String']['output'];
};

export type Reference = {
  __typename?: 'Reference';
  /** Text alternative for the resource */
  display?: Maybe<Scalars['String']['output']>;
  /** Identifier */
  identifier?: Maybe<Identifier>;
  /** Literal reference; Relative; internal or absolute URL */
  reference?: Maybe<Scalars['String']['output']>;
  /** Type the reference refers to (e.g. Patient) */
  type?: Maybe<Scalars['String']['output']>;
};

export type ReferenceInput = {
  /** Text alternative for the resource */
  display?: InputMaybe<Scalars['String']['input']>;
  /** Identifier */
  identifier?: InputMaybe<IdentifierInput>;
  /** Literal reference; Relative; internal or absolute URL */
  reference?: InputMaybe<Scalars['String']['input']>;
  /** Type the reference refers to (e.g. Patient) */
  type?: InputMaybe<Scalars['String']['input']>;
};

export type ReferenceRange = {
  __typename?: 'ReferenceRange';
  /** Applicable age range, if relevant */
  age?: Maybe<Range>;
  /** Reference range population */
  appliesTo?: Maybe<Array<Maybe<CodeableConcept>>>;
  /** High Range, if relevant */
  high?: Maybe<Quantity>;
  /** Low Range, if relevant */
  low?: Maybe<Quantity>;
  /** Normal value, if relevant */
  normalValue?: Maybe<CodeableConcept>;
  /** Text based reference range in an observation */
  text?: Maybe<Scalars['String']['output']>;
  /** Reference range qualifier */
  type?: Maybe<CodeableConcept>;
};

export type ReferenceRangeInput = {
  /** Applicable age range, if relevant */
  age?: InputMaybe<RangeInput>;
  /** Reference range population */
  appliesTo?: InputMaybe<Array<InputMaybe<CodeableConceptInput>>>;
  /** High Range, if relevant */
  high?: InputMaybe<QuantityInput>;
  /** Low Range, if relevant */
  low?: InputMaybe<QuantityInput>;
  /** Normal value, if relevant */
  normalValue?: InputMaybe<CodeableConceptInput>;
  /** Text based reference range in an observation */
  text?: InputMaybe<Scalars['String']['input']>;
  /** Reference range qualifier */
  type?: InputMaybe<CodeableConceptInput>;
};

export type ReferenceRangeModel = {
  __typename?: 'ReferenceRangeModel';
  /** Category the reference range belongs to */
  category?: Maybe<Scalars['String']['output']>;
  /** Observation code the reference range applies to */
  code: Scalars['String']['output'];
  /** Unique identifier of the reference range */
  reference_range_id: Scalars['String']['output'];
  /** Risk-level groupings within the reference range */
  risks: Array<ReferenceRangeRiskModel>;
  /** Unit of measurement for the reference range */
  unit?: Maybe<Scalars['String']['output']>;
};

export type ReferenceRangeOptionModel = {
  __typename?: 'ReferenceRangeOptionModel';
  /** Category the reference range option belongs to */
  category?: Maybe<Scalars['String']['output']>;
  /** Observation code for the reference range option */
  code: Scalars['String']['output'];
  /** Unique identifier of the reference range option */
  reference_range_id: Scalars['String']['output'];
};

export enum ReferenceRangeRiskLevel {
  below_target = 'below_target',
  crisis = 'crisis',
  high = 'high',
  ideal = 'ideal',
  low = 'low',
  mild = 'mild',
  moderate = 'moderate',
  normal = 'normal',
  target = 'target'
}

export type ReferenceRangeRiskModel = {
  __typename?: 'ReferenceRangeRiskModel';
  /** Parameters defining this risk level's boundaries */
  parameters: Array<ParameterModel>;
  /** Unique identifier of the reference range risk */
  reference_range_risk_id: Scalars['String']['output'];
  /** Risk level for this grouping of parameters */
  risk: ReferenceRangeRiskLevel;
};

export type RefreshModel = {
  __typename?: 'RefreshModel';
  /** Refreshed JWT access token */
  access: Scalars['String']['output'];
  /** Refreshed session identifier */
  id: Scalars['String']['output'];
  /** Identifier of the user owning the session */
  user_id: Scalars['String']['output'];
};

export type RegisterEhrConnectionInput = {
  account_id: Scalars['String']['input'];
  ehr_vendor: EhrVendor;
  environment: EhrEnvironment;
  fhir_base_url: Scalars['String']['input'];
  fhir_version?: InputMaybe<FhirVersion>;
  network?: InputMaybe<Scalars['String']['input']>;
  qie_zone_name: Scalars['String']['input'];
};

export type RegisterSingleModel = {
  __typename?: 'RegisterSingleModel';
  /** The account created for the registered user */
  account: AccountModel;
  /** Result message for the registration */
  message: Scalars['String']['output'];
  /** The registered user */
  user: UserModel;
};

export type RelatedArtifact = {
  __typename?: 'RelatedArtifact';
  /** Citation */
  citation?: Maybe<Scalars['String']['output']>;
  /** Display */
  display?: Maybe<Scalars['Float']['output']>;
  /** Document */
  document?: Maybe<Attachment>;
  /** Label */
  label?: Maybe<Scalars['String']['output']>;
  /** Resource */
  resource?: Maybe<Scalars['String']['output']>;
  /** Type */
  type?: Maybe<Scalars['String']['output']>;
  /** Url */
  url?: Maybe<Scalars['String']['output']>;
};

export type RelatedArtifactInput = {
  /** Citation */
  citation?: InputMaybe<Scalars['String']['input']>;
  /** Display */
  display?: InputMaybe<Scalars['Float']['input']>;
  /** Document */
  document?: InputMaybe<AttachmentInput>;
  /** Label */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Resource */
  resource?: InputMaybe<Scalars['String']['input']>;
  /** Type */
  type?: InputMaybe<Scalars['String']['input']>;
  /** Url */
  url?: InputMaybe<Scalars['String']['input']>;
};

/** RelatedPersonModel */
export type RelatedPersonModel = {
  __typename?: 'RelatedPersonModel';
  /** Whether this related person's record is in active use */
  active?: Maybe<Scalars['Boolean']['output']>;
  /** Addresses where the related person can be contacted */
  address?: Maybe<Array<Address>>;
  associatedResources?: Maybe<Array<ResourceAssociationUnion>>;
  attachments?: Maybe<Array<Attachment>>;
  /** Date on which the related person was born */
  birthDate?: Maybe<Scalars['String']['output']>;
  /** Languages used to communicate with this person */
  communication?: Maybe<Array<CommunicationType>>;
  /** Contained */
  contained?: Maybe<Array<Resource>>;
  displayName?: Maybe<Scalars['String']['output']>;
  /** Extension */
  extension?: Maybe<Array<Extension>>;
  /** Administrative gender: male, female, other, or unknown */
  gender?: Maybe<Gender>;
  /** FHIR logical id of the related person resource */
  id?: Maybe<Scalars['String']['output']>;
  /** Human identifiers for this related person */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /** A set of rules under which this content was created */
  implicitRules?: Maybe<Scalars['String']['output']>;
  /** Language of the resource content */
  language?: Maybe<Scalars['String']['output']>;
  /** Metadata about the resource */
  meta?: Maybe<Meta>;
  /** Names associated with the related person */
  name?: Maybe<Array<HumanName>>;
  /** Reference to the patient this person is related to */
  patient: Reference;
  /** Period during which this relationship is valid */
  period?: Maybe<Period>;
  /** Images of the related person */
  photo?: Maybe<Array<Attachment>>;
  /** Nature of the relationship to the patient */
  relationship?: Maybe<Array<CodeableConcept>>;
  /** FHIR resource type, always RelatedPerson */
  resourceType?: Maybe<Scalars['String']['output']>;
  /** Contact details for the related person */
  telecom?: Maybe<Array<ContactPoint>>;
  /** Text */
  text?: Maybe<Narrative>;
};

export type RelatedPersonModelInput = {
  /** Whether this related person's record is in active use */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Addresses where the related person can be contacted */
  address?: InputMaybe<Array<AddressInput>>;
  /** Date on which the related person was born */
  birthDate?: InputMaybe<Scalars['String']['input']>;
  /** Languages used to communicate with this person */
  communication?: InputMaybe<Array<CommunicationTypeInput>>;
  /** Contained */
  contained?: InputMaybe<Array<ResourceInput>>;
  /** Extension */
  extension?: InputMaybe<Array<ExtensionInput>>;
  /** Administrative gender: male, female, other, or unknown */
  gender?: InputMaybe<Gender>;
  /** FHIR logical id of the related person resource */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Human identifiers for this related person */
  identifier?: InputMaybe<Array<InputMaybe<IdentifierInput>>>;
  /** A set of rules under which this content was created */
  implicitRules?: InputMaybe<Scalars['String']['input']>;
  /** Language of the resource content */
  language?: InputMaybe<Scalars['String']['input']>;
  /** Metadata about the resource */
  meta?: InputMaybe<MetaInput>;
  /** Names associated with the related person */
  name?: InputMaybe<Array<HumanNameInput>>;
  /** Reference to the patient this person is related to */
  patient: ReferenceInput;
  /** Period during which this relationship is valid */
  period?: InputMaybe<PeriodInput>;
  /** Images of the related person */
  photo?: InputMaybe<Array<AttachmentInput>>;
  /** Nature of the relationship to the patient */
  relationship?: InputMaybe<Array<CodeableConceptInput>>;
  /** FHIR resource type, always RelatedPerson */
  resourceType?: InputMaybe<Scalars['String']['input']>;
  /** Contact details for the related person */
  telecom?: InputMaybe<Array<ContactPointInput>>;
  /** Text */
  text?: InputMaybe<NarrativeInput>;
};

export type Repeat = {
  __typename?: 'Repeat';
  /** Bounds duration */
  boundsDuration?: Maybe<Quantity>;
  /** Bounds period */
  boundsPeriod?: Maybe<Period>;
  /** Bounds range */
  boundsRange?: Maybe<Range>;
  /** Number of times to repeat */
  count?: Maybe<Scalars['Float']['output']>;
  /** Maximum number of times to repeat */
  countMax?: Maybe<Scalars['Float']['output']>;
  /** mon | tue | wed | thu | fri | sat | sun */
  dayOfWeek?: Maybe<Array<Maybe<DayOfWeek>>>;
  /** How long when it happens */
  duration?: Maybe<Scalars['Float']['output']>;
  /** How long when it happens (Max) */
  durationMax?: Maybe<Scalars['Float']['output']>;
  /** s | min | h | d | wk | mo | a - unit of time (UCUM) */
  durationUnit?: Maybe<Scalars['String']['output']>;
  /** Extension */
  extension?: Maybe<Array<Maybe<Extension>>>;
  /** Indicates the number of repetitions that should occur within a period. I.e. Event occurs frequency times per period */
  frequency?: Maybe<Scalars['Float']['output']>;
  /** Event occurs up to frequencyMax times per period */
  frequencyMax?: Maybe<Scalars['Float']['output']>;
  /** Minutes from event (before or after) */
  offset?: Maybe<Scalars['Float']['output']>;
  /** The duration to which the frequency applies. I.e. Event occurs frequency times per period */
  period?: Maybe<Scalars['Float']['output']>;
  /** Upper limit of period (3-4 hours) */
  periodMax?: Maybe<Scalars['Float']['output']>;
  /** s | min | h | d | wk | mo | a - unit of time (UCUM) */
  periodUnit?: Maybe<Scalars['String']['output']>;
  /** Time of day for action */
  timeOfDay?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** (Code[]) EventTiming codes: MORN | AFT | EVE | HS | AC | PC etc. */
  when?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type RepeatInput = {
  /** Bounds duration */
  boundsDuration?: InputMaybe<QuantityInput>;
  /** Bounds period */
  boundsPeriod?: InputMaybe<PeriodInput>;
  /** Bounds range */
  boundsRange?: InputMaybe<RangeInput>;
  /** Number of times to repeat */
  count?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum number of times to repeat */
  countMax?: InputMaybe<Scalars['Float']['input']>;
  /** mon | tue | wed | thu | fri | sat | sun */
  dayOfWeek?: InputMaybe<Array<InputMaybe<DayOfWeek>>>;
  /** How long when it happens */
  duration?: InputMaybe<Scalars['Float']['input']>;
  /** How long when it happens (Max) */
  durationMax?: InputMaybe<Scalars['Float']['input']>;
  /** s | min | h | d | wk | mo | a - unit of time (UCUM) */
  durationUnit?: InputMaybe<Scalars['String']['input']>;
  /** Extension */
  extension?: InputMaybe<Array<InputMaybe<ExtensionInput>>>;
  /** Indicates the number of repetitions that should occur within a period. I.e. Event occurs frequency times per period */
  frequency?: InputMaybe<Scalars['Float']['input']>;
  /** Event occurs up to frequencyMax times per period */
  frequencyMax?: InputMaybe<Scalars['Float']['input']>;
  /** Minutes from event (before or after) */
  offset?: InputMaybe<Scalars['Float']['input']>;
  /** The duration to which the frequency applies. I.e. Event occurs frequency times per period */
  period?: InputMaybe<Scalars['Float']['input']>;
  /** Upper limit of period (3-4 hours) */
  periodMax?: InputMaybe<Scalars['Float']['input']>;
  /** s | min | h | d | wk | mo | a - unit of time (UCUM) */
  periodUnit?: InputMaybe<Scalars['String']['input']>;
  /** Time of day for action */
  timeOfDay?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** (Code[]) EventTiming codes: MORN | AFT | EVE | HS | AC | PC etc. */
  when?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Resource = {
  __typename?: 'Resource';
  /** Logical id of this artifact */
  id?: Maybe<Scalars['String']['output']>;
  /** A set of rules under which this content was created */
  implicitRules?: Maybe<Scalars['String']['output']>;
  /** Language of the resource content */
  language?: Maybe<Scalars['String']['output']>;
  /** Metadata about the resource */
  meta?: Maybe<Meta>;
  /** The FHIR resource type, e.g. Patient, Observation, etc. */
  resourceType?: Maybe<Scalars['String']['output']>;
};

export type ResourceAssociationInput = {
  /** Resource identifiers to associate with the resource, each in the format <resourceType>/<resourceId> */
  associations: Array<Scalars['String']['input']>;
  /** Resource identifier having associations attached to it, in the format <resourceType>/<resourceId> */
  resource: Scalars['String']['input'];
};

export type ResourceAssociationUnion = AllergyModel | AppointmentModel | ConditionModel | CoverageModel | DiagnosticReportModel | EncounterModel | FamilyMemberHistoryModel | ImmunizationModel | MedicationStatementModel | ObservationModel | ProcedureModel | TaskModel;

export type ResourceInput = {
  /** Logical id of this artifact */
  id?: InputMaybe<Scalars['String']['input']>;
  /** A set of rules under which this content was created */
  implicitRules?: InputMaybe<Scalars['String']['input']>;
  /** Language of the resource content */
  language?: InputMaybe<Scalars['String']['input']>;
  /** Metadata about the resource */
  meta?: InputMaybe<MetaInput>;
  /** The FHIR resource type, e.g. Patient, Observation, etc. */
  resourceType?: InputMaybe<Scalars['String']['input']>;
};

/** ResourceModel */
export type ResourceModel = {
  __typename?: 'ResourceModel';
  /** Clinically relevant date of the resource */
  date?: Maybe<Scalars['DateTime']['output']>;
  /** Human-readable display name for the resource */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Identifier of the patient this resource belongs to */
  patient_id: Scalars['String']['output'];
  /** Display category or record subtype for the resource */
  recordType?: Maybe<Scalars['String']['output']>;
  /** Unique identifier of the resource model */
  resource_model_id: Scalars['String']['output'];
  /** FHIR resource type name for this record */
  resource_name: Scalars['String']['output'];
  /** Route of administration, when applicable */
  route?: Maybe<Scalars['String']['output']>;
  /** Whether the record was self-reported by the patient */
  selfReported?: Maybe<Scalars['Boolean']['output']>;
  /** Origin of the resource, such as EMR or patient-reported */
  source_type: ResourceSourceType;
  /** Curation status of the resource */
  status: Scalars['String']['output'];
};

export type ResourceModelInput = {
  /** Clinically relevant date of the resource */
  date?: InputMaybe<Scalars['DateTime']['input']>;
  /** Human-readable display name for the resource */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** Identifier of the patient this resource belongs to */
  patient_id: Scalars['String']['input'];
  /** Display category or record subtype for the resource */
  recordType?: InputMaybe<Scalars['String']['input']>;
  /** Unique identifier of the resource model */
  resource_model_id: Scalars['String']['input'];
  /** FHIR resource type name for this record */
  resource_name: Scalars['String']['input'];
  /** Route of administration, when applicable */
  route?: InputMaybe<Scalars['String']['input']>;
  /** Whether the record was self-reported by the patient */
  selfReported?: InputMaybe<Scalars['Boolean']['input']>;
  /** Origin of the resource, such as EMR or patient-reported */
  source_type: ResourceSourceType;
  /** Curation status of the resource */
  status: Scalars['String']['input'];
};

export enum ResourceSourceType {
  device = 'device',
  discern = 'discern',
  emr = 'emr',
  network = 'network',
  pdf = 'pdf',
  scan = 'scan',
  self = 'self'
}

export type RespondToAuthChallengeInput = {
  /** Identity provider challenge name to respond to */
  challengeName: Scalars['String']['input'];
  /** Responses required by the auth challenge */
  challengeResponses: Scalars['JSON']['input'];
};

export type Restriction = {
  __typename?: 'Restriction';
  /** Period */
  period?: Maybe<Period>;
  /** Recipient */
  recipient?: Maybe<Array<Reference>>;
  /** Repetitions */
  repetitions?: Maybe<Scalars['Float']['output']>;
};

export type RestrictionInput = {
  /** Period */
  period?: InputMaybe<PeriodInput>;
  /** Recipient */
  recipient?: InputMaybe<Array<ReferenceInput>>;
  /** Repetitions */
  repetitions?: InputMaybe<Scalars['Float']['input']>;
};

export type ReviewEhrPatientLinkInput = {
  decision: EhrPatientReviewDecision;
  /** Required for Approve; MUST be one of the case's candidates. */
  external_patient_id?: InputMaybe<Scalars['String']['input']>;
  link_id: Scalars['String']['input'];
};

export type RevokeShareAuthInput = {
  /** Recipient email whose share access to revoke */
  recipient: Scalars['String']['input'];
  /** Identifier of the share to revoke access from */
  share_id: Scalars['String']['input'];
};

export type RevokeShareAuthResponse = {
  __typename?: 'RevokeShareAuthResponse';
  /** Whether share access was revoked successfully */
  success: Scalars['Boolean']['output'];
};

/** RiskAssessmentModel */
export type RiskAssessmentModel = {
  __typename?: 'RiskAssessmentModel';
  associatedResources?: Maybe<Array<ResourceAssociationUnion>>;
  attachments?: Maybe<Array<Attachment>>;
  /** Request fulfilled by this assessment */
  basedOn?: Maybe<Reference>;
  /** Information used in the assessment */
  basis?: Maybe<Array<Reference>>;
  /** Type of assessment performed */
  code?: Maybe<CodeableConcept>;
  /** Condition assessed */
  condition?: Maybe<Reference>;
  /** Contained */
  contained?: Maybe<Array<Resource>>;
  displayName?: Maybe<Scalars['String']['output']>;
  /** Encounter where the assessment was performed */
  encounter?: Maybe<Reference>;
  /** Extension */
  extension?: Maybe<Array<Extension>>;
  /** Logical id of this artifact */
  id?: Maybe<Scalars['String']['output']>;
  /** Unique identifiers for the assessment */
  identifier?: Maybe<Array<Identifier>>;
  /** A set of rules under which this content was created */
  implicitRules?: Maybe<Scalars['String']['output']>;
  /** Language of the resource content */
  language?: Maybe<Scalars['String']['output']>;
  /** Metadata about the resource */
  meta?: Maybe<Meta>;
  /** Evaluation mechanism used */
  method?: Maybe<CodeableConcept>;
  /** How to reduce the identified risk */
  mitigation?: Maybe<Scalars['String']['output']>;
  /** Comments on the risk assessment */
  note?: Maybe<Array<Annotation>>;
  /** FHIR Observations referenced by the risk assessment basis */
  observations?: Maybe<Array<ObservationModel>>;
  /** When the assessment was made, as a date-time */
  occurrenceDateTime?: Maybe<Scalars['String']['output']>;
  /** When the assessment was made, as a period */
  occurrencePeriod?: Maybe<Period>;
  /** Occurrence this assessment is part of */
  parent?: Maybe<Reference>;
  /** Who performed the assessment (Practitioner, Patient, Device, etc.) */
  performer?: Maybe<Reference>;
  /** Predicted outcomes for the subject */
  prediction?: Maybe<Array<RiskAssessmentPredictionModel>>;
  /** Why the assessment was necessary */
  reason?: Maybe<Array<CodeableReference>>;
  /** FHIR resource type, always RiskAssessment */
  resourceType?: Maybe<Scalars['String']['output']>;
  /** Status of the risk assessment (e.g. registered, preliminary, final) */
  status: Scalars['String']['output'];
  /** Who/what the assessment applies to (Patient or Group) */
  subject: Reference;
  /** Text */
  text?: Maybe<Narrative>;
};

/** RiskAssessmentPredictionModel */
export type RiskAssessmentPredictionModel = {
  __typename?: 'RiskAssessmentPredictionModel';
  /** Possible outcome for the subject */
  outcome?: Maybe<CodeableConcept>;
  /** Likelihood of the outcome as a decimal probability */
  probabilityDecimal?: Maybe<Scalars['Float']['output']>;
  /** Likelihood of the outcome as a probability range */
  probabilityRange?: Maybe<Range>;
  /** Likelihood of specified outcome as a qualitative value */
  qualitativeRisk?: Maybe<CodeableConcept>;
  /** Explanation of the prediction */
  rationale?: Maybe<Scalars['String']['output']>;
  /** Relative likelihood of the outcome */
  relativeRisk?: Maybe<Scalars['Float']['output']>;
  /** Timeframe or age range for the predicted outcome */
  when?: Maybe<RiskAssessmentWhenModel>;
};

/** RiskAssessmentWhenModel */
export type RiskAssessmentWhenModel = {
  __typename?: 'RiskAssessmentWhenModel';
  /** Timeframe over which the risk is quantified */
  whenPeriod?: Maybe<Period>;
  /** Age range over which the risk is quantified */
  whenRange?: Maybe<Range>;
};

/** RoleModel */
export type RoleModel = {
  __typename?: 'RoleModel';
  /** Timestamp when the role was created */
  created_at: Scalars['DateTime']['output'];
  /** Identifier of the user who created the role */
  created_user_id?: Maybe<Scalars['String']['output']>;
  /** Policies granted to this role */
  policies?: Maybe<Array<PolicyModel>>;
  /** Ordering rank of the role within its scope */
  rank?: Maybe<Scalars['Int']['output']>;
  /** Detailed description of the role */
  role_description: Scalars['String']['output'];
  /** Unique identifier of the role */
  role_id: Scalars['String']['output'];
  /** Human-readable name of the role */
  role_name: Scalars['String']['output'];
  /** Account type scope the role applies to */
  scope?: Maybe<AccountType>;
  /** Timestamp when the role was last updated */
  updated_at: Scalars['DateTime']['output'];
};

export enum RoleName {
  AccountAdmin = 'AccountAdmin',
  Admin = 'Admin',
  Client = 'Client',
  Curator = 'Curator',
  CuratorAdmin = 'CuratorAdmin',
  MarketingAdmin = 'MarketingAdmin',
  OrgAdmin = 'OrgAdmin',
  Patient = 'Patient',
  Practitioner = 'Practitioner',
  Registrar = 'Registrar',
  SysAdmin = 'SysAdmin',
  User = 'User'
}

export type RolePolicyInput = {
  /** Identifier of the policy to fetch */
  policy_id: Scalars['String']['input'];
  /** Identifier of the role to associate with the policy */
  role_id: Scalars['String']['input'];
};

/** RoutineInstanceStatusModel */
export type RoutineInstanceStatusModel = {
  __typename?: 'RoutineInstanceStatusModel';
  /** Timestamp when the status record was created */
  created_at?: Maybe<Scalars['DateTime']['output']>;
  /** Identifier of the routine instance */
  instance_id?: Maybe<Scalars['String']['output']>;
  /** Current status of the routine instance */
  status?: Maybe<Scalars['String']['output']>;
  /** Identifier of the routine task */
  task_id?: Maybe<Scalars['String']['output']>;
  /** Timestamp when the status record was last updated */
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  /** Vitall patient identifier for the routine instance status */
  vitall_patient_id?: Maybe<Scalars['String']['output']>;
};

export type RoutineInstanceStatusModelInput = {
  /** Timestamp when the status record was created */
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  /** Identifier of the routine instance */
  instance_id?: InputMaybe<Scalars['String']['input']>;
  /** Current status of the routine instance */
  status?: InputMaybe<Scalars['String']['input']>;
  /** Identifier of the routine task */
  task_id?: InputMaybe<Scalars['String']['input']>;
  /** Timestamp when the status record was last updated */
  updated_at?: InputMaybe<Scalars['DateTime']['input']>;
  /** Vitall patient identifier for the routine instance status */
  vitall_patient_id?: InputMaybe<Scalars['String']['input']>;
};

export type S3AssetModel = {
  __typename?: 'S3AssetModel';
  /** Content type of the S3 object */
  contentType: Scalars['String']['output'];
  /** ID of the binary resource */
  id: Scalars['String']['output'];
  /** A set of rules under which this content was created */
  implicitRules?: Maybe<Scalars['String']['output']>;
  /** Language of the resource content */
  language?: Maybe<Scalars['String']['output']>;
  /** Metadata about the resource */
  meta?: Maybe<Meta>;
  /** A presigned URL to download the object */
  presignedGetUrl?: Maybe<Scalars['String']['output']>;
  /** A presigned URL to upload the object */
  presignedPutUrl?: Maybe<Scalars['String']['output']>;
  /**
   * The content type of the S3 object
   * @deprecated Not using binaries to store document references any more
   */
  resourceType?: Maybe<Scalars['String']['output']>;
};

export type SampleData = {
  __typename?: 'SampleData';
  /** Data */
  data?: Maybe<Scalars['String']['output']>;
  /** Dimensions */
  dimensions?: Maybe<Scalars['Float']['output']>;
  /** Factor */
  factor?: Maybe<Scalars['Float']['output']>;
  /** Lower limit */
  lowerLimit?: Maybe<Scalars['Float']['output']>;
  /** Origin */
  origin: Quantity;
  /** Period */
  period: Scalars['Float']['output'];
  /** Upper limit */
  upperLimit?: Maybe<Scalars['Float']['output']>;
};

export type SampleDataInput = {
  /** Data */
  data?: InputMaybe<Scalars['String']['input']>;
  /** Dimensions */
  dimensions?: InputMaybe<Scalars['Float']['input']>;
  /** Factor */
  factor?: InputMaybe<Scalars['Float']['input']>;
  /** Lower limit */
  lowerLimit?: InputMaybe<Scalars['Float']['input']>;
  /** Origin */
  origin: QuantityInput;
  /** Period */
  period: Scalars['Float']['input'];
  /** Upper limit */
  upperLimit?: InputMaybe<Scalars['Float']['input']>;
};

export type SampledData = {
  __typename?: 'SampledData';
  /** Decimal values with spaces, or "E" | "U" | "L" */
  data?: Maybe<Scalars['String']['output']>;
  /** Number of sample points at each time point */
  dimensions: Scalars['Float']['output'];
  /** Multiply data by this before adding to origin */
  factor?: Maybe<Scalars['Float']['output']>;
  /** Lower limit of detection */
  lowerLimit?: Maybe<Scalars['Float']['output']>;
  /** Zero value and units */
  origin: Quantity;
  /** Number of milliseconds between samples */
  period: Scalars['Float']['output'];
  /** Upper limit of detection */
  upperLimit?: Maybe<Scalars['Float']['output']>;
};

export type SampledDataInput = {
  /** Decimal values with spaces, or "E" | "U" | "L" */
  data?: InputMaybe<Scalars['String']['input']>;
  /** Number of sample points at each time point */
  dimensions: Scalars['Float']['input'];
  /** Multiply data by this before adding to origin */
  factor?: InputMaybe<Scalars['Float']['input']>;
  /** Lower limit of detection */
  lowerLimit?: InputMaybe<Scalars['Float']['input']>;
  /** Zero value and units */
  origin: QuantityInput;
  /** Number of milliseconds between samples */
  period: Scalars['Float']['input'];
  /** Upper limit of detection */
  upperLimit?: InputMaybe<Scalars['Float']['input']>;
};

export type SaveCustomPlansInput = {
  account_id: Scalars['String']['input'];
  /**
   * Wholesale replace: plans absent here are deleted; array order becomes
   * display order. Nullable for the same frontend serialisation reason as
   * CustomPlanInput.feature_ids — deleting the last plan submits null.
   */
  plans?: InputMaybe<Array<CustomPlanInput>>;
};

export type ScanAppConnection = {
  __typename?: 'ScanAppConnection';
  /** Name of the connected scan integration */
  integration: Scalars['String']['output'];
  /** When the integration was last updated */
  last_updated: Scalars['DateTime']['output'];
};

/** Patient demographics needed to perform a face/body scan */
export type ScanProfile = {
  __typename?: 'ScanProfile';
  /** Patient's age in years */
  age: Scalars['Float']['output'];
  /** Patient's first name */
  first_name: Scalars['String']['output'];
  /** Whether the patient takes blood pressure medication */
  has_blood_pressure_medication?: Maybe<Scalars['Boolean']['output']>;
  /** Patient's height */
  height?: Maybe<Scalars['Float']['output']>;
  /** Unit of measure for the patient's height */
  height_denomination?: Maybe<Scalars['String']['output']>;
  /** Whether the patient is diabetic */
  is_diabetic?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the patient is hypertensive */
  is_hypertensive?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the patient is a smoker */
  is_smoker?: Maybe<Scalars['Boolean']['output']>;
  /** Patient's last name */
  last_name: Scalars['String']['output'];
  /** FHIR patient id */
  patient_id: Scalars['String']['output'];
  /** Users permitted to run scans for this patient */
  permissible_users: Array<Scalars['String']['output']>;
  /** Patient's biological sex */
  sex?: Maybe<Scalars['String']['output']>;
  /** Smoker status: 0=Current, 1=Former, 2=Never */
  smoker_status?: Maybe<Scalars['Int']['output']>;
  /** Patient's weight */
  weight?: Maybe<Scalars['Float']['output']>;
  /** Unit of measure for the patient's weight */
  weight_denomination?: Maybe<Scalars['String']['output']>;
};

export type ScanProfileDemographicsInput = {
  /** Whether the patient takes blood pressure medication */
  has_blood_pressure_medication?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the patient is diabetic */
  is_diabetic?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the patient is hypertensive */
  is_hypertensive?: InputMaybe<Scalars['Boolean']['input']>;
  /** 0=Current, 1=Former, 2=Never */
  is_smoker?: InputMaybe<Scalars['Int']['input']>;
};

export type ScanResultModel = {
  __typename?: 'ScanResultModel';
  /** Attachment from a respiratory or skin scan observation */
  attachment?: Maybe<Attachment>;
  /** Cough scan results, present for respiratory scans */
  cough_results?: Maybe<CoughScanResultModel>;
  /** Date the scan was performed */
  date: Scalars['DateTime']['output'];
  /** FHIR patient id linked to the scan result */
  fhir_patient_id?: Maybe<Scalars['String']['output']>;
  /** ID of observation resource containing the image */
  observation_id?: Maybe<Scalars['String']['output']>;
  /** FHIR observations for a face or body scan result */
  observations?: Maybe<Array<ObservationModel>>;
  /** Unique id of the scan result */
  result_id: Scalars['String']['output'];
  /** Type of scan performed */
  scan_type: ScanType;
  /** Body site of the lesion for a skin scan result */
  skin_lesion_location?: Maybe<Scalars['String']['output']>;
  /** Skin scan results, present for skin scans */
  skin_results?: Maybe<SkinScanResultModel>;
  /** The patient the scan result belongs to */
  vitall_patient?: Maybe<VitallPatientModel>;
  /** Vitall patient id for the scan result */
  vitall_patient_id: Scalars['String']['output'];
};

export enum ScanType {
  bha = 'bha',
  body = 'body',
  face = 'face',
  respiratory = 'respiratory',
  skin = 'skin'
}

export type SendAlertSettingCodeInput = {
  /** Account identifier the alert recipient setting applies to */
  account_id?: InputMaybe<Scalars['String']['input']>;
  /** Delivery channel used to send the verification code */
  delivery_method: VerifyDeliveryMethod;
  /** Email address or phone number to send the verification code to */
  destination: Scalars['String']['input'];
  /** User identifier the alert recipient setting applies to */
  user_id?: InputMaybe<Scalars['String']['input']>;
};

export type SendDisableEnableUserEmailInput = {
  /** Email address of the user being disabled or enabled */
  email: Scalars['String']['input'];
  /** Message explaining the enable or disable request */
  message: Scalars['String']['input'];
};

export type SendEnableUserEmailInput = {
  /** Email address of the user to reactivate */
  email: Scalars['String']['input'];
};

export type SendFeedbackEmailInput = {
  /** Email address of the user being disabled or enabled */
  email: Scalars['String']['input'];
  /** Message explaining the enable or disable request */
  message: Scalars['String']['input'];
  /** Name of the person submitting the feedback */
  name: Scalars['String']['input'];
  /** Category of the feedback email */
  type?: InputMaybe<FeedbackEmailType>;
};

export type SendGroupInviteInput = {
  /** Group to send invitations for */
  group_id: Scalars['String']['input'];
};

export type SendRecordReportedEmailInput = {
  /** Message body describing the reported record */
  message: Scalars['String']['input'];
  /** Content of the task generated for the report */
  taskContent: Scalars['String']['input'];
  /** Type of record update being reported */
  type: Scalars['String']['input'];
  /** ID of the user reporting the record */
  user_id: Scalars['String']['input'];
};

export type SendSmsMfaCodeInput = {
  /** Phone number to receive the SMS MFA code */
  phoneNumber: Scalars['String']['input'];
};

export type SetBulkResourceViewedStatusInput = {
  /** Category to filter records by */
  category?: InputMaybe<Scalars['String']['input']>;
  /** Identifier of the patient whose records to update */
  patient_id: Scalars['String']['input'];
  /** Start of the published-on date range filter */
  published_on_from?: InputMaybe<Scalars['DateTime']['input']>;
  /** End of the published-on date range filter */
  published_on_to?: InputMaybe<Scalars['DateTime']['input']>;
  /** FHIR resource type to filter records by */
  resource_name?: InputMaybe<Scalars['String']['input']>;
};

export type SetDocumentsUploadedInput = {
  /** Documents to mark as uploaded */
  documents: Array<UploadClientRecordsModelInput>;
};

export type SetEhrPatientLinkPausedInput = {
  link_id: Scalars['String']['input'];
  paused: Scalars['Boolean']['input'];
};

export type SetPolicyPermissionsInput = {
  /** Permission settings to set on the policy */
  permissions: Array<PermissionSetting>;
  /** Identifier of the policy to fetch */
  policy_id: Scalars['String']['input'];
};

export type SetPreferredMfaInput = {
  /** Preferred MFA method to set */
  preferredMethod: MfaMethod;
};

export type SetResourceViewedStatusInput = {
  /** FHIR resource reference to mark as viewed or unviewed */
  resource: Scalars['String']['input'];
  /** Whether the resource has been viewed */
  viewed: Scalars['Boolean']['input'];
};

export enum ShareType {
  BodyScans = 'BodyScans',
  Body_bloodSugar = 'Body_bloodSugar',
  Body_bodyChestCm = 'Body_bodyChestCm',
  Body_bodyFatPercentage = 'Body_bodyFatPercentage',
  Body_bodyHeight = 'Body_bodyHeight',
  Body_bodyHipsCm = 'Body_bodyHipsCm',
  Body_bodyMassIndex = 'Body_bodyMassIndex',
  Body_bodyThighCm = 'Body_bodyThighCm',
  Body_bodyWaistCm = 'Body_bodyWaistCm',
  Body_bodyWaistHeight = 'Body_bodyWaistHeight',
  Body_bodyWaistHip = 'Body_bodyWaistHip',
  Body_bodyWeight = 'Body_bodyWeight',
  Body_muscleMass = 'Body_muscleMass',
  CoughScans = 'CoughScans',
  DailyStats_averageHeartRate = 'DailyStats_averageHeartRate',
  DailyStats_distance = 'DailyStats_distance',
  DailyStats_energyBurned = 'DailyStats_energyBurned',
  DailyStats_restingHeartRate = 'DailyStats_restingHeartRate',
  DailyStats_steps = 'DailyStats_steps',
  DigitalHealthAssessment = 'DigitalHealthAssessment',
  FaceScans = 'FaceScans',
  GeneticInformation = 'GeneticInformation',
  HealthSummary = 'HealthSummary',
  Immunizations = 'Immunizations',
  LabResults = 'LabResults',
  Medications = 'Medications',
  SingleResource = 'SingleResource',
  SkinScans = 'SkinScans',
  Sleep_averageHeartRate = 'Sleep_averageHeartRate',
  Sleep_sleepDuration = 'Sleep_sleepDuration',
  Sleep_sleepScore = 'Sleep_sleepScore',
  Timeline = 'Timeline',
  VitalSigns_bloodPressure = 'VitalSigns_bloodPressure',
  VitalSigns_hrv = 'VitalSigns_hrv',
  VitalSigns_oxygenSaturation = 'VitalSigns_oxygenSaturation',
  VitalSigns_pain = 'VitalSigns_pain',
  VitalSigns_pulse = 'VitalSigns_pulse',
  VitalSigns_respiration = 'VitalSigns_respiration',
  VitalSigns_temperature = 'VitalSigns_temperature'
}

export type SharedAssessmentObservationModel = {
  __typename?: 'SharedAssessmentObservationModel';
  /** Categories classifying the observation */
  category?: Maybe<Array<CodeableConcept>>;
  /** Code identifying what was observed */
  code?: Maybe<CodeableConcept>;
  /** Component sub-observations of this observation */
  component?: Maybe<Array<Maybe<ObservationComponent>>>;
  /** FHIR Observation resource id */
  id?: Maybe<Scalars['String']['output']>;
  /** FHIR resource type of the observation */
  resourceType?: Maybe<Scalars['String']['output']>;
  /** Status of the observation */
  status?: Maybe<Scalars['String']['output']>;
  /** Measured value of the observation as an integer */
  valueInteger?: Maybe<Scalars['Int']['output']>;
  /** Measured value of the observation as a quantity */
  valueQuantity?: Maybe<Quantity>;
};

export type SharedAssessmentProfileModel = {
  __typename?: 'SharedAssessmentProfileModel';
  /** Patient age used for reference ranges */
  age?: Maybe<Scalars['Int']['output']>;
  /** Patient height used for reference ranges */
  height?: Maybe<Scalars['Float']['output']>;
  /** Unit of measure for the height value */
  height_denomination?: Maybe<Scalars['String']['output']>;
  /** Patient sex used for reference ranges */
  sex?: Maybe<Scalars['String']['output']>;
  /** Patient smoker status used for reference ranges */
  smoker_status?: Maybe<Scalars['Int']['output']>;
  /** Patient weight used for reference ranges */
  weight?: Maybe<Scalars['Float']['output']>;
  /** Unit of measure for the weight value */
  weight_denomination?: Maybe<Scalars['String']['output']>;
};

export type SharedAssessmentResultModel = {
  __typename?: 'SharedAssessmentResultModel';
  /** Identifier of the completed assessment */
  assessment_id: Scalars['String']['output'];
  /** When the assessment was completed */
  completed_at?: Maybe<Scalars['DateTime']['output']>;
  /** Suggested filename for the exported report */
  export_filename?: Maybe<Scalars['String']['output']>;
  /** Short-lived presigned URL for this assessment's report PDF. Resolved server-side from the DocumentReference of this share's own risk assessment, so the recipient never receives an S3 key. */
  export_url?: Maybe<Scalars['String']['output']>;
  /** Patient demographics needed to render reference ranges */
  profile?: Maybe<SharedAssessmentProfileModel>;
  /** Synthetic discriminator identifying the shared result type */
  resourceType?: Maybe<Scalars['String']['output']>;
  /** Risk assessment behind the shared result */
  risk_assessment?: Maybe<SharedRiskAssessmentModel>;
};

export type SharedResourceHistory = {
  __typename?: 'SharedResourceHistory';
  /** When this share was created */
  created_at: Scalars['DateTime']['output'];
  /** When the share link expires, if set */
  expires?: Maybe<Scalars['DateTime']['output']>;
  /** Patient user the shared resource belongs to */
  patient_user?: Maybe<UserModel>;
  /** Email address of the share recipient */
  recipient_email: Scalars['String']['output'];
  /** Vitall id of the share recipient */
  recipient_id: Scalars['String']['output'];
  /** Formatted as `{resource_name}/{resource_id}` */
  record: Scalars['String']['output'];
  /** Resolved FHIR resource or collection being shared */
  resource: SharedResourceModel;
  /** Identifier of the share record */
  share_id: Scalars['String']['output'];
  /** Formatted as `{FRONTEND_URL}/shared?share_id={share_link}` */
  share_link: Scalars['String']['output'];
  /** Status of the shared resource record */
  status: StatusModel;
  /** Current status of the share */
  status_id: Scalars['String']['output'];
  /** Vitall patient id that owns the shared resource */
  vitall_patient_id?: Maybe<Scalars['String']['output']>;
};

export type SharedResourceModel = {
  __typename?: 'SharedResourceModel';
  /** Display name of the shared resource */
  name: Scalars['String']['output'];
  /** Frontend route to open the shared resource */
  route: Scalars['String']['output'];
};

export type SharedRiskAssessmentModel = {
  __typename?: 'SharedRiskAssessmentModel';
  /** FHIR extensions on the risk assessment */
  extension?: Maybe<Array<Extension>>;
  /** FHIR RiskAssessment resource id */
  id?: Maybe<Scalars['String']['output']>;
  /** Method used to compute the risk assessment */
  method?: Maybe<CodeableConcept>;
  /** Sanitised observations backing the risk assessment */
  observations?: Maybe<Array<SharedAssessmentObservationModel>>;
  /** When the risk assessment was performed */
  occurrenceDateTime?: Maybe<Scalars['String']['output']>;
  /** Predicted outcomes from the risk assessment */
  prediction?: Maybe<Array<RiskAssessmentPredictionModel>>;
  /** FHIR resource type of the risk assessment */
  resourceType?: Maybe<Scalars['String']['output']>;
  /** Status of the risk assessment */
  status?: Maybe<Scalars['String']['output']>;
};

export type SharedScanResultModel = {
  __typename?: 'SharedScanResultModel';
  /** For skin only atm, will apply to cough in the future */
  attachment?: Maybe<Attachment>;
  /** Cough scan results, present for respiratory scans */
  cough_results?: Maybe<CoughScanResultModel>;
  /** Date the scan was performed */
  date: Scalars['DateTime']['output'];
  /** FHIR patient id linked to the scan result */
  fhir_patient_id?: Maybe<Scalars['String']['output']>;
  /** ID of observation resource containing the image */
  observation_id?: Maybe<Scalars['String']['output']>;
  /** For face and body */
  observations?: Maybe<Array<ObservationModel>>;
  /** Synthetic discriminator identifying the shared scan type */
  resourceType?: Maybe<Scalars['String']['output']>;
  /** Unique id of the scan result */
  result_id: Scalars['String']['output'];
  /** Type of scan performed */
  scan_type: ScanType;
  /** Body site of the lesion for a skin scan result */
  skin_lesion_location?: Maybe<Scalars['String']['output']>;
  /** Skin scan results, present for skin scans */
  skin_results?: Maybe<SkinScanResultModel>;
  /** The patient the scan result belongs to */
  vitall_patient?: Maybe<VitallPatientModel>;
  /** Vitall patient id for the scan result */
  vitall_patient_id: Scalars['String']['output'];
};

export type SharingAssociationUnion = AllergyModel | AppointmentModel | ConditionModel | ConsentModel | CoverageModel | DiagnosticReportModel | EncounterModel | FamilyMemberHistoryModel | ImmunizationModel | MedicationStatementModel | ObservationModel | PatientModel | ProcedureModel | RelatedPersonModel | SharedAssessmentResultModel | SharedScanResultModel;

export type Signature = {
  __typename?: 'Signature';
  /** Data */
  data?: Maybe<Scalars['String']['output']>;
  /** On behalf of */
  onBehalfOf?: Maybe<Reference>;
  /** Sig format */
  sigFormat?: Maybe<Scalars['String']['output']>;
  /** Target format */
  targetFormat?: Maybe<Scalars['String']['output']>;
  /** Indication of the reason the entity signed the object(s) */
  type?: Maybe<Array<Coding>>;
  /** When */
  when?: Maybe<Scalars['String']['output']>;
  /** Who */
  who?: Maybe<Reference>;
};

export type SignatureInput = {
  /** Data */
  data?: InputMaybe<Scalars['String']['input']>;
  /** On behalf of */
  onBehalfOf?: InputMaybe<ReferenceInput>;
  /** Sig format */
  sigFormat?: InputMaybe<Scalars['String']['input']>;
  /** Target format */
  targetFormat?: InputMaybe<Scalars['String']['input']>;
  /** Indication of the reason the entity signed the object(s) */
  type?: InputMaybe<Array<CodingInput>>;
  /** When */
  when?: InputMaybe<Scalars['String']['input']>;
  /** Who */
  who?: InputMaybe<ReferenceInput>;
};

export type SkinLesionModel = {
  __typename?: 'SkinLesionModel';
  /** Probability score for the lesion risk */
  probability?: Maybe<Scalars['Float']['output']>;
  /** Risk classification for the skin lesion */
  risk: Scalars['String']['output'];
};

export type SkinScanResultModel = {
  __typename?: 'SkinScanResultModel';
  /** Individual lesions detected in the skin scan */
  lesions: Array<SkinLesionModel>;
  /** Overall skin cancer risk assessment */
  overall_risk: Scalars['String']['output'];
};

export type Sort = {
  __typename?: 'Sort';
  /** Direction */
  direction?: Maybe<Scalars['String']['output']>;
  /** Path */
  path?: Maybe<Scalars['String']['output']>;
};

export type SortInput = {
  /** Direction */
  direction?: InputMaybe<Scalars['String']['input']>;
  /** Path */
  path?: InputMaybe<Scalars['String']['input']>;
};

export type Stage = {
  __typename?: 'Stage';
  /** Assessment */
  assessment?: Maybe<Array<Reference>>;
  /** Summary */
  summary: CodeableConcept;
  /** Type */
  type: CodeableConcept;
};

export type StageInput = {
  /** Assessment */
  assessment?: InputMaybe<Array<ReferenceInput>>;
  /** Summary */
  summary: CodeableConceptInput;
  /** Type */
  type: CodeableConceptInput;
};

export type StartAutoCurationInput = {
  /** FHIR Binary resource ID of the source file */
  binary_id?: InputMaybe<Scalars['String']['input']>;
  /** Multipart upload details for the source file */
  multipartUploadInfo?: InputMaybe<MultipartUploadModelInput>;
  /** Page groups to curate, each a list of page numbers */
  pageGroups: Array<Array<Scalars['Int']['input']>>;
  /** Optional session identifier for the curation run */
  session_id?: InputMaybe<Scalars['String']['input']>;
  /** Vitall patient to run auto-curation for */
  vitall_patient_id: Scalars['String']['input'];
};

export enum StatementStatus {
  active = 'active',
  completed = 'completed',
  enteredInError = 'enteredInError',
  intended = 'intended',
  notTaken = 'notTaken',
  onHold = 'onHold',
  stopped = 'stopped',
  unknown = 'unknown'
}

export enum StatusCode {
  arrived = 'arrived',
  booked = 'booked',
  cancelled = 'cancelled',
  checkedIn = 'checkedIn',
  enteredInError = 'enteredInError',
  fulfilled = 'fulfilled',
  noshow = 'noshow',
  pending = 'pending',
  proposed = 'proposed',
  waitlist = 'waitlist'
}

export type StatusHistory = {
  __typename?: 'StatusHistory';
  /** Time the episode was in the specified status */
  period: Period;
  /** Encounter status during this historical period */
  status: EncounterHistoryStatus;
};

export type StatusHistoryInput = {
  /** Time the episode was in the specified status */
  period: PeriodInput;
  /** Encounter status during this historical period */
  status: EncounterHistoryStatus;
};

export type StatusModel = {
  __typename?: 'StatusModel';
  /** Status color */
  color?: Maybe<Scalars['String']['output']>;
  /** Whether the status is internal-use only or not */
  internal: Scalars['Boolean']['output'];
  /** Status type/model */
  model: StatusType;
  /** Internal-use display name of the status */
  private_name: Scalars['String']['output'];
  /** Client-facing display name of the status */
  public_name: Scalars['String']['output'];
  /** Status sequence/order */
  sequence?: Maybe<Scalars['Int']['output']>;
  /** ID of the status */
  status_id: Scalars['String']['output'];
  /** Immutable name of the status */
  status_name: Scalars['String']['output'];
};

export enum StatusType {
  Discern_Document = 'Discern_Document',
  Sharing_Recipient = 'Sharing_Recipient',
  VitallPatient_Profile = 'VitallPatient_Profile',
  VitallPatient_RecordFiles = 'VitallPatient_RecordFiles'
}

/** StripeAddress */
export type StripeAddress = {
  __typename?: 'StripeAddress';
  /** Address city */
  city?: Maybe<Scalars['String']['output']>;
  /** Address country */
  country?: Maybe<Scalars['String']['output']>;
  /** Address line 1 */
  line1?: Maybe<Scalars['String']['output']>;
  /** Address line 2 */
  line2?: Maybe<Scalars['String']['output']>;
  /** Address postal code */
  postal_code?: Maybe<Scalars['String']['output']>;
  /** Address state */
  state?: Maybe<Scalars['String']['output']>;
};

export type StripeAddressInput = {
  /** Address city */
  city?: InputMaybe<Scalars['String']['input']>;
  /** Address country */
  country?: InputMaybe<Scalars['String']['input']>;
  /** Address line 1 */
  line1?: InputMaybe<Scalars['String']['input']>;
  /** Address line 2 */
  line2?: InputMaybe<Scalars['String']['input']>;
  /** Address postal code */
  postal_code?: InputMaybe<Scalars['String']['input']>;
  /** Address state */
  state?: InputMaybe<Scalars['String']['input']>;
};

/** StripeCoupon */
export type StripeCoupon = {
  __typename?: 'StripeCoupon';
  /** Fixed amount discounted by the coupon */
  amount_off?: Maybe<Scalars['Float']['output']>;
  /** Coupon creation timestamp */
  created: Scalars['Float']['output'];
  /** Currency for the amount off */
  currency?: Maybe<Scalars['String']['output']>;
  /** How long the discount lasts */
  duration: Scalars['String']['output'];
  /** Number of months the discount applies for repeating coupons */
  duration_inmonths?: Maybe<Scalars['Float']['output']>;
  /** Stripe coupon identifier */
  id: Scalars['String']['output'];
  /** Whether the coupon exists in live mode */
  livemode: Scalars['Boolean']['output'];
  /** Maximum number of times the coupon can be redeemed */
  max_redemptions?: Maybe<Scalars['Float']['output']>;
  /** Coupon display name */
  name?: Maybe<Scalars['String']['output']>;
  /** Stripe object type */
  object: Scalars['String']['output'];
  /** Percentage discounted by the coupon */
  percent_off?: Maybe<Scalars['Float']['output']>;
  /** Timestamp after which the coupon can no longer be redeemed */
  redeem_by?: Maybe<Scalars['Float']['output']>;
  /** Number of times the coupon has been redeemed */
  times_redeemed: Scalars['Float']['output'];
  /** Whether the coupon is currently valid */
  valid: Scalars['Boolean']['output'];
};

/** StripeCustomer */
export type StripeCustomer = {
  __typename?: 'StripeCustomer';
  /** Customer billing address */
  address?: Maybe<StripeAddress>;
  /** Customer default currency */
  currency?: Maybe<Scalars['String']['output']>;
  /** Stripe customer identifier */
  customerId: Scalars['String']['output'];
  /** Customer name */
  name?: Maybe<Scalars['String']['output']>;
  /** Customer upcoming payment details */
  nextPayment?: Maybe<NextPayment>;
  /** Customer default payment method */
  paymentMethod?: Maybe<PaymentMethod>;
};

export type StripeCustomerInput = {
  /** Stripe customer account identifier */
  account_id: Scalars['String']['input'];
};

/** StripeInvoice */
export type StripeInvoice = {
  __typename?: 'StripeInvoice';
  /** Invoice creation timestamp */
  created: Scalars['Float']['output'];
  /** Invoice due date timestamp */
  due_date?: Maybe<Scalars['Float']['output']>;
  /** Stripe invoice identifier */
  id: Scalars['String']['output'];
  /** URL to the invoice PDF */
  invoice_pdf?: Maybe<Scalars['String']['output']>;
  /** Human-readable invoice number */
  number?: Maybe<Scalars['String']['output']>;
  /** Invoice payment status */
  status?: Maybe<Scalars['String']['output']>;
};

/** StripePayment */
export type StripePayment = {
  /** Billing address city */
  city: Scalars['String']['input'];
  /** Billing address country */
  country: Scalars['String']['input'];
  /** Billing address line 1 */
  line1: Scalars['String']['input'];
  /** Billing address line 2 */
  line2?: InputMaybe<Scalars['String']['input']>;
  /** Cardholder or billing name */
  name: Scalars['String']['input'];
  /** Billing contact phone number */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** Billing address postal code */
  postal_code: Scalars['String']['input'];
  /** Stripe payment source token */
  source: Scalars['String']['input'];
  /** Billing address state or region */
  state: Scalars['String']['input'];
};

export type StripePrice = {
  __typename?: 'StripePrice';
  /** Whether the price is active */
  active: Scalars['Boolean']['output'];
  /** Billing scheme for the price */
  billing_scheme: Scalars['String']['output'];
  /** Price creation timestamp */
  created: Scalars['Float']['output'];
  /** Currency of the price */
  currency: Scalars['String']['output'];
  /** Per-currency pricing options */
  currency_options?: Maybe<Array<CurrencyOptions>>;
  /** Stripe price identifier */
  id: Scalars['String']['output'];
  /** Whether the price exists in live mode */
  livemode: Scalars['Boolean']['output'];
  /** Price metadata such as plan type and fees */
  metadata: PriceMetadata;
  /** Stripe object type */
  object: Scalars['String']['output'];
  /** Identifier of the product the price belongs to */
  product: Scalars['String']['output'];
  /** Recurring billing configuration */
  recurring?: Maybe<RecurringData>;
  /** Whether the price is one-time or recurring */
  type: PriceType;
  /** Unit amount charged in cents */
  unit_amount: Scalars['Float']['output'];
};

export type SupportedAppPlatformModel = {
  __typename?: 'SupportedAppPlatformModel';
  /** Application being described */
  app: AppVersionApp;
  /** Platforms supported for this application */
  platforms: Array<AppVersionPlatform>;
};

export enum TaskDateFilter {
  ALL = 'ALL',
  COMPLETE = 'COMPLETE',
  DUE_TODAY = 'DUE_TODAY',
  OVERDUE = 'OVERDUE',
  UPCOMING = 'UPCOMING'
}

export enum TaskIntent {
  fillerOrder = 'fillerOrder',
  instanceOrder = 'instanceOrder',
  option = 'option',
  order = 'order',
  originalOrder = 'originalOrder',
  plan = 'plan',
  proposal = 'proposal',
  reflexOrder = 'reflexOrder',
  unknown = 'unknown'
}

/** TaskModel */
export type TaskModel = {
  __typename?: 'TaskModel';
  associatedResources?: Maybe<Array<ResourceAssociationUnion>>;
  attachments?: Maybe<Array<Attachment>>;
  /** Date the task was created */
  authoredOn?: Maybe<Scalars['String']['output']>;
  /** Request fulfilled by this task */
  basedOn?: Maybe<Array<Reference>>;
  /** Business-level status of the task */
  businessStatus?: Maybe<CodeableConcept>;
  /** Coded type of the task */
  code?: Maybe<CodeableConcept>;
  /** Contained */
  contained?: Maybe<Array<Resource>>;
  /** Curation metadata for this task resource */
  curationMeta?: Maybe<CurationMeta>;
  /** Human-readable explanation of the task */
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  /** Encounter during which this task originated */
  encounter?: Maybe<Reference>;
  /** Start and end time of task execution */
  executionPeriod?: Maybe<Period>;
  /** Extension */
  extension?: Maybe<Array<Extension>>;
  /** Resource the task is acting on */
  focus?: Maybe<Reference>;
  /** Beneficiary of the task */
  for?: Maybe<Reference>;
  /** Requisition or grouper id */
  groupIdentifier?: Maybe<Identifier>;
  /** Logical id of the Task resource */
  id?: Maybe<Scalars['String']['output']>;
  /** Business identifiers for the task */
  identifier?: Maybe<Array<Identifier>>;
  /** A set of rules under which this content was created */
  implicitRules?: Maybe<Scalars['String']['output']>;
  /** Input parameters supplied to the task */
  input?: Maybe<Array<InputModel>>;
  /** Formal definition of task as a canonical URL */
  instantiatesCanonical?: Maybe<Scalars['String']['output']>;
  /** Formal definition of task as a URI */
  instantiatesUri?: Maybe<Scalars['String']['output']>;
  /** Associated insurance coverage */
  insurance?: Maybe<Array<Reference>>;
  /** Intent of the task, e.g. order or proposal */
  intent: TaskIntent;
  /** Language of the resource content */
  language?: Maybe<Scalars['String']['output']>;
  /** Date the task was last modified */
  lastModified?: Maybe<Scalars['String']['output']>;
  /** Location where the task occurs */
  location?: Maybe<Reference>;
  /** Metadata about the resource */
  meta?: Maybe<Meta>;
  /** Comments made about the task */
  note?: Maybe<Array<Annotation>>;
  /** Output produced by the task */
  output?: Maybe<Array<OutputModel>>;
  /** Responsible individual or owner of the task */
  owner?: Maybe<Reference>;
  /** Composite task this task is part of */
  partOf?: Maybe<Array<Reference>>;
  /** Requested type of performer for the task */
  performerType?: Maybe<Array<CodeableConcept>>;
  /** Task priority: routine, urgent, asap or stat */
  priority?: Maybe<Scalars['String']['output']>;
  /** Coded reason why the task is needed */
  reasonCode?: Maybe<CodeableConcept>;
  /** Referenced resource explaining why the task is needed */
  reasonReference?: Maybe<Reference>;
  /** Key provenance events in the task history */
  relevantHistory?: Maybe<Array<Reference>>;
  /** Who is asking for the task to be done */
  requester?: Maybe<Reference>;
  /** FHIR resource type, always Task */
  resourceType?: Maybe<Scalars['String']['output']>;
  /** Constraints on task fulfillment */
  restriction?: Maybe<Restriction>;
  /** Current lifecycle status of the task */
  status: Scalars['String']['output'];
  /** Reason for the current status */
  statusReason?: Maybe<CodeableConcept>;
  /** Text */
  text?: Maybe<Narrative>;
};

export type TaskModelInput = {
  /** Date the task was created */
  authoredOn?: InputMaybe<Scalars['String']['input']>;
  /** Request fulfilled by this task */
  basedOn?: InputMaybe<Array<ReferenceInput>>;
  /** Business-level status of the task */
  businessStatus?: InputMaybe<CodeableConceptInput>;
  /** Coded type of the task */
  code?: InputMaybe<CodeableConceptInput>;
  /** Contained */
  contained?: InputMaybe<Array<ResourceInput>>;
  /** Human-readable explanation of the task */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Encounter during which this task originated */
  encounter?: InputMaybe<ReferenceInput>;
  /** Start and end time of task execution */
  executionPeriod?: InputMaybe<PeriodInput>;
  /** Extension */
  extension?: InputMaybe<Array<ExtensionInput>>;
  /** Resource the task is acting on */
  focus?: InputMaybe<ReferenceInput>;
  /** Beneficiary of the task */
  for?: InputMaybe<ReferenceInput>;
  /** Requisition or grouper id */
  groupIdentifier?: InputMaybe<IdentifierInput>;
  /** Logical id of the Task resource */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Business identifiers for the task */
  identifier?: InputMaybe<Array<IdentifierInput>>;
  /** A set of rules under which this content was created */
  implicitRules?: InputMaybe<Scalars['String']['input']>;
  /** Input parameters supplied to the task */
  input?: InputMaybe<Array<InputModelInput>>;
  /** Formal definition of task as a canonical URL */
  instantiatesCanonical?: InputMaybe<Scalars['String']['input']>;
  /** Formal definition of task as a URI */
  instantiatesUri?: InputMaybe<Scalars['String']['input']>;
  /** Associated insurance coverage */
  insurance?: InputMaybe<Array<ReferenceInput>>;
  /** Intent of the task, e.g. order or proposal */
  intent: TaskIntent;
  /** Language of the resource content */
  language?: InputMaybe<Scalars['String']['input']>;
  /** Date the task was last modified */
  lastModified?: InputMaybe<Scalars['String']['input']>;
  /** Location where the task occurs */
  location?: InputMaybe<ReferenceInput>;
  /** Metadata about the resource */
  meta?: InputMaybe<MetaInput>;
  /** Comments made about the task */
  note?: InputMaybe<Array<AnnotationInput>>;
  /** Output produced by the task */
  output?: InputMaybe<Array<OutputModelInput>>;
  /** Responsible individual or owner of the task */
  owner?: InputMaybe<ReferenceInput>;
  /** Composite task this task is part of */
  partOf?: InputMaybe<Array<ReferenceInput>>;
  /** Requested type of performer for the task */
  performerType?: InputMaybe<Array<CodeableConceptInput>>;
  /** Task priority: routine, urgent, asap or stat */
  priority?: InputMaybe<Scalars['String']['input']>;
  /** Coded reason why the task is needed */
  reasonCode?: InputMaybe<CodeableConceptInput>;
  /** Referenced resource explaining why the task is needed */
  reasonReference?: InputMaybe<ReferenceInput>;
  /** Key provenance events in the task history */
  relevantHistory?: InputMaybe<Array<ReferenceInput>>;
  /** Who is asking for the task to be done */
  requester?: InputMaybe<ReferenceInput>;
  /** FHIR resource type, always Task */
  resourceType?: InputMaybe<Scalars['String']['input']>;
  /** Constraints on task fulfillment */
  restriction?: InputMaybe<RestrictionInput>;
  /** Current lifecycle status of the task */
  status: TaskStatus;
  /** Reason for the current status */
  statusReason?: InputMaybe<CodeableConceptInput>;
  /** Text */
  text?: InputMaybe<NarrativeInput>;
};

export enum TaskOwnership {
  ALL = 'ALL',
  MY = 'MY'
}

export enum TaskStatus {
  accepted = 'accepted',
  cancelled = 'cancelled',
  completed = 'completed',
  draft = 'draft',
  enteredInError = 'enteredInError',
  failed = 'failed',
  inProgress = 'inProgress',
  onHold = 'onHold',
  ready = 'ready',
  received = 'received',
  rejected = 'rejected',
  requested = 'requested'
}

export enum TaxBehavior {
  exclusive = 'exclusive',
  inclusive = 'inclusive',
  unspecified = 'unspecified'
}

export type TaxRate = {
  __typename?: 'TaxRate';
  /** Whether the tax rate is active */
  active: Scalars['Boolean']['output'];
  /** Tax rate creation timestamp */
  created: Scalars['Float']['output'];
  /** Tax rate description */
  description?: Maybe<Scalars['String']['output']>;
  /** Display name for the tax rate */
  display_name: Scalars['String']['output'];
  /** Stripe tax rate identifier */
  id: Scalars['String']['output'];
  /** Whether the tax is inclusive of the price */
  inclusive: Scalars['Boolean']['output'];
  /** Jurisdiction the tax rate applies to */
  jurisdiction?: Maybe<Scalars['String']['output']>;
  /** Whether the tax rate exists in live mode */
  livemode: Scalars['Boolean']['output'];
  /** Stripe object type */
  object: Scalars['String']['output'];
  /** Tax rate percentage */
  percentage: Scalars['Float']['output'];
};

export type TerraActivityFilters = {
  /** Filter activities by numeric activity type */
  activity_type?: InputMaybe<Scalars['Float']['input']>;
  /** Cursor used for pagination */
  cursor?: InputMaybe<Scalars['String']['input']>;
  /** Filter activities ending at or before this time */
  end_time?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter activities starting at or after this time */
  start_time?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TerraConnection = {
  __typename?: 'TerraConnection';
  /** When the connection was created */
  created_at?: Maybe<Scalars['DateTime']['output']>;
  /** Wearable provider integration name */
  integration: Scalars['String']['output'];
  /** Whether the connection is currently authenticated */
  is_authenticated: Scalars['Boolean']['output'];
  /** Timestamp of the most recent webhook update */
  last_webhook_update?: Maybe<Scalars['String']['output']>;
  /** Unique identifier of the Terra connection */
  terra_connection_id: Scalars['String']['output'];
  /** Vitall patient this connection belongs to */
  vitall_patient_id: Scalars['String']['output'];
};

export type TerraConnectionSession = {
  __typename?: 'TerraConnectionSession';
  /** URL the patient visits to authenticate the provider */
  auth_url: Scalars['String']['output'];
  /** Status of the connection session */
  status: Scalars['String']['output'];
  /** Unique identifier of the Terra connection */
  terra_connection_id: Scalars['String']['output'];
};

export type TerraIntegration = {
  __typename?: 'TerraIntegration';
  /** Patient's existing connection for this integration */
  connection?: Maybe<TerraConnection>;
  /** URL of the integration's logo image */
  image_src?: Maybe<Scalars['String']['output']>;
  /** Wearable provider integration name */
  integration: Scalars['String']['output'];
  /** Human-readable name of the integration */
  name: Scalars['String']['output'];
  /** Data scopes supported by the integration */
  scopes: Array<Scalars['String']['output']>;
};

export type Tier = {
  __typename?: 'Tier';
  /** Price for the entire tier. */
  flat_amount?: Maybe<Scalars['Float']['output']>;
  /** Same as `flat_amount`, but contains a decimal value with at most 12 decimal places. */
  flat_amount_decimal?: Maybe<Scalars['String']['output']>;
  /** Per unit price for units relevant to the tier. */
  unit_amount?: Maybe<Scalars['Float']['output']>;
  /** Same as `unit_amount`, but contains a decimal value with at most 12 decimal places. */
  unit_amount_decimal?: Maybe<Scalars['String']['output']>;
  /** Up to and including to this quantity will be contained in the tier. */
  up_to?: Maybe<Scalars['Float']['output']>;
};

export type Timing = {
  __typename?: 'Timing';
  /** C | BID | TID | QID | AM | PM | QD | QOD | + */
  code?: Maybe<CodeableConcept>;
  /** When the event occurs */
  event?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** When the event is to occur */
  repeat?: Maybe<Repeat>;
};

export type TimingInput = {
  /** C | BID | TID | QID | AM | PM | QD | QOD | + */
  code?: InputMaybe<CodeableConceptInput>;
  /** When the event occurs */
  event?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** When the event is to occur */
  repeat?: InputMaybe<RepeatInput>;
};

/** TitrationCarePlanEntry */
export type TitrationCarePlanEntry = {
  __typename?: 'TitrationCarePlanEntry';
  /** FHIR CarePlan for the titration program */
  carePlan: CarePlanModel;
  /** Medication requests generated for this titration plan */
  medicationRequests: Array<MedicationRequestModel>;
  /** Medication statements linked to this titration plan */
  medicationStatements: Array<MedicationStatementModel>;
};

export enum TitrationDecision {
  Continue = 'Continue',
  Decrease = 'Decrease',
  Discontinue = 'Discontinue',
  Hold = 'Hold',
  Increase = 'Increase'
}

export enum TitrationDecisionReason {
  AbnormalBloodwork = 'AbnormalBloodwork',
  Admitted = 'Admitted',
  AdverseReaction = 'AdverseReaction',
  AllergicReaction = 'AllergicReaction',
  Away = 'Away',
  DecliningFurther = 'DecliningFurther',
  Other = 'Other',
  Symptomatic = 'Symptomatic'
}

export enum TitrationDrugClass {
  BetaBlocker = 'BetaBlocker',
  RASi = 'RASi',
  SGLT2i = 'SGLT2i',
  nsMRA = 'nsMRA'
}

export enum TitrationMedicationCategory {
  acei = 'acei',
  arbs = 'arbs',
  arnis = 'arnis',
  betaBlockers = 'betaBlockers',
  mras = 'mras',
  sglt2i = 'sglt2i'
}

export type TitrationMedicationInput = {
  /** Current medication details (strength, quantity, frequency) */
  current: TitrationStepInput;
  /** Date that the medication is to be started on */
  date_started?: InputMaybe<Scalars['DateTime']['input']>;
  /** Clinical decision applied to this medication */
  decision?: InputMaybe<TitrationDecision>;
  /** Reasons supporting the titration decision */
  decision_reasons?: InputMaybe<Array<TitrationDecisionReason>>;
  /** Medication being discontinued as part of this titration */
  discontinued_medication?: InputMaybe<BaseTitrationMedicationInput>;
  /** Drug class targeted by this titration medication */
  drug_class: TitrationDrugClass;
  /** Coded medication being titrated */
  medication_codeable_concept: CodeableConceptInput;
  /** RASi subcategory (acei, arbs, or arnis) */
  medication_statement_class?: InputMaybe<TitrationMedicationCategory>;
  /** Free-text rationale for the titration */
  reason_for_titration?: InputMaybe<Scalars['String']['input']>;
  /** Source MedicationStatement id this titration derives from */
  source_medication_statement_id?: InputMaybe<Scalars['String']['input']>;
  /** Target medication details (strength, quantity, frequency) */
  target: TitrationStepInput;
};

export enum TitrationProgram {
  HeartFailureGdmt = 'HeartFailureGdmt'
}

export type TitrationStepInput = {
  dosage?: InputMaybe<Array<DosageInput>>;
  form: CodeableConceptInput;
  ingredient?: InputMaybe<Array<MedicationIngredientInput>>;
};

export type TriggerDefinition = {
  __typename?: 'TriggerDefinition';
  /** Condition */
  condition?: Maybe<Expression>;
  /** Data */
  data?: Maybe<Array<DataRequirement>>;
  /** Name */
  name?: Maybe<Scalars['String']['output']>;
  /** Timing date */
  timingDate?: Maybe<Scalars['String']['output']>;
  /** Timing date time */
  timingDateTime?: Maybe<Scalars['String']['output']>;
  /** Timing reference */
  timingReference?: Maybe<Reference>;
  /** Timing timing */
  timingTiming?: Maybe<Timing>;
  /** Type */
  type?: Maybe<Scalars['String']['output']>;
};

export type TriggerDefinitionInput = {
  /** Condition */
  condition?: InputMaybe<ExpressionInput>;
  /** Data */
  data?: InputMaybe<Array<DataRequirementInput>>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Timing date */
  timingDate?: InputMaybe<Scalars['String']['input']>;
  /** Timing date time */
  timingDateTime?: InputMaybe<Scalars['String']['input']>;
  /** Timing reference */
  timingReference?: InputMaybe<ReferenceInput>;
  /** Timing timing */
  timingTiming?: InputMaybe<TimingInput>;
  /** Type */
  type?: InputMaybe<Scalars['String']['input']>;
};

export type TriggeringObservation = {
  __typename?: 'TriggeringObservation';
  /** The observation that triggered this one */
  observation: ObservationModel;
  /** Reason the observation was triggered */
  reason?: Maybe<Scalars['String']['output']>;
  /** Type of trigger (reflex, repeat, re-run) */
  type?: Maybe<Scalars['String']['output']>;
};

export type TriggeringObservationInput = {
  /** The observation that triggered this one */
  observation: ObservationModelInput;
  /** Reason the observation was triggered */
  reason?: InputMaybe<Scalars['String']['input']>;
  /** Type of trigger (reflex, repeat, re-run) */
  type?: InputMaybe<Scalars['String']['input']>;
};

export enum TypeCode {
  allergy = 'allergy',
  intolerance = 'intolerance'
}

export type UpdateAccountBillingAddressModelInput = {
  /** ID of the account to update */
  account_id: Scalars['String']['input'];
  /** City of the billing address */
  city: Scalars['String']['input'];
  /** Country of the billing address */
  country: Scalars['String']['input'];
  /** Primary line of the billing address */
  line1: Scalars['String']['input'];
  /** Secondary line of the billing address */
  line2?: InputMaybe<Scalars['String']['input']>;
  /** Postal code of the billing address */
  postal_code: Scalars['String']['input'];
  /** State of the billing address */
  state: Scalars['String']['input'];
};

export type UpdateAccountLicenseInput = {
  /** Identifier of the account to update the license for */
  account_id: Scalars['String']['input'];
  /** Identifier of the license to assign to the account */
  license_id: Scalars['String']['input'];
};

export type UpdateAccountModelInput = {
  /** Updated primary line of the account address */
  account_address?: InputMaybe<Scalars['String']['input']>;
  /** Updated secondary line of the account address */
  account_address2?: InputMaybe<Scalars['String']['input']>;
  /** Updated city of the account address */
  account_city?: InputMaybe<Scalars['String']['input']>;
  /** Updated country ID of the account address */
  account_country_id?: InputMaybe<Scalars['String']['input']>;
  /** ID of the account to update */
  account_id: Scalars['String']['input'];
  /** Updated name of the account */
  account_name: Scalars['String']['input'];
  /** Updated region ID of the account address */
  account_region_id?: InputMaybe<Scalars['String']['input']>;
  /** Updated zip or postal code of the account address */
  account_zip_postal?: InputMaybe<Scalars['String']['input']>;
  /** Updated contact email for the account */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Updated contact phone number for the account */
  phone_number?: InputMaybe<Scalars['String']['input']>;
  /** Updated profile picture URL for the account */
  profile_picture?: InputMaybe<Scalars['String']['input']>;
};

/** UpdateAccountResponse */
export type UpdateAccountResponse = {
  __typename?: 'UpdateAccountResponse';
  /** The updated account when the operation succeeds */
  data?: Maybe<AccountModel>;
  /** Result message for the account update */
  message: Scalars['String']['output'];
  /** Whether the account update succeeded */
  success: Scalars['Boolean']['output'];
};

export type UpdateAccountSettingInput = {
  /** Identifier of the account to update settings for */
  account_id: Scalars['String']['input'];
  /** New primary branding color for the account */
  branding_color_primary?: InputMaybe<Scalars['String']['input']>;
  /** New secondary branding color for the account */
  branding_color_secondary?: InputMaybe<Scalars['String']['input']>;
  /** Whether MFA is required for patients on this account */
  is_patient_mfa_required?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether MFA is required for practitioners on this account */
  is_practitioner_mfa_required?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether Medly integration is enabled for the account */
  medly_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether medication titration is enabled for the account */
  titration_enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateAccountUserAddedEmailNotificationSettingInput = {
  /** Identifier of the account to update the notification setting for */
  account_id: Scalars['String']['input'];
  /** Whether account-user-added email notifications are enabled */
  enabled: Scalars['Boolean']['input'];
};

export type UpdateAlertRecipientSettingInput = {
  /** Account identifier the alert recipient setting applies to */
  account_id?: InputMaybe<Scalars['String']['input']>;
  /** Whether email alert delivery is enabled */
  email_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether SMS alert delivery is enabled */
  sms_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** User identifier the alert recipient setting applies to */
  user_id?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAlertsInput = {
  /** IDs of the alerts to update */
  alert_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Metric selector for updating alerts by metric instead of IDs */
  metric?: InputMaybe<MetricAlertInput>;
  /** New status to apply to the alerts */
  status: AlertStatus;
};

export type UpdateAllergyInput = {
  /** Updated allergy resource payload */
  allergy: AllergyModelInput;
  /** Id of the allergy record to update */
  allergy_id: Scalars['String']['input'];
};

export type UpdateAppVersionDraftInput = {
  /** Identifier of the draft version to update */
  app_version_id: Scalars['String']['input'];
  /** Whether the draft should be the minimum supported version */
  is_minimum_version?: InputMaybe<Scalars['Boolean']['input']>;
  /** Updated release date for the draft */
  release_date?: InputMaybe<Scalars['DateTime']['input']>;
  /** Updated release notes for the draft */
  release_notes?: InputMaybe<Scalars['String']['input']>;
  /** Updated semantic version number */
  version_number?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAppointmentInput = {
  /** Appointment payload to create */
  appointment: AppointmentModelInput;
  /** ID of the appointment to update */
  appointment_id: Scalars['String']['input'];
  /** Location associated with the record */
  location?: InputMaybe<LocationModelInput>;
};

export type UpdateCareTeamInput = {
  /** CareTeam's FHIR Organization account */
  organization_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Care team member to add or update */
  participant: ContactModelInput;
  /** Identifier of the patient whose care team to update */
  patient_id: Scalars['String']['input'];
};

export type UpdateConditionInput = {
  /** Condition payload to update */
  condition: ConditionModelInput;
  /** Logical id of the condition to update */
  id: Scalars['String']['input'];
};

export type UpdateConsentInput = {
  /** Updated consent resource payload */
  consent: ConsentModelInput;
  /** Id of the consent to update */
  consent_id: Scalars['String']['input'];
};

export type UpdateCoveragesInput = {
  /** Coverage resource with updated values */
  coverage: CoverageModelInput;
  /** ID of the coverage to update */
  id: Scalars['String']['input'];
};

export type UpdateCurationStatusInput = {
  /** FHIR resource reference in [type]/[id] format */
  resource: Scalars['String']['input'];
  /** New curation status to apply to the resource */
  status: CurationStatus;
};

export type UpdateCuratorTaskInput = {
  /** Fields to update on the curator task */
  curator_task: UpdateCuratorTaskModelInput;
  /** Unique identifier of the curator task to update */
  curator_task_id: Scalars['String']['input'];
};

export type UpdateCuratorTaskModelInput = {
  /** Updated creating user of the task */
  created_user_id?: InputMaybe<Scalars['String']['input']>;
  /** Updated description of the curator task */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Updated due date for the task */
  due_date?: InputMaybe<Scalars['DateTime']['input']>;
  /** Updated name of the curator task */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Updated priority ranking of the task */
  priority?: InputMaybe<Scalars['Float']['input']>;
  /** Updated linked FHIR resource reference id */
  resource?: InputMaybe<Scalars['String']['input']>;
  /** Updated completion state of the task */
  status?: InputMaybe<Scalars['Boolean']['input']>;
  /** Updated practitioner user assigned to the task */
  user_id?: InputMaybe<Scalars['String']['input']>;
  /** Updated Vitall patient for the task */
  vitall_patient_id?: InputMaybe<Scalars['String']['input']>;
};

/** UpdateCuratorTaskResponse */
export type UpdateCuratorTaskResponse = {
  __typename?: 'UpdateCuratorTaskResponse';
  /** Updated curator task record */
  data?: Maybe<CuratorTaskModel>;
  /** Human-readable result message for the update */
  message: Scalars['String']['output'];
  /** Whether the update operation succeeded */
  success: Scalars['Boolean']['output'];
};

export type UpdateDiagnosticReportInput = {
  /** Diagnostic report to create */
  diagnosticReport: DiagnosticReportInput;
  /** ID of the diagnostic report to update */
  diagnostic_report_id: Scalars['String']['input'];
  /** Encounter to associate with the report */
  encounter?: InputMaybe<EncounterModelInput>;
  /** Location to associate with the report */
  location?: InputMaybe<LocationModelInput>;
};

export type UpdateDiscernDocumentInput = {
  /** ID of the Discern document to update */
  discern_document_id: Scalars['String']['input'];
  /** Updated page grouping state for the document */
  grouping_state_json?: InputMaybe<Scalars['JSON']['input']>;
  /** New processing status for the document */
  status?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDiscernResultStatusInput = {
  /** Bounding box identifier of the result to update */
  bbox_id?: InputMaybe<Scalars['String']['input']>;
  /** ID of the Discern job whose results to update */
  discern_job_id?: InputMaybe<Scalars['String']['input']>;
  /** ID of the Discern result to update */
  discern_result_id?: InputMaybe<Scalars['String']['input']>;
  /** New curation status for the result */
  status: DiscernResultStatus;
};

export type UpdateDocumentInput = {
  /** Fields to update on the document */
  document: UpdateDocumentModelInput;
  /** Identifier of the document to update */
  document_id: Scalars['String']['input'];
};

export type UpdateDocumentModelInput = {
  /** Updated document description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Updated document name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Updated document health status identifier */
  status_id?: InputMaybe<Scalars['String']['input']>;
};

/** UpdateDocumentResponse */
export type UpdateDocumentResponse = {
  __typename?: 'UpdateDocumentResponse';
  /** Updated document record */
  data?: Maybe<DocumentModel>;
  /** Result message describing the update outcome */
  message: Scalars['String']['output'];
  /** Whether the update succeeded */
  success: Scalars['Boolean']['output'];
};

export type UpdateEmergencyVisitInput = {
  /** Encounter resource for the emergency visit to create */
  encounter: EncounterModelInput;
  /** Id of the emergency visit encounter to update */
  encounter_id: Scalars['String']['input'];
  /** Location associated with the record */
  location?: InputMaybe<LocationModelInput>;
};

export type UpdateFamilyHistoryInput = {
  /** Updated family member history payload */
  familyMemberHistory: FamilyMemberHistoryModelInput;
  /** Id of the family member history record to update */
  familymemberhistory_id: Scalars['String']['input'];
};

export type UpdateGroupInput = {
  /** Identifier of the group to update */
  group_id: Scalars['String']['input'];
  /** New name to assign to the group */
  group_name: Scalars['String']['input'];
};

export type UpdateHospitalizationInput = {
  /** Encounter resource for the hospitalization to create */
  encounter: EncounterModelInput;
  /** Id of the hospitalization encounter to update */
  encounter_id: Scalars['String']['input'];
  /** Location associated with the record */
  location?: InputMaybe<LocationModelInput>;
};

export type UpdateImmunizationInput = {
  /** Immunization resource to create */
  immunization: ImmunizationModelInput;
  /** FHIR id of the immunization to update */
  immunization_id: Scalars['String']['input'];
  /** Location associated with the record */
  location?: InputMaybe<LocationModelInput>;
};

export type UpdateMedStatementInput = {
  /** ID of the medication statement to update */
  medication_statement_id: Scalars['String']['input'];
  /** Updated medication statement payload */
  medicationstatement: MedicationStatementModelInput;
};

export type UpdateMedicationRequestInput = {
  /** Identifier of the medication request to update */
  medication_request_id: Scalars['String']['input'];
  /** Updated medication request payload */
  medicationrequest: MedicationRequestModelInput;
};

export type UpdateNotificationConnectionInput = {
  /** ID of the connected user for this notification connection */
  connected_user_id: Scalars['String']['input'];
  /** Whether to enable email for this notification connection */
  email_enabled: Scalars['Boolean']['input'];
  /** ID of the user whose notification connection is being updated */
  user_id: Scalars['String']['input'];
};

export type UpdateNotificationPreferenceInput = {
  /** Whether to enable email for this notification preference */
  email_enabled: Scalars['Boolean']['input'];
  /** Notification identifier */
  identifier: Scalars['String']['input'];
  /** ID of the user whose preference is being updated */
  user_id: Scalars['String']['input'];
};

export type UpdateObservationInput = {
  /** Id of the observation to update */
  id: Scalars['String']['input'];
  /** Updated observation resource payload */
  observation: ObservationModelInput;
};

export type UpdateOperationInput = {
  /** Operation name */
  operation: Scalars['String']['input'];
  /** New operation name */
  operationName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePatientAssignedUserInput = {
  /** User id to assign to the patient */
  user_id: Scalars['String']['input'];
  /** Vitall patient id to assign the user to */
  vitall_patient_id: Scalars['String']['input'];
};

export type UpdatePatientEmergencyAccessInput = {
  /** New emergency access flag for the patient */
  allow_emergency_access?: InputMaybe<Scalars['Boolean']['input']>;
  /** Vitall patient id to update emergency access for */
  vitall_patient_id: Scalars['String']['input'];
};

export type UpdatePatientInput = {
  /** Updated patient resource payload */
  patient: PatientModelInput;
  /** FHIR logical id of the patient to update */
  patient_id: Scalars['String']['input'];
};

export type UpdatePatientProfileStatusInput = {
  /** New profile status id to set on the patient */
  status_id: Scalars['String']['input'];
  /** Vitall patient id to update the profile status for */
  vitall_patient_id: Scalars['String']['input'];
};

export type UpdatePatientSeatsInput = {
  account_id: Scalars['String']['input'];
  limit_patients: Scalars['Int']['input'];
};

export type UpdatePermissionInput = {
  /** Identifier of the permission to update */
  permission_id: Scalars['String']['input'];
  /** New name for the permission */
  permission_name?: InputMaybe<Scalars['String']['input']>;
  /** PermissionScope */
  permission_scope?: InputMaybe<PermissionScope>;
};

export type UpdatePolicyInput = {
  /** Updated description for the policy */
  policy_description?: InputMaybe<Scalars['String']['input']>;
  /** Identifier of the policy to fetch */
  policy_id: Scalars['String']['input'];
  /** Updated name for the policy */
  policy_name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProcedureInput = {
  /** Identifier of the procedure to update */
  id: Scalars['String']['input'];
  /** Location associated with the record */
  location?: InputMaybe<LocationModelInput>;
  /** Procedure resource to create */
  procedure: ProcedureModelInput;
};

export type UpdateRecordSourceInput = {
  /** FHIR resource reference in [type]/[id] format */
  resource: Scalars['String']['input'];
  /** New source type to assign to the record */
  source_type: ResourceSourceType;
};

export type UpdateRelatedPersonInput = {
  /** FHIR logical id of the related person to update */
  id: Scalars['String']['input'];
  /** Related person payload to update */
  relatedPerson: RelatedPersonModelInput;
};

export type UpdateRoleInput = {
  /** Updated ordering rank for the role */
  rank?: InputMaybe<Scalars['Int']['input']>;
  /** Updated description for the role */
  role_description?: InputMaybe<Scalars['String']['input']>;
  /** Unique identifier of the role to fetch */
  role_id: Scalars['String']['input'];
  /** Updated name for the role */
  role_name?: InputMaybe<Scalars['String']['input']>;
  /** Updated account type scope for the role */
  scope?: InputMaybe<AccountType>;
};

export type UpdateStripeCustomerModelInput = {
  /** Stripe customer account identifier to update */
  account_id: Scalars['String']['input'];
  /** Updated customer name */
  name: Scalars['String']['input'];
  /** New card token source for the customer */
  source: Scalars['String']['input'];
};

/** UpdateStripeCustomerResponse */
export type UpdateStripeCustomerResponse = {
  __typename?: 'UpdateStripeCustomerResponse';
  /** Updated Stripe customer data */
  data?: Maybe<CustomerData>;
  /** Result message for the customer update */
  message: Scalars['String']['output'];
};

export type UpdateTaskInput = {
  /** Updated task payload */
  task: TaskModelInput;
  /** Id of the task to update */
  task_id: Scalars['String']['input'];
};

export type UpdateUserAttributesResponse = {
  __typename?: 'UpdateUserAttributesResponse';
  /** Delivery details for codes sent per updated attribute */
  CodeDeliveryDetailsList?: Maybe<Array<CodeDeliveryDetailsType>>;
};

/** UpdateUserResponse */
export type UpdateUserResponse = {
  __typename?: 'UpdateUserResponse';
  /** List of fields that changed during the update */
  changes?: Maybe<Array<FieldChange>>;
  /** Updated user record */
  data?: Maybe<UserModel>;
  /** Human-readable result message */
  message: Scalars['String']['output'];
  /** Whether the update succeeded */
  success: Scalars['Boolean']['output'];
};

export type UpdateVitallPatientResponse = {
  __typename?: 'UpdateVitallPatientResponse';
  /** Updated Vitall patient record */
  data?: Maybe<VitallPatientModel>;
  /** Human-readable result message for the update */
  message: Scalars['String']['output'];
  /** Whether the patient update succeeded */
  success: Scalars['Boolean']['output'];
};

/** UpdatedAlertModel */
export type UpdatedAlertModel = {
  __typename?: 'UpdatedAlertModel';
  /** ID of the updated alert */
  alert_id: Scalars['String']['output'];
  /** ID of the FHIR Observation linked to the alert */
  observation_id?: Maybe<Scalars['String']['output']>;
  /** Vitall patient ID the updated alert belongs to */
  vitall_patient_id?: Maybe<Scalars['String']['output']>;
};

export type UploadClientRecordsModelInput = {
  /** Identifier of the uploaded document */
  documentId: Scalars['String']['input'];
  /** Multipart upload details for the document */
  multipartUploadInfo: MultipartUploadModelInput;
};

export type UploadImportJobCsvInput = {
  /** CSV document to upload for the import job */
  document: CreateDocumentModelInput;
  /** Identifier of the group the import belongs to */
  group_id: Scalars['String']['input'];
  /** Identifier of the import job */
  job_id: Scalars['String']['input'];
};

export type UpsertAlertSettingInput = {
  /** Account identifier scoping the alert setting */
  account_id: Scalars['String']['input'];
  /** Existing alert setting identifier to update */
  alert_setting_id?: InputMaybe<Scalars['String']['input']>;
  /** Recipient and parameter changes to apply */
  changes: AlertSettingChangesInput;
  /** Reference range identifier to create the alert setting from */
  reference_range_id?: InputMaybe<Scalars['String']['input']>;
  /** Vitall patient identifier the alert setting belongs to */
  vitall_patient_id: Scalars['String']['input'];
};

export type UpsertEhrSyncResourceInput = {
  ehr_connection_id: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  resource_type: Scalars['String']['input'];
};

export type UpsertPurchasedPlansInput = {
  /** Account to upsert the purchased plan for */
  account_id: Scalars['String']['input'];
  /** Purchased usage limit for the plan */
  limit: Scalars['Int']['input'];
  /** Identifier of the plan to purchase */
  plan_id: Scalars['String']['input'];
};

export type UpsertScanProfileInput = {
  /** Demographics used to build the scan profile */
  demographics: ScanProfileDemographicsInput;
  /** FHIR patient id to upsert the scan profile for */
  patient_id: Scalars['String']['input'];
};

export type UsageContext = {
  __typename?: 'UsageContext';
  /** Code */
  code?: Maybe<Coding>;
  /** Value codeable concept */
  valueCodeableConcept?: Maybe<CodeableConcept>;
  /** Value quantity */
  valueQuantity?: Maybe<Quantity>;
  /** Value range */
  valueRange?: Maybe<Range>;
  /** Value reference */
  valueReference?: Maybe<Reference>;
};

export type UsageContextInput = {
  /** Code */
  code?: InputMaybe<CodingInput>;
  /** Value codeable concept */
  valueCodeableConcept?: InputMaybe<CodeableConceptInput>;
  /** Value quantity */
  valueQuantity?: InputMaybe<QuantityInput>;
  /** Value range */
  valueRange?: InputMaybe<RangeInput>;
  /** Value reference */
  valueReference?: InputMaybe<ReferenceInput>;
};

export type UserAccess = {
  __typename?: 'UserAccess';
  /** User's granted access level */
  level: UserAccessLevel;
  /** Permission scopes available to the user */
  scopes: Array<PermissionScope>;
};

export enum UserAccessLevel {
  Full = 'Full',
  None = 'None',
  Partial = 'Partial'
}

/** UserImportJob */
export type UserImportJob = {
  __typename?: 'UserImportJob';
  /** Count of imported accounts in the job's group */
  AccountsInGroup: Scalars['Float']['output'];
  /** Timestamp when the job completed */
  CompletionDate?: Maybe<Scalars['DateTime']['output']>;
  /** Message describing the import job completion */
  CompletionMessage?: Maybe<Scalars['String']['output']>;
  /** Timestamp when the job was created */
  CreationDate: Scalars['DateTime']['output'];
  /** Number of users that failed to import */
  FailedUsers: Scalars['Float']['output'];
  /** Resolves the group id from a group name */
  GroupId: Scalars['String']['output'];
  /** Count of accounts imported into the named group */
  ImportedAccounts: Scalars['Float']['output'];
  /** Number of users successfully imported */
  ImportedUsers: Scalars['Float']['output'];
  /** Stored import job details for this user import job */
  JobDetails?: Maybe<JobDetails>;
  /** Unique identifier of the import job */
  JobId: Scalars['String']['output'];
  /** Name of the import job */
  JobName: Scalars['String']['output'];
  /** Number of users skipped during import */
  SkippedUsers: Scalars['Float']['output'];
  /** Timestamp when the job started */
  StartDate: Scalars['DateTime']['output'];
  /** Current status of the import job */
  Status: Scalars['String']['output'];
};


/** UserImportJob */
export type UserImportJobGroupIdArgs = {
  groupName: Scalars['String']['input'];
};


/** UserImportJob */
export type UserImportJobImportedAccountsArgs = {
  groupName: Scalars['String']['input'];
};

/** UserMfaSettingsModel */
export type UserMfaSettingsModel = {
  __typename?: 'UserMfaSettingsModel';
  /** Whether email-based MFA is enabled */
  emailEnabled: Scalars['Boolean']['output'];
  /** Whether the MFA phone number is verified */
  phoneVerified: Scalars['Boolean']['output'];
  /** Phone number used for MFA */
  phone_number?: Maybe<Scalars['String']['output']>;
  /** Whether SMS-based MFA is enabled */
  smsEnabled: Scalars['Boolean']['output'];
  /** Preferred MFA method for the user */
  status: MfaMethod;
  /** Whether TOTP-based MFA is enabled */
  totpEnabled: Scalars['Boolean']['output'];
};

/** UserModel */
export type UserModel = {
  __typename?: 'UserModel';
  /** Returns the access level of the parent user relative to the provided user */
  access_level?: Maybe<UserAccess>;
  /** Returns the users (in the same account as the parent) that have been given permission to access the parent */
  accessed_by?: Maybe<Array<UserModel>>;
  /** The account this user belongs to */
  account: AccountModel;
  /** Account identifier for the user */
  account_id: Scalars['String']['output'];
  /** Returns the users (in the same account as the parent) that the parent has been given permission to access */
  can_access?: Maybe<Array<UserModel>>;
  /** Whether the user completed CASL consent */
  casl_completed?: Maybe<Scalars['Boolean']['output']>;
  /** Identity provider user identifier */
  cognito_id?: Maybe<Scalars['String']['output']>;
  /** Timestamp when the user was created */
  created_at: Scalars['DateTime']['output'];
  /** The user who created this user record */
  created_user?: Maybe<UserModel>;
  /** Identifier of the user who created this record */
  created_user_id?: Maybe<Scalars['String']['output']>;
  /** Whether the user is disabled at the identity provider */
  disabled: Scalars['Boolean']['output'];
  /** User's login email address */
  email?: Maybe<Scalars['String']['output']>;
  /**
   * DEPRECATED
   * @deprecated Replaced with featuresv2
   */
  features?: Maybe<Array<Feature>>;
  /** Returns the features that the user has access to */
  featuresv2?: Maybe<Array<Scalars['String']['output']>>;
  /** FHIR resource references associated with the user */
  fhir_metadata?: Maybe<Array<Scalars['String']['output']>>;
  /** Timestamp of the user's first login */
  first_login?: Maybe<Scalars['DateTime']['output']>;
  /** User's first name */
  first_name: Scalars['String']['output'];
  /** Group the user is assigned to */
  group_id?: Maybe<Scalars['String']['output']>;
  /** Name of the group this user is assigned to */
  group_name?: Maybe<Scalars['String']['output']>;
  /** Whether the user is soft-deleted */
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  /** Date of the most recent alert for this user */
  last_alert_date?: Maybe<Scalars['DateTime']['output']>;
  /** Timestamp of the user's most recent login */
  last_login?: Maybe<Scalars['DateTime']['output']>;
  /** User's last name */
  last_name: Scalars['String']['output'];
  /** The user's multi-factor authentication settings */
  mfa?: Maybe<UserMfaSettingsModel>;
  /** User's middle name */
  middle_name?: Maybe<Scalars['String']['output']>;
  /** Number of open health alerts for this user */
  open_alert_count: Scalars['Int']['output'];
  /** The parent account of this user's account, if any */
  parent_account?: Maybe<AccountModel>;
  /** User's password */
  password?: Maybe<Scalars['String']['output']>;
  /** The license plan associated with this user, if any */
  plan?: Maybe<UserPlanModel>;
  /** Whether the user completed the privacy notice */
  pn_completed?: Maybe<Scalars['Boolean']['output']>;
  /** URL of the user's profile picture */
  profile_picture?: Maybe<Scalars['String']['output']>;
  /** Roles granted to this user */
  roles: Array<RoleModel>;
  /** Current status of the user */
  status: UserStatus;
  /** User's title or honorific */
  title?: Maybe<Scalars['String']['output']>;
  /** Whether the user accepted the terms of care */
  toc_completed?: Maybe<Scalars['Boolean']['output']>;
  /** Timestamp when the user was last updated */
  updated_at: Scalars['DateTime']['output'];
  /** Unique user identifier */
  user_id: Scalars['String']['output'];
  /** The subscription plan assigned to this user */
  user_plan?: Maybe<PlanModel>;
  /** Other users this individual user can access */
  users: Array<UserModel>;
  /** The Vitall patient profile linked to this user */
  vitall_patient?: Maybe<VitallPatientModel>;
  /** The Vitall practitioner profile linked to this user */
  vitall_practitioner?: Maybe<VitallPractitionerModel>;
  /** Internal Vitall user identifier */
  vitall_user_id?: Maybe<Scalars['Int']['output']>;
};


/** UserModel */
export type UserModelAccess_LevelArgs = {
  user_id: Scalars['String']['input'];
};

/** UserNotificationConnection */
export type UserNotificationConnection = {
  __typename?: 'UserNotificationConnection';
  /** ID of the connected user receiving notifications */
  connected_user_id: Scalars['String']['output'];
  /** Timestamp when the connection was created */
  created_at: Scalars['DateTime']['output'];
  /** Whether email notifications are enabled for this connection */
  email_enabled: Scalars['Boolean']['output'];
  /** Timestamp when the connection was last updated */
  updated_at: Scalars['DateTime']['output'];
  /** ID of the user who owns this notification connection */
  user_id: Scalars['String']['output'];
};

/** UserNotificationPreference */
export type UserNotificationPreference = {
  __typename?: 'UserNotificationPreference';
  /** Whether email notifications are enabled for this preference */
  email_enabled: Scalars['Boolean']['output'];
  /** Notification identifier */
  identifier: Scalars['String']['output'];
  /** ID of the user this notification preference belongs to */
  user_id: Scalars['String']['output'];
};

export type UserPlanModel = {
  __typename?: 'UserPlanModel';
  /** Credit allowances granted under this plan */
  credits: Array<PlanCreditModel>;
  /** Date the plan became effective for the user */
  effective_date: Scalars['DateTime']['output'];
  /** Display name of the user's license plan */
  name: Scalars['String']['output'];
  /** Identifier of the license plan assigned to the user */
  plan_id: Scalars['String']['output'];
};

/** UserPlanTypeModel */
export type UserPlanTypeModel = {
  __typename?: 'UserPlanTypeModel';
  /** Number of active users */
  active: Scalars['Int']['output'];
  /** Number of invited users */
  invited: Scalars['Int']['output'];
  /** Number of newly added users */
  new: Scalars['Int']['output'];
  /** Total number of users on the plan */
  total: Scalars['Int']['output'];
};

export type UserRoleInput = {
  /** Identifier of the role to assign */
  role_id: Scalars['String']['input'];
  /** Identifier of the user to assign the role to */
  user_id: Scalars['String']['input'];
};

/** UserSettings */
export type UserSettings = {
  __typename?: 'UserSettings';
  /** Whether the user's account is disabled */
  disabled?: Maybe<Scalars['Boolean']['output']>;
  /** Identifier of the user these settings belong to */
  user_id: Scalars['String']['output'];
};

export enum UserStatus {
  active = 'active',
  cancelled = 'cancelled',
  disabled = 'disabled',
  invited = 'invited',
  new = 'new'
}

export type ValidateCouponInput = {
  /** Coupon code to validate */
  code: Scalars['String']['input'];
};

export type Verification = {
  __typename?: 'Verification';
  /** When consent verified */
  verificationDate?: Maybe<Scalars['String']['output']>;
  /** Has been verified */
  verified: Scalars['Boolean']['output'];
  /** (Patient|RelatedPerson) Person who verified */
  verifiedWith?: Maybe<Reference>;
};

export type VerificationInput = {
  /** When consent verified */
  verificationDate?: InputMaybe<Scalars['String']['input']>;
  /** Has been verified */
  verified: Scalars['Boolean']['input'];
  /** (Patient|RelatedPerson) Person who verified */
  verifiedWith?: InputMaybe<ReferenceInput>;
};

export enum VerificationStatusCode {
  confirmed = 'confirmed',
  enteredInError = 'enteredInError',
  refuted = 'refuted',
  unconfirmed = 'unconfirmed'
}

export type VerifyAlertSettingCodeInput = {
  /** Account identifier the alert recipient setting applies to */
  account_id?: InputMaybe<Scalars['String']['input']>;
  /** Verification code entered by the recipient */
  code: Scalars['String']['input'];
  /** Email address or phone number the code was sent to */
  destination: Scalars['String']['input'];
  /** User identifier the alert recipient setting applies to */
  user_id?: InputMaybe<Scalars['String']['input']>;
};

export enum VerifyDeliveryMethod {
  auto = 'auto',
  call = 'call',
  email = 'email',
  sms = 'sms',
  sna = 'sna',
  whatsapp = 'whatsapp'
}

export type VerifyEmailInput = {
  /** Email verification confirmation code */
  confirmationCode: Scalars['String']['input'];
};

export type VerifyPhoneInput = {
  /** Phone verification confirmation code */
  confirmationCode: Scalars['String']['input'];
};

export type ViewedStatusResourcesUnion = AllergyModel | AppointmentModel | ConditionModel | DiagnosticReportModel | EncounterModel | FamilyMemberHistoryModel | ImmunizationModel | MedicationStatementModel | ObservationModel | ProcedureModel;

/** VitallPatientModel */
export type VitallPatientModel = {
  __typename?: 'VitallPatientModel';
  /** Whether emergency access to this patient is allowed */
  allow_emergency_access: Scalars['Boolean']['output'];
  /** Timestamp when the patient record was created */
  created_at?: Maybe<Scalars['DateTime']['output']>;
  /** User id that created this patient record */
  created_user_id?: Maybe<Scalars['String']['output']>;
  /** Curator user assigned to the patient */
  curator?: Maybe<UserModel>;
  /** User id of the curator assigned to this patient */
  curator_user_id?: Maybe<Scalars['String']['output']>;
  /** Patient birth date resolved from the FHIR Patient resource */
  date_of_birth?: Maybe<Scalars['String']['output']>;
  /** Health Gorilla patient identifier */
  health_gorilla_patient_id?: Maybe<Scalars['String']['output']>;
  /** Whether the patient record is soft-deleted */
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  /** Timestamp of the last Validic data sync */
  last_validic_sync?: Maybe<Scalars['DateTime']['output']>;
  /** Most recent assessment of the given type for the patient */
  latest_assessment?: Maybe<AssessmentModel>;
  /** Formatted FHIR Patient resource identifier */
  patient_id: Scalars['String']['output'];
  /** Practitioner user assigned to the patient */
  practitioner?: Maybe<UserModel>;
  /** User id of the practitioner assigned to this patient */
  practitioner_user_id?: Maybe<Scalars['String']['output']>;
  /** Curation metadata for the patient FHIR record */
  recordMeta?: Maybe<RecordMeta>;
  /** Current profile status of the patient */
  status?: Maybe<StatusModel>;
  /** Profile status identifier for this patient */
  status_id?: Maybe<Scalars['String']['output']>;
  /** Timestamp when the patient record was last updated */
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  /** Linked application user account for this patient */
  user?: Maybe<UserModel>;
  /** Linked identity provider user id for this patient */
  user_id?: Maybe<Scalars['String']['output']>;
  /** Validic integration patient id */
  validic_id?: Maybe<Scalars['String']['output']>;
  /** Validic API access token for this patient */
  validic_token?: Maybe<Scalars['String']['output']>;
  /** Vitall internal patient identifier */
  vitall_patient_id: Scalars['String']['output'];
};


/** VitallPatientModel */
export type VitallPatientModelLatest_AssessmentArgs = {
  type: AssessmentType;
};

/** VitallPractitionerModel */
export type VitallPractitionerModel = {
  __typename?: 'VitallPractitionerModel';
  /** Record creation timestamp */
  created_at?: Maybe<Scalars['DateTime']['output']>;
  /** User id that created this practitioner record */
  created_user_id?: Maybe<Scalars['String']['output']>;
  /** Soft-delete flag for the practitioner */
  deleted?: Maybe<Scalars['Boolean']['output']>;
  /** FHIR Practitioner resource id */
  fhir_practitioner_id: Scalars['String']['output'];
  /** Record last update timestamp */
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  /** Linked application user id */
  user_id?: Maybe<Scalars['String']['output']>;
  /** Internal Vitall practitioner id */
  vitall_practitioner_id?: Maybe<Scalars['String']['output']>;
};

/** WillPlanningModel */
export type WillPlanningModel = {
  __typename?: 'WillPlanningModel';
  associatedResources?: Maybe<Array<ResourceAssociationUnion>>;
  attachments?: Maybe<Array<Attachment>>;
  /** Classification of the consent statement for indexing and retrieval */
  category: Array<CodeableConcept>;
  /** Contained */
  contained?: Maybe<Array<Resource>>;
  /** Curation metadata for this consent resource */
  curationMeta?: Maybe<CurationMeta>;
  /** When this consent was created or indexed */
  dateTime?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  /** Extension */
  extension?: Maybe<Array<Extension>>;
  /** Logical id of this consent resource */
  id?: Maybe<Scalars['String']['output']>;
  /** External identifiers for this consent record */
  identifier?: Maybe<Array<Maybe<Identifier>>>;
  /** A set of rules under which this content was created */
  implicitRules?: Maybe<Scalars['String']['output']>;
  /** Language of the resource content */
  language?: Maybe<Scalars['String']['output']>;
  /** Metadata about the resource */
  meta?: Maybe<Meta>;
  /** Organizations acting as custodian of the consent */
  organization?: Maybe<Array<Reference>>;
  /** Patient the consent applies to */
  patient?: Maybe<Reference>;
  /** Who is agreeing to the policy and rules */
  performer?: Maybe<Reference>;
  /** Policies covered by this consent */
  policy?: Maybe<Array<ConsentPolicy>>;
  /** Regulation that this consent adheres to */
  policyRule?: Maybe<CodeableConcept>;
  /** Constraints to the base consent decision */
  provision?: Maybe<ConsentProvision>;
  /** FHIR resource type, always "Consent" */
  resourceType?: Maybe<Scalars['String']['output']>;
  /** Which of the four areas this consent covers */
  scope: CodeableConcept;
  /** Attachment source from which this consent is taken */
  sourceAttachment?: Maybe<Attachment>;
  /** Reference source from which this consent is taken */
  sourceReference?: Maybe<Reference>;
  /** Consent lifecycle status: draft, proposed, active, rejected, inactive, or entered-in-error */
  status: ConsentStatus;
  /** Text */
  text?: Maybe<Narrative>;
  /** Consent verification by patient or family */
  verification?: Maybe<Array<Verification>>;
};
